export default <const>[
  {
    id: 'ball_001_01',
    move_to: 'c',
    text_jp: '今日はなにしてあそぶコロ？\nサッカー？ボーリング？',
    text_en: 'What do we do today? Soccer? Bowling?',
    type: 'conversational',
  },
  {
    id: 'ball_002_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n小さいころどこであそぶのが\n好きだったコロ？',
    text_en: 'Where did you like to play in your childhood?',
    type: 'selectional',
    answer_var: 'play_place',
    option_1_jp: 'おそとで',
    option_1_en: 'outside',
    option_2_jp: 'おうちのなかで',
    option_2_en: 'at home',
    next_script_id: 'ball_002_02',
  },
  {
    id: 'ball_002_02',
    text_jp:
      'へー。{play_place}あそぶのが\n好きだったのコロね〜\n{pet_name}はね…',
    text_en: 'Oh, you liked to play {play_place}? Me?',
    type: 'conversational',
    next_script_id: 'ball_002_03',
  },
  {
    id: 'ball_002_03',
    animation: 'joy',
    text_jp: 'どっちも好きコロ〜！',
    text_en: 'Both!',
    type: 'conversational',
  },
  {
    id: 'ball_003_01',
    move_to: 'c',
    text_jp: 'ね〜ね〜\nビー玉はどうして「ビー玉」\nっていうか知ってるコロ？',
    text_en: 'Hey hey! Do you knowo why B-dama is called B-dama?',
    type: 'selectional',
    answer_var: 'marble',
    option_1_jp: '知ってる',
    option_1_en: 'I know',
    option_2_jp: '知らない',
    option_2_en: "I don't know",
    next_script_id: 'ball_003_02',
  },
  {
    id: 'ball_003_02',
    text_jp:
      '諸説あるコロけど、\nポルトガル語のビードロから\n来たという説が有力コロ！',
    text_en:
      'There are many theories, but the most popular one is that it came from the Portuguese word "vidro"!',
    type: 'conversational',
  },
  {
    id: 'ball_004_01',
    animation: 'waive',
    text_jp: 'もぞもぞ…',
    text_en: 'Wriggling...',
    type: 'conversational',
  },
  {
    id: 'ball_005_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'あめちゃんって\nおいしいコロよね〜',
    text_en: 'Candies are so delicious!',
    type: 'conversational',
    next_script_id: 'ball_005_02',
  },
  {
    id: 'ball_005_02',
    expression: 'happy',
    text_jp:
      '{pet_name}ね、\nおやつの中であめちゃんが\n一番好きかもしれないコロ',
    text_en: 'Candies might be my most favorite snack',
    type: 'conversational',
  },
  {
    id: 'ball_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\nおかしの中で何が一番好きコロ？',
    text_en: 'What is your most favorite snack?',
    type: 'descriptive',
    answer_var: 'fav_snack',
    question_jp: '一番好きなお菓子',
    question_en: 'Most favorite snack',
    max_len: 14,
    next_script_id: 'ball_006_02',
  },
  {
    id: 'ball_006_02',
    expression: 'happy',
    text_jp: '{fav_snack}が\n好きなのコロね〜',
    text_en: 'Oh, you like {fav_snack}?',
    type: 'conversational',
    next_script_id: 'ball_006_03',
  },
  {
    id: 'ball_006_03',
    expression: 'normal',
    animation: 'joy',
    text_jp:
      '{pet_name}って、\nそれ食べたことあったコロ？\n一度食べてみたいコロ〜',
    text_en: 'Have I eaten it before? I want to eat it!',
    type: 'conversational',
  },
  {
    id: 'ball_007_01',
    expression: 'sad',
    move_to: 'c',
    text_jp:
      '{pet_name}ね、\n転がって移動するから、\n体が汚れやすいのが玉にキズコロ',
    text_en: 'I roll and move around a lot, so my body gets dirty easily',
    type: 'conversational',
    next_script_id: 'ball_007_02',
  },
  {
    id: 'ball_007_02',
    expression: 'happy',
    text_jp: 'こまめにお風呂に入れてくれると\nうれしいコロ！',
    text_en: "It'd be great if you bathe me often!",
    type: 'conversational',
  },
  {
    id: 'ball_008_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'サッカーボールは、どうして\n白と黒の2色か知ってるコロ？',
    text_en:
      'Do you know why soccer balls are painted in two colors, black and white?',
    type: 'selectional',
    answer_var: 'soccer_ball_color',
    option_1_jp: '白い布が足りなかった',
    option_1_en: 'Lack of white cloth',
    option_2_jp: 'テレビ映えのため',
    option_2_en: 'For TV',
    next_script_id: 'ball_008_02',
  },
  {
    id: 'ball_008_02',
    expression: 'normal',
    text_jp: '答えは…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'ball_008_03',
  },
  {
    id: 'ball_008_03',
    expression: 'happy',
    text_jp: '「テレビ映えのため」コロ！',
    text_en: 'For TV!',
    type: 'conversational',
    next_script_id: 'ball_008_04',
  },
  {
    id: 'ball_008_04',
    animation: 'joy',
    text_jp:
      '昔のサッカーボールは\n茶色だったコロけど、白黒テレビで\n見やすいように白黒になったコロ',
    text_en:
      'In the past, soccer balls were brown, but they became black and white for easier viewing on black and white TVs',
    text_en_alt:
      'They became black and white for easier viewing on black and white TVs',
    type: 'conversational',
  },
  {
    id: 'ball_009_01',
    move_to: 'c',
    text_jp:
      '{player_name}は、\n海であそぶのと山であそぶの\nどっちが好きコロ？',
    text_en:
      'Which do you like better, playing in the ocean or playing in the mountains?',
    type: 'selectional',
    answer_var: 'ocean_or_mountains',
    option_1_jp: '海',
    option_1_en: 'Ocean',
    option_2_jp: '山',
    option_2_en: 'Mountains',
    case: 'ocean_or_mountains',
    next_script_id_1: 'ball_009_02',
    next_script_id_2: 'ball_009_03',
  },
  {
    id: 'ball_009_02',
    animation: 'joy',
    text_jp: '砂浜を転がりまわるの、\n開放感いっぱいで最高コロね！',
    text_en: "I love rolling around on the beach, it's so liberating!",
    type: 'conversational',
  },
  {
    id: 'ball_009_03',
    animation: 'joy',
    text_jp:
      '山のてっぺんから転がり落ちるの、\nスリル満点で病みつきに\nなっちゃうコロね！',
    text_en: 'The thrill of rolling off the top of a mountain is so addictive!',
    type: 'conversational',
  },
  {
    id: 'ball_010_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n小さい頃にドッジボールで\nあそんだコロ？',
    text_en: 'Did you play dodgeball when you were little?',
    type: 'conversational',
    next_script_id: 'ball_010_02',
  },
  {
    id: 'ball_010_02',
    animation: 'cry',
    text_jp:
      '{pet_name}は、\nちょいちょいボールと間違えられて\n投げられちゃうコロ',
    text_en: "I'm often mistaken for a ball and thrown!",
    type: 'conversational',
    next_script_id: 'ball_010_03',
  },
  {
    id: 'ball_010_03',
    animation: 'anxious',
    text_jp: 'ドッジボールには\n苦手意識があるコロ',
    text_en: 'I have bittersweet memories of dodgeball',
    type: 'conversational',
  },
  {
    id: 'ball_011_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'はー\nなんだか幸せコロー',
    text_en: "I'm sooooo happy!",
    type: 'conversational',
  },
  {
    id: 'ball_012_01',
    move_to: 'c',
    text_jp: '{pet_name}ね、\n{player_name}とあそぶの\n一番楽しいコロ〜',
    text_en: 'I really enjoy playing with you!',
    type: 'conversational',
    next_script_id: 'ball_012_02',
  },
  {
    id: 'ball_012_02',
    text_jp: '{player_name}は？',
    text_en: 'How about you?',
    type: 'selectional',
    answer_var: 'enjoy_playing',
    option_1_jp: '楽しい',
    option_1_en: 'Me too!',
    option_2_jp: 'そうでもない',
    option_2_en: 'Not really...',
    next_script_id_1: 'ball_012_03',
    next_script_id_2: 'ball_012_04',
  },
  {
    id: 'ball_012_03',
    expression: 'happy',
    text_jp: 'わ〜い！\nずっと一緒にあそんでコロ！',
    text_en: 'Yay! Please play with me more!',
    type: 'conversational',
  },
  {
    id: 'ball_012_04',
    animation: 'angry',
    text_jp: 'ひ、ひどい！\n{pet_name}のことは\nあそびだったコロ？',
    text_en: "You're so mean!",
    type: 'conversational',
    next_script_id: 'ball_012_05',
  },
  {
    id: 'ball_012_05',
    animation: 'cry',
    text_jp: 'えぐえぐ\nえぐえぐ',
    text_en: 'waah, waah',
    type: 'conversational',
  },
  {
    id: 'ball_013_01',
    move_to: 'c',
    animation: 'joy',
    text_jp: 'うーん！\n今日がいちばんの日だコロ！',
    text_en: "Hooray! It's the best day ever!",
    type: 'conversational',
  },
  {
    id: 'ball_014_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nボケかツッコミだとどっちコロ？',
    text_en: 'Which are you, a joke or a comedian?',
    type: 'selectional',
    answer_var: 'boke_or_tsukkomi',
    option_1_jp: 'ボケ',
    option_1_en: 'Joke',
    option_2_jp: 'ツッコミ',
    option_2_en: 'Comedian',
    case: 'boke_or_tsukkomi',
    next_script_id_1: 'ball_014_02',
    next_script_id_2: 'ball_014_03',
  },
  {
    id: 'ball_014_02',
    animation: 'anxious',
    text_jp: 'え！\n負けてられないコロ…',
    text_en: "What? I can't let you beat me",
    type: 'conversational',
  },
  {
    id: 'ball_014_03',
    expression: 'happy',
    text_jp: 'そうなのコロね\nおてやわらかにお願いしたいコロ',
    text_en: 'I see. Please be gentle',
    type: 'conversational',
  },
  {
    id: 'ball_015_01',
    move_to: 'c',
    text_jp: 'みかんの皮は栄養たっぷりって\n知ってたコロ？',
    text_en: 'Did you know that mandarin peels are full of nutrients?',
    type: 'conversational',
    next_script_id: 'ball_015_02',
  },
  {
    id: 'ball_015_02',
    animation: 'joy',
    text_jp:
      '有機農法のみかんを買って、\n皮ごとオーブンなどで焼くと、\n皮までおいしく食べられるコロ！',
    text_en:
      'Buy organic oranges and bake them in the oven or something. You can eat them right down to the peels!',
    type: 'conversational',
    next_script_id: 'ball_015_03',
  },
  {
    id: 'ball_015_03',
    animation: 'waive',
    text_jp: 'これで免疫力アップだコロ！',
    text_en: 'This will boost your immune system!',
    type: 'conversational',
  },
  {
    id: 'ball_016_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'んー\nちょっとおなかが\nすいてきたコロね',
    text_en: "Hmm... I'm a little bit hungry",
    type: 'conversational',
    next_script_id: 'ball_016_02',
  },
  {
    id: 'ball_016_02',
    expression: 'normal',
    text_jp: 'ごはんまだコロ？',
    text_en: 'Can I have some food?',
    type: 'conversational',
  },
  {
    id: 'ball_017_01',
    move_to: 'c',
    text_jp: 'うう…\nおなかがすいて…\n死にそうコロ…',
    text_en: "Ugh... I'm starving...",
    type: 'conversational',
    next_script_id: 'ball_017_02',
  },
  {
    id: 'ball_017_02',
    animation: 'cry',
    text_jp: 'なにか食べさせて欲しいコロ〜',
    text_en: 'Please give me some food...',
    type: 'conversational',
  },
  {
    id: 'ball_018_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'あれ〜？\nちょっとからだが\nホコリっぽい気がするコロ…',
    text_en: 'I feel a little dusty...',
    type: 'conversational',
    next_script_id: 'ball_018_02',
  },
  {
    id: 'ball_018_02',
    expression: 'sad',
    text_jp: 'お風呂に入ったほうがいいコロね',
    text_en: "I think I'd better take a bath",
    type: 'conversational',
  },
  {
    id: 'ball_019_01',
    move_to: 'c',
    text_jp: 'うう…\nホコリがたまって\n体積2割増しコロ',
    text_en: "I'm getting dusty and my volume has increased by 20%...",
    type: 'conversational',
    next_script_id: 'ball_019_02',
  },
  {
    id: 'ball_019_02',
    animation: 'cry',
    text_jp: 'お風呂に入りたいコロ〜',
    text_en: 'I want to take a bath!',
    type: 'conversational',
  },
  {
    id: 'ball_020_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'ね〜ね〜\nそろそろあそびたいコロ〜',
    text_en: 'Hey hey! I want to play with you!',
    type: 'conversational',
  },
  {
    id: 'ball_021_01',
    move_to: 'c',
    text_jp: 'かまって〜\nかまって欲しいコロよ〜',
    text_en: 'I want some toy! I want some toy!',
    type: 'conversational',
    next_script_id: 'ball_021_02',
  },
  {
    id: 'ball_021_02',
    expression: 'normal',
    text_jp: 'おやつで手を打ってもいいコロよ',
    text_en: 'Or, snack time...?',
    type: 'conversational',
  },
  {
    id: 'ball_022_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'ちょっとおトイレ\n行きたくなってきたコロ',
    text_en: 'I think I need to go to the bathroom',
    type: 'conversational',
  },
  {
    id: 'ball_023_01',
    move_to: 'c',
    text_jp: 'こ…これはもう…\n限界に近いコロ…',
    text_en: "I'm getting close to my limit...",
    type: 'conversational',
    next_script_id: 'ball_023_02',
  },
  {
    id: 'ball_023_02',
    animation: 'anxious',
    text_jp: 'ト…ト…イレ…',
    text_en: 'B... bathroom...',
    type: 'conversational',
  },
  {
    id: 'ball_024_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: '急にこわい話思い出したコロ！\nこわいよ〜！こわいよ〜！',
    text_en: "I suddenly remembered something scary! I'm scared!",
    type: 'conversational',
    next_script_id: 'ball_024_02',
  },
  {
    id: 'ball_024_02',
    text_jp: '何かで気を紛らわせて欲しいコロ〜',
    text_en: 'I need something to take my mind off of it',
    type: 'conversational',
  },
  {
    id: 'ball_025_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'ちょっとからだがぶるぶるするコロ',
    text_en: "I'm feeling I'm shivering",
    type: 'conversational',
    next_script_id: 'ball_025_02',
  },
  {
    id: 'ball_025_02',
    animation: 'anxious',
    text_jp: 'おクスリ飲んで安静にしたいコロ',
    text_en: 'I just want to take my medicine and rest',
    type: 'conversational',
  },
  {
    id: 'ball_026_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: '歯がいたいコロ〜！\nこれなにコロ〜？\nこれが虫歯…？',
    text_en: "My tooth hurts! What's this? Is this a cavity...?",
    type: 'conversational',
    next_script_id: 'ball_026_02',
  },
  {
    id: 'ball_026_02',
    text_jp: '虫歯が治るおクスリなんて\nあるコロかね〜？',
    text_en: 'Is there any medicine that can cure cavity?',
    type: 'conversational',
  },
  {
    id: 'ball_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'そろそろおねむだコロ\nおやすみコロ〜',
    text_en: "I'm very sleeply I'm going to sleep now.",
    type: 'conversational',
  },
  {
    id: 'ball_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'なんだかからだが\nムズムズするコロ…',
    text_en: 'My body feels kind of mushy.',
    type: 'conversational',
  },
  {
    id: 'ball_029_01',
    move_to: 'c',
    text_jp: 'しんじゃったコロ…',
    text_en: "I'm dead...",
    type: 'conversational',
    next_script_id: 'ball_029_02',
  },
  {
    id: 'ball_029_02',
    text_jp:
      '短いあいだだったけど、\nこれまで一緒にあそんでくれて\nどうもありがとうコロ',
    text_en: 'Thank you for playing with me',
    type: 'conversational',
    next_script_id: 'ball_029_03',
  },
  {
    id: 'ball_029_03',
    text_jp:
      'もし生まれ変わってまた会えたら\nまた一緒にあそんでほしいコロ…\n約束コロよ？',
    text_en: 'Please play with me again if I get reborn and meet you again',
    type: 'conversational',
  },
  {
    id: 'ball_030_01',
    move_to: 'c',
    text_jp: 'ちょっと、これは…\n本当にしんじゃうかもしれないコロ',
    text_en: 'Hey, I might be dying seriously...',
    type: 'conversational',
    next_script_id: 'ball_030_02',
  },
  {
    id: 'ball_030_02',
    text_jp: '万能コロンを\nふりかけて欲しいコロ…',
    text_en: 'Please use Magic Potion for me...',
    type: 'conversational',
  },
  {
    id: 'ball_031_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'うー。\nおでかけしたいコロ〜',
    text_en: 'Hey, I want to go out!',
    type: 'conversational',
    next_script_id: 'ball_031_02',
  },
  {
    id: 'ball_031_02',
    expression: 'happy',
    text_jp: 'お友だちといっしょに食べる\nぶるぶるフードは格別コロ〜',
    text_en: 'I want to visit a friend and eat buruburu food together!',
    type: 'conversational',
  },
  {
    id: 'ball_032_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'さっき、\n{friend.player_name}が\nあそびに来てくれたコロ',
    text_en: '{friend.player_name} came to play with me just now.',
    type: 'conversational',
    next_script_id: 'ball_032_02',
  },
  {
    id: 'ball_032_02',
    expression: 'happy',
    text_jp:
      '{player_name}に\nよろしくって言ってたコロ\n今度はこっちがあそびに行くコロ！',
    text_en: "It was really fun! Let's visit them next time!",
    type: 'conversational',
  },
  {
    id: 'ball_033_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}は\n小さい頃どこであそぶのが\n好きだったか知ってるコロ？',
    text_en:
      'Do you know where {friend.player_name} liked to play when little?',
    type: 'conversational',
    next_script_id: 'ball_033_02',
  },
  {
    id: 'ball_033_02',
    animation: 'joy',
    text_jp: 'なんと、{friend.play_place}あそぶのが\n好きだったコロって！',
    text_en: 'They were saying they liked to play {friend.play_place}',
    type: 'conversational',
    next_script_id: 'ball_033_03',
  },
  {
    id: 'ball_033_03',
    expression: 'normal',
    text_jp: 'ちょっと意外じゃないコロ？',
    text_en: "Isn't is surprising?",
    type: 'conversational',
  },
  {
    id: 'ball_034_01',
    move_to: 'c',
    text_jp: '{friend.player_name}が\n一番好きなお菓子、知ってるコロ？',
    text_en: 'Do you know the favorite snack of {friend.player_name}?',
    type: 'conversational',
    next_script_id: 'ball_034_02',
  },
  {
    id: 'ball_034_02',
    text_jp: 'なんと、\n{friend.fav_snack}が\n好きらしいコロ！',
    text_en: "It's {friend.fav_snack}",
    type: 'conversational',
    next_script_id: 'ball_034_03',
  },
  {
    id: 'ball_034_03',
    animation: 'waive',
    text_jp: '{pet_name}も\n食べたいコロ〜！！\n今度一緒におねだりするコロ？',
    text_en: 'I want to eat it! ',
    type: 'conversational',
  },
  {
    id: 'ball_035_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は\n海と山どっちが好きか\n知ってるコロ？',
    text_en:
      'Do you know which {friend.player_name} likes better, ocean or mountains?',
    type: 'conversational',
    next_script_id: 'ball_035_02',
  },
  {
    id: 'ball_035_02',
    text_jp: 'どうやら、{friend.ocean_or_mountains}が\n好きらしいコロ！',
    text_en: 'Looks like they like {friend.ocean_or_mountains}',
    type: 'conversational',
    next_script_id: 'ball_035_03',
  },
  {
    id: 'ball_035_03',
    animation: 'waive',
    text_jp: '{player_name}は\nどっちが好きコロ？',
    text_en: 'How about you?',
    type: 'conversational',
  },
  {
    id: 'ball_036_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\n{pet_name}とあそぶの楽しい？\nって聞いたら、',
    text_en: 'When I asked {friend.player_name} if they like to play with me,',
    type: 'conversational',
    next_script_id: 'ball_036_02',
  },
  {
    id: 'ball_036_02',
    text_jp: '{friend.enjoy_playing}って言ってたコロ！',
    text_en: 'They were saying {friend.enjoy_playing}',
    type: 'conversational',
    next_script_id: 'ball_036_03',
  },
  {
    id: 'ball_036_03',
    text_jp: '{player_name}は\nどうコロ？',
    text_en: 'How about you?',
    type: 'conversational',
  },
  {
    id: 'ball_037_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}は、\nボケかツッコミかで言ったら、\nどうやら{friend.boke_or_tsukkomi}らしいのコロよ〜',
    text_en:
      '{player_name} is apparently {friend.boke_or_tsukkomi} when it comes to boke or tsukkomi',
    type: 'conversational',
    next_script_id: 'ball_037_02',
  },
  {
    id: 'ball_037_02',
    text_jp: '才能の片りんは感じるコロ',
    text_en: 'I sense a glimmer of talent',
    type: 'conversational',
  },
  {
    id: 'ball_038_01',
    move_to: 'c',
    text_jp: '…\nん…？だれコロ？',
    text_en: '...\nWho are you...?',
    type: 'conversational',
  },
  {
    id: 'ball_039_01',
    animation: 'waive',
    text_jp: 'あそびに来たコロよ〜！',
    text_en: "I'm here to play with you!",
    type: 'conversational',
  },
  {
    id: 'ball_040_01',
    animation: 'waive',
    text_jp: 'よく来たコロ〜！\nゆっくりしてくコロ〜！',
    text_en: 'Welcome! Please make yourself at home.',
    type: 'conversational',
  },
  {
    id: 'ball_041_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ほんの感謝の気持ちコロ',
    text_en: 'This is just a small token of my gratitude.',
    type: 'conversational',
  },
  {
    id: 'ball_042_01',
    animation: 'waive',
    text_jp: 'そろそろおうち帰るコロ\nまたあそびに来るコロ',
    text_en: "It's time to go home. I'll see you soon",
    type: 'conversational',
  },
  {
    id: 'ball_043_01',
    animation: 'waive',
    text_jp: 'またいつでも来るコロ〜',
    text_en: 'Come abain anytime!',
    type: 'conversational',
  },
  {
    id: 'ball_044_01',
    text_jp: 'どうやら\n{friend.player_name}が\n帰ってきたみたいコロ',
    text_en: 'Looks like {friend.player_name} is back',
    type: 'conversational',
    next_script_id: 'ball_044_02',
  },
  {
    id: 'ball_044_02',
    animation: 'waive',
    text_jp: 'またあそびに来るコロ〜',
    text_en: "I'll see you soon!",
    type: 'conversational',
  },
  {
    id: 'ball_045_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないコロ',
    text_en: "I'm too scared to go to the bathroom",
    type: 'conversational',
  },
  {
    id: 'ball_046_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないコロ',
    text_en: "Cavities are so painful that I can't eat food or snacks.",
    type: 'conversational',
  },
  {
    id: 'ball_047_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今はそんな余裕無いコロ〜\n万能コロンをかけて欲しいコロ…',
    text_en: "I can't do that right now. Please use the Magic Potion...",
    type: 'conversational',
  },
  {
    id: 'ball_048_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないコロ〜！',
    text_en: "I want to go out so much that I can't do anything else",
    type: 'conversational',
  },
  {
    id: 'ball_049_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったコロ！\nどうもありがとうコロ！',
    text_en: "I'm fully recovered! Thank you!",
    type: 'conversational',
  },
  {
    id: 'ball_050_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったコロ！\nどうもありがとうコロ！',
    text_en: "I'm fully recovered! Thank you!",
    type: 'conversational',
  },
  {
    id: 'ball_051_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'なんとか助かったコロ！\n{player_name}は\n命の恩人コロ！',
    text_en: 'You saved my life! Thank you so much!',
    type: 'conversational',
  },
  {
    id: 'ball_052_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったコロ…\nもう1回試してみて欲しいコロ',
    text_en: "It didn't work... Could you try one more time?",
    type: 'conversational',
  },
  {
    id: 'ball_053_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったコロ…\nもう1回試してみて欲しいコロ',
    text_en: "It didn't work... Could you try one more time?",
    type: 'conversational',
  },
  {
    id: 'ball_054_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったコロ…\nもう1回試してみて欲しいコロ',
    text_en: "It didn't work... Could you try one more time?",
    type: 'conversational',
  },
  {
    id: 'crab_001_01',
    move_to: 'c',
    text_jp:
      '今日もいい天気カニ〜\nこんな日はお外を\nブラブラお散歩したいカニね',
    text_en:
      "It's another beautiful day. I want to go for a walk outside on a day like this",
    type: 'conversational',
    next_script_id: 'crab_001_02',
  },
  {
    id: 'crab_001_02',
    expression: 'happy',
    text_jp: 'いつもと違う道を歩くと\n思わぬ発見があるカニよね',
    text_en:
      "Walking on a different path, you'll find unexpected things, right?",
    type: 'conversational',
  },
  {
    id: 'crab_002_01',
    move_to: 'c',
    text_jp: '今日はなにしてあそぶカニ？\n反復横跳び？シャボン玉？',
    text_en:
      'What are you going to do today? Repetitive jumping? Soap bubbles?',
    type: 'conversational',
    next_script_id: 'crab_002_02',
  },
  {
    id: 'crab_002_02',
    animation: 'surprised',
    text_jp: '反復横跳びって、\nたまにめちゃくちゃ速いやつ\nいるカニよね？',
    text_en:
      'You know how some repetitive lateral jumpers are really fast sometimes?',
    type: 'conversational',
  },
  {
    id: 'crab_003_01',
    move_to: 'c',
    text_jp: '{pet_name}って、\n実はけっこう家事好きカニよ',
    text_en: "I'm actually quite fond of housework",
    type: 'conversational',
    next_script_id: 'crab_003_02',
  },
  {
    id: 'crab_003_02',
    text_jp: 'まじめにやると、かなり\nいろんな筋肉使うから',
    text_en: "If you work seriously, you'll use a lot of muscles",
    type: 'conversational',
    next_script_id: 'crab_003_03',
  },
  {
    id: 'crab_003_03',
    expression: 'happy',
    text_jp: '運動不足解消にちょうどいいカニ！',
    text_en: 'Just the thing for a good workout!',
    type: 'conversational',
  },
  {
    id: 'crab_004_01',
    move_to: 'c',
    text_jp: '話は変わるけど、\nタイミングって大事カニよね',
    text_en:
      "I know it's a little off topic, but the timing is important, right?",
    type: 'conversational',
    next_script_id: 'crab_004_02',
  },
  {
    id: 'crab_004_02',
    text_jp: '世の中だいたい\nタイミングな気がするカニ',
    text_en: 'I feel like the world is all about timing.',
    type: 'conversational',
  },
  {
    id: 'crab_005_01',
    animation: 'joy',
    text_jp: 'ららら〜カニ〜',
    text_en: 'La la la',
    type: 'conversational',
  },
  {
    id: 'crab_006_01',
    animation: 'anxious',
    text_jp: '腹八分目が大事なのは\nよく分かってるカニよ…',
    text_en: "I'm well aware of the importance of not overeating...",
    type: 'conversational',
  },
  {
    id: 'crab_007_01',
    expression: 'sad',
    move_to: 'c',
    text_jp:
      '行きたくないときにトイレに\n行かされるのも、それはそれで\nストレスなのカニよ',
    text_en:
      "Being forced to go to the bathroom when you don't want to is also stressfull",
    type: 'conversational',
    next_script_id: 'crab_007_02',
  },
  {
    id: 'crab_007_02',
    expression: 'happy',
    text_jp:
      'トイレに行きたいのに\n行けないストレスに比べれば\n100倍マシカニけどね',
    text_en:
      "It's a hundred times better than the stress of not being able to go to the bathroom when you want to.",
    type: 'conversational',
  },
  {
    id: 'crab_008_01',
    animation: 'waive',
    text_jp: 'やっほ〜\n元気カニ？',
    text_en: 'Hi, how are you?',
    type: 'conversational',
  },
  {
    id: 'crab_009_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'またお部屋を泡だらけに\nしちゃったカニ…',
    text_en: "I've got bubbles all over my room again...",
    type: 'conversational',
    next_script_id: 'crab_009_02',
  },
  {
    id: 'crab_009_02',
    expression: 'normal',
    text_jp: 'そんなことより、\nそろそろご飯の\n時間じゃないカニ？',
    text_en: "Anyway, isn't it almost time for dinner?",
    type: 'conversational',
  },
  {
    id: 'crab_010_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'なにカニ？あそんでくれるカニ？',
    text_en: 'What is it? Are you going to play with me?',
    type: 'conversational',
  },
  {
    id: 'crab_011_01',
    move_to: 'c',
    text_jp: '貧乏ゆすりはお行儀が悪いって\n言われがちカニよね',
    text_en: 'People tend to say that shaking legs is bad manners',
    type: 'conversational',
    next_script_id: 'crab_011_02',
  },
  {
    id: 'crab_011_02',
    expression: 'happy',
    text_jp:
      'でも、実は血流が良くなって、\n手足の冷えやむくみの解消に\nつながるらしいカニ！',
    text_en:
      "But it's actually supposed to improve blood flow and help relieve cold and swollen hands and feet!",
    type: 'conversational',
  },
  {
    id: 'crab_012_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nネコは好きカニ？',
    text_en: 'Do you like cats?',
    type: 'conversational',
    next_script_id: 'crab_012_02',
  },
  {
    id: 'crab_012_02',
    text_jp:
      'ネコをなでると、免疫向上や\nストレス減少に効果のある\nホルモンが分泌されるらしいカニ',
    text_en:
      'Petting a cat releases hormones that improve immunity and reduce stress.',
    type: 'conversational',
    next_script_id: 'crab_012_03',
  },
  {
    id: 'crab_012_03',
    expression: 'happy',
    text_jp: '{pet_name}を\nなでなでしても、\n同じ効果があるらしいカニよ',
    text_en: 'Stroking me has the same effect.',
    type: 'conversational',
  },
  {
    id: 'crab_013_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n最近よく眠れてるカニ？',
    text_en: 'Have you been sleeping well lately?',
    type: 'conversational',
    next_script_id: 'crab_013_02',
  },
  {
    id: 'crab_013_02',
    expression: 'sad',
    text_jp: '寝だめは生活リズムが崩れて\n疲労回復に効果が薄いカニ',
    text_en:
      'Sleep deprivation is ineffective for recovery from fatigue because it disrupts the rhythm of life.',
    type: 'conversational',
    next_script_id: 'crab_013_03',
  },
  {
    id: 'crab_013_03',
    expression: 'normal',
    text_jp: '寝だめするより、15分ぐらいの\n短いお昼寝をした方がいいカニよ',
    text_en: "It's better to take a short nap of about 15 minutes",
    type: 'conversational',
  },
  {
    id: 'crab_014_01',
    move_to: 'c',
    text_jp: '睡眠は、量も大事だけど\n質も同じくらい大事カニ',
    text_en:
      'The quantity of sleep is important, but the quality is just as important.',
    type: 'conversational',
    next_script_id: 'crab_014_02',
  },
  {
    id: 'crab_014_02',
    expression: 'happy',
    text_jp:
      'ぬるめのお風呂にゆっくりつかって\nお風呂のあとに軽いストレッチで\n体をほぐすといいカニ',
    text_en:
      'You should take a lukewarm bath and do some light stretching after the bath to loosen up your body.',
    type: 'conversational',
  },
  {
    id: 'crab_015_01',
    move_to: 'c',
    text_jp: 'ちょっと近所をお散歩するだけでも\nけっこういい運動になるカニ',
    text_en:
      'Even a short walk around the neighborhood is a good way to get some exercise.',
    type: 'conversational',
    next_script_id: 'crab_015_02',
  },
  {
    id: 'crab_015_02',
    expression: 'happy',
    text_jp: '歩幅を広めにして速歩きで歩くと\nさらに効果的カニ',
    text_en: 'Walking at a faster pace with a wider stride is more effective.',
    type: 'conversational',
  },
  {
    id: 'crab_016_01',
    move_to: 'c',
    text_jp: '毎日の目標は低めに設定するのが\n長続きのコツカニ',
    text_en: 'Setting a low daily goal is the key to lasting longer.',
    type: 'conversational',
    next_script_id: 'crab_016_02',
  },
  {
    id: 'crab_016_02',
    text_jp: 'ジムでシャワーを浴びる\nだけでもいいと思うカニ',
    text_en: 'Just taking a shower at the gym is fine.',
    type: 'conversational',
  },
  {
    id: 'crab_017_01',
    move_to: 'c',
    text_jp: 'レモンに含まれるビタミンCって\n実はそんなに多くないカニよ',
    text_en: 'The vitamin C in lemons is actually not that much.',
    type: 'conversational',
    next_script_id: 'crab_017_02',
  },
  {
    id: 'crab_017_02',
    text_jp:
      'レモン1個に含まれるビタミンCの\n量が、成人の1日の必要量と同じで\nわかりやすいから、',
    text_en:
      'The amount of vitamin C contained in one lemon is the same as the daily requirement for an adult.',
    type: 'conversational',
    next_script_id: 'crab_017_03',
  },
  {
    id: 'crab_017_03',
    text_jp: 'よく「レモン○個分のビタミンC」\nって言うだけなのカニ',
    text_en:
      'That\'s why they often say "Vitamin C equivaent to X number of lemons"',
    type: 'conversational',
  },
  {
    id: 'crab_018_01',
    move_to: 'c',
    text_jp: 'バナナはカロリー控えめで\nビタミン・ミネラル豊富がカニ',
    text_en: 'Bananas are low in calories and rich in vitamins and minerals.',
    type: 'conversational',
    next_script_id: 'crab_018_02',
  },
  {
    id: 'crab_018_02',
    expression: 'happy',
    text_jp: '健康維持やダイエットに\nぴったりの果物カニ！',
    text_en: 'The perfect fruit to keep you healthy and on a diet!',
    type: 'conversational',
  },
  {
    id: 'crab_019_01',
    move_to: 'c',
    text_jp: 'サラダ油って、サラダが原料\nなわけじゃないカニよ',
    text_en: 'Salad oil is not made from salad',
    type: 'conversational',
    next_script_id: 'crab_019_02',
  },
  {
    id: 'crab_019_02',
    text_jp:
      'もともと、生野菜に合わせるために\n開発されたから、サラダ油という\n名前になったカニ',
    text_en:
      'It was originally developed to be used with raw vegetables, hence the name "salad oil".',
    type: 'conversational',
  },
  {
    id: 'crab_020_01',
    move_to: 'c',
    text_jp: '肩こりは色々な\n原因が考えられるカニ',
    text_en: 'Stiff shoulders can be caused by many things.',
    type: 'conversational',
    next_script_id: 'crab_020_02',
  },
  {
    id: 'crab_020_02',
    text_jp: '毎日ストレッチして\n体を動かすことが\n一番の予防法カニ！',
    text_en:
      'Stretching and moving your body every day is the best way to prevent it!',
    type: 'conversational',
  },
  {
    id: 'crab_021_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n長距離走と短距離走は\nどっちが得意カニ？',
    text_en:
      'Are you better at long distance running or short distance running?',
    type: 'selectional',
    answer_var: 'long_run_or_short_run',
    option_1_jp: '長距離',
    option_1_en: 'Long distance',
    option_2_jp: '短距離',
    option_2_en: 'Short distance',
    next_script_id: 'crab_021_02',
  },
  {
    id: 'crab_021_02',
    expression: 'sad',
    text_jp: '{pet_name}は、\nまっすぐ走るのが\nあまり得意じゃないカニよ〜',
    text_en: "I'm not very good at running in a straight line.",
    type: 'conversational',
    next_script_id: 'crab_021_03',
  },
  {
    id: 'crab_021_03',
    expression: 'happy',
    text_jp: 'まっすぐ走れるだけで\n尊敬しちゃうカニ',
    text_en: 'I respect you just because you can run straight.',
    type: 'conversational',
  },
  {
    id: 'crab_022_01',
    move_to: 'c',
    text_jp:
      '{player_name}は、\n一生太らない体と一生荒れないお肌\nどっちが欲しいカニ？',
    text_en:
      'Would you rather have a body that will never get fat or skin that will never get rough?',
    type: 'selectional',
    answer_var: 'no_fat_or_good_skin',
    option_1_jp: '一生太らない体',
    option_1_en: 'Body that will never be fat',
    option_2_jp: '一生荒れないお肌',
    option_2_en: 'Skin that will never be rough.',
    case: 'no_fat_or_good_skin',
    next_script_id_1: 'crab_022_02',
    next_script_id_2: 'crab_022_03',
  },
  {
    id: 'crab_022_02',
    text_jp: '{pet_name}も！\n太るのを気にせずに\n好きなだけご飯食べたいカニ…',
    text_en:
      'Me too! I want to eat as much food as I can without worrying about gaining weight.',
    type: 'conversational',
  },
  {
    id: 'crab_022_03',
    text_jp: 'それもいいカニよね〜\nお肌のお手入れめんどいカニ…',
    text_en: "That's good, too. It's a pain in the ass to take care of skin.",
    type: 'conversational',
  },
  {
    id: 'crab_023_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n学校で体育と音楽どっちが\n好きだったカニ？',
    text_en: 'Which was your favorite activity in school, PE or music?',
    type: 'selectional',
    answer_var: 'pe_or_music',
    option_1_jp: '体育',
    option_1_en: 'PE',
    option_2_jp: '音楽',
    option_2_en: 'Music',
    case: 'pe_or_music',
    next_script_id_1: 'crab_023_02',
    next_script_id_2: 'crab_023_03',
  },
  {
    id: 'crab_023_02',
    expression: 'sad',
    text_jp: '{pet_name}は、\nまっすぐ前に走れなくて\nなかなか大変カニ…',
    text_en: "I can't run straight ahead, so it's hard for me...",
    type: 'conversational',
  },
  {
    id: 'crab_023_03',
    expression: 'happy',
    text_jp:
      '音楽って良いカニよね…\nきれいな音楽を聞いていると頭から\n泡があふれてくるカニ…',
    text_en:
      "Music is good, isn't it? When I listen to beautiful music, my head is filled with bubbles.",
    type: 'conversational',
  },
  {
    id: 'crab_024_01',
    move_to: 'c',
    text_jp:
      '{player_name}は、\nプレゼントをするのとされるの\nどっちが好きカニ？',
    text_en: 'Which do you prefer, giving gifts or being given gifts?',
    type: 'selectional',
    answer_var: 'give_or_given',
    option_1_jp: 'する方',
    option_1_en: 'Giving',
    option_2_jp: 'される方',
    option_2_en: 'Being given',
    next_script_id: 'crab_024_02',
  },
  {
    id: 'crab_024_02',
    text_jp: '{pet_name}は、\nけっこうどっちも好きカニよ',
    text_en: 'I like both.',
    type: 'conversational',
    next_script_id: 'crab_024_03',
  },
  {
    id: 'crab_024_03',
    expression: 'happy',
    text_jp: 'これ喜んでくれるかなって\nプレゼントを選ぶのも楽しいし',
    text_en: "It's fun to choose a gift and wonder if the person will like it.",
    type: 'conversational',
    next_script_id: 'crab_024_04',
  },
  {
    id: 'crab_024_04',
    expression: 'happy',
    text_jp: '自分ではなかなか買わないものを\nもらうのも嬉しいカニね',
    text_en: "It's nice to have something that you don't buy yourself.",
    type: 'conversational',
  },
  {
    id: 'crab_025_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nお風呂で頭と体どっちから\n先に洗うカニ？',
    text_en:
      'When you take a bath, which do you wash first, your head or your body?',
    type: 'selectional',
    answer_var: 'head_or_body',
    option_1_jp: '頭',
    option_1_en: 'Head',
    option_2_jp: '体',
    option_2_en: 'Body',
    next_script_id: 'crab_025_02',
  },
  {
    id: 'crab_025_02',
    text_jp: '{pet_name}は、\n頭を洗って出た泡で\n体を洗うカニ！',
    text_en:
      'I wash my head first and use the foam from washing my head to wash my body.',
    type: 'conversational',
  },
  {
    id: 'crab_026_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nブロッコリーの茎は\n食べるタイプカニ？',
    text_en: 'Are you the type of person who eats broccoli stems?',
    type: 'selectional',
    answer_var: 'eat_or_not_eat_broccoli',
    option_1_jp: '食べる',
    option_1_en: 'Yes',
    option_2_jp: '食べない',
    option_2_en: 'No',
    next_script_id: 'crab_026_02',
  },
  {
    id: 'crab_026_02',
    animation: 'angry',
    text_jp: 'ブロッコリーの茎は栄養満点だから\n捨てるなんてもったいないカニ',
    text_en:
      'Broccoli stems are full of nutrients, so it would be a shame to throw them away.',
    type: 'conversational',
    next_script_id: 'crab_026_03',
  },
  {
    id: 'crab_026_03',
    expression: 'happy',
    text_jp: '千切りにしてキンピラにしても\nおいしいカニ！',
    text_en: 'You can even shred it and make it into kinpira!',
    type: 'conversational',
  },
  {
    id: 'crab_027_01',
    move_to: 'c',
    text_jp:
      '{player_name}は、\n待ち合わせで待つのと待たせるの\nどっちが多いカニ？',
    text_en:
      'Are you more likely to wait for someone or to make someone wait for you?',
    type: 'selectional',
    answer_var: 'wait_or_make_wait',
    option_1_jp: '待つ方',
    option_1_en: 'Wait for someone',
    option_2_jp: '待たせる方',
    option_2_en: 'Make someone wait',
    next_script_id: 'crab_027_02',
  },
  {
    id: 'crab_027_02',
    expression: 'happy',
    text_jp: '{pet_name}は、\nなぜかいつも5分くらい\n遅れちゃうカニ',
    text_en: "For some reason, I'm always about five minutes late.",
    type: 'conversational',
  },
  {
    id: 'crab_028_01',
    move_to: 'c',
    text_jp:
      '{pet_name}ね、\n髪型変えてみようと思うんだけど\nどんなのが似合うと思うカニ？',
    text_en:
      "I'm going to try a new hairstyle, what do you think would look good on me?",
    type: 'selectional',
    answer_var: 'long_hair_or_short_hair',
    option_1_jp: '長め',
    option_1_en: 'Long',
    option_2_jp: '短め',
    option_2_en: 'Short',
    next_script_id: 'crab_028_02',
  },
  {
    id: 'crab_028_02',
    expression: 'happy',
    text_jp: 'うん、やっぱり{long_hair_or_short_hair}に\nしておくカニかね〜',
    text_en: "Yeaht, I think I'll make it {long_hair_or_short_hair}",
    type: 'conversational',
    next_script_id: 'crab_028_03',
  },
  {
    id: 'crab_028_03',
    expression: 'sad',
    text_jp: 'って、\n髪型変えようがなかったカニ！',
    text_en: 'Whoa, I have no way to change my hair in the first place.',
    type: 'conversational',
  },
  {
    id: 'crab_029_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n雨の日は何をして\n過ごすのが好きカニ？',
    text_en: 'What do you like to do on a rainy day',
    type: 'descriptive',
    answer_var: 'rainy_day_activity',
    question_jp: '雨の日の過ごし方',
    question_en: 'How to spend a rainy day',
    max_len: 14,
    next_script_id: 'crab_029_02',
  },
  {
    id: 'crab_029_02',
    expression: 'happy',
    text_jp: '{pet_name}は、\n晴れたら何しようって\n考えるのが好きカニ',
    text_en:
      "I like to think about what I'm going to do when the sun comes out.",
    type: 'conversational',
  },
  {
    id: 'crab_030_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n小さい頃のあだ名は\n何だったカニ？',
    text_en: 'What was your nickname when you were little?',
    type: 'descriptive',
    answer_var: 'childhood_nickname',
    question_jp: '小さい頃のあだ名',
    question_en: 'Childhood nickname',
    max_len: 14,
    next_script_id: 'crab_030_02',
  },
  {
    id: 'crab_030_02',
    text_jp: 'へ〜\nそれ、気に入ってたカニ？',
    text_en: 'Did you like it?',
    type: 'selectional',
    answer_var: 'liked_nickname',
    option_1_jp: '気に入ってた',
    option_1_en: 'Yes',
    option_2_jp: 'そうでもない',
    option_2_en: 'No',
    case: 'liked_nickname',
    next_script_id_1: 'crab_030_03',
    next_script_id_2: 'crab_030_04',
  },
  {
    id: 'crab_030_03',
    animation: 'joy',
    text_jp: '{player_name}に\nぴったりのあだ名カニね！',
    text_en: "Yeah, that's the perfect nickname for you!",
    type: 'conversational',
  },
  {
    id: 'crab_030_04',
    expression: 'happy',
    text_jp: 'うん。\n{player_name}には\nもっと良いあだ名がありそうカニね！',
    text_en: 'Yeah. You could have a better nickname!',
    type: 'conversational',
  },
  {
    id: 'crab_031_01',
    move_to: 'c',
    text_jp: '{player_name}の\n特技は何カニ？',
    text_en: 'What are your special skills?',
    type: 'descriptive',
    answer_var: 'speciality',
    question_jp: '特技',
    question_en: 'Speciality',
    max_len: 14,
    next_script_id: 'crab_031_02',
  },
  {
    id: 'crab_031_02',
    expression: 'happy',
    text_jp: '{pet_name}の\n特技は、反復横跳びカニ！',
    text_en: 'My special skill is repetitive jumping!',
    type: 'conversational',
  },
  {
    id: 'crab_032_01',
    move_to: 'c',
    text_jp: '最近何か面白かった本あるカニ？',
    text_en: 'Have you read anything interesting lately?',
    type: 'descriptive',
    answer_var: 'interesting_book',
    question_jp: '面白かった本',
    question_en: 'Interesting book',
    max_len: 14,
    next_script_id: 'crab_032_02',
  },
  {
    id: 'crab_032_02',
    text_jp: '今度読んで聞かせて欲しいカニ！',
    text_en: 'I want you to read it to me next time.',
    type: 'conversational',
  },
  {
    id: 'crab_033_01',
    move_to: 'c',
    text_jp: '健康のために\n心がけていることあるカニ？',
    text_en: 'Do you have any health tips?',
    type: 'descriptive',
    answer_var: 'health_tips',
    question_jp: '健康のためにしていること',
    question_en: 'Health tips',
    max_len: 14,
    next_script_id: 'crab_033_02',
  },
  {
    id: 'crab_033_02',
    text_jp: '{pet_name}は、\n毎日15分はお散歩するように\nしてるカニ！',
    text_en: "I'm trying to take a 15-minute walk every day.",
    type: 'conversational',
  },
  {
    id: 'crab_034_01',
    move_to: 'c',
    text_jp: '将来の夢を教えて欲しいカニ！',
    text_en: 'I want you to tell me about your dreams for the future!',
    type: 'descriptive',
    answer_var: 'future_dream',
    question_jp: '将来の夢',
    question_en: 'Future dream',
    max_len: 14,
    next_script_id: 'crab_034_02',
  },
  {
    id: 'crab_034_02',
    expression: 'happy',
    text_jp: '{pet_name}は、\nヨガ講師になりたいカニ！',
    text_en: 'I want to be a yoga teacher!',
    type: 'conversational',
  },
  {
    id: 'crab_035_01',
    move_to: 'c',
    text_jp: 'どんなときに\n「生きてて良かった」って\n思うカニ？',
    text_en: 'When do you feel happiness?',
    type: 'descriptive',
    answer_var: 'happy_moment',
    question_jp: '生きてて良かった瞬間',
    question_en: 'Happy moment',
    max_len: 14,
    next_script_id: 'crab_035_02',
  },
  {
    id: 'crab_035_02',
    expression: 'happy',
    text_jp: '{pet_name}は、\nあったかいお風呂に\n入ったときカニ！',
    text_en: 'I feel happy when I take a warm bath!',
    type: 'conversational',
  },
  {
    id: 'crab_036_01',
    move_to: 'c',
    text_jp: '昔に戻れるとしたら、\n何歳ごろに戻りたいカニ？',
    text_en: 'If you could go back in time, how old would you want to be?',
    type: 'descriptive',
    answer_var: 'how_old_to_go_back',
    question_jp: '何歳に戻りたい',
    question_en: 'How old you want to go back',
    max_len: 14,
    next_script_id: 'crab_036_02',
  },
  {
    id: 'crab_036_02',
    expression: 'happy',
    text_jp: '{pet_name}は、\n昨日に戻ってもう一度\nおやつを食べたいカニ！',
    text_en: 'I want to go back to yesterday and have that snack again!',
    type: 'conversational',
  },
  {
    id: 'crab_037_01',
    move_to: 'c',
    text_jp:
      'おしょうゆの\n「うすくち」と「こいくち」\nどっちが塩分が多いと思うカニ？',
    text_en:
      'Which type of soy sauce do you think has more salt in it, "light soy sauce" or "dark soy sauce"?',
    text_en_alt:
      'Which type of soy sauce has more salt, "light soy sauce" or "dark soy sauce"?',
    type: 'selectional',
    answer_var: 'soy_sauce',
    option_1_jp: 'うすくち',
    option_1_en: 'Light',
    option_2_jp: 'こいくち',
    option_2_en: 'Dark',
    next_script_id: 'crab_037_02',
  },
  {
    id: 'crab_037_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_037_03',
  },
  {
    id: 'crab_037_03',
    text_jp: '「うすくち」カニ！',
    text_en: 'Light!',
    type: 'conversational',
    next_script_id: 'crab_037_04',
  },
  {
    id: 'crab_037_04',
    text_jp:
      'うすくちしょうゆは色はうすいけど\n実は塩分はこいくちより多いから\n気をつけるカニ！',
    text_en:
      'Light soy sauce may be light in color, but it actually contains more salt than dark soy sauce, so be careful with it!',
    text_en_alt:
      'Light soy sauce contains more salt than dark soy sauce, so be careful with it!',
    type: 'conversational',
  },
  {
    id: 'crab_038_01',
    move_to: 'c',
    text_jp:
      '糖尿病の人は、日本酒はダメでも\nウイスキーなら\n飲んでもいいカニ？',
    text_en:
      "Diabetics can't drink sake, but they can drink whiskey. is this correct?",
    type: 'selectional',
    answer_var: 'whiskey_ok',
    option_1_jp: '飲んでもいい',
    option_1_en: 'Yes',
    option_2_jp: '飲んではいけない',
    option_2_en: 'No',
    next_script_id: 'crab_038_02',
  },
  {
    id: 'crab_038_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_038_03',
  },
  {
    id: 'crab_038_03',
    text_jp: '「飲んではいけない」カニ！',
    text_en: 'No!',
    type: 'conversational',
    next_script_id: 'crab_038_04',
  },
  {
    id: 'crab_038_04',
    text_jp:
      'アルコールはインシュリンの作用を\n下げちゃうから、アルコール自体が\n良くないカニ！',
    text_en:
      'Alcohol lowers the effect of insulin, so alcohol itself is not good for diabetics.',
    text_en_alt:
      'Alcohol lowers the effect of insulin, so is not good for diabetics.',
    type: 'conversational',
  },
  {
    id: 'crab_039_01',
    move_to: 'c',
    text_jp: 'コーラには角砂糖何個分の\nお砂糖が入っているか知ってるカニ？',
    text_en: 'Do you know how many cubes of sugar there are in a Coke?',
    type: 'selectional',
    answer_var: 'sugars_in_coke',
    option_1_jp: '3個',
    option_1_en: '3 cubes',
    option_2_jp: '10個',
    option_2_en: '10 cubes',
    option_3_jp: '15個',
    option_3_en: '15 cubes',
    next_script_id: 'crab_039_02',
  },
  {
    id: 'crab_039_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_039_03',
  },
  {
    id: 'crab_039_03',
    text_jp: '「15個」カニ！',
    text_en: '15!',
    type: 'conversational',
    next_script_id: 'crab_039_04',
  },
  {
    id: 'crab_039_04',
    text_jp:
      'ジュースはおいしいけど、お砂糖が\nたくさん入ってるから、飲みすぎ\nには注意カニ！',
    text_en:
      "The juice is delicious, but there's a lot of sugar in it, so be careful not to drink too much!",
    text_en_alt:
      "The juice is delicious, but there's a lot of sugar in it, so be careful!",
    type: 'conversational',
  },
  {
    id: 'crab_040_01',
    move_to: 'c',
    text_jp:
      'テスト前におすすめの、記憶力が\n良くなるといわれる\n食べ物はどれカニ？',
    text_en:
      'Which of the following foods is recommended before a test and is said to improve memory?',
    text_en_alt: 'Which of the following foods is said to improve memory?',
    type: 'selectional',
    answer_var: 'food_for_memory',
    option_1_jp: '大豆',
    option_1_en: 'Soybeans',
    option_2_jp: 'クルミ',
    option_2_en: 'Walnuts',
    option_3_jp: 'ピーナッツ',
    option_3_en: 'Peanuts',
    next_script_id: 'crab_040_02',
  },
  {
    id: 'crab_040_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_040_03',
  },
  {
    id: 'crab_040_03',
    text_jp: '「クルミ」カニ！',
    text_en: 'Walnuts!',
    type: 'conversational',
    next_script_id: 'crab_040_04',
  },
  {
    id: 'crab_040_04',
    expression: 'happy',
    text_jp:
      'クルミは、脳細胞の血行をよくして\n記憶力を高め、脳の病気を\n予防してくれまるカニ！',
    text_en:
      'Walnuts can improve blood circulation in brain cells, enhance memory and prevent brain diseases.',
    text_en_alt:
      'Walnuts can improve blood circulation in brain cells and prevent brain diseases.',
    type: 'conversational',
  },
  {
    id: 'crab_041_01',
    move_to: 'c',
    text_jp: '免疫力を高めるのに効果的な\nお風呂の温度は何度カニ？',
    text_en: 'What is the best temperature for a bath to boost immunity?',
    type: 'selectional',
    answer_var: 'bath_temperature',
    option_1_jp: '38度',
    option_1_en: '38℃',
    option_1_en_alt: '38 degrees Celsius',
    option_2_jp: '40度',
    option_2_en: '40℃',
    option_2_en_alt: '40 degrees Celsius',
    option_3_jp: '42度',
    option_3_en: '42℃',
    option_3_en_alt: '42 degrees Celsius',
    next_script_id: 'crab_041_02',
  },
  {
    id: 'crab_041_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    text_en_alt: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_041_03',
  },
  {
    id: 'crab_041_03',
    text_jp: '「40度」カニ！',
    text_en: '40 degree Celsius!',
    type: 'conversational',
    next_script_id: 'crab_041_04',
  },
  {
    id: 'crab_041_04',
    text_jp:
      '40度のぬるま湯に15分間つかると\n免疫力を高めて体の冷えを\nとってくれるカニ',
    text_en:
      'A 15-minute soak in lukewarm water at 40 degrees Celsius will help boost your immunity and take the chill out of your body.',
    text_en_alt:
      'A 15-minute bath at 40 degrees Celsius will help boost your immunity.',
    type: 'conversational',
    next_script_id: 'crab_041_05',
  },
  {
    id: 'crab_041_05',
    text_jp:
      '42度以上のお湯は心臓に負担が\nかかる可能性があるから\n要注意カニ！',
    text_en:
      'Hot water over 42 degrees Celsius may cause a heart attack, so be careful!',
    type: 'conversational',
  },
  {
    id: 'crab_042_01',
    move_to: 'c',
    text_jp: '食べる日焼け止めと言われている\nお菓子はどれカニ？',
    text_en: 'Which of these snacks are called "eating sunscreen"?',
    type: 'selectional',
    answer_var: 'snack_for_sunscreen',
    option_1_jp: 'チョコレート',
    option_1_en: 'Chocolate',
    option_2_jp: 'バニラアイス',
    option_2_en: 'Vanilla icecream',
    option_3_jp: 'クッキー',
    option_3_en: 'Cookie',
    next_script_id: 'crab_042_02',
  },
  {
    id: 'crab_042_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_042_03',
  },
  {
    id: 'crab_042_03',
    text_jp: '「チョコレート」カニ！',
    text_en: 'Chocolate!',
    type: 'conversational',
    next_script_id: 'crab_042_04',
  },
  {
    id: 'crab_042_04',
    text_jp:
      'ポリフェノールはお肌のダメージを\n治してくれて、フラボノイドは\n紫外線から肌を守ってくれるカニ！',
    text_en:
      'The polyphenols help heal skin damage, and the flavonoids protect your skin from UV rays!',
    type: 'conversational',
  },
  {
    id: 'crab_043_01',
    move_to: 'c',
    text_jp: '今日がいちばんの日カニ〜',
    text_en: 'Today is the best day ever!',
    type: 'conversational',
  },
  {
    id: 'crab_044_01',
    move_to: 'c',
    animation: 'play',
    text_jp: 'ぶくぶくぶくぶく\nぶっくぶく〜',
    text_en: 'Bubbling bubbling bub bubbling',
    type: 'conversational',
    next_script_id: 'crab_044_02',
  },
  {
    id: 'crab_044_02',
    animation: 'play',
    text_jp: 'ぶっくん、ぶっくん\nぶくぶくぶ〜',
    text_en: 'Bub bub bub bub bub bubbling',
    type: 'conversational',
  },
  {
    id: 'crab_045_01',
    move_to: 'c',
    text_jp: 'さっきちょっとだけお昼寝したから\n頭スッキリして調子いいカニ',
    text_en:
      "I took a short nap a while ago, so my head is clear and I'm feeling good.",
    type: 'conversational',
    next_script_id: 'crab_045_02',
  },
  {
    id: 'crab_045_02',
    text_jp: '睡眠って大事カニね',
    text_en: "Sleep is important, isn't it?",
    type: 'conversational',
  },
  {
    id: 'crab_046_01',
    move_to: 'c',
    animation: 'joy',
    text_jp: '誰かれかまわずハグしたいカニ！',
    text_en: 'I want to hug everyone I can!',
    type: 'conversational',
    next_script_id: 'crab_046_02',
  },
  {
    id: 'crab_046_02',
    text_jp: 'そんな気分だカニ！',
    text_en: "I'm in the mood!",
    type: 'conversational',
  },
  {
    id: 'crab_047_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{pet_name}ね',
    text_en: 'I',
    type: 'conversational',
    next_script_id: 'crab_047_02',
  },
  {
    id: 'crab_047_02',
    expression: 'happy',
    text_jp: '{player_name}のこと',
    text_en: 'LOVE',
    type: 'conversational',
    next_script_id: 'crab_047_03',
  },
  {
    id: 'crab_047_03',
    animation: 'joy',
    text_jp: '大好きカニ〜！',
    text_en: 'YOU!',
    type: 'conversational',
  },
  {
    id: 'crab_048_01',
    move_to: 'c',
    text_jp: '小さい頃はブルブルフードとか\n好きだったカニけど',
    text_en: 'When I was little, I used to love to eat Buruburu food.',
    type: 'conversational',
    next_script_id: 'crab_048_02',
  },
  {
    id: 'crab_048_02',
    text_jp: '最近はサラダのおいしさに\n目覚めたカニ！',
    text_en: "I've recently discovered how delicious salads are.",
    type: 'conversational',
    next_script_id: 'crab_048_03',
  },
  {
    id: 'crab_048_03',
    text_jp: '野菜おいしいカニ！',
    text_en: 'I love vegitables!',
    type: 'conversational',
  },
  {
    id: 'crab_049_01',
    expression: 'sad',
    move_to: 'c',
    text_jp:
      '{pet_name}ね、\nちょいちょい自分の泡で\nびちょびちょになりがちカニ',
    text_en: 'I tend to get soaked in my own bubbles every now and then.',
    type: 'conversational',
    next_script_id: 'crab_049_02',
  },
  {
    id: 'crab_049_02',
    text_jp: 'ちょいちょいお風呂に\n入れてくれると\nうれしいカニ！',
    text_en: 'It would be nice if you could give me a bath every now and then.',
    type: 'conversational',
  },
  {
    id: 'crab_050_01',
    move_to: 'c',
    text_jp: '世界三大美女の1人の楊貴妃は\nきゅうりが大好きだったカニ',
    text_en:
      "Yang Guifei, one of the world's three most beautiful women, loved cucumbers.",
    type: 'conversational',
    next_script_id: 'crab_050_02',
  },
  {
    id: 'crab_050_02',
    text_jp:
      'きゅうりの汁には美容効果が\nあって、お肌をみずみずしく\nしてくれるカニ！',
    text_en:
      'Cucumber juice has a lot of beauty benefits and can make your skin feel fresh!',
    type: 'conversational',
  },
  {
    id: 'crab_051_01',
    move_to: 'c',
    text_jp:
      'おせんべいは砂糖が入ってないし\n硬くて歯にくっつきにくいから、\n虫歯になりづらいおやつカニ',
    text_en:
      "Rice crackers don't contain sugar and they are hard and don't stick to your teeth, so they are less likely to cause cavities.",
    type: 'conversational',
  },
  {
    id: 'crab_052_01',
    move_to: 'c',
    text_jp:
      '疲れ目やドライアイは、\n冷やすのではなく温めると\n筋肉がほぐれて改善されるカニ',
    text_en:
      'Warming up tired and dry eyes instead of cooling them down can help relax the muscles and improve them.',
    type: 'conversational',
    next_script_id: 'crab_052_02',
  },
  {
    id: 'crab_052_02',
    text_jp: '逆に、目の充血は\n冷やして血管を縮めた方がいいカニ',
    text_en:
      'On the other hand, bloodshot eyes should be cooled to shrink blood vessels.',
    type: 'conversational',
  },
  {
    id: 'crab_053_01',
    move_to: 'c',
    text_jp: '立っていると、カロリー消費量が\n増えてダイエット効果があるカニ',
    text_en: 'Standing increases calorie burn and helps you lose weight.',
    type: 'conversational',
    next_script_id: 'crab_053_02',
  },
  {
    id: 'crab_053_02',
    text_jp: '座っているときより体への負担も\n少ないらしいカニよ',
    text_en:
      'It is said that standing is less stressful on the body than sitting.',
    type: 'conversational',
  },
  {
    id: 'crab_054_01',
    move_to: 'c',
    text_jp: 'チョコレートには疲労回復や\n殺菌効果があるカニ',
    text_en: 'Chocolate has anti-fatigue and antibacterial properties.',
    type: 'conversational',
    next_script_id: 'crab_054_02',
  },
  {
    id: 'crab_054_02',
    text_jp: '昔はお菓子じゃなくて薬として\n飲まれていたらしいカニよ',
    text_en:
      'I heard that in the past, people used to take it as medicine, not as candy.',
    type: 'conversational',
  },
  {
    id: 'crab_055_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nカラオケで最初に歌うタイプカニ？',
    text_en: 'Are you the type of person who sings first at karaoke?',
    type: 'selectional',
    answer_var: 'first_in_karaoke',
    option_1_jp: '最初に歌う',
    option_1_en: 'Sing first',
    option_2_jp: '様子を見る',
    option_2_en: 'Follow others',
    next_script_id: 'crab_055_02',
  },
  {
    id: 'crab_055_02',
    text_jp: '{pet_name}は、\nだいたい3番目くらいに\nこっそり入れるカニ',
    text_en: "I'm usually the third one to sneak in a song.",
    type: 'conversational',
  },
  {
    id: 'crab_056_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n夏と冬、どっちが好きカニ？',
    text_en: 'Which do you like better, summer or winter?',
    type: 'selectional',
    answer_var: 'summer_or_winter',
    option_1_jp: '夏',
    option_1_en: 'Summer',
    option_2_jp: '冬',
    option_2_en: 'Winter',
    next_script_id: 'crab_056_02',
  },
  {
    id: 'crab_056_02',
    text_jp: '{pet_name}は、\n暑い夏の日には冬が恋しくなるし',
    text_en: 'I miss winter on hot summer days.',
    type: 'conversational',
    next_script_id: 'crab_056_03',
  },
  {
    id: 'crab_056_03',
    text_jp: '寒い冬の日には\n夏が恋しくなるカニ',
    text_en: 'Cold winter days make me miss summer.',
    type: 'conversational',
  },
  {
    id: 'crab_057_01',
    move_to: 'c',
    text_jp: 'じゃんけんするカニ？\nじゃんけん！',
    text_en: 'Rock, paper, scissors? Rock, paper, scissors!',
    type: 'selectional',
    answer_var: 'rock_paper_scissors',
    option_1_jp: 'グー',
    option_1_en: 'Rock',
    option_2_jp: 'チョキ',
    option_2_en: 'Scissors',
    option_3_jp: 'パー',
    option_3_en: 'Paper',
    case: 'rock_paper_scissors',
    next_script_id_1: 'crab_057_02',
    next_script_id_2: 'crab_057_04',
    next_script_id_3: 'crab_057_04',
  },
  {
    id: 'crab_057_02',
    expression: 'happy',
    text_jp: '{pet_name}が、\nチョキ出すと思ったカニ？',
    text_en: "You thought I was gonna give you shissors, didn't you?",
    type: 'conversational',
    next_script_id: 'crab_057_03',
  },
  {
    id: 'crab_057_03',
    animation: 'cry',
    text_jp: '当たりだカニ…\nシクシク',
    text_en: 'You were right...',
    type: 'conversational',
  },
  {
    id: 'crab_057_04',
    animation: 'surprised',
    text_jp: '{pet_name}が、\nチョキを出すと分かっていて…',
    text_en:
      "Did you deliberately give that because you knew I'd give you scissors?",
    type: 'conversational',
    next_script_id: 'crab_057_05',
  },
  {
    id: 'crab_057_05',
    expression: 'happy',
    text_jp: '優しいカニね！',
    text_en: 'You are so nice!',
    type: 'conversational',
  },
  {
    id: 'crab_058_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nコーヒーと紅茶\nどっちが好きカニ？',
    text_en: 'Which do you like better, coffer or tea?',
    type: 'selectional',
    answer_var: 'coffee_or_tea',
    option_1_jp: 'コーヒー',
    option_1_en: 'Coffee',
    option_2_jp: '紅茶',
    option_2_en: 'Tea',
    next_script_id: 'crab_058_02',
  },
  {
    id: 'crab_058_02',
    expression: 'sad',
    text_jp: '{pet_name}は、\n水しか飲めないカニ…',
    text_en: "I can't drink either...",
    type: 'conversational',
  },
  {
    id: 'crab_059_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n風邪をひいたら\nどうやって治すカニ？',
    text_en: 'How do you get over a cold?',
    type: 'descriptive',
    answer_var: 'cure_cold',
    question_jp: '風邪の治し方',
    question_en: 'How to get over a cold',
    max_len: 14,
    next_script_id: 'crab_059_02',
  },
  {
    id: 'crab_059_02',
    text_jp: '{pet_name}は、\n水分とってひたすら寝るカニ',
    text_en: 'I just drink water and sleep a lot.',
    type: 'conversational',
  },
  {
    id: 'crab_060_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nどんな音楽をよく聴くカニ？',
    text_en: 'What kind of music do you like?',
    type: 'descriptive',
    answer_var: 'favorite_music',
    question_jp: 'よく聴く音楽',
    question_en: 'Favorite music',
    max_len: 14,
    next_script_id: 'crab_060_02',
  },
  {
    id: 'crab_060_02',
    text_jp: '{pet_name}は\n最近80年代歌謡にこってるカニ',
    text_en: "I'm a sucker for 80's songs these days.",
    type: 'conversational',
  },
  {
    id: 'crab_061_01',
    move_to: 'c',
    text_jp: '足がしびれたときの治し方\n知ってるカニ？',
    text_en: 'Do you know how to fix a numb foot?',
    type: 'selectional',
    answer_var: 'heal_numb_feet',
    option_1_jp: '足をにぎる',
    option_1_en: 'Massage feet',
    option_2_jp: '足を冷やす',
    option_2_en: 'Cool feet',
    next_script_id: 'crab_061_02',
  },
  {
    id: 'crab_061_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    text_en_alt: 'The answer is...',
    type: 'conversational',
    next_script_id: 'crab_061_03',
  },
  {
    id: 'crab_061_03',
    text_jp: '「足をにぎる」カニ！',
    text_en: 'Massage feet!',
    type: 'conversational',
    next_script_id: 'crab_061_04',
  },
  {
    id: 'crab_061_04',
    expression: 'happy',
    text_jp: '足をにぎって血行を良くしてやると\nしびれが治るカニ！',
    text_en:
      "Clench your legs to get the circulation going and that'll cure the numbness!",
    type: 'conversational',
    next_script_id: 'crab_061_05',
  },
  {
    id: 'crab_061_05',
    animation: 'anxious',
    text_jp: '足がしびれているのに足をにぎるの\nけっこうつらいカニけどね',
    text_en:
      "It's pretty hard to hold on to your legs when they're numb, though.",
    type: 'conversational',
  },
  {
    id: 'crab_062_01',
    move_to: 'c',
    text_jp: '夏、寝ている間にかく汗の量は\nどのくらいか知ってるカニ？',
    text_en: 'In the summer, do you know how much you sweat while you sleep?',
    type: 'selectional',
    answer_var: 'sweat_amount',
    option_1_jp: '紙コップ1杯分',
    option_1_en: 'One Paper cup',
    option_2_jp: '500mlボトル1本分',
    option_2_en: 'One 500ml bottle',
    option_3_jp: '一升瓶1本分',
    option_3_en: 'One liter bottle',
    next_script_id: 'crab_062_02',
  },
  {
    id: 'crab_062_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_062_03',
  },
  {
    id: 'crab_062_03',
    text_jp: '「500mlボトル1本分」カニ！',
    text_en: 'One 500ml bottle',
    type: 'conversational',
    next_script_id: 'crab_062_04',
  },
  {
    id: 'crab_062_04',
    text_jp: '寝る前によく水分を\nとることが大切カニ！',
    text_en: "It's important to drink water well before bed!",
    text_en_alt: "It's important to drink water well before going to bed!",
    type: 'conversational',
  },
  {
    id: 'crab_063_01',
    move_to: 'c',
    text_jp:
      'おなかの調子を良くする善玉菌を\n増やすのに良い食べものは\nどれか分かるカニ？',
    text_en:
      'Can you tell me which foods are good for increasing good bacteria for tummy health?',
    type: 'selectional',
    answer_var: 'food_for_good_bacteria',
    option_1_jp: '枝豆',
    option_1_en: 'Edamame',
    option_2_jp: '豚肉',
    option_2_en: 'Pork',
    option_3_jp: 'キムチ',
    option_3_en: 'Kimchi',
    next_script_id: 'crab_063_02',
  },
  {
    id: 'crab_063_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'crab_063_03',
  },
  {
    id: 'crab_063_03',
    text_jp: '「キムチ」カニ！',
    text_en: 'Kimchi!',
    type: 'conversational',
    next_script_id: 'crab_063_04',
  },
  {
    id: 'crab_063_04',
    text_jp: '他にも、納豆やヨーグルト、\nおつけものなどが良いカニ！',
    text_en: 'Other good ones are natto, yogurt, and pickles!',
    type: 'conversational',
  },
  {
    id: 'crab_064_01',
    move_to: 'c',
    text_jp: 'ちょっとおなかが\nすいてきた気がするカニ〜',
    text_en: "I think I'm getting a little hungry.",
    type: 'conversational',
    next_script_id: 'crab_064_02',
  },
  {
    id: 'crab_064_02',
    expression: 'sad',
    text_jp: 'ごはん、まだカニ？',
    text_en: 'Is the food ready yet?',
    type: 'conversational',
  },
  {
    id: 'crab_065_01',
    move_to: 'c',
    text_jp: 'まだカニ〜\nまだカニ〜',
    text_en: 'Not yet? Not yet?',
    type: 'conversational',
    next_script_id: 'crab_065_02',
  },
  {
    id: 'crab_065_02',
    text_jp: '今日のごはんは何カニね〜？\n楽しみカニ〜',
    text_en: "What's for dinner today? I'm looking forward to it.",
    type: 'conversational',
  },
  {
    id: 'crab_066_01',
    move_to: 'c',
    text_jp: 'ううう…\nおなかがすいて倒れちゃうカニ',
    text_en: "I'm going to collapse from hunger.",
    type: 'conversational',
    next_script_id: 'crab_066_02',
  },
  {
    id: 'crab_066_02',
    animation: 'cry',
    text_jp: '何でもいいから\n食べさせてほしいカニ…',
    text_en: 'Please feed me anything.',
    type: 'conversational',
  },
  {
    id: 'crab_067_01',
    move_to: 'c',
    text_jp: 'ううう〜\n空腹マックスカニ〜',
    text_en: "I'm super hungry...",
    type: 'conversational',
    next_script_id: 'crab_067_02',
  },
  {
    id: 'crab_067_02',
    animation: 'cry',
    text_jp: '今ならゴムタイヤでも\nおいしく食べられる気がするカニ',
    text_en: 'Now I feel I could eat a rubber tire.',
    type: 'conversational',
  },
  {
    id: 'crab_068_01',
    move_to: 'c',
    text_jp: '頭が泡でブクブクになってきたカニ',
    text_en: 'My head is getting all bubbly.',
    type: 'conversational',
    next_script_id: 'crab_068_02',
  },
  {
    id: 'crab_068_02',
    text_jp: 'そろそろお風呂に\n入ってもいい頃カニ',
    text_en: "It's time to take a bath.",
    type: 'conversational',
  },
  {
    id: 'crab_069_01',
    move_to: 'c',
    text_jp: 'いつもキレイにしてないと\n病気になっちゃうカニよ',
    text_en: "If you don't keep me clean, I'll get sick.",
    type: 'conversational',
    next_script_id: 'crab_069_02',
  },
  {
    id: 'crab_069_02',
    text_jp: 'お風呂入りたいカニね〜',
    text_en: 'I want to take a bath...',
    type: 'conversational',
  },
  {
    id: 'crab_070_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'なんか自分がくさいカニ',
    text_en: 'I feel like I stink.',
    type: 'conversational',
    next_script_id: 'crab_070_02',
  },
  {
    id: 'crab_070_02',
    text_jp: '早くお風呂入れて欲しいカニ',
    text_en: "I can't wait to take a bath.",
    type: 'conversational',
  },
  {
    id: 'crab_071_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '自分史上一二を争う不潔さカニ',
    text_en: "Now I'm the dirtiest in my life",
    type: 'conversational',
    next_script_id: 'crab_071_02',
  },
  {
    id: 'crab_071_02',
    text_jp: 'お…ふ…ろ…',
    text_en: 'B...a...th...',
    type: 'conversational',
  },
  {
    id: 'crab_072_01',
    move_to: 'c',
    text_jp: '{player_name}と\nもっとあそびたいカニ〜',
    text_en: 'I want to play with you more.',
    type: 'conversational',
    next_script_id: 'crab_072_02',
  },
  {
    id: 'crab_072_02',
    text_jp: 'おもちゃであそんで欲しいカニ！',
    text_en: 'I want to play with your toys.',
    type: 'conversational',
  },
  {
    id: 'crab_073_01',
    move_to: 'c',
    text_jp: '{pet_name}ね、\n愛されてる実感が欲しいカニ',
    text_en: 'I want to feel loved',
    type: 'conversational',
    next_script_id: 'crab_073_02',
  },
  {
    id: 'crab_073_02',
    expression: 'normal',
    text_jp: '具体的には、おやつが食べたいカニ',
    text_en: 'Specifically, I want a snack.',
    type: 'conversational',
  },
  {
    id: 'crab_074_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '{pet_name}は、\nいらない子なのカニ？',
    text_en: 'Am I an unwanted child?',
    type: 'conversational',
    next_script_id: 'crab_074_02',
  },
  {
    id: 'crab_074_02',
    text_jp: 'もっと一緒にあそんで欲しいカニ…',
    text_en: 'I want you to play with me more.',
    type: 'conversational',
    next_script_id: 'crab_074_03',
  },
  {
    id: 'crab_074_03',
    animation: 'cry',
    text_jp: 'あんまりさみしいと\n病気になっちゃうカニ…',
    text_en: "If I get too lonely, I'll get sick.",
    type: 'conversational',
  },
  {
    id: 'crab_075_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'さみしいよ〜\nさみしいよ〜\nシクシク…',
    text_en: 'I feel lonely very much.',
    type: 'conversational',
    next_script_id: 'crab_075_02',
  },
  {
    id: 'crab_075_02',
    text_jp: 'おもちゃであそんで欲しいカニよ〜',
    text_en: 'I want to play with your toys.',
    type: 'conversational',
    next_script_id: 'crab_075_03',
  },
  {
    id: 'crab_075_03',
    animation: 'cry',
    text_jp: 'あんまりさみしいと\n病気になっちゃうカニ…',
    text_en: "If I get too lonely, I'll get sick.",
    type: 'conversational',
  },
  {
    id: 'crab_076_01',
    move_to: 'c',
    text_jp: 'そろそろトイレ行っておいた方が\nいいみたいカニ',
    text_en: "I think it's time to go to the bathroom.",
    type: 'conversational',
  },
  {
    id: 'crab_077_01',
    move_to: 'c',
    text_jp: 'トイレがまんし過ぎると\n病気になっちゃうカニ',
    text_en: 'I get sick if I hold back too long from going to the bathroom.',
    type: 'conversational',
    next_script_id: 'crab_077_02',
  },
  {
    id: 'crab_077_02',
    animation: 'cry',
    text_jp: 'そろそろトイレ行かせて欲しいカニ',
    text_en: 'I need to go to the bathroom soon',
    type: 'conversational',
  },
  {
    id: 'crab_078_01',
    move_to: 'c',
    text_jp: 'トイレがかなり限界に近いカニ…',
    text_en: "I can't hold it any more...",
    type: 'conversational',
    next_script_id: 'crab_078_02',
  },
  {
    id: 'crab_078_02',
    text_jp: 'はやく…トイレに…',
    text_en: 'I have to go to the...',
    type: 'conversational',
  },
  {
    id: 'crab_079_01',
    move_to: 'c',
    text_jp: 'これはもう\nいつ漏れてもおかしくないカニ…',
    text_en: 'It could leak at any moment...',
    type: 'conversational',
    next_script_id: 'crab_079_02',
  },
  {
    id: 'crab_079_02',
    text_jp: 'はやく…トイレに…',
    text_en: 'I have to go to the...',
    type: 'conversational',
  },
  {
    id: 'crab_080_01',
    move_to: 'c',
    text_jp: 'いま、こわい夢見たカニ！\nううう〜。こわいカニ〜',
    text_en: 'I just had a scary dream! Uu~. Scary!',
    type: 'conversational',
    next_script_id: 'crab_080_02',
  },
  {
    id: 'crab_080_02',
    text_jp: '何かで気を紛らわせて欲しいカニ〜',
    text_en: 'I need something to take my mind off of it.',
    type: 'conversational',
    next_script_id: 'crab_080_03',
  },
  {
    id: 'crab_080_03',
    animation: 'cry',
    text_jp: 'お風呂やトイレに行けないカニ〜',
    text_en: 'Cannot go to the bathroom or toilet',
    type: 'conversational',
  },
  {
    id: 'crab_081_01',
    move_to: 'c',
    text_jp: 'そこの壁のシミがこわいカニ！\nこわいカニ〜',
    text_en: 'That stain on the wall over there is scary!',
    type: 'conversational',
    next_script_id: 'crab_081_02',
  },
  {
    id: 'crab_081_02',
    text_jp: '何かで気を紛らわせて欲しいカニ〜',
    text_en: 'I need something to take my mind off of it.',
    type: 'conversational',
    next_script_id: 'crab_081_03',
  },
  {
    id: 'crab_081_03',
    animation: 'cry',
    text_jp: 'お風呂やトイレに行けないカニ〜',
    text_en: 'Cannot go to the bathroom or toilet',
    type: 'conversational',
  },
  {
    id: 'crab_082_01',
    move_to: 'c',
    text_jp: 'ちょっとおなかいたいカニ〜\nお菓子拾い食いしたからカニ？',
    text_en:
      "I'm a little sick to my stomach. Is it because I picked up some snacks and ate them?",
    type: 'conversational',
    next_script_id: 'crab_082_02',
  },
  {
    id: 'crab_082_02',
    animation: 'cry',
    text_jp: 'おクスリ飲ませて欲しいカニ〜',
    text_en: 'I want you to give me a medicine.',
    type: 'conversational',
  },
  {
    id: 'crab_083_01',
    move_to: 'c',
    text_jp: 'う〜ん。こんなにおなかいたいの\n初めてカニ〜',
    text_en: "Hmmm... I've never felt this sick to my stomach before.",
    type: 'conversational',
    next_script_id: 'crab_083_02',
  },
  {
    id: 'crab_083_02',
    animation: 'cry',
    text_jp: 'おクスリ飲ませて欲しいカニ〜',
    text_en: 'I want you to give me a medicine.',
    type: 'conversational',
  },
  {
    id: 'crab_084_01',
    move_to: 'c',
    text_jp: 'あーん。歯がいたいカニ〜\nいたいカニ〜',
    text_en: 'Ahh... My teeth hurt. They really hurt!',
    type: 'conversational',
    next_script_id: 'crab_084_02',
  },
  {
    id: 'crab_084_02',
    animation: 'cry',
    text_jp: '痛くて何も食べられないカニ〜',
    text_en: "It hurts so much I can't eat anything.",
    type: 'conversational',
  },
  {
    id: 'crab_085_01',
    move_to: 'c',
    text_jp: 'これが虫歯ってやつなのカニ？',
    text_en: 'Is this what you call a cavity?',
    type: 'conversational',
    next_script_id: 'crab_085_02',
  },
  {
    id: 'crab_085_02',
    text_jp: 'おやつは当分がまんするから\n治して欲しいカニ〜',
    text_en:
      "I'm going to hold off on the snacks for the time being, so please fix this.",
    type: 'conversational',
    next_script_id: 'crab_085_03',
  },
  {
    id: 'crab_085_03',
    animation: 'cry',
    text_jp: '痛くて何も食べられないカニ〜',
    text_en: "It hurts so much I can't eat anything.",
    type: 'conversational',
  },
  {
    id: 'crab_086_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '寝不足はお肌の敵カニよ\nもう寝るカニ〜',
    text_en: "Lack of sleep is the enemy of your skin. I'm going to bed now.",
    type: 'conversational',
  },
  {
    id: 'crab_087_01',
    move_to: 'c',
    text_jp: 'あれあれ？\nからだがムズムズしてきたカニよ',
    text_en: "What's this? My body is getting all mushy",
    type: 'conversational',
  },
  {
    id: 'crab_088_01',
    move_to: 'c',
    text_jp: 'しんじゃったカニ…',
    text_en: "I'm dead...",
    type: 'conversational',
    next_script_id: 'crab_088_02',
  },
  {
    id: 'crab_088_02',
    text_jp: '{player_name}と\n一緒にいられて、本当に\n楽しかったカニ…',
    text_en: 'It was really fun to be with you...',
    type: 'conversational',
    next_script_id: 'crab_088_03',
  },
  {
    id: 'crab_088_03',
    text_jp:
      '今までたくさん優しくしてくれて、\nどうもありがとうカニ。\nまたいつか会えたらうれしいカニ',
    text_en:
      'Thank you for all of your kindness. I hope to see you again someday',
    type: 'conversational',
  },
  {
    id: 'crab_089_01',
    move_to: 'c',
    text_jp: 'あっ\nこれは、本当にヤバイやつカニ\nほっといたらしぬやつカニ',
    text_en: 'Hey, I might be dying seriously...',
    type: 'conversational',
    next_script_id: 'crab_089_02',
  },
  {
    id: 'crab_089_02',
    text_jp: '万能コロンを\nシュッシュして欲しいカニ…',
    text_en: 'Please use Magic Potion for me...',
    type: 'conversational',
  },
  {
    id: 'crab_090_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'おでかけしたいカニ〜',
    text_en: 'Hey, I want to go out!',
    type: 'conversational',
    next_script_id: 'crab_090_02',
  },
  {
    id: 'crab_090_02',
    expression: 'happy',
    text_jp: 'お友だちとお風呂でブクブク\nあわあわしたいカニ〜',
    text_en: 'I want to play with bubbles in the bath with my friends',
    type: 'conversational',
  },
  {
    id: 'crab_091_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'さっき、\n{friend.player_name}が\nあそびに来てくれたカニよ',
    text_en: '{friend.player_name} came to play with me just now.',
    type: 'conversational',
    next_script_id: 'crab_091_02',
  },
  {
    id: 'crab_091_02',
    expression: 'happy',
    text_jp:
      '{player_name}にも\n会いたがってたカニ\n今度一緒にあそびに行くカニ！',
    text_en: "They wanted to see you too. Let's visit them next time!",
    type: 'conversational',
  },
  {
    id: 'crab_092_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\n雨の日の過ごし方を聞いたら、\n何て言ってたと思うカニ？',
    text_en: 'When I asked {friend.player_name} how they spend a rainy day,',
    type: 'conversational',
    next_script_id: 'crab_092_02',
  },
  {
    id: 'crab_092_02',
    text_jp:
      '{friend.rainy_day_activity}\nだって！\nなかなかロマンチックカニよね〜',
    text_en:
      'They were saying "{friend.rainy_day_activity}" \nIsn\'t it romantic?',
    type: 'conversational',
  },
  {
    id: 'crab_093_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}の\n小さい頃のあだ名は、\n{friend.childhood_nickname}',
    text_en:
      "{friend.player_name}'s childfood nickname was {friend.childhood_nickname}",
    type: 'conversational',
    case: 'friend.childhood_nickname',
    next_script_id_1: 'crab_093_02',
    next_script_id_2: 'crab_093_03',
  },
  {
    id: 'crab_093_02',
    expression: 'happy',
    text_jp:
      '本人もけっこう気に入ってた\nみたいカニよ\n今度呼んでみたらどうカニ？',
    text_en:
      "Looks like they liked it. Let's call them by the nickname next time!",
    type: 'conversational',
  },
  {
    id: 'crab_093_03',
    expression: 'normal',
    text_jp:
      'でも、本人はあまり気に入って\nなかったみたいカニから、呼ぶのは\nやめた方がいいかもカニ',
    text_en:
      "But it seems they didn't like it very much. Better not to call them by it.",
    type: 'conversational',
  },
  {
    id: 'crab_094_01',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n特技を聞いたら、なんと！',
    text_en: "{friend.player_name}'s special skill is",
    type: 'conversational',
    next_script_id: 'crab_094_02',
  },
  {
    id: 'crab_094_02',
    expression: 'happy',
    text_jp: '{friend.speciality}\nだそうカニ！\n人は見かけによらないカニね！',
    text_en: '{friend.speciality}! People are not what they seem, right?',
    type: 'conversational',
  },
  {
    id: 'crab_095_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n最近読んだ面白い本を聞いたら、',
    text_en: 'When I asked {friend.player_name} for a recommended book,',
    type: 'conversational',
    next_script_id: 'crab_095_02',
  },
  {
    id: 'crab_095_02',
    text_jp:
      '{friend.interesting_book}\nって言ってたカニ\n読んだことあるカニ？',
    text_en:
      'they were saying {friend.interesting_book}. Have you ever read it?',
    type: 'conversational',
  },
  {
    id: 'crab_096_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n健康のために心がけていることを\n聞いたら、',
    text_en: 'When I asked {friend.player_name} what they do for their health,',
    type: 'conversational',
    next_script_id: 'crab_096_02',
  },
  {
    id: 'crab_096_02',
    text_jp: '{friend.health_tips}\nって言ってたカニ！',
    text_en: 'they were saying {friend.health_tips}!',
    type: 'conversational',
    next_script_id: 'crab_096_03',
  },
  {
    id: 'crab_096_03',
    text_jp: '{player_name}も\n真似するといいカニ！',
    text_en: 'You should do that too!',
    type: 'conversational',
  },
  {
    id: 'crab_097_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n将来の夢を聞いたら、',
    text_en: 'When I asked {friend.player_name} about their dream,',
    type: 'conversational',
    next_script_id: 'crab_097_02',
  },
  {
    id: 'crab_097_02',
    animation: 'surprised',
    text_jp: '{friend.future_dream}\nって言ってたカニ！',
    text_en: 'they were saying {friend.future_dream}!',
    type: 'conversational',
    next_script_id: 'crab_097_03',
  },
  {
    id: 'crab_097_03',
    text_jp: '意外に野心家なところあるカニね！',
    text_en: 'They are surprisingly ambitious!',
    type: 'conversational',
  },
  {
    id: 'crab_098_01',
    move_to: 'c',
    text_jp: '{friend.player_name}が\n生きてて良かったって思う瞬間は',
    text_en: "{friend.player_name}'s happiest moment is...",
    type: 'conversational',
    next_script_id: 'crab_098_02',
  },
  {
    id: 'crab_098_02',
    text_jp: '{friend.happy_moment}\nだそうカニ！\n納得感あるカニ？',
    text_en: "{friend.happy_moment}! Isn't it understandable?",
    type: 'conversational',
  },
  {
    id: 'crab_099_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n何歳ごろに戻りたいか聞いたら\n何て言ってたと思うカニ？',
    text_en:
      'Can you guess to how many years old {friend.player_name} wants to go back?',
    type: 'conversational',
    next_script_id: 'crab_099_02',
  },
  {
    id: 'crab_099_02',
    animation: 'surprised',
    text_jp: 'なんと、\n{friend.how_old_to_go_back}\nって言ってたカニ！',
    text_en: 'They were saying {friend.how_old_to_go_back}!',
    type: 'conversational',
    next_script_id: 'crab_099_03',
  },
  {
    id: 'crab_099_03',
    text_jp: 'その頃に、人生における重大な\n何かがあったに違いないカニ！',
    text_en: 'I guess something important happened to them around that time!',
    type: 'conversational',
  },
  {
    id: 'crab_100_01',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n風邪を引いたときの治し方は',
    text_en: 'The way {friend.player_name} cures their cold is',
    type: 'conversational',
    next_script_id: 'crab_100_02',
  },
  {
    id: 'crab_100_02',
    text_jp: '{friend.cure_cold}\nだそうカニ！\n安静にするのが一番カニ！',
    text_en: "{friend.cure_cold}! I think it's best to rest.",
    type: 'conversational',
  },
  {
    id: 'crab_101_01',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n好きな音楽は、',
    text_en: "{friend.player_name}'s favorite music is",
    type: 'conversational',
    next_script_id: 'crab_101_02',
  },
  {
    id: 'crab_101_02',
    text_jp:
      '{friend.favorite_music}\nだそうカニ！\nなかなか良い趣味してるカニよね？',
    text_en: '{friend.favorite_music}! They have a pretty good taste!',
    type: 'conversational',
  },
  {
    id: 'crab_102_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n長距離走と短距離走だと',
    text_en:
      'Between long-distance and short-distance running, {friend.player_name} is good at',
    type: 'conversational',
    case: 'friend.long_run_or_short_run',
    next_script_id_1: 'crab_102_02',
    next_script_id_2: 'crab_102_04',
  },
  {
    id: 'crab_102_02',
    text_jp: '長距離走の方が得意らしいカニよ',
    text_en: 'long-distance running!',
    type: 'conversational',
    next_script_id: 'crab_102_03',
  },
  {
    id: 'crab_102_03',
    animation: 'play',
    text_jp:
      'まっすぐ走るだけでも難しいのに、\nたくさん走れるなんてすごいカニ！',
    text_en:
      "It's hard enough just to run straight, but to be able to run a long distance is amazing!",
    type: 'conversational',
  },
  {
    id: 'crab_102_04',
    text_jp: '短距離走の方が得意らしいカニよ。',
    text_en: 'short-distance running!',
    type: 'conversational',
    next_script_id: 'crab_102_05',
  },
  {
    id: 'crab_102_05',
    animation: 'play',
    text_jp: 'まっすぐ走るだけでも難しいのに、\n速く走れるなんてすごいカニ！',
    text_en:
      "It's hard enough just to run straight, but to be able to run fast is amazing!",
    type: 'conversational',
  },
  {
    id: 'crab_103_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n一生太らない体と一生荒れないお肌\nどっちが欲しいか聞いたら、',
    text_en:
      'When I asked {friend.player_name} if they would rather have a body that will never get fat or skin that will never get rough,',
    type: 'conversational',
    case: 'friend.no_fat_or_good_skin',
    next_script_id_1: 'crab_103_02',
    next_script_id_2: 'crab_103_04',
  },
  {
    id: 'crab_103_02',
    text_jp: '一生太らない体が欲しいって\n言ってたカニ！',
    text_en: 'they were saying they wanted a body that will never get fat!',
    type: 'conversational',
    next_script_id: 'crab_103_03',
  },
  {
    id: 'crab_103_03',
    animation: 'joy',
    text_jp: '{pet_name}も\n体重を気にせずに暴飲暴食\nしたいカニ〜！',
    text_en:
      'I too would like to drink and eat without worrying about my weight!',
    type: 'conversational',
  },
  {
    id: 'crab_103_04',
    text_jp: '一生荒れないお肌が欲しいって\n言ってたカニ！',
    text_en: 'they were saying they wanted skin that will never get rough!',
    type: 'conversational',
    next_script_id: 'crab_103_05',
  },
  {
    id: 'crab_103_05',
    animation: 'joy',
    text_jp:
      '{pet_name}も、\n肌荒れを気にせずに自堕落な\n生活を送りたいカニ〜！',
    text_en:
      'I too would like to live a self-indulgent life without worrying about skin problems!',
    type: 'conversational',
  },
  {
    id: 'crab_104_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n体育と音楽どっちが好きだったか\n聞いたカニけど、',
    text_en:
      'When I asked {friend.player_name} which they liked better, PE or music,',
    type: 'conversational',
    case: 'friend.pe_or_music',
    next_script_id_1: 'crab_104_02',
    next_script_id_2: 'crab_104_04',
  },
  {
    id: 'crab_104_02',
    text_jp: '体育が好きだったって\n言ってたカニ！',
    text_en: 'they answered PE!',
    type: 'conversational',
    next_script_id: 'crab_104_03',
  },
  {
    id: 'crab_104_03',
    text_jp: '活発なお子さんだったのカニね！',
    text_en: 'They must have been active kids!',
    type: 'conversational',
  },
  {
    id: 'crab_104_04',
    text_jp: '音楽が好きだったって\n言ってたカニ！',
    text_en: 'thye answered music!',
    type: 'conversational',
    next_script_id: 'crab_104_05',
  },
  {
    id: 'crab_104_05',
    text_jp: '今度何か歌ってもらおうカニかね？',
    text_en: "Let's ask them to sing a song next time.",
    type: 'conversational',
  },
  {
    id: 'crab_105_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\nプレゼントするのとされるのだと、',
    text_en:
      'Between giving a present or being givne a present, {friend.player_name} prefers',
    type: 'conversational',
    case: 'friend.give_or_given',
    next_script_id_1: 'crab_105_02',
    next_script_id_2: 'crab_105_04',
  },
  {
    id: 'crab_105_02',
    text_jp: 'プレゼントする方が好きだって\n言ってたカニ！',
    text_en: 'giving a present!',
    type: 'conversational',
    next_script_id: 'crab_105_03',
  },
  {
    id: 'crab_105_03',
    animation: 'play',
    text_jp: '今度一緒に何か\nおねだりしてみるカニ？',
    text_en: "Let's ask them to give us something next time!",
    type: 'conversational',
  },
  {
    id: 'crab_105_04',
    text_jp: 'プレゼントされる方が好きだって\n言ってたカニ！',
    text_en: 'being given a present!',
    type: 'conversational',
    next_script_id: 'crab_105_05',
  },
  {
    id: 'crab_105_05',
    animation: 'play',
    text_jp: '今度一緒に何か\nプレゼントしてみるカニ？',
    text_en: "Let's give them a present together next time!",
    type: 'conversational',
  },
  {
    id: 'crab_106_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\n頭と体、お風呂でどっちから\n先に洗うか聞いたら、',
    text_en:
      'When I asked {friend.player_name} which they wash first at a bath, head or body,',
    type: 'conversational',
    next_script_id: 'crab_106_02',
  },
  {
    id: 'crab_106_02',
    animation: 'waive',
    text_jp:
      '{friend.head_or_body}から洗うって\n言ってたカニ！\n{pet_name}と同じカニ！',
    text_en: 'they were saying {friend.head_or_body}! Same as me!',
    type: 'conversational',
  },
  {
    id: 'crab_107_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nブロッコリーの茎を食べるかどうか\n聞いたら、',
    text_en:
      'When I asked {friend.player_name} if they eat broccoli stems, they were saying',
    type: 'conversational',
    case: 'friend.eat_or_not_eat_broccoli',
    next_script_id_1: 'crab_107_02',
    next_script_id_2: 'crab_107_04',
  },
  {
    id: 'crab_107_02',
    text_jp: 'ブロッコリーは茎までちゃんと\n食べるって言ってたカニ！',
    text_en: 'they eat broccoli stems!',
    type: 'conversational',
    next_script_id: 'crab_107_03',
  },
  {
    id: 'crab_107_03',
    animation: 'joy',
    text_jp: 'ブロッコリーは茎に栄養があるって\nちゃんと分かってて偉いカニ！',
    text_en: "It's good they know broccoli stems are full of nutrients!",
    type: 'conversational',
  },
  {
    id: 'crab_107_04',
    text_jp: 'ブロッコリーの茎は食べないって\n言ってたカニ！',
    text_en: "they dont' eat broccoli stems!",
    type: 'conversational',
    next_script_id: 'crab_107_05',
  },
  {
    id: 'crab_107_05',
    animation: 'angry',
    text_jp:
      'もったいないことこの上ないカニ！\n{player_name}からも\n言ってやって欲しいカニ！',
    text_en: "It's really a waste! Please say somethign to them!",
    type: 'conversational',
  },
  {
    id: 'crab_108_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n待ち合わせすると',
    text_en: 'When {friend.player_name} meets up with someone, they tend to',
    type: 'conversational',
    case: 'friend.wait_or_make_wait',
    next_script_id_1: 'crab_108_02',
    next_script_id_2: 'crab_108_04',
  },
  {
    id: 'crab_108_02',
    text_jp: '待つことの方が多いらしいカニ',
    text_en: 'wait more often than making the other person wait.',
    type: 'conversational',
    next_script_id: 'crab_108_03',
  },
  {
    id: 'crab_108_03',
    animation: 'joy',
    text_jp: '{pet_name}は\n待たせることが多いから、\nちょうどいいカニ！',
    text_en: "I tend to make the other person wait, so it's a good balance!",
    type: 'conversational',
  },
  {
    id: 'crab_108_04',
    text_jp: '待たせることの方が多いらしいカニ',
    text_en: 'make the other person wait more often than waiting for others.',
    type: 'conversational',
    next_script_id: 'crab_108_05',
  },
  {
    id: 'crab_108_05',
    animation: 'play',
    text_jp:
      '{friend.player_name}との\n待ち合わせは、少し遅れて\n行った方がいいかもカニね',
    text_en: 'It might be better to be a little late when you meet with them.',
    type: 'conversational',
  },
  {
    id: 'crab_109_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n髪型の相談をしたら、',
    text_en:
      'When I asked {friend.player_name} for advice about my hair style,',
    type: 'conversational',
    case: 'friend.long_hair_or_short_hair',
    next_script_id_1: 'crab_109_02',
    next_script_id_2: 'crab_109_04',
  },
  {
    id: 'crab_109_02',
    text_jp: 'ロングヘアを勧められたカニ！',
    text_en: 'they recommended long hair.',
    type: 'conversational',
    next_script_id: 'crab_109_03',
  },
  {
    id: 'crab_109_03',
    animation: 'surprised',
    text_jp:
      'たまには伸ばしてみても\nいいカニよね〜\nって、髪なんて無かったカニ！',
    text_en:
      "Yeah, it might be a good idea to grow hair... Oh, I didn't have hair from the beginning!",
    type: 'conversational',
  },
  {
    id: 'crab_109_04',
    text_jp: 'ショートヘアを勧められたカニ！',
    text_en: 'they recommended short hair.',
    type: 'conversational',
    next_script_id: 'crab_109_05',
  },
  {
    id: 'crab_109_05',
    animation: 'surprised',
    text_jp:
      'ショートが似合うのが本当の美人\nって言うカニよね〜\nって、髪なんて無かったカニ！',
    text_en:
      "People say a real beauty looks good with short hair.\nOh, I didn't have hair from the beginning!",
    type: 'conversational',
  },
  {
    id: 'crab_110_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\nカラオケに行くと',
    text_en: '{friend.player_name}\nseems like the type at karaoke...',
    type: 'conversational',
    case: 'friend.first_in_karaoke',
    next_script_id_1: 'crab_110_02',
    next_script_id_2: 'crab_110_04',
  },
  {
    id: 'crab_110_02',
    text_jp: '最初に歌うタイプだそうカニ！',
    text_en: 'like the type to sing first!',
    type: 'conversational',
    next_script_id: 'crab_110_03',
  },
  {
    id: 'crab_110_03',
    text_jp: '意外に度胸あるカニよね！',
    text_en: 'Pretty brave!',
    type: 'conversational',
  },
  {
    id: 'crab_110_04',
    text_jp: 'しばらく様子を見る\nタイプだそうカニ',
    text_en: 'seems like the type to wait and read the room!',
    type: 'conversational',
    next_script_id: 'crab_110_05',
  },
  {
    id: 'crab_110_05',
    text_jp: '意外としたたかなとこあるカニ！',
    text_en: 'Surprisingly patient!',
    type: 'conversational',
  },
  {
    id: 'crab_111_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n夏と冬だと',
    text_en: 'Between summer and winter, {friend.player_name}...',
    type: 'conversational',
    case: 'friend.summer_or_winter',
    next_script_id_1: 'crab_111_02',
    next_script_id_2: 'crab_111_04',
  },
  {
    id: 'crab_111_02',
    text_jp: '夏の方が好きらしいカニ！',
    text_en: 'likes summer better!',
    type: 'conversational',
    next_script_id: 'crab_111_03',
  },
  {
    id: 'crab_111_03',
    text_jp: '{pet_name}も\n砂浜で波とたわむれたいカニ〜',
    text_en: '{pet_name} wants to play at the beach, too!',
    type: 'conversational',
  },
  {
    id: 'crab_111_04',
    text_jp: '冬の方が好きらしいカニ！',
    text_en: 'likes winter better!',
    type: 'conversational',
    next_script_id: 'crab_111_05',
  },
  {
    id: 'crab_111_05',
    text_jp: '{pet_name}も\nこたつでミカンが至福カニ〜',
    text_en: '{pet_name} loves lounging with snacks near the heater.',
    type: 'conversational',
  },
  {
    id: 'crab_112_01',
    move_to: 'c',
    text_jp:
      'このまえ、\n{friend.player_name}の\nおやつをうっかり食べちゃったカニ',
    text_en:
      'A little while ago, I accidentally ate {friend.player_name}’s snack!',
    type: 'conversational',
    next_script_id: 'crab_112_02',
  },
  {
    id: 'crab_112_02',
    text_jp: '{friend.player_name}には\nナイショカニよ！',
    text_en: 'Don’t tell {friend.player_name}!',
    type: 'conversational',
  },
  {
    id: 'crab_113_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}の\n靴の中でお昼寝してたら、靴が\nアワアワになっちゃったカニ',
    text_en:
      'I took a nap in {friend.player_name}’s shoe and got it all bubbly!',
    type: 'conversational',
    next_script_id: 'crab_113_02',
  },
  {
    id: 'crab_113_02',
    text_jp: '{friend.player_name}には\nナイショカニよ！',
    text_en: 'Don’t tell {friend.player_name}!',
    type: 'conversational',
  },
  {
    id: 'crab_114_01',
    move_to: 'c',
    text_jp: 'ちょっとおっきくなったカニ！',
    text_en: 'I got a little bit bigger',
    type: 'conversational',
  },
  {
    id: 'crab_115_01',
    animation: 'waive',
    text_jp: 'あそびに来たカニ！',
    text_en: 'I’m here to play!',
    type: 'conversational',
  },
  {
    id: 'crab_116_01',
    animation: 'waive',
    text_jp: 'いらっしゃいませカニ〜！\n来てくれてうれしいカニ〜！',
    text_en: 'Welcome! \nI’m happy you’re here!',
    type: 'conversational',
  },
  {
    id: 'crab_117_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'これ、ほんの気持ちカニ…',
    text_en: 'Here’s a little thank-you…',
    type: 'conversational',
  },
  {
    id: 'crab_118_01',
    animation: 'waive',
    text_jp:
      'そろそろおいとまするカニ〜。\n今度はうちにもあそびに来て\n欲しいカニ！',
    text_en: 'Time to get going.\nCome over to my place sometime!',
    type: 'conversational',
  },
  {
    id: 'crab_119_01',
    animation: 'waive',
    text_jp: '今日は来てくれてありがとうカニ！\nまたいつでも来て欲しいカニ！',
    text_en: 'Thanks for coming today!\nCome back soon!',
    type: 'conversational',
  },
  {
    id: 'crab_120_01',
    text_jp: '{friend.player_name}が\n帰ってきたみたいカニね',
    text_en: 'Looks like {friend.player_name} is home!',
    type: 'conversational',
    next_script_id: 'crab_120_02',
  },
  {
    id: 'crab_120_02',
    animation: 'waive',
    text_jp: '今日はこのへんで帰るカニ',
    text_en: 'Time to go home for now!',
    type: 'conversational',
  },
  {
    id: 'crab_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないカニ',
    text_en: 'I’m too scared to use the bathroom!',
    type: 'conversational',
  },
  {
    id: 'crab_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないカニ',
    text_en: 'I can’t eat food or snacks because my tooth hurts!',
    type: 'conversational',
  },
  {
    id: 'crab_123_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今はつらすぎて無理カニ\n万能コロンをかけて欲しいカニ…',
    text_en: 'It’s too hard to do right now.\nI want some Magic Potion!',
    type: 'conversational',
  },
  {
    id: 'crab_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '今は何よりもおでかけしたい\n気分なのカニ〜\nおでかけさせて欲しいカニ〜',
    text_en:
      'I want to go out more than anything right now!\nWill you let me go outside?',
    type: 'conversational',
  },
  {
    id: 'crab_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったカニ！\nありがとうカニ〜',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'crab_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったカニ！\nありがとうカニ〜',
    text_en: 'My toothache is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'crab_127_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ふー。助かったカニ〜\n九死に一生カニ〜',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'crab_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったカニ…\nもう1回、試してみてくれるカニ？',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'crab_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'まだ痛いカニ\nもう1回試してみて欲しいカニ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'crab_130_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'まだ治ってないカニ〜…\nもう1回お願いするカニ〜',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'dog_001_01',
    move_to: 'c',
    text_jp: 'ん？\nお散歩行きたいヌ？',
    text_en: 'Hmm? Do you want to go for a walk?',
    type: 'conversational',
    next_script_id: 'dog_001_02',
  },
  {
    id: 'dog_001_02',
    animation: 'play',
    text_jp: '行こうヌ！行こうヌ！',
    text_en: "Let's go! Let's go!",
    type: 'conversational',
  },
  {
    id: 'dog_002_01',
    move_to: 'c',
    text_jp: '明日は晴れるヌかね〜？\n晴れたらいいな〜',
    text_en: "I wonder if it'll be sunny tomorrow. I hope so!",
    type: 'conversational',
    next_script_id: 'dog_002_02',
  },
  {
    id: 'dog_002_02',
    expression: 'happy',
    text_jp: '晴れたらお散歩行こうヌ！',
    text_en: "Let's go for a walk when the sun shines!",
    type: 'conversational',
    next_script_id: 'dog_002_03',
  },
  {
    id: 'dog_002_03',
    expression: 'normal',
    text_jp: 'ん？\n雨が降っても行くヌよ？',
    text_en: "Yes? I'll go even if it rains.",
    type: 'conversational',
  },
  {
    id: 'dog_003_01',
    move_to: 'c',
    text_jp: '{pet_name}の\n好きなものを発表するヌ！',
    text_en: "I'll tell you what I like!",
    type: 'conversational',
    next_script_id: 'dog_003_02',
  },
  {
    id: 'dog_003_02',
    expression: 'happy',
    text_jp: 'ズバリ、お散歩ヌ！',
    text_en: 'A walk in the park!',
    type: 'conversational',
    next_script_id: 'dog_003_03',
  },
  {
    id: 'dog_003_03',
    expression: 'normal',
    text_jp: '知ってたヌか？',
    text_en: 'Did you know that?',
    type: 'conversational',
  },
  {
    id: 'dog_004_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'また、お部屋を\n散らかしてしまったヌ…',
    text_en: "I've made a mess of my room again.",
    type: 'conversational',
    next_script_id: 'dog_004_02',
  },
  {
    id: 'dog_004_02',
    animation: 'anxious',
    text_jp: '{player_name}に\nしかられる前に片付けるヌ',
    text_en: 'I will clean up before {player_name} scolds me.',
    type: 'conversational',
    next_script_id: 'dog_004_03',
  },
  {
    id: 'dog_004_03',
    animation: 'joy',
    text_jp: 'あ！ボールが落ちてるヌ！\nキャンキャンキャン！',
    text_en: 'Oh! There is a ball! Yay!',
    type: 'conversational',
  },
  {
    id: 'dog_005_01',
    animation: 'waive',
    text_jp: 'ふりふり',
    text_en: 'Swing swing.',
    type: 'conversational',
    next_script_id: 'dog_005_02',
  },
  {
    id: 'dog_005_02',
    animation: 'waive',
    text_jp: 'ふりふり',
    text_en: 'Swing swing.',
    type: 'conversational',
  },
  {
    id: 'dog_006_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '雨の日は髪が\n重くなっていやヌよね',
    text_en: 'I hate rainy days because it weighs my hair down.',
    type: 'conversational',
    next_script_id: 'dog_006_02',
  },
  {
    id: 'dog_006_02',
    animation: 'surprised',
    text_jp: '湿度90%だと\n髪は1割も重くなるらしいヌ',
    text_en: 'They say that at 90% humidity, hair becomes 10% heavier.',
    type: 'conversational',
    next_script_id: 'dog_006_03',
  },
  {
    id: 'dog_006_03',
    animation: 'cry',
    text_jp: '{pet_name}は\n毛が多いから大変だヌ…',
    text_en: "I have a lot of hair, so it's hard for me.",
    type: 'conversational',
  },
  {
    id: 'dog_007_01',
    move_to: 'c',
    text_jp: '飛行機雲がすぐに消えたら\n晴れ間が続く合図ヌ',
    text_en:
      "If the plane clouds disappear quickly, it's a sign that the weather will remain clear.",
    type: 'conversational',
    next_script_id: 'dog_007_02',
  },
  {
    id: 'dog_007_02',
    text_jp: '空の湿度が低くて\n雲ができにくいってことヌ',
    text_en:
      'It means that the sky is less humid and clouds are less likely to form.',
    type: 'conversational',
    next_script_id: 'dog_007_03',
  },
  {
    id: 'dog_007_03',
    text_jp: '逆に、飛行機雲が長く残るときは\n雨が降る可能性が高いヌ',
    text_en:
      'On the other hand, when airplane clouds stay for a long time, there is a high possibility of rain.',
    type: 'conversational',
    next_script_id: 'dog_007_04',
  },
  {
    id: 'dog_007_04',
    text_jp: '覚えておくといいヌ！',
    text_en: "It's good to remember.",
    type: 'conversational',
  },
  {
    id: 'dog_008_01',
    move_to: 'c',
    text_jp: '夕焼けがきれいに見えたら\n次の日は晴れるヌ',
    text_en: 'If you see a beautiful sunset, the next day will be sunny.',
    type: 'conversational',
    next_script_id: 'dog_008_02',
  },
  {
    id: 'dog_008_02',
    text_jp: '西に雲が無いってことだヌ',
    text_en: 'That means no clouds to the west.',
    type: 'conversational',
    next_script_id: 'dog_008_03',
  },
  {
    id: 'dog_008_03',
    text_jp: '覚えておくといいヌ！',
    text_en: "It's good to remember.",
    type: 'conversational',
  },
  {
    id: 'dog_009_01',
    move_to: 'c',
    text_jp: '降水確率は四捨五入して\n表示されるヌ',
    text_en:
      'The probability of precipitation is rounded to the nearest 10 percent.',
    type: 'conversational',
    next_script_id: 'dog_009_02',
  },
  {
    id: 'dog_009_02',
    text_jp: 'だから、降水確率0%でも、\n実は4%の場合もあるヌ',
    text_en:
      'So, even if they say the probability of precipitation is 0%, it may actually be 4%.',
    type: 'conversational',
    next_script_id: 'dog_009_03',
  },
  {
    id: 'dog_009_03',
    text_jp: '油断は禁物ヌ！',
    text_en: "You can't be too careful!",
    type: 'conversational',
  },
  {
    id: 'dog_010_01',
    move_to: 'c',
    text_jp: '{pet_name}も最近\n知ったんヌけど',
    text_en: 'I recently found out that',
    type: 'conversational',
    next_script_id: 'dog_010_02',
  },
  {
    id: 'dog_010_02',
    text_jp: '「日本雨女雨男協会」\nという会があるらしいヌ',
    text_en:
      'there is a group called the "Japan Rain Women\'s and Rain Men\'s Association".',
    type: 'conversational',
    next_script_id: 'dog_010_03',
  },
  {
    id: 'dog_010_03',
    expression: 'happy',
    text_jp: '雨を降らせることなら負けない\nという人たちが集まる会らしいヌ',
    text_en: "It's a group of people who know how to make it rain.",
    type: 'conversational',
  },
  {
    id: 'dog_011_01',
    move_to: 'c',
    text_jp: '{player_name}は\n暑いのと寒いの\nどっちが好きヌ？',
    text_en: 'Do you prefer hot weather or cold weather?',
    type: 'selectional',
    answer_var: 'hot_or_cold',
    option_1_jp: '暑いの',
    option_1_en: 'hot',
    option_2_jp: '寒いの',
    option_2_en: 'cold',
    next_script_id: 'dog_011_02',
  },
  {
    id: 'dog_011_02',
    text_jp: 'へー\n{hot_or_cold}が好きなのヌね',
    text_en: 'Oh, you like {hot_or_cold} weather?',
    type: 'conversational',
    next_script_id: 'dog_011_03',
  },
  {
    id: 'dog_011_03',
    expression: 'sad',
    text_jp: '{pet_name}は\n毛が多いから暑いのは苦手ヌ…',
    text_en: "I have a lot of hair, so I don't like hot weather.",
    type: 'conversational',
  },
  {
    id: 'dog_012_01',
    move_to: 'c',
    text_jp: '{player_name}は\n春と秋なら\nどっちが好きヌ？',
    text_en: 'Which do you like better, spring or fall?',
    type: 'selectional',
    answer_var: 'spring_or_fall',
    option_1_jp: '春',
    option_1_en: 'Spring',
    option_2_jp: '秋',
    option_2_en: 'Fall',
    next_script_id: 'dog_012_02',
  },
  {
    id: 'dog_012_02',
    text_jp: 'へー\n{spring_or_fall}が好きなのヌね',
    text_en: 'Oh, you like {spring_or_fall}?',
    type: 'conversational',
    next_script_id: 'dog_012_03',
  },
  {
    id: 'dog_012_03',
    expression: 'happy',
    text_jp: '{pet_name}は\n秋の方が好きヌ〜',
    text_en: 'I like fall better.',
    type: 'conversational',
    next_script_id: 'dog_012_04',
  },
  {
    id: 'dog_012_04',
    animation: 'cry',
    text_jp: '春は花粉症がつらいヌ…',
    text_en: 'Pollen allergies are hard to deal with in spring.',
    type: 'conversational',
  },
  {
    id: 'dog_013_01',
    move_to: 'c',
    text_jp: '{player_name}は\nお世話するのとされるの\nどっちが多いヌ？',
    text_en:
      'Are you more likely to take care of other people or be taken care of?',
    type: 'selectional',
    answer_var: 'care_or_cared',
    option_1_jp: 'お世話する方',
    option_1_en: 'Take care',
    option_2_jp: 'お世話される方',
    option_2_en: 'Be taken care',
    case: 'care_or_cared',
    next_script_id_1: 'dog_013_02',
    next_script_id_2: 'dog_013_03',
  },
  {
    id: 'dog_013_02',
    expression: 'happy',
    text_jp: '困ってる人を放っておけない\nタイプなのヌね！',
    text_en:
      "You're the type of person who can't leave someone in trouble alone!",
    type: 'conversational',
  },
  {
    id: 'dog_013_03',
    expression: 'happy',
    text_jp: '愛されキャラなのヌね！\n{pet_name}も\nそうなりたいヌ！',
    text_en: "You're a beloved character! I wish I could be like you!",
    type: 'conversational',
  },
  {
    id: 'dog_014_01',
    move_to: 'c',
    text_jp: '秋の果物と言えば\n何を思い出すヌ？',
    text_en: 'When you think of autumn fruits, what do you think of?',
    type: 'descriptive',
    answer_var: 'autumn_fruit',
    question_jp: '秋の果物',
    question_en: 'Autumn fruit',
    max_len: 14,
    next_script_id: 'dog_014_02',
  },
  {
    id: 'dog_014_02',
    animation: 'play',
    text_jp:
      '桃、ぶどう、梨、りんご、柿…\n美味しいものがありすぎて\n1つに絞れないヌ！',
    text_en:
      "Peaches, grapes, pears, apples, persimmons.... There are so many delicious things to choose from, it's hard to narrow it down to just one!",
    type: 'conversational',
  },
  {
    id: 'dog_015_01',
    move_to: 'c',
    text_jp: '小さい頃に流行っていたあそびを\n教えて欲しいヌ！',
    text_en: 'Tell me about a game that was popular when you were little!',
    type: 'descriptive',
    answer_var: 'childhood_game',
    question_jp: '小さい頃の遊び',
    question_en: 'A game you played when you were little',
    max_len: 14,
    next_script_id: 'dog_015_02',
  },
  {
    id: 'dog_015_02',
    text_jp: '今度一緒にやってみたいヌ！',
    text_en: 'I want to try it with you next time!',
    type: 'conversational',
  },
  {
    id: 'dog_016_01',
    move_to: 'c',
    text_jp: '今まで行った場所で\n一番好きな場所はどこヌ？',
    text_en: "What is your favorite place you've ever been?",
    type: 'descriptive',
    answer_var: 'favorite_place',
    question_jp: '一番好きな場所',
    question_en: 'Favorite place',
    max_len: 14,
    next_script_id: 'dog_016_02',
  },
  {
    id: 'dog_016_02',
    expression: 'happy',
    text_jp: '{favorite_place}か〜\n{pet_name}も\n行ってみたいヌ〜',
    text_en: 'Oh, {favorite_place}! I wish I could visit too.',
    type: 'conversational',
  },
  {
    id: 'dog_017_01',
    move_to: 'c',
    text_jp: '「快晴」と「晴れ」って\n何が違うか知ってるヌ？',
    text_en:
      'Do you know what the difference is between "clear weather" and "fair weather"?',
    type: 'selectional',
    answer_var: 'clear_and_fair',
    option_1_jp: '気温',
    option_1_en: 'Temperature',
    option_2_jp: '湿度',
    option_2_en: 'Humidity',
    option_3_jp: '雲の量',
    option_3_en: 'Amount of clouds',
    next_script_id: 'dog_017_02',
  },
  {
    id: 'dog_017_02',
    text_jp: '正解は…',
    text_en: 'The right answer is...',
    type: 'conversational',
    next_script_id: 'dog_017_03',
  },
  {
    id: 'dog_017_03',
    text_jp: '「雲の量」ヌ！',
    text_en: 'Amount of clouds!',
    type: 'conversational',
    next_script_id: 'dog_017_04',
  },
  {
    id: 'dog_017_04',
    text_jp:
      '雲が0〜1割なら「快晴」\n2〜8割なら「晴れ」\nそれ以上は「くもり」だヌ！',
    text_en:
      'If the cloud cover is 0 to 10 percent, it is "clear," if it is 20 to 80 percent, it is "fair," and if it is more than that, it is "cloudy."',
    type: 'conversational',
  },
  {
    id: 'dog_018_01',
    move_to: 'c',
    text_jp:
      'カミナリが鳴っているときに\n家の中でも危険な\n場所はどこか知ってるヌ？',
    text_en:
      'Do you know where the most dangerous place in the house is when thunder is rumbling?',
    text_en_alt:
      'Where the most dangerous place in the house is when thunder is rumbling?',
    type: 'selectional',
    answer_var: 'dangerous_place_with_thunder',
    option_1_jp: 'リビング',
    option_1_en: 'Living room',
    option_2_jp: '廊下',
    option_2_en: 'Hallway',
    option_3_jp: 'お風呂',
    option_3_en: 'Bathroom',
    next_script_id: 'dog_018_02',
  },
  {
    id: 'dog_018_02',
    text_jp: '正解は…',
    text_en: 'The right answer is...',
    type: 'conversational',
    next_script_id: 'dog_018_03',
  },
  {
    id: 'dog_018_03',
    text_jp: '「お風呂」ヌ！',
    text_en: 'Bathroom!',
    type: 'conversational',
    next_script_id: 'dog_018_04',
  },
  {
    id: 'dog_018_04',
    animation: 'anxious',
    text_jp:
      'カミナリが落ちると水道管を\n伝わって電圧が入ってくる\nかもしれないヌ',
    text_en:
      'If thunder falls, you might get voltage coming in through the water pipes.',
    type: 'conversational',
  },
  {
    id: 'dog_019_01',
    move_to: 'c',
    text_jp: '「五月晴れ（さつきばれ）」って\n何月ごろのことか知ってるヌ？',
    text_en: 'Do you know what month "Satsuki-bare" is?',
    type: 'selectional',
    answer_var: 'satsuki_bare',
    option_1_jp: '4月',
    option_1_en: 'April',
    option_2_jp: '5月',
    option_2_en: 'May',
    option_3_jp: '6月',
    option_3_en: 'June',
    next_script_id: 'dog_019_02',
  },
  {
    id: 'dog_019_02',
    text_jp: '正解は…',
    text_en: 'The right answer is...',
    type: 'conversational',
    next_script_id: 'dog_019_03',
  },
  {
    id: 'dog_019_03',
    text_jp: '「6月」ヌ！',
    text_en: 'June!',
    type: 'conversational',
    next_script_id: 'dog_019_04',
  },
  {
    id: 'dog_019_04',
    text_jp:
      '現在の6月（旧暦の5月）の\n梅雨の晴れ間のことを\n五月晴れっていうヌ！',
    text_en:
      'The sunny days of the rainy season in the current month of June (May in the lunar calendar) are called "Satsuki-bare."',
    type: 'conversational',
  },
  {
    id: 'dog_020_01',
    move_to: 'c',
    text_jp: '「小春日和」って\n何月ごろのことか知ってるヌ？',
    text_en: 'Do you know what month "Koharu biyori" is?',
    type: 'selectional',
    answer_var: 'koharu_biyori',
    option_1_jp: '1〜2月',
    option_1_en: 'Jan-Feb',
    option_2_jp: '3〜4月',
    option_2_en: 'Mar-Apr',
    option_3_jp: '11〜12月',
    option_3_en: 'Nov-Dec',
    next_script_id: 'dog_020_02',
  },
  {
    id: 'dog_020_02',
    text_jp: '正解は…',
    text_en: 'The right answer is...',
    type: 'conversational',
    next_script_id: 'dog_020_03',
  },
  {
    id: 'dog_020_03',
    text_jp: '「11〜12月」ヌ！',
    text_en: 'November to December!',
    type: 'conversational',
    next_script_id: 'dog_020_04',
  },
  {
    id: 'dog_020_04',
    text_jp: '「小春」は、旧暦10月の別名だヌ\n現在の11〜12月のことだヌ',
    text_en:
      'Koharu is another name for the lunar month of October, which is now November and December.',
    type: 'conversational',
  },
  {
    id: 'dog_021_01',
    move_to: 'c',
    animation: 'joy',
    text_jp: 'キャン！キャン！\nハッピーだヌ！',
    text_en: "Yes! Yes! I'm happy!",
    type: 'conversational',
    next_script_id: 'dog_021_02',
  },
  {
    id: 'dog_021_02',
    text_jp: '嬉しくて震えるヌ！',
    text_en: "I'm shaking with joy!",
    type: 'conversational',
  },
  {
    id: 'dog_022_01',
    move_to: 'c',
    text_jp: '今日はすごく良いことがあったヌ！\n知りたいヌ？',
    text_en: "I've had a very good day! Would you like to know?",
    type: 'conversational',
    next_script_id: 'dog_022_02',
  },
  {
    id: 'dog_022_02',
    text_jp: 'たまごを割ったら\n黄身が2つも入ってたヌ！',
    text_en: 'I cracked open the egg and found two yolks in it!',
    type: 'conversational',
    next_script_id: 'dog_022_03',
  },
  {
    id: 'dog_022_03',
    text_jp: 'お得だヌ！',
    text_en: "That's a good dea!",
    type: 'conversational',
  },
  {
    id: 'dog_023_01',
    move_to: 'c',
    text_jp: '今日はすごく良いことがあったヌ！\n知りたいヌ？',
    text_en: "I've had a very good day! Would you like to know?",
    type: 'conversational',
    next_script_id: 'dog_023_02',
  },
  {
    id: 'dog_023_02',
    text_jp: '雨上がりに虹が2つも見えたヌ！',
    text_en: 'I saw two rainbows after the rain.',
    type: 'conversational',
    next_script_id: 'dog_023_03',
  },
  {
    id: 'dog_023_03',
    text_jp: '{player_name}にも\n見せてあげたかったヌ！',
    text_en: 'I wish I could have shown it to you!',
    type: 'conversational',
  },
  {
    id: 'dog_024_01',
    move_to: 'c',
    text_jp: 'すごいことを発見したヌ！\n知りたいヌ？',
    text_en: "I've discovered something amazing! You want to know?",
    type: 'conversational',
    next_script_id: 'dog_024_02',
  },
  {
    id: 'dog_024_02',
    animation: 'surprised',
    text_jp:
      'おでこのあたりにシャーペンの先を\n近づけると、目をつむっていても\nなんかチリチリするヌ！',
    text_en:
      'When I put the tip of a mechanical pencil close to my forehead, even with my eyes closed, I can kind of feel it!',
    type: 'conversational',
    next_script_id: 'dog_024_03',
  },
  {
    id: 'dog_024_03',
    text_jp: '超能力だヌ！',
    text_en: "It's a superpower!",
    type: 'conversational',
  },
  {
    id: 'dog_025_01',
    move_to: 'c',
    text_jp: '空から降ってくる\nヒョウとアラレの違い、\n知ってるかヌ？',
    text_en: 'Do you know the difference between hail and graupel?',
    type: 'conversational',
    next_script_id: 'dog_025_02',
  },
  {
    id: 'dog_025_02',
    text_jp: '直径5ミリ未満はアラレ、\n5ミリ以上はヒョウって呼ぶヌ！',
    text_en:
      "If the diameter is less than 5 mm, it's called graupel, if it's more than 5 mm, it's called hail!",
    type: 'conversational',
    next_script_id: 'dog_025_03',
  },
  {
    id: 'dog_025_03',
    text_jp: '誰かに自慢するといいヌ！',
    text_en: 'You should brag to someone!',
    type: 'conversational',
  },
  {
    id: 'dog_026_01',
    move_to: 'c',
    text_jp: '雪の日は、いつもより世界が\n静かに感じるヌよね',
    text_en: 'On a snowy day, the world feels quieter than usual.',
    type: 'conversational',
    next_script_id: 'dog_026_02',
  },
  {
    id: 'dog_026_02',
    text_jp: '雪が音を吸収して遠くまで\n届かないから、静かに感じるヌ！',
    text_en:
      "The snow absorbs the sound and it doesn't reach as far, so it feels quieter!",
    type: 'conversational',
  },
  {
    id: 'dog_027_01',
    move_to: 'c',
    text_jp: '朝暖かい日は、雨が降りやすいヌ',
    text_en: "When it's warm in the morning, it's likely to rain.",
    type: 'conversational',
    next_script_id: 'dog_027_02',
  },
  {
    id: 'dog_027_02',
    text_jp: '雨雲が膜になって、暖かい空気が\n逃げづらくなっているのヌ',
    text_en:
      'The rain clouds form a membrane that makes it difficult for the warm air to escape.',
    type: 'conversational',
  },
  {
    id: 'dog_028_01',
    move_to: 'c',
    text_jp: '{player_name}は\n占いって信じるヌか？',
    text_en: 'Do you believe in fortune telling?',
    type: 'selectional',
    answer_var: 'fortune_telling',
    option_1_jp: '信じる',
    option_1_en: 'Yes',
    option_2_jp: '信じない',
    option_2_en: 'No',
    next_script_id: 'dog_028_02',
  },
  {
    id: 'dog_028_02',
    animation: 'anxious',
    text_jp: '{pet_name}は\nけっこう信じてしまう\nタイプなのヌ！',
    text_en: "I'm the type of person who believes in fortune telling.",
    type: 'conversational',
    next_script_id: 'dog_028_03',
  },
  {
    id: 'dog_028_03',
    text_jp: '今日のラッキーフードは\nモンブランなのヌ！',
    text_en: "Today's lucky food is Mont Blanc!",
    type: 'conversational',
    next_script_id: 'dog_028_04',
  },
  {
    id: 'dog_028_04',
    animation: 'play',
    text_jp: 'あとで食べさせて欲しいのヌ！',
    text_en: 'Please give me later!',
    type: 'conversational',
  },
  {
    id: 'dog_029_01',
    move_to: 'c',
    text_jp: '最近買って良かったものを\n教えて欲しいヌ！',
    text_en: "What's the best thing you've bought recently?",
    type: 'descriptive',
    answer_var: 'best_buy',
    question_jp: '買って良かったもの',
    question_en: "Best thing you've bought",
    max_len: 14,
    next_script_id: 'dog_029_02',
  },
  {
    id: 'dog_029_02',
    text_jp: 'それっておいしいものヌ？',
    text_en: 'Is that something delicious?',
    type: 'conversational',
  },
  {
    id: 'dog_030_01',
    move_to: 'c',
    text_jp: '「未明」って、何時頃のことか\n知ってるかヌ？',
    text_en: 'Do you know what time it is "before dawn"?',
    type: 'selectional',
    answer_var: 'before_dawn',
    option_1_jp: '午前0時〜3時',
    option_1_en: '12am to 3am',
    option_2_jp: '午前2時〜5時',
    option_2_en: '2am to 5am',
    option_3_jp: '午前3時〜6時',
    option_3_en: '3am to 6am',
    next_script_id: 'dog_030_02',
  },
  {
    id: 'dog_030_02',
    text_jp: '正解は…',
    text_en: 'The right answer is...',
    type: 'conversational',
    next_script_id: 'dog_030_03',
  },
  {
    id: 'dog_030_03',
    text_jp: '「午前0時〜3時」ヌ！',
    text_en: '12am to 3am!',
    type: 'conversational',
    next_script_id: 'dog_030_04',
  },
  {
    id: 'dog_030_04',
    text_jp: 'ちなみに\n午前3時から6時のことは\n「明け方」というヌ',
    text_en: 'By the way, the period between 3 and 6 am is called "dawn."',
    type: 'conversational',
  },
  {
    id: 'dog_031_01',
    move_to: 'c',
    text_jp: 'そろそろごはんの時間ヌかね…',
    text_en: "It's time to eat...",
    type: 'conversational',
    next_script_id: 'dog_031_02',
  },
  {
    id: 'dog_031_02',
    animation: 'play',
    text_jp: '今日のごはんは何かヌ〜？',
    text_en: "What's today's food?",
    type: 'conversational',
  },
  {
    id: 'dog_032_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: 'おなかすいてるヌ！',
    text_en: "I'm starving!",
    type: 'conversational',
    next_script_id: 'dog_032_02',
  },
  {
    id: 'dog_032_02',
    animation: 'cry',
    text_jp: 'なんでごはんくれないヌ？',
    text_en: "Why won't you give me food?",
    type: 'conversational',
  },
  {
    id: 'dog_033_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'ちょっと毛玉が目立ってきたヌ',
    text_en: "I'm starting to see a little hairball.",
    type: 'conversational',
    next_script_id: 'dog_033_02',
  },
  {
    id: 'dog_033_02',
    text_jp: 'お風呂入った方がいいヌ',
    text_en: "I think I'd better take a bath.",
    type: 'conversational',
  },
  {
    id: 'dog_034_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '自分がくさいヌ！',
    text_en: 'I stink!',
    type: 'conversational',
    next_script_id: 'dog_034_02',
  },
  {
    id: 'dog_034_02',
    animation: 'cry',
    text_jp: '{pet_name}、鼻がいいから\n自分がくさいの耐えられないヌ！',
    text_en: "I have a good nose, I can't stand to smell myself!",
    type: 'conversational',
    next_script_id: 'dog_034_03',
  },
  {
    id: 'dog_034_03',
    animation: 'cry',
    text_jp: 'お風呂入れて欲しいヌ！',
    text_en: 'I want you to bathe me right now!',
    type: 'conversational',
  },
  {
    id: 'dog_035_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '最近、あまりかまってくれないヌ？',
    text_en: "You haven't been playing with me much lately, have you?",
    type: 'conversational',
    next_script_id: 'dog_035_02',
  },
  {
    id: 'dog_035_02',
    expression: 'very_sad',
    text_jp: '{player_name}も\n忙しいヌかね？',
    text_en: 'I guess you are very busy...',
    type: 'conversational',
    next_script_id: 'dog_035_03',
  },
  {
    id: 'dog_035_03',
    animation: 'cry',
    text_jp: '{pet_name}と\nあそんで欲しいヌ…',
    text_en: 'Please play with me more often...',
    type: 'conversational',
  },
  {
    id: 'dog_036_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: 'もっとあそんで欲しいヌ！',
    text_en: 'I want you to play with me more!',
    type: 'conversational',
    next_script_id: 'dog_036_02',
  },
  {
    id: 'dog_036_02',
    animation: 'angry',
    text_jp: 'ちょっと怒ってるヌ！',
    text_en: "I'm a little mad at you!",
    type: 'conversational',
  },
  {
    id: 'dog_037_01',
    move_to: 'c',
    text_jp: 'そろそろトイレ行っておいた方が\n良さそうヌ',
    text_en: "I'de better go to the bathroom...",
    type: 'conversational',
  },
  {
    id: 'dog_038_01',
    move_to: 'c',
    text_jp: 'うー。トイレ行きたいヌ〜',
    text_en: 'I have to go to the bathroom. I have to go to the bathroom.',
    type: 'conversational',
    next_script_id: 'dog_038_02',
  },
  {
    id: 'dog_038_02',
    animation: 'cry',
    text_jp: 'もう限界に近いヌ〜',
    text_en: "I can't hold it any more...",
    type: 'conversational',
  },
  {
    id: 'dog_039_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: 'タンスの中に誰かいる気がするヌ！',
    text_en: "I think there's someone in the wardrobe!",
    type: 'conversational',
    next_script_id: 'dog_039_02',
  },
  {
    id: 'dog_039_02',
    animation: 'anxious',
    text_jp: '怖いヌ！',
    text_en: "I'm scared!",
    type: 'conversational',
    next_script_id: 'dog_039_03',
  },
  {
    id: 'dog_039_03',
    animation: 'cry',
    text_jp: 'トイレやお風呂に行けないヌ！',
    text_en: "I can't go to the toilet or bathroom!",
    type: 'conversational',
  },
  {
    id: 'dog_040_01',
    move_to: 'c',
    text_jp: 'いつもよりよけいに\nぶるぶるするヌ',
    text_en: "I'm even more shaky than usual.",
    type: 'conversational',
    next_script_id: 'dog_040_02',
  },
  {
    id: 'dog_040_02',
    animation: 'anxious',
    text_jp: 'どうやら病気になっちゃったヌ',
    text_en: "Apparently, I'm getting sick.",
    type: 'conversational',
    next_script_id: 'dog_040_03',
  },
  {
    id: 'dog_040_03',
    animation: 'cry',
    text_jp: 'おクスリ飲ませて欲しいヌ…',
    text_en: 'I want to take a medicine...',
    type: 'conversational',
  },
  {
    id: 'dog_041_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: '歯が痛くて何も食べられないヌ',
    text_en: "My teeth hurt and I can't eat anything.",
    type: 'conversational',
    next_script_id: 'dog_041_02',
  },
  {
    id: 'dog_041_02',
    animation: 'cry',
    text_jp: '痛くて悲しいヌ',
    text_en: "I'm sad...",
    type: 'conversational',
  },
  {
    id: 'dog_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'もうねむいヌ〜\n寝ますヌ〜\nあしたは晴れるかヌ…？',
    text_en: "I'm already sleepy. I'm going to bed. Will it be sunny tomorrow?",
    type: 'conversational',
  },
  {
    id: 'dog_043_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ヌヌヌ…\nからだがムズムズするヌ…',
    text_en: 'Hmm. My body is mushy.',
    type: 'conversational',
  },
  {
    id: 'dog_044_01',
    move_to: 'c',
    text_jp: '今日もごはんがおいしいヌ！\nそういえば昨日もおいしかったヌ！',
    text_en:
      'This is the best meal ever!\nCome to think of it, so was yesterday’s!',
    type: 'conversational',
    next_script_id: 'dog_044_02',
  },
  {
    id: 'dog_044_02',
    animation: 'play',
    text_jp: 'もしかして、ごはんはいつも\nおいしいヌか…？',
    text_en: 'Maybe food is always great?',
    type: 'conversational',
  },
  {
    id: 'dog_045_01',
    move_to: 'c',
    text_jp: 'お天気が良い日にお散歩して、\nごはん食べてお昼寝して、',
    text_en: 'Going on walks when the weather’s good, eating, napping,',
    type: 'conversational',
    next_script_id: 'dog_045_02',
  },
  {
    id: 'dog_045_02',
    expression: 'happy',
    text_jp: 'またお散歩しておやつ食べて…\nこれが幸せってやつかヌ？',
    text_en:
      'going on another walk, eating again…\nThis must be what happiness is all about!',
    type: 'conversational',
  },
  {
    id: 'dog_046_01',
    move_to: 'c',
    text_jp:
      '{pet_name}、\n早く大きくなって、ぶるぶる\nカフェでデビューしたいヌ！',
    text_en: '{pet_name} wants to get big and debut at the BuruBuru café!',
    type: 'conversational',
    next_script_id: 'dog_046_02',
  },
  {
    id: 'dog_046_02',
    text_jp: 'でも、\n{player_name}と\n離れるのはさみしいヌ…',
    text_en: "But I'd be sad to be away from you, \n{player_name}…",
    type: 'conversational',
    next_script_id: 'dog_046_03',
  },
  {
    id: 'dog_046_03',
    text_jp: '{pet_name}の\nココロは複雑ヌ…',
    text_en: '{pet_name}’s heart is conflicted…',
    type: 'conversational',
  },
  {
    id: 'dog_047_01',
    move_to: 'c',
    text_jp: 'あっ！\nちょうちょだヌ！',
    text_en: 'Hey! \nA butterfly!',
    type: 'conversational',
    next_script_id: 'dog_047_02',
  },
  {
    id: 'dog_047_02',
    expression: 'happy',
    move_to: 'rm',
    text_jp: 'キャンキャンキャンキャン！',
    text_en: 'Woof! Woof! Woof! Woof!',
    type: 'conversational',
    next_script_id: 'dog_047_03',
  },
  {
    id: 'dog_047_03',
    expression: 'happy',
    move_to: 'lm',
    text_jp: 'キャンキャンキャンキャン！',
    text_en: 'Woof! Woof! Woof! Woof!',
    type: 'conversational',
    next_script_id: 'dog_047_04',
  },
  {
    id: 'dog_047_04',
    move_to: 'c',
    text_jp: 'ふー。\nちょっと取り乱してしまったヌ',
    text_en: 'Whoof! \nI got a little too excited.',
    type: 'conversational',
  },
  {
    id: 'dog_048_01',
    move_to: 'c',
    text_jp: '{pet_name}、\nたまに考えるヌ…',
    text_en: 'Sometimes {pet_name} wonders…',
    type: 'conversational',
    next_script_id: 'dog_048_02',
  },
  {
    id: 'dog_048_02',
    animation: 'anxious',
    text_jp: '{pet_name}は、いったい\nどこから来て、どこへ行くのヌ…？',
    text_en: 'Where did {pet_name} come from, and where am I going…?',
    type: 'conversational',
    next_script_id: 'dog_048_03',
  },
  {
    id: 'dog_048_03',
    expression: 'happy',
    animation: 'joy',
    text_jp: 'でも、そろそろお散歩の時間かヌ？',
    text_en: 'But I think it’s almost time for walkies!',
    type: 'conversational',
  },
  {
    id: 'dog_049_01',
    move_to: 'c',
    text_jp: 'ネコが耳の後ろまで顔を洗うと\n雨が降るとよく言われるヌ！',
    text_en:
      'They say if a cat washes all the way behind their ears, it’s going to rain!',
    type: 'conversational',
    next_script_id: 'dog_049_02',
  },
  {
    id: 'dog_049_02',
    text_jp:
      'それだけ毛が湿気を含んでいるから\n雨が降りやすいということらしいヌ',
    text_en: 'I think it’s because their fur gets so wet, it calls the rain.',
    type: 'conversational',
    next_script_id: 'dog_049_03',
  },
  {
    id: 'dog_049_03',
    text_jp: '信じるかどうかはあなた次第ヌ！',
    text_en: "It's up to you to believe it or not!",
    type: 'conversational',
  },
  {
    id: 'dog_050_01',
    move_to: 'c',
    text_jp: 'ツバメが低く飛ぶと雨が降ると\n言われているヌ',
    text_en: 'They say when a swallow flies low, it’s going to rain!',
    type: 'conversational',
    next_script_id: 'dog_050_02',
  },
  {
    id: 'dog_050_02',
    text_jp:
      'ツバメのエサになる虫の羽が、\n湿度が高くなると湿気を吸って\n重たくなって高く飛べなくなるから',
    text_en:
      'It’s because the bugs that swallows eat absorb moisture and get too heavy to fly any higher.',
    type: 'conversational',
    next_script_id: 'dog_050_03',
  },
  {
    id: 'dog_050_03',
    text_jp:
      '低い場所を飛ぶ虫を捕まえるために\nツバメも低く飛ぶように\nなるらしいヌ！',
    text_en: 'So the swallows fly low to catch the low-flying bugs!',
    type: 'conversational',
    next_script_id: 'dog_050_04',
  },
  {
    id: 'dog_050_04',
    expression: 'happy',
    text_jp: '誰かに自慢するといいヌ！',
    text_en: 'You can show off your smarts to someone!',
    type: 'conversational',
  },
  {
    id: 'dog_051_01',
    move_to: 'c',
    text_jp: '気象予報士の試験は、\n合格率5%という難関だヌ！',
    text_en: 'The test to become a meteorologist is so hard that only 5% pass!',
    type: 'conversational',
    next_script_id: 'dog_051_02',
  },
  {
    id: 'dog_051_02',
    animation: 'surprised',
    text_jp: 'よっぽどお天気好きじゃないと\n合格は難しいヌ！',
    text_en: 'You’d have to really love the weather to make it through!',
    type: 'conversational',
  },
  {
    id: 'dog_052_01',
    move_to: 'c',
    text_jp: 'てるてる坊主の歌の歌詞は、\n実はけっこう怖いヌ！\n3番の歌詞は…',
    text_en:
      'The lyrics to the TeruTeruBozu song are scary! \nThe third verse goes…',
    type: 'conversational',
    next_script_id: 'dog_052_02',
  },
  {
    id: 'dog_052_02',
    text_jp: '「それでも曇って泣いてたら\nそなたの首をチョンと切るぞ」',
    text_en: '“If it still rains, I’ll cut your head off.”',
    type: 'conversational',
    next_script_id: 'dog_052_03',
  },
  {
    id: 'dog_052_03',
    animation: 'cry',
    text_jp: 'こ、怖すぎるヌ！',
    text_en: 'Terrifying!',
    type: 'conversational',
  },
  {
    id: 'dog_053_01',
    move_to: 'c',
    text_jp: 'クーラーを27度に設定しても、\n27度の風が出てくるわけじゃないヌ',
    text_en:
      'Even if you set the AC to 27 degrees, that’s not the temperature of the wind that comes out.',
    type: 'conversational',
    next_script_id: 'dog_053_02',
  },
  {
    id: 'dog_053_02',
    animation: 'anxious',
    text_jp:
      '実際に出てくる風の温度は10度\nくらいだから、直接風に当たらない\nように気をつけるヌ！',
    text_en: "It's actually about 10 degrees, so don’t sit directly under it!",
    type: 'conversational',
  },
  {
    id: 'dog_054_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n人の顔と名前を覚えるのは\n得意なタイプかヌ？',
    text_en:
      'Are you the type who can remember people’s names and faces, {player_name}?',
    type: 'selectional',
    answer_var: 'remember_face_and_name',
    option_1_jp: '得意',
    option_1_en: 'Good',
    option_2_jp: '苦手',
    option_2_en: 'Bad',
    case: 'remember_face_and_name',
    next_script_id_1: 'dog_054_02',
    next_script_id_2: 'dog_054_03',
  },
  {
    id: 'dog_054_02',
    expression: 'happy',
    text_jp:
      'すごいヌ！{pet_name}は、\nなかなか覚えられないから、\nコツを教えて欲しいヌ！',
    text_en:
      'Wow! {pet_name} has a hard time remembering, so could you teach me some tricks?',
    type: 'conversational',
  },
  {
    id: 'dog_054_03',
    animation: 'cry',
    text_jp: 'そうなのヌね。\nでも、{pet_name}のことは\n忘れないで欲しいヌ！',
    text_en: 'Oh. Just don’t forget about {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'dog_055_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n異性と同性どっちに\nモテるタイプかヌ？',
    text_en:
      'Hey {player_name}, do you get along better with the same, or opposite gender?',
    type: 'selectional',
    answer_var: 'same_or_opposite_gender',
    option_1_jp: '異性',
    option_1_en: 'Opposite gender',
    option_2_jp: '同性',
    option_2_en: 'Same gender',
    next_script_id: 'dog_055_02',
  },
  {
    id: 'dog_055_02',
    expression: 'happy',
    text_jp: 'なんとなくそんな気がしていたヌ！',
    text_en: 'That’s what I thought!',
    type: 'conversational',
  },
  {
    id: 'dog_056_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n1人で焼肉屋さんに\n行けるタイプかヌ？',
    text_en:
      'Hey, {player_name}, are you the type that can go to a BBQ place alone?',
    type: 'selectional',
    answer_var: 'solo_yakiniku',
    option_1_jp: '行ける',
    option_1_en: 'Yes',
    option_2_jp: '行けない',
    option_2_en: 'No',
    case: 'solo_yakiniku',
    next_script_id_1: 'dog_056_02',
    next_script_id_2: 'dog_056_03',
  },
  {
    id: 'dog_056_02',
    text_jp: 'なかなかツワモノなのヌね',
    text_en: 'You’re certainly not shy!',
    type: 'conversational',
  },
  {
    id: 'dog_056_03',
    text_jp: '{pet_name}も\n1人は難しいヌ〜\n今度一緒に行って欲しいヌ〜',
    text_en: '{pet_name} would get shy, too.\nBring me with you next time!',
    type: 'conversational',
  },
  {
    id: 'dog_057_01',
    move_to: 'c',
    text_jp: '{player_name}は\nマンガとアニメどっちが好きヌ？',
    text_en: 'Hey, {player_name}, do you like manga or anime?',
    type: 'selectional',
    answer_var: 'manga_or_anime',
    option_1_jp: 'マンガ',
    option_1_en: 'Manga',
    option_2_jp: 'アニメ',
    option_2_en: 'Anime',
    case: 'manga_or_anime',
    next_script_id_1: 'dog_057_02',
    next_script_id_2: 'dog_057_03',
  },
  {
    id: 'dog_057_02',
    text_jp: 'マンガは自分のペースで\n読み進められていいヌよね〜',
    text_en: 'Manga are great because you can read at your own pace!',
    type: 'conversational',
  },
  {
    id: 'dog_057_03',
    text_jp: '{pet_name}は、\nマンガを読んでからアニメを\n観るタイプだヌ！',
    text_en: '{pet_name} likes to read the manga before watching the anime!',
    type: 'conversational',
  },
  {
    id: 'dog_058_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n歯みがき粉は最後まで\n使い切るタイプかヌ？',
    text_en: 'Hey, {player_name}, do you use up the entire tube of toothpaste?',
    type: 'selectional',
    answer_var: 'tooth_paste',
    option_1_jp: '使い切る',
    option_1_en: 'Yes',
    option_2_jp: '使い切れない',
    option_2_en: 'No',
    case: 'tooth_paste',
    next_script_id_1: 'dog_058_02',
    next_script_id_2: 'dog_058_03',
  },
  {
    id: 'dog_058_02',
    expression: 'sad',
    text_jp: 'えらいヌ〜\n{pet_name}は、どうしても\n新しいのを使いたくなるヌ',
    text_en: 'Good for you!\n{pet_name} always wants a new tube.',
    type: 'conversational',
  },
  {
    id: 'dog_058_03',
    expression: 'sad',
    text_jp:
      'わかるヌ〜\n新しい歯みがき粉を買っちゃうと\nそっちを使ってしまうヌ〜',
    text_en: 'I get it!\nIf you buy a new tube, you end up using it instead!',
    type: 'conversational',
  },
  {
    id: 'dog_059_01',
    move_to: 'c',
    text_jp: '{player_name}の\n最近の推しは誰かヌ？',
    text_en: 'Hey, {player_name}, who are you into these days?',
    type: 'descriptive',
    answer_var: 'recent_fave',
    question_jp: '最近の推しは誰？',
    question_en: 'Your recent fave',
    max_len: 14,
    next_script_id: 'dog_059_02',
  },
  {
    id: 'dog_059_02',
    expression: 'happy',
    text_jp: '{pet_name}の推しは\n{player_name}だヌ！',
    text_en: '{pet_name} is into \n{player_name}!',
    type: 'conversational',
  },
  {
    id: 'dog_060_01',
    move_to: 'c',
    text_jp: '{player_name}の\n好きな四字熟語を\n教えて欲しいヌ！',
    text_en: "What's your favorite saying, {player_name}?",
    type: 'descriptive',
    answer_var: 'compound_word',
    question_jp: '好きな四字熟語',
    question_en: 'Favorite four-character compound word',
    max_len: 14,
    next_script_id: 'dog_060_02',
  },
  {
    id: 'dog_060_02',
    text_jp: 'ずいぶん難しい言葉を\n知ってるのヌね！',
    text_en: 'You know some really deep stuff!',
    type: 'conversational',
    next_script_id: 'dog_060_03',
  },
  {
    id: 'dog_060_03',
    animation: 'joy',
    text_jp: '{pet_name}の\n好きな四字熟語は\n「毎日散歩」ヌ！',
    text_en: '{pet_name}’s favorite saying is “Walk every day!”',
    type: 'conversational',
  },
  {
    id: 'dog_061_01',
    move_to: 'c',
    text_jp: '{player_name}は、\nもし生まれ変わったら\n何になりたいヌ？',
    text_en: 'What would you be if you could be reborn, {player_name}?',
    type: 'descriptive',
    answer_var: 'reincarnation',
    question_jp: '生まれ変わったら？',
    question_en: 'Reincarnation',
    max_len: 14,
    next_script_id: 'dog_061_02',
  },
  {
    id: 'dog_061_02',
    expression: 'happy',
    text_jp: '{pet_name}、実は\n生まれ変わったらネコに\nなってみたいヌ…',
    text_en: 'If {pet_name} were reborn, I’d be a cat…',
    type: 'conversational',
    next_script_id: 'dog_061_03',
  },
  {
    id: 'dog_061_03',
    expression: 'normal',
    text_jp: 'みんなにはナイショヌよ？',
    text_en: 'Don’t tell anyone!',
    type: 'conversational',
  },
  {
    id: 'dog_062_01',
    move_to: 'c',
    text_jp: '{player_name}は\n自分の身体のどのパーツが\n好きだヌ？',
    text_en: 'What’s your favorite part of your body {player_name}?',
    type: 'descriptive',
    answer_var: 'body_part',
    question_jp: '好きな身体のパーツ',
    question_en: 'Favorite body part',
    max_len: 14,
    next_script_id: 'dog_062_02',
  },
  {
    id: 'dog_062_02',
    text_jp: 'たしかに、とっても魅力的だヌ！',
    text_en: "That's great!",
    type: 'conversational',
  },
  {
    id: 'dog_063_01',
    move_to: 'c',
    text_jp:
      '{player_name}は、\n有名人だと誰に似てるって\n言われたことがあるヌ？',
    text_en:
      'Hey, {player_name}, what celebrity have you been told you look like?',
    type: 'descriptive',
    answer_var: 'similar_celebrities',
    question_jp: '似ている有名人',
    question_en: 'Similar celebrities',
    max_len: 14,
    next_script_id: 'dog_063_02',
  },
  {
    id: 'dog_063_02',
    animation: 'play',
    text_jp: '{pet_name}は、よく\nセーターっぽいって言われるヌ！',
    text_en: 'People tell me {pet_name} looks like a sweater!',
    type: 'conversational',
  },
  {
    id: 'dog_064_01',
    move_to: 'c',
    text_jp: '晴れているのに雨が降ることを\n何というか知っているかヌ？',
    text_en:
      'Do you know what it’s called in Japan when it rains while it’s sunny?',
    type: 'selectional',
    answer_var: 'sun_shower',
    option_1_jp: 'タヌキの嫁入り',
    option_1_en: 'Marriage of a raccoon',
    option_2_jp: 'キツネの嫁入り',
    option_2_en: 'Marriage of a fox',
    option_3_jp: 'カラスの嫁入り',
    option_3_en: 'Marriage of a crow',
    next_script_id: 'dog_064_02',
  },
  {
    id: 'dog_064_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'dog_064_03',
  },
  {
    id: 'dog_064_03',
    text_jp: '「キツネの嫁入り」だヌ！',
    text_en: '“A fox’s wedding!”',
    type: 'conversational',
    next_script_id: 'dog_064_04',
  },
  {
    id: 'dog_064_04',
    expression: 'happy',
    text_jp:
      '晴れているのに雨が降るなんて\nキツネに化かされてるみたいだから\nそう呼ばれるようになったヌ！',
    text_en:
      'It’s because foxes are tricksters, and it feels like you’re being tricked when it rains on a sunny day!',
    type: 'conversational',
  },
  {
    id: 'dog_065_01',
    move_to: 'c',
    text_jp: '世界の観測史上最高気温は\n何度か知ってるかヌ？',
    text_en: 'Do you know what the highest recorded temperature on Earth is?',
    type: 'selectional',
    answer_var: 'highest_temperature',
    option_1_jp: '46度',
    option_1_en: '46℃',
    option_2_jp: '52度',
    option_2_en: '52℃',
    option_3_jp: '56度',
    option_3_en: '56℃',
    next_script_id: 'dog_065_02',
  },
  {
    id: 'dog_065_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'dog_065_03',
  },
  {
    id: 'dog_065_03',
    text_jp: '56度だヌ！\nアメリカのデスバレーで、\n1913年に観測されたヌ！',
    text_en:
      '56 degrees Celsius!\nIt was recorded at Death Valley in the USA in 1913!',
    type: 'conversational',
  },
  {
    id: 'dog_066_01',
    move_to: 'c',
    text_jp: '突然ヌけど、ここで一句ヌ…',
    text_en: 'And now, a haiku…',
    type: 'conversational',
    next_script_id: 'dog_066_02',
  },
  {
    id: 'dog_066_02',
    text_jp: '………\n………………\n………………………',
    text_en: '......\n............\n..................',
    type: 'conversational',
    next_script_id: 'dog_066_03',
  },
  {
    id: 'dog_066_03',
    animation: 'cry',
    text_jp: '何も思いつかなかったヌ…',
    text_en: 'I couldn’t think of one…',
    type: 'conversational',
  },
  {
    id: 'dog_067_01',
    move_to: 'c',
    text_jp: '今日はすごく良いことがあったヌ！\n知りたいヌ？',
    text_en: 'Something great happened today!\nCan you guess what?',
    type: 'conversational',
    next_script_id: 'dog_067_02',
  },
  {
    id: 'dog_067_02',
    animation: 'joy',
    text_jp: 'ゆで卵のカラが、スポッと\nきれいにむけたヌ！',
    text_en: 'A hardboiled egg I had came out of its shell really cleanly!',
    type: 'conversational',
    next_script_id: 'dog_067_03',
  },
  {
    id: 'dog_067_03',
    text_jp: '{player_name}にも\n見せてあげたかったヌ！\nもう食べちゃったヌ！',
    text_en: 'I wanted to show you, {player_name}!\nBut I ate it already!',
    type: 'conversational',
  },
  {
    id: 'dog_068_01',
    move_to: 'c',
    text_jp: 'ミャーミャー',
    text_en: 'Meow Meow',
    type: 'conversational',
    next_script_id: 'dog_068_02',
  },
  {
    id: 'dog_068_02',
    text_jp: 'ネコの鳴き真似じゃないヌ！\n名古屋弁の真似だヌ！',
    text_en: 'That’s not a cat impression!\nIt’s a Nagoya dialect!',
    type: 'conversational',
  },
  {
    id: 'dog_069_01',
    move_to: 'c',
    text_jp:
      '降水確率は、その時間に雨が\n1mm以上降る確率のことヌ！\n雨が降る量とは関係ないヌ！',
    text_en:
      'The rainfall forecast is the chance it’ll rain more than 1mm at that time!\nIt has nothing to do with how much it will rain!',
    type: 'conversational',
    next_script_id: 'dog_069_02',
  },
  {
    id: 'dog_069_02',
    text_jp: '降水確率100%で小雨のこともあれば\n30%でどしゃ降りのこともあるヌ',
    text_en:
      'It could be 100% and just sprinkle or be 30% and be pouring cats and me!',
    type: 'conversational',
    next_script_id: 'dog_069_03',
  },
  {
    id: 'dog_069_03',
    animation: 'play',
    text_jp: '誰かに自慢するといいヌ！',
    text_en: 'You can show off your smarts to someone!',
    type: 'conversational',
  },
  {
    id: 'dog_070_01',
    move_to: 'c',
    text_jp: '雨粒のかたちというと涙型を\nイメージするかもしれないヌけど',
    text_en: 'Everyone thinks that raindrops are tear-shaped.',
    type: 'conversational',
    next_script_id: 'dog_070_02',
  },
  {
    id: 'dog_070_02',
    text_jp: '本当は肉まんみたいなひしゃげた\nかたちをしてるヌ！',
    text_en: 'They’re actually squished like a dumpling!',
    type: 'conversational',
    next_script_id: 'dog_070_03',
  },
  {
    id: 'dog_070_03',
    animation: 'waive',
    text_jp: '誰かに自慢するといいヌ！',
    text_en: 'Show off your smarts to someone!',
    type: 'conversational',
  },
  {
    id: 'dog_071_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n辛い食べ物はけっこう得意かヌ？',
    text_en: 'How are you with spicy food, {player_name}?',
    type: 'selectional',
    answer_var: 'spicy_food',
    option_1_jp: '得意',
    option_1_en: 'Yes',
    option_2_jp: '得意じゃない',
    option_2_en: 'No',
    next_script_id: 'dog_071_02',
  },
  {
    id: 'dog_071_02',
    expression: 'sad',
    text_jp:
      '{pet_name}は、\n辛いものを食べると毛が膨らんで\n大変なことになるヌ',
    text_en: '{pet_name}’s fur gets all fluffy when I eat something spicy!',
    type: 'conversational',
  },
  {
    id: 'dog_072_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n流行には敏感なほうかヌ？',
    text_en: 'Do you keep up with trends, {player_name}?',
    type: 'selectional',
    answer_var: 'sensitive_to_fads',
    option_1_jp: '敏感なほう',
    option_1_en: 'Yes',
    option_2_jp: '鈍感なほう',
    option_2_en: 'No',
    next_script_id: 'dog_072_02',
  },
  {
    id: 'dog_072_02',
    expression: 'sad',
    text_jp:
      '{pet_name}は\nだいたい流行が終わりそうな頃に\n盛り上がってくるタイプだヌ',
    text_en:
      '{pet_name} gets into stuff just as its popularity is dropping off.',
    type: 'conversational',
  },
  {
    id: 'dog_073_01',
    move_to: 'c',
    text_jp: '{player_name}は、\n付き合うならどっちがいいヌ？',
    text_en: 'Which would you rather date, {player_name}?',
    type: 'selectional',
    answer_var: 'everyone_or_only_you',
    option_1_jp: '誰にでも優しい人',
    option_1_en: 'Person who is kind to eveyrone',
    option_2_jp: '自分だけに優しい人',
    option_2_en: 'Person who is kind to only you',
    case: 'everyone_or_only_you',
    next_script_id_1: 'dog_073_02',
    next_script_id_2: 'dog_073_03',
  },
  {
    id: 'dog_073_02',
    text_jp: 'やっぱりみんなに優しい人が\nいいヌよね〜',
    text_en: 'Everyone likes a kind-hearted person!',
    type: 'conversational',
  },
  {
    id: 'dog_073_03',
    text_jp:
      '他の人には冷たいのに\n自分にだけ優しくしてくれるのも\nちょっといいヌよね〜',
    text_en: 'There’s something special about someone who’s only nice to you!',
    type: 'conversational',
  },
  {
    id: 'dog_074_01',
    move_to: 'c',
    text_jp: '{player_name}の、\n夏の定番メニューを\n教えて欲しいヌ！',
    text_en: 'What’s your favorite thing to eat in the summer, {player_name}?',
    type: 'descriptive',
    answer_var: 'summer_menu',
    question_jp: '夏の定番メニュー',
    question_en: 'Favorite summer food',
    max_len: 14,
    next_script_id: 'dog_074_02',
  },
  {
    id: 'dog_074_02',
    text_jp:
      '{pet_name}は、\nひたすらソーメンを食べ続けるヌ！\nとっても美味しいヌ！',
    text_en: '{pet_name} loves cold noodles!\nThey’re delicious!',
    type: 'conversational',
  },
  {
    id: 'dog_075_01',
    move_to: 'c',
    text_jp: '韓国で、雨の日に食べたくなると\n言われている食べ物はどれかヌ？',
    text_en: 'Do you know what food people in Korea want to eat when it rains?',
    type: 'selectional',
    answer_var: 'food_on_rainy_day',
    option_1_jp: 'クッパ',
    option_1_en: 'Gukbap',
    option_2_jp: 'ビビンバ',
    option_2_en: 'Bibimbap',
    option_3_jp: 'チヂミ',
    option_3_en: 'Korean Pancake',
    next_script_id: 'dog_075_02',
  },
  {
    id: 'dog_075_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'dog_075_03',
  },
  {
    id: 'dog_075_03',
    text_jp: '「チヂミ」だヌ！',
    text_en: 'Buchimgae! Korean pancakes!',
    type: 'conversational',
    next_script_id: 'dog_075_04',
  },
  {
    id: 'dog_075_04',
    text_jp: '雨の音とチヂミを焼く音が似ている\nから、食べたくなるらしいヌ！',
    text_en:
      'They say it’s because the rain sounds like Buchimgae being cooked!',
    type: 'conversational',
  },
  {
    id: 'dog_076_01',
    move_to: 'c',
    text_jp: '静電気を防止する服の着方、\n知ってるかヌ？',
    text_en: 'Do you know how to keep clothes from getting static electricity?',
    type: 'selectional',
    answer_var: 'static_electricity',
    option_1_jp: '化学繊維を着る',
    option_1_en: 'Synthetic fiber clothing',
    option_2_jp: '違う素材の服を着る',
    option_2_en: 'Clothes made of different materials',
    option_3_jp: '同じ素材の服を着る',
    option_3_en: 'Clothes made of the same matrials',
    next_script_id: 'dog_076_02',
  },
  {
    id: 'dog_076_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'dog_076_03',
  },
  {
    id: 'dog_076_03',
    text_jp: '「同じ素材の服を着る」ヌ！',
    text_en: 'By wearing clothes of the same material!',
    type: 'conversational',
    next_script_id: 'dog_076_04',
  },
  {
    id: 'dog_076_04',
    text_jp: '異素材の服がこすれあうと、\n静電気がたまっていくのヌ！',
    text_en:
      'Static electricity builds up when different materials rub together!',
    type: 'conversational',
  },
  {
    id: 'dog_077_01',
    move_to: 'c',
    text_jp: '{pet_name}は今…\nけっこうおなかがすいているのヌ…',
    text_en: '{pet_name}…\nis getting pretty hungry…',
    type: 'conversational',
    next_script_id: 'dog_077_02',
  },
  {
    id: 'dog_077_02',
    animation: 'play',
    text_jp: 'ごはんをもらえるのを…\n楽しみにしてるのヌ…！',
    text_en: "I can't wait…\nto be fed!",
    type: 'conversational',
  },
  {
    id: 'dog_078_01',
    move_to: 'c',
    text_jp: 'おなかがすきすぎて…\n悲しくなってきたヌ…',
    text_en: 'I’m so hungry… \nI’m getting sad…',
    type: 'conversational',
    next_script_id: 'dog_078_02',
  },
  {
    id: 'dog_078_02',
    animation: 'cry',
    text_jp: 'しくしく…\nしくしく…\nしくしく…',
    text_en: 'Sniff…\nSniff…\nSniff…',
    type: 'conversational',
  },
  {
    id: 'dog_079_01',
    move_to: 'c',
    text_jp: 'そろそろお風呂に入りたい\n気分なのヌ',
    text_en: 'I wanna have a bath soon.',
    type: 'conversational',
    next_script_id: 'dog_079_02',
  },
  {
    id: 'dog_079_02',
    text_jp: 'アワアワでブクブクして欲しいヌ',
    text_en: 'I wanna get soapy and bubbly.',
    type: 'conversational',
  },
  {
    id: 'dog_080_01',
    move_to: 'c',
    text_jp: '体がかゆいヌ！\nこのままでは病気に\nなってしまうヌ！',
    text_en: 'I feel itchy!\nI’m gonna get sick!',
    type: 'conversational',
    next_script_id: 'dog_080_02',
  },
  {
    id: 'dog_080_02',
    animation: 'cry',
    text_jp: 'お風呂入れてくださいヌ〜',
    text_en: 'Please let me take a bath!',
    type: 'conversational',
  },
  {
    id: 'dog_081_01',
    move_to: 'c',
    text_jp: 'なんだか心がスースーするヌ',
    text_en: 'My heart feels cold.',
    type: 'conversational',
    next_script_id: 'dog_081_02',
  },
  {
    id: 'dog_081_02',
    text_jp: '{pet_name}、\nちょっとだけさみしいのかも\nしれないヌ…',
    text_en: '{pet_name} is just a little sad…',
    type: 'conversational',
    next_script_id: 'dog_081_03',
  },
  {
    id: 'dog_081_03',
    text_jp: 'おもちゃで遊んで欲しいヌ…',
    text_en: 'I wish you’d give me a toy to play with…',
    type: 'conversational',
  },
  {
    id: 'dog_082_01',
    move_to: 'c',
    text_jp: 'なんでかわからないけど、\nすごく悲しいヌ',
    text_en: 'I don’t know why, but I’m really sad.',
    type: 'conversational',
    next_script_id: 'dog_082_02',
  },
  {
    id: 'dog_082_02',
    animation: 'cry',
    text_jp: '{pet_name}のこと、\nもうちょっとかまって欲しいヌ…',
    text_en: 'I wish you’d play with {pet_name} more…',
    type: 'conversational',
  },
  {
    id: 'dog_083_01',
    move_to: 'c',
    text_jp: '{pet_name}、\nけっこうこまめに\nトイレ行っておきたいタイプだヌ',
    text_en: '{pet_name} wants go to the bathroom pretty regularly.',
    type: 'conversational',
    next_script_id: 'dog_083_02',
  },
  {
    id: 'dog_083_02',
    text_jp: 'トイレ連れて行って\nもらってもいいヌ？',
    text_en: 'Can’t you take me to the bathroom?',
    type: 'conversational',
  },
  {
    id: 'dog_084_01',
    move_to: 'c',
    text_jp: 'だいぶ危険な状況だヌ！',
    text_en: 'It’s getting dangerous!',
    type: 'conversational',
    next_script_id: 'dog_084_02',
  },
  {
    id: 'dog_084_02',
    text_jp: '大惨事になる前に\nトイレお願いするヌ！',
    text_en: 'Please take me to the bathroom before the worst happens!',
    type: 'conversational',
  },
  {
    id: 'dog_085_01',
    move_to: 'c',
    text_jp: 'ものかげに小さいおじさんが\nいた気がするヌ！\n怖いヌ！',
    text_en: 'I think there’s a tiny little man in the shadows!\nI’m scared!',
    type: 'conversational',
    next_script_id: 'dog_085_02',
  },
  {
    id: 'dog_085_02',
    animation: 'cry',
    text_jp: '何か楽しいことしたいヌ！',
    text_en: 'Let’s do something fun!',
    type: 'conversational',
  },
  {
    id: 'dog_086_01',
    move_to: 'c',
    text_jp: 'なんでこんなに苦しいヌ〜？',
    text_en: 'Why do I feel so bad?',
    type: 'conversational',
    next_script_id: 'dog_086_02',
  },
  {
    id: 'dog_086_02',
    text_jp: 'おクスリ、飲ませて欲しいヌ…',
    text_en: "I wish you'd give me some medicine…",
    type: 'conversational',
  },
  {
    id: 'dog_087_01',
    move_to: 'c',
    text_jp: '歯が痛くて何も食べられないヌ！',
    text_en: 'My tooth hurts too much to eat anything!',
    type: 'conversational',
    next_script_id: 'dog_087_02',
  },
  {
    id: 'dog_087_02',
    text_jp: 'おやつ食べ過ぎたのかヌ？',
    text_en: 'Did I eat too many snacks?',
    type: 'conversational',
  },
  {
    id: 'dog_088_01',
    move_to: 'c',
    text_jp: '{player_name}、\nごめんなさいヌ',
    text_en: 'I’m sorry, {player_name}.',
    type: 'conversational',
    next_script_id: 'dog_088_02',
  },
  {
    id: 'dog_088_02',
    text_jp: 'いっぱいかわいがってもらったのに\n{pet_name}、\nしんじゃったヌ',
    text_en: 'You played with {pet_name} so much, but I died.',
    type: 'conversational',
    next_script_id: 'dog_088_03',
  },
  {
    id: 'dog_088_03',
    text_jp:
      '{player_name}が\nいっぱい優しくしてくれたこと\nぜったい忘れないヌ',
    text_en: "I won't forget how nice you were to me, {player_name}.",
    type: 'conversational',
    next_script_id: 'dog_088_04',
  },
  {
    id: 'dog_088_04',
    text_jp: 'もし生まれ変われたら\nまた一緒にあそんで欲しいヌ',
    text_en: 'If I get reborn, I hope you’ll play with me again.',
    type: 'conversational',
  },
  {
    id: 'dog_089_01',
    move_to: 'c',
    text_jp: 'これは危険な状態ヌ…\n早くなんとかしないと\nしんじゃうヌ…',
    text_en:
      'This is a dangerous situation…\nIf you don’t do something, I’m done for…',
    type: 'conversational',
    next_script_id: 'dog_089_02',
  },
  {
    id: 'dog_089_02',
    text_jp: '万能コロンをかけて欲しいヌ',
    text_en: 'Won’t you use the Magic Potion?',
    type: 'conversational',
  },
  {
    id: 'dog_090_01',
    move_to: 'c',
    text_jp:
      'お友だちが呼んでる気がするヌ！\n{pet_name}、\n耳も良いから分かるヌ！',
    text_en:
      'I think I can hear my friend calling!\n{pet_name} has great hearing!',
    type: 'conversational',
    next_script_id: 'dog_090_02',
  },
  {
    id: 'dog_090_02',
    text_jp: 'おでかけしたいヌ〜\nお願いだヌ〜',
    text_en: 'I want to go somewhere!\nPretty please?',
    type: 'conversational',
  },
  {
    id: 'dog_091_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}が\nあそびに来てくれたヌよ〜！\nいっぱいかまってもらったヌ！',
    text_en: '{friend.player_name} came to play!\nWe had lots of fun!',
    type: 'conversational',
    next_script_id: 'dog_091_02',
  },
  {
    id: 'dog_091_02',
    text_jp: '今度は\n{friend.player_name}の\nところにあそびに行こうヌ！',
    text_en: 'Next time, let’s go play at {friend.player_name}’s place!',
    type: 'conversational',
  },
  {
    id: 'dog_092_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n秋の果物で何が好きか聞いたら',
    text_en: 'I asked {friend.player_name} what autumn fruits they like!',
    type: 'conversational',
    next_script_id: 'dog_092_02',
  },
  {
    id: 'dog_092_02',
    text_jp: '{friend.autumn_fruit}って\n言ってたヌ！',
    text_en: 'They said {friend.autumn_fruit}!',
    type: 'conversational',
    next_script_id: 'dog_092_03',
  },
  {
    id: 'dog_092_03',
    text_jp:
      '良いとこついて来るヌ！\n{pet_name}は\nいっぱいあって決められないヌ！',
    text_en: 'Good choice!\n{pet_name} can’t choose, there’s so many!',
    type: 'conversational',
  },
  {
    id: 'dog_093_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n小さい頃流行っていたあそびを\n聞いたら、',
    text_en:
      'I asked {friend.player_name} what game they played when they were little!',
    type: 'conversational',
    next_script_id: 'dog_093_02',
  },
  {
    id: 'dog_093_02',
    text_jp: '{friend.childhood_game}\nって言ってたヌ！',
    text_en: 'They said {friend.childhood_game}!',
    type: 'conversational',
    next_script_id: 'dog_093_03',
  },
  {
    id: 'dog_093_03',
    text_jp: '{player_name}は\nあそんだことあるヌか？',
    text_en: 'Have you played it, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'dog_094_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n今まで行った中で一番\n好きな場所を聞いたら、',
    text_en:
      'I asked {friend.player_name} where their favorite place to visit is!',
    type: 'conversational',
    next_script_id: 'dog_094_02',
  },
  {
    id: 'dog_094_02',
    text_jp: '{friend.favorite_place}\nって言ってたヌ！',
    text_en: 'They said {friend.favorite_place}!',
    type: 'conversational',
    next_script_id: 'dog_094_03',
  },
  {
    id: 'dog_094_03',
    text_jp: '{player_name}は\n行ったことあるヌ？',
    text_en: 'Have you been there, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'dog_095_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n最近買って良かったものを\n聞いたら、',
    text_en:
      'I asked {friend.player_name} if they bought anything new recently!',
    type: 'conversational',
    next_script_id: 'dog_095_02',
  },
  {
    id: 'dog_095_02',
    text_jp: '{friend.best_buy}\nって言ってたヌ！',
    text_en: 'They bought {friend.best_buy}!',
    type: 'conversational',
    next_script_id: 'dog_095_03',
  },
  {
    id: 'dog_095_03',
    animation: 'play',
    text_jp: 'よくわからないけど、\nよほど美味しいものに違いないヌ！',
    text_en: 'I’m not sure what that is, but it sounds delicious!',
    type: 'conversational',
  },
  {
    id: 'dog_096_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n最近の推しを聞いたら、',
    text_en: 'I asked {friend.player_name} what they’re into lately.',
    type: 'conversational',
    next_script_id: 'dog_096_02',
  },
  {
    id: 'dog_096_02',
    text_jp: '{friend.recent_fave}\nって言ってたヌ！',
    text_en: 'They said {friend.recent_fave}!',
    type: 'conversational',
    next_script_id: 'dog_096_03',
  },
  {
    id: 'dog_096_03',
    animation: 'play',
    text_jp: '今度語ってみるといいヌ！',
    text_en: 'You should ask them about that!',
    type: 'conversational',
  },
  {
    id: 'dog_097_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな四字熟語を聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite saying is!',
    type: 'conversational',
    next_script_id: 'dog_097_02',
  },
  {
    id: 'dog_097_02',
    text_jp: '{friend.compound_word}\nって言ってたヌ！',
    text_en: 'The said it’s {friend.compound_word}!',
    type: 'conversational',
    next_script_id: 'dog_097_03',
  },
  {
    id: 'dog_097_03',
    text_jp: 'あふれる知性を感じるヌ！',
    text_en: 'They’re super smart!',
    type: 'conversational',
  },
  {
    id: 'dog_098_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n生まれ変わったら何に\nなりたいか聞いたら、',
    text_en:
      'I asked {friend.player_name} what they’d want to be if they were reincarnated!',
    type: 'conversational',
    next_script_id: 'dog_098_02',
  },
  {
    id: 'dog_098_02',
    text_jp: '{friend.reincarnation}\nって言ってたヌ！',
    text_en: 'They said a {friend.reincarnation}!',
    type: 'conversational',
    next_script_id: 'dog_098_03',
  },
  {
    id: 'dog_098_03',
    text_jp: 'じっくり理由を\n聞かせてもらいたいヌ',
    text_en: 'You should ask them why!',
    type: 'conversational',
  },
  {
    id: 'dog_099_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n自分の身体の好きな\nパーツを聞いたら、',
    text_en:
      'I asked {friend.player_name} what their favorite part of their body is.',
    type: 'conversational',
    next_script_id: 'dog_099_02',
  },
  {
    id: 'dog_099_02',
    text_jp: '{friend.body_part}\nって言ってたヌ！',
    text_en: 'They said {friend.body_part}!',
    type: 'conversational',
    next_script_id: 'dog_099_03',
  },
  {
    id: 'dog_099_03',
    text_jp: '{pet_name}は\n密かにおしりに自信があるヌ！',
    text_en: '{pet_name} likes my own butt!',
    type: 'conversational',
  },
  {
    id: 'dog_100_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n有名人で誰に似ているって\n言われるか聞いたら、',
    text_en:
      'I asked {friend.player_name} what celebrity people say they look like!',
    type: 'conversational',
    next_script_id: 'dog_100_02',
  },
  {
    id: 'dog_100_02',
    text_jp: '{friend.similar_celebrities}\nって言ってたヌ！',
    text_en: 'They said {friend.similar_celebrities}',
    type: 'conversational',
    next_script_id: 'dog_100_03',
  },
  {
    id: 'dog_100_03',
    text_jp: '目元、とかヌかね…？',
    text_en: 'Maybe around the eyes?',
    type: 'conversational',
  },
  {
    id: 'dog_101_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n夏の定番メニューを聞いたら',
    text_en: 'I asked {friend.player_name} what their favorite summer food is!',
    type: 'conversational',
    next_script_id: 'dog_101_02',
  },
  {
    id: 'dog_101_02',
    text_jp: '{friend.summer_menu}\nって言ってたヌ！',
    text_en: 'They said {friend.summer_menu}!',
    type: 'conversational',
    next_script_id: 'dog_101_03',
  },
  {
    id: 'dog_101_03',
    text_jp: '暑い夏もこれでバッチリだヌ！',
    text_en: 'We’ve got summer figured out!',
    type: 'conversational',
  },
  {
    id: 'dog_102_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n暑いのと寒いの\nどっちが好きか聞いたら、',
    text_en:
      'When I asked {friend.player_name} if they like it hot or cold best…',
    type: 'conversational',
    case: 'friend.hot_or_cold',
    next_script_id_1: 'dog_102_02',
    next_script_id_2: 'dog_102_04',
  },
  {
    id: 'dog_102_02',
    text_jp: '暑いのが好きって言ってたヌ！',
    text_en: 'They said they like it hot!',
    type: 'conversational',
    next_script_id: 'dog_102_03',
  },
  {
    id: 'dog_102_03',
    text_jp: '{pet_name}は\n暑いのは苦手だけど、\nカキ氷は好きヌ！',
    text_en: "{pet_name}'s not a fan of the heat, but I love shaved ice!",
    type: 'conversational',
  },
  {
    id: 'dog_102_04',
    text_jp: '寒いのが好きって言ってたヌ！',
    text_en: 'They said they like it cold!',
    type: 'conversational',
    next_script_id: 'dog_102_05',
  },
  {
    id: 'dog_102_05',
    text_jp: '{pet_name}も\n寒いとうれしくなっちゃうヌ！\nキャンキャン！',
    text_en: '{pet_name} likes when it gets cold, too! \nWoof! Woof!',
    type: 'conversational',
  },
  {
    id: 'dog_103_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n春と秋どっちが好きか聞いたら、',
    text_en:
      'When I asked {friend.player_name} if they like Spring or Fall best…',
    type: 'conversational',
    case: 'friend.spring_or_fall',
    next_script_id_1: 'dog_103_02',
    next_script_id_2: 'dog_103_04',
  },
  {
    id: 'dog_103_02',
    text_jp: '春が好きって言ってたヌ！',
    text_en: 'They said Spring!',
    type: 'conversational',
    next_script_id: 'dog_103_03',
  },
  {
    id: 'dog_103_03',
    text_jp: 'お花見に誘ってみるといいヌ！',
    text_en: 'You should ask them to go for a walk!',
    type: 'conversational',
  },
  {
    id: 'dog_103_04',
    text_jp: '秋が好きって言ってたヌ！',
    text_en: 'They said Fall!',
    type: 'conversational',
    next_script_id: 'dog_103_05',
  },
  {
    id: 'dog_103_05',
    text_jp: '{friend.player_name}の\nイメージにぴったりだと思うヌ！',
    text_en: 'That’s so like {friend.player_name}!',
    type: 'conversational',
  },
  {
    id: 'dog_104_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は\nお世話するのとされるのだと',
    text_en:
      'I asked {friend.player_name} if they would rather give help, or get help!',
    type: 'conversational',
    case: 'friend.care_or_cared',
    next_script_id_1: 'dog_104_02',
    next_script_id_2: 'dog_104_04',
  },
  {
    id: 'dog_104_02',
    text_jp: 'お世話する方が多いらしいヌ！',
    text_en: 'They’d rather give help!',
    type: 'conversational',
    next_script_id: 'dog_104_03',
  },
  {
    id: 'dog_104_03',
    text_jp: '積極的にお世話されていきたいヌ！',
    text_en: "I hope they'll help me, {friend.player_name}!",
    type: 'conversational',
  },
  {
    id: 'dog_104_04',
    text_jp: 'お世話される方が多いらしいヌ！',
    text_en: 'They’d rather get help!',
    type: 'conversational',
    next_script_id: 'dog_104_05',
  },
  {
    id: 'dog_104_05',
    text_jp: '{pet_name}も、\n今までだいたいお世話されて\n生きてきたヌ！',
    text_en: '{pet_name} has been getting helped all my life!',
    type: 'conversational',
  },
  {
    id: 'dog_105_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n占いは信じるかどうか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they believe in fortune-telling!',
    type: 'conversational',
    case: 'friend.fortune_telling',
    next_script_id_1: 'dog_105_02',
    next_script_id_2: 'dog_105_04',
  },
  {
    id: 'dog_105_02',
    text_jp: 'けっこう信じちゃうタイプ\nらしいヌ！',
    text_en: 'They said they kind of do!',
    type: 'conversational',
    next_script_id: 'dog_105_03',
  },
  {
    id: 'dog_105_03',
    text_jp: '{pet_name}は、\n良い結果は積極的に\n信じていきたいタイプだヌ！',
    text_en: '{pet_name} believes in it if it’s positive!',
    type: 'conversational',
  },
  {
    id: 'dog_105_04',
    text_jp: 'あまり信じないタイプ\nらしいヌ！',
    text_en: 'They said not really!',
    type: 'conversational',
    next_script_id: 'dog_105_05',
  },
  {
    id: 'dog_105_05',
    text_jp: 'たしかにそんな感じするヌよね！',
    text_en: 'That makes sense!',
    type: 'conversational',
  },
  {
    id: 'dog_106_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n人の顔と名前を覚えるのは',
    text_en:
      'Do you think {friend.player_name} is good at remembering names and faces?',
    type: 'conversational',
    case: 'friend.remember_face_and_name',
    next_script_id_1: 'dog_106_02',
    next_script_id_2: 'dog_106_04',
  },
  {
    id: 'dog_106_02',
    text_jp: 'けっこう得意なほうらしいヌ！',
    text_en: 'They said they’re pretty good at it!',
    type: 'conversational',
    next_script_id: 'dog_106_03',
  },
  {
    id: 'dog_106_03',
    text_jp: 'ぜひコツを知りたいヌ！',
    text_en: 'I’d love to learn how!',
    type: 'conversational',
  },
  {
    id: 'dog_106_04',
    text_jp: 'あまり得意じゃないらしいヌ！',
    text_en: "They said they're not too good at it!",
    type: 'conversational',
    next_script_id: 'dog_106_05',
  },
  {
    id: 'dog_106_05',
    text_jp: 'ちょいちょい自己紹介した方が\nいいかもしれないヌ！',
    text_en: 'You might have to remind them every once in a while!',
    type: 'conversational',
  },
  {
    id: 'dog_107_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は\n異性か同性かだと',
    text_en:
      'Between the same or opposite gender, {friend.player_name} said they’re more popular…',
    type: 'conversational',
    case: 'friend.same_or_opposite_gender',
    next_script_id_1: 'dog_107_02',
    next_script_id_2: 'dog_107_04',
  },
  {
    id: 'dog_107_02',
    text_jp: '異性にモテるタイプらしいヌ！',
    text_en: '…with the opposite gender!',
    type: 'conversational',
    next_script_id: 'dog_107_03',
  },
  {
    id: 'dog_107_03',
    text_jp: '実際のとこ、どうヌか？',
    text_en: 'I wonder if it’s true?',
    type: 'conversational',
  },
  {
    id: 'dog_107_04',
    text_jp: '同性にモテるタイプらしいヌ！',
    text_en: '…with the same gender!',
    type: 'conversational',
    next_script_id: 'dog_107_05',
  },
  {
    id: 'dog_107_05',
    text_jp: '同性に好かれるのって\nいいヌよね',
    text_en: 'That must be nice!',
    type: 'conversational',
  },
  {
    id: 'dog_108_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n1人で焼肉屋さんに\n行けるか聞いたら',
    text_en:
      'I asked {friend.player_name} if their the type that can go to a BBQ place alone!',
    type: 'conversational',
    case: 'friend.solo_yakiniku',
    next_script_id_1: 'dog_108_02',
    next_script_id_2: 'dog_108_04',
  },
  {
    id: 'dog_108_02',
    text_jp: '余裕で行けるって言ってたヌ！',
    text_en: 'They said no problem!',
    type: 'conversational',
    next_script_id: 'dog_108_03',
  },
  {
    id: 'dog_108_03',
    text_jp: 'たまには一緒に\n連れて行って欲しいヌね！',
    text_en: 'They should take us with them sometime!',
    type: 'conversational',
  },
  {
    id: 'dog_108_04',
    text_jp: '1人で行くのはまだ無理って\n言ってたヌ！',
    text_en: 'They said they couldn’t go by themselves!',
    type: 'conversational',
    next_script_id: 'dog_108_05',
  },
  {
    id: 'dog_108_05',
    text_jp: '今度誘って一緒に行くといいヌ！',
    text_en: 'You should invite them to go together sometime!',
    type: 'conversational',
  },
  {
    id: 'dog_109_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\nマンガとアニメどっちが\n好きか聞いたら、',
    text_en: 'I asked {friend.player_name} if they like manga or anime better!',
    type: 'conversational',
    case: 'friend.manga_or_anime',
    next_script_id_1: 'dog_109_02',
    next_script_id_2: 'dog_109_04',
  },
  {
    id: 'dog_109_02',
    text_jp: 'マンガのほうが好きって\n言ってたヌ！',
    text_en: 'They said manga!',
    type: 'conversational',
    next_script_id: 'dog_109_03',
  },
  {
    id: 'dog_109_03',
    text_jp: '今度オススメのマンガを\n聞いてみるといいヌ！',
    text_en: 'You should ask them for recommendations!',
    type: 'conversational',
  },
  {
    id: 'dog_109_04',
    text_jp: 'アニメのほうが好きって\n言ってたヌ！',
    text_en: 'They said anime!',
    type: 'conversational',
    next_script_id: 'dog_109_05',
  },
  {
    id: 'dog_109_05',
    text_jp: '今度オススメのアニメを\n聞いてみるといいヌ！',
    text_en: 'You should ask them for recommendations!',
    type: 'conversational',
  },
  {
    id: 'dog_110_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n歯みがき粉を',
    text_en: 'When {friend.player_name} uses toothpaste…',
    type: 'conversational',
    case: 'friend.tooth_paste',
    next_script_id_1: 'dog_110_02',
    next_script_id_2: 'dog_110_04',
  },
  {
    id: 'dog_110_02',
    text_jp: '最後まできっちり使い切れる\nタイプらしいヌ！',
    text_en: '…they use up the entire tube!',
    type: 'conversational',
    next_script_id: 'dog_110_03',
  },
  {
    id: 'dog_110_03',
    text_jp: 'シンプルにえらいヌ！',
    text_en: 'Good for them!',
    type: 'conversational',
  },
  {
    id: 'dog_110_04',
    text_jp: 'なかなか最後まで\n使い切れないタイプらしいヌ！',
    text_en: '…they don’t use up the entire tube!',
    type: 'conversational',
    next_script_id: 'dog_110_05',
  },
  {
    id: 'dog_110_05',
    text_jp: '意外と人間らしいところあるヌ！',
    text_en: 'Everyone can relate to that!',
    type: 'conversational',
  },
  {
    id: 'dog_111_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に、\n辛い食べ物は得意か聞いたら、',
    text_en: 'I asked {friend.player_name} if they like spicy food!',
    type: 'conversational',
    case: 'friend.spicy_food',
    next_script_id_1: 'dog_111_02',
    next_script_id_2: 'dog_111_04',
  },
  {
    id: 'dog_111_02',
    text_jp: '超得意って言ってたヌ！',
    text_en: 'They said they love it!',
    type: 'conversational',
    next_script_id: 'dog_111_03',
  },
  {
    id: 'dog_111_03',
    text_jp: '今度激辛料理のお店に\n一緒に行ってみるといいヌ！',
    text_en: 'You should go to a spicy restaurant with them!',
    type: 'conversational',
  },
  {
    id: 'dog_111_04',
    text_jp: 'あまり得意じゃないって\n言ってたヌ！',
    text_en: 'They said not really!',
    type: 'conversational',
    next_script_id: 'dog_111_05',
  },
  {
    id: 'dog_111_05',
    text_jp: '{pet_name}も、\n辛すぎるのは苦手だヌ！\nあまからこそ至高だヌ！',
    text_en:
      '{pet_name} isn’t good with spicy food, either!\nMild spice is the best!',
    type: 'conversational',
  },
  {
    id: 'dog_112_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n流行には',
    text_en: 'When it comes to trends, {friend.player_name} is…',
    type: 'conversational',
    case: 'friend.sensitive_to_fads',
    next_script_id_1: 'dog_112_02',
    next_script_id_2: 'dog_112_04',
  },
  {
    id: 'dog_112_02',
    text_jp: 'けっこう敏感なほうらしいヌ！',
    text_en: 'pretty in touch with what’s popular!',
    type: 'conversational',
    next_script_id: 'dog_112_03',
  },
  {
    id: 'dog_112_03',
    text_jp: '今度、次に来るものを\n聞いてみるといいヌ！',
    text_en: 'You should ask them for recommendations!',
    type: 'conversational',
  },
  {
    id: 'dog_112_04',
    text_jp: 'あまり敏感じゃないらしいヌ！',
    text_en: 'not that in touch with what’s popular!',
    type: 'conversational',
    next_script_id: 'dog_112_05',
  },
  {
    id: 'dog_112_05',
    text_jp: '最近流行っているものを\n教えてあげるといいヌ！',
    text_en: 'You should let them know what’s hot!',
    type: 'conversational',
  },
  {
    id: 'dog_113_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\nもし付き合うとしたら',
    text_en: 'If {friend.player_name} was going to date someone…',
    type: 'conversational',
    case: 'friend.everyone_or_only_you',
    next_script_id_1: 'dog_113_02',
    next_script_id_2: 'dog_113_04',
  },
  {
    id: 'dog_113_02',
    text_jp: '誰にでも優しい人がいいらしいヌ！',
    text_en: '…they like a person who’s nice to everyone!',
    type: 'conversational',
    next_script_id: 'dog_113_03',
  },
  {
    id: 'dog_113_03',
    text_jp: 'やっぱりみんなに優しく\nできる人がいいヌね',
    text_en: 'Everyone likes a person who’s nice all-around!',
    type: 'conversational',
  },
  {
    id: 'dog_113_04',
    text_jp: '自分だけに優しい人が\nいいらしいヌ！',
    text_en: '…they like a person who’s only nice to them!',
    type: 'conversational',
    next_script_id: 'dog_113_05',
  },
  {
    id: 'dog_113_05',
    text_jp: 'その気持ち、\nちょっとわかるヌ！',
    text_en: 'I super get how the feel!',
    type: 'conversational',
  },
  {
    id: 'dog_114_01',
    move_to: 'c',
    text_jp: 'これからもいっぱい\n遊んでほしいヌ！\nキャンキャン！',
    text_en: 'I hope you play with me a lot more! \nWoof! Woof!',
    type: 'conversational',
  },
  {
    id: 'dog_115_01',
    animation: 'waive',
    text_jp: 'あそびに来たヌ！\nおじゃましますヌ！',
    text_en: 'I’m here to play!\nThanks for having me!',
    type: 'conversational',
  },
  {
    id: 'dog_116_01',
    animation: 'waive',
    text_jp: 'よく来てくれましたヌ！\nゆっくりしていって欲しいヌ！',
    text_en: 'Thanks for coming!\nMake yourself at home!',
    type: 'conversational',
  },
  {
    id: 'dog_117_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'いっぱいかまってくれてうれしいヌ\nこれ、感謝の気持ちヌ',
    text_en:
      'I’m so happy you’re spending time with me!\nHere’s a little something from me!',
    type: 'conversational',
  },
  {
    id: 'dog_118_01',
    animation: 'waive',
    text_jp: 'そろそろおいとまするヌ\nうちにもあそびに来て欲しいヌ！',
    text_en: 'I’ve got to get going.\nCome to my place next time!',
    type: 'conversational',
  },
  {
    id: 'dog_119_01',
    animation: 'waive',
    text_jp: '今日は来てくれてありがとヌ！\nまたいつでも来て欲しいヌ！',
    text_en: 'Thanks for coming today!\nCome back soon!',
    type: 'conversational',
  },
  {
    id: 'dog_120_01',
    text_jp: 'あ、\n{friend.player_name}が\n帰ってきたみたいヌね',
    text_en: 'Oh, looks like {friend.player_name} is back.',
    type: 'conversational',
    next_script_id: 'dog_120_02',
  },
  {
    id: 'dog_120_02',
    animation: 'waive',
    text_jp: 'あまり長居してもわるいヌから、\nこのへんでおいとまするヌ',
    text_en: "I don't want to overstay my welcome, so I’ll get going.",
    type: 'conversational',
  },
  {
    id: 'dog_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないヌ',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'dog_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないヌ',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'dog_123_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今はつらすぎて無理ヌ〜\n万能コロンをかけて欲しいヌ…',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'dog_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '今は何よりもおでかけしたい\n気分ヌ〜\nおでかけさせて欲しいヌ〜',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'dog_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったヌ！\nありがとヌ〜',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'dog_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったヌ！\nありがとヌ〜',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'dog_127_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ふー。助かったヌ〜\n九死に一生ヌ〜',
    text_en: 'Phew! You saved me!\nThat was a close one…',
    type: 'conversational',
  },
  {
    id: 'dog_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったヌ…\nもう1回、試してみてくれるヌ？',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'dog_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'まだ痛いヌ\nもう1回試してみて欲しいヌ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'dog_130_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'まだ治ってないヌ〜…\nもう1回お願いするヌ〜',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'starball_001_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}、\n今日も一緒にころころするスタ★',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'starball_002_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'お、おはようスタ',
    text_en: "G.. Good mornin'",
    type: 'conversational',
    next_script_id: 'starball_002_02',
  },
  {
    id: 'starball_002_02',
    expression: 'normal',
    text_jp: '{player_name}は、\n昨日はよく眠れたスタ？',
    text_en: '{player_name},\nDid you sleep well last night?',
    type: 'selectional',
    answer_var: 'sleep_well',
    option_1_jp: 'はい',
    option_1_en: 'Yes',
    option_2_jp: 'いいえ',
    option_2_en: 'No',
    case: 'sleep_well',
    next_script_id_1: 'starball_002_03',
    next_script_id_2: 'starball_002_04',
  },
  {
    id: 'starball_002_03',
    expression: 'happy',
    text_jp: 'よかったスタ\n{pet_name}もスタ★',
    text_en: 'Good, good.\nI did too!',
    type: 'conversational',
  },
  {
    id: 'starball_002_04',
    expression: 'normal',
    text_jp: '寝不足は体によくないスタ〜',
    text_en: 'Lack of sleep is not good for you.',
    type: 'conversational',
  },
  {
    id: 'starball_003_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'は、はろー★',
    text_en: 'H.. Hello...',
    type: 'conversational',
    next_script_id: 'starball_003_02',
  },
  {
    id: 'starball_003_02',
    expression: 'happy',
    text_jp: '...英語でも挨拶できるスタ',
    text_en: "... I'm learning English.",
    type: 'conversational',
  },
  {
    id: 'starball_004_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}、\nき、聞いてほしいスタ',
    text_en: '{player_name}, \nL.. Listen to me.',
    type: 'conversational',
    next_script_id: 'starball_004_02',
  },
  {
    id: 'starball_004_02',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '無理やりスキージャンプを\nさせられる夢を見たスタ...',
    text_en: 'I dreamed that I was forced to ski jump',
    type: 'conversational',
    next_script_id: 'starball_004_03',
  },
  {
    id: 'starball_004_03',
    animation: 'cry',
    text_jp: '流れ星になるかと思ったスタ',
    text_en: 'I thought I was going to be a shooting star.',
    type: 'conversational',
  },
  {
    id: 'starball_005_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}、\n聞いてほしいスタ',
    text_en: '{player_name}, \nListen to me.',
    type: 'conversational',
    next_script_id: 'starball_005_02',
  },
  {
    id: 'starball_005_02',
    animation: 'joy',
    text_jp: '絆創膏の匂いを嗅ぐのが\nやめられないスタ...',
    text_en: "I can't stop smelling the band-aid...",
    type: 'conversational',
  },
  {
    id: 'starball_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{pet_name}は\n金平糖に似てるって言われるスタ',
    text_en: 'People say I look like a "kompeito."',
    type: 'conversational',
    next_script_id: 'starball_006_02',
  },
  {
    id: 'starball_006_02',
    expression: 'normal',
    text_jp: 'ところで金平糖は大きな釜で\n2週間もころころして作られるスタ',
    text_en:
      'By the way, kompeito is made by spinning in a big pot for two weeks.',
    type: 'conversational',
    next_script_id: 'starball_006_03',
  },
  {
    id: 'starball_006_03',
    animation: 'surprised',
    text_jp: '目が回るスタ...',
    text_en: 'I feel dizzy...',
    type: 'conversational',
  },
  {
    id: 'starball_007_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}、\nどっちの気分スタ？',
    text_en: '{player_name}\nWhich do you want to eat?',
    type: 'selectional',
    answer_var: 'plum_or_fish',
    option_1_jp: 'うめぼし',
    option_1_en: 'Dried plum',
    option_2_jp: '一夜干し',
    option_2_en: 'Dried fish',
    case: 'plum_or_fish',
    next_script_id_1: 'starball_007_02',
    next_script_id_2: 'starball_007_03',
  },
  {
    id: 'starball_007_02',
    animation: 'surprised',
    text_jp: 'スッぱいものが好きスタね〜',
    text_en: 'You like sour food, {player_name}.',
    type: 'conversational',
  },
  {
    id: 'starball_007_03',
    expression: 'happy',
    text_jp: 'ショッぱいものが\n食べたい気分スタ？',
    text_en: "You feel like to eat a salty food, don't you?",
    type: 'conversational',
  },
  {
    id: 'starball_008_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '目玉焼きには何をかけるスタ？',
    text_en: 'What do you put on a fried egg?',
    type: 'selectional',
    answer_var: 'sunny_side_up',
    option_1_jp: 'しょう油',
    option_1_en: 'Soy sauce',
    option_2_jp: 'ソース',
    option_2_en: 'Tonkatsu source',
    option_3_jp: 'それ以外',
    option_3_en: 'Other',
    case: 'sunny_side_up',
    next_script_id_1: 'starball_008_02',
    next_script_id_2: 'starball_008_03',
    next_script_id_3: 'starball_008_04',
  },
  {
    id: 'starball_008_02',
    expression: 'happy',
    text_jp: '{sunny_side_up}派スタ〜\n一番一般的スタね〜',
    text_en: 'Hmm, {sunny_side_up}...\nThat is common.',
    type: 'conversational',
  },
  {
    id: 'starball_008_03',
    expression: 'happy',
    text_jp: '{sunny_side_up}派スタ〜\n少数派スタね〜',
    text_en: 'Hmm, {sunny_side_up}...\nYou are in the minority.',
    type: 'conversational',
  },
  {
    id: 'starball_008_04',
    expression: 'happy',
    text_jp: '{sunny_side_up}派スタ〜\n塩こしょうスタ？',
    text_en: 'Hmm, {sunny_side_up}...\nSalt and pepper?',
    type: 'conversational',
    next_script_id: 'starball_008_05',
  },
  {
    id: 'starball_008_05',
    animation: 'surprised',
    text_jp: 'まさかケチャップじゃ\nないスタよね？',
    text_en: "You don't mean ketchup, do you?",
    type: 'conversational',
  },
  {
    id: 'starball_009_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きなアニメはなにスタ？',
    text_en: '{player_name},\nWhat anime do you like best?',
    type: 'descriptive',
    answer_var: 'fav_anime',
    question_jp: '好きなアニメ',
    question_en: 'Favorite anime',
    max_len: 14,
    next_script_id: 'starball_009_02',
  },
  {
    id: 'starball_009_02',
    animation: 'surprised',
    text_jp: 'へぇ\n{fav_anime}\nスタか〜',
    text_en: 'Eh,\n{fav_anime}!!',
    type: 'conversational',
    next_script_id: 'starball_009_03',
  },
  {
    id: 'starball_009_03',
    expression: 'normal',
    text_jp: 'ごめんスタ\n聞いたこともないスタ',
    text_en: 'Sorry, I have never even heard the title.',
    type: 'conversational',
  },
  {
    id: 'starball_010_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次の中で実在しない星座は\nどれかわかるスタ？',
    text_en: 'Which of the following constellations is not real?',
    type: 'selectional',
    answer_var: 'true_constellation',
    option_1_jp: 'けんびきょう座',
    option_1_en: 'Microscopium',
    option_2_jp: 'そうがんきょう座',
    option_2_en: 'Binoculapium',
    option_3_jp: 'ぼうえんきょう座',
    option_3_en: 'Telescopium',
    next_script_id: 'starball_010_02',
  },
  {
    id: 'starball_010_02',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    text_en_alt: 'The answer is...',
    type: 'conversational',
    next_script_id: 'starball_010_03',
  },
  {
    id: 'starball_010_03',
    expression: 'happy',
    text_jp: '「そうがんきょう座」スタ！',
    text_en: 'Binoculapium!',
    type: 'conversational',
    next_script_id: 'starball_010_04',
  },
  {
    id: 'starball_010_04',
    animation: 'play',
    text_jp: 'けんびきょう座も\nぼうえんきょう座も\n南のお空に見える星座スタ★',
    text_en:
      'Both the Microscopium and the Telescopium are visible in the southern sky.',
    text_en_alt:
      'Both the Microscopium and the Telescopium are visible in the sky.',
    type: 'conversational',
  },
  {
    id: 'starball_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'テンションが上がると\n顔が赤くなるスタ',
    text_en: 'When I get excited, I get red in the face.',
    type: 'conversational',
    next_script_id: 'starball_011_02',
  },
  {
    id: 'starball_011_02',
    animation: 'angry',
    text_jp: 'こんな感じスタ！',
    text_en: 'Like this!',
    type: 'conversational',
  },
  {
    id: 'starball_012_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'お金が落ちてる...！',
    text_en: 'I found the money!',
    type: 'conversational',
    next_script_id: 'starball_012_02',
  },
  {
    id: 'starball_012_02',
    expression: 'normal',
    text_jp: 'と思ったらなんかのフタだったスタ',
    text_en: '...It was a lid of some kind.',
    type: 'conversational',
  },
  {
    id: 'starball_013_01',
    expression: 'happy',
    move_to: 'tl',
    text_jp: 'スタスタスタ〜',
    text_en: 'Sta-Sta-Star★',
    type: 'conversational',
    next_script_id: 'starball_013_02',
  },
  {
    id: 'starball_013_02',
    expression: 'happy',
    move_to: 'tr',
    text_jp: 'スタスタスタスタ〜',
    text_en: 'Sta-Sta-Sta-Star★',
    type: 'conversational',
    next_script_id: 'starball_013_03',
  },
  {
    id: 'starball_013_03',
    expression: 'happy',
    move_to: 'bl',
    text_jp: 'スタスタスタスタスタ〜',
    text_en: 'Sta-Sta-Sta-Sta-Star★',
    type: 'conversational',
  },
  {
    id: 'starball_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '口の中でぱちぱち弾けるキャンディ\n食べたことあるスタ？',
    text_en: 'Have you ever had candy that pops in your mouth?',
    type: 'conversational',
    next_script_id: 'starball_014_02',
  },
  {
    id: 'starball_014_02',
    animation: 'joy',
    text_jp: 'あれは炭酸ジュースを作る時に\n偶然できたものらしいスタ★',
    text_en:
      'That was accidentaly created during the process of making carbonated juice.',
    type: 'conversational',
  },
  {
    id: 'starball_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちを体験してみたいスタ？',
    text_en: 'Which do you want to experience?',
    type: 'selectional',
    answer_var: 'safari_or_aurora',
    option_1_jp: 'アフリカでサファリ',
    option_1_en: 'Safari in Africa',
    option_2_jp: 'アラスカでオーロラ',
    option_2_en: 'Aurora in Alaska',
    case: 'safari_or_aurora',
    next_script_id_1: 'starball_015_02',
    next_script_id_2: 'starball_015_03',
  },
  {
    id: 'starball_015_02',
    expression: 'happy',
    text_jp:
      'わかるスタ！\nサバンナをジープで駆けて\n動物を愛でまくりたいスタね〜★',
    text_en:
      'I agree! I want to drive through the savannah and love all the animals.',
    type: 'conversational',
  },
  {
    id: 'starball_015_03',
    animation: 'joy',
    text_jp:
      'わかるスタ！\n一生に一度はこの目でオーロラを\n見てみたいスタね〜★',
    text_en: 'I agree! I want to see an aurora at least once in my lifetime.',
    type: 'conversational',
  },
  {
    id: 'starball_016_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'おなかが...\nおなかがすいたスタ...',
    text_en: "I'm... I'm hungry...",
    type: 'conversational',
  },
  {
    id: 'starball_017_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'ご、ごはんは\nまだかスタ...？',
    text_en: 'Is my food ready yet?',
    type: 'conversational',
    next_script_id: 'starball_017_02',
  },
  {
    id: 'starball_017_02',
    animation: 'cry',
    text_jp: 'おなかすきすぎて\n多めに震えるスタ...',
    text_en: "I'm starving and shivering...",
    type: 'conversational',
  },
  {
    id: 'starball_018_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'ん？なんだか体がきたないスタ',
    text_en: 'Hm? Looks like my body is a bit dirty.',
    type: 'conversational',
    next_script_id: 'starball_018_02',
  },
  {
    id: 'starball_018_02',
    expression: 'very_sad',
    text_jp: 'そろそろお風呂に入って\nキラキラになりたいスタ',
    text_en: 'I want to take a bath and be shiny.',
    type: 'conversational',
  },
  {
    id: 'starball_019_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '体のあちこちがかゆいスタ...！',
    text_en: "I'm itchy...!",
    type: 'conversational',
    next_script_id: 'starball_019_02',
  },
  {
    id: 'starball_019_02',
    animation: 'angry',
    text_jp: 'お願いだからそろそろ\nお風呂にいれてほしいスタ...！',
    text_en: "It's about time you bathe me.",
    type: 'conversational',
  },
  {
    id: 'starball_020_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '{player_name}に\nお願いがあるスタ',
    text_en: 'I beg you, {player_name}.',
    type: 'conversational',
    next_script_id: 'starball_020_02',
  },
  {
    id: 'starball_020_02',
    animation: 'cry',
    text_jp: '{pet_name}と\n一緒に遊んでほしいスタ...',
    text_en: 'Please play with me.',
    type: 'conversational',
  },
  {
    id: 'starball_021_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'さみしすぎて震えるスタ...！',
    text_en: "I'm so lonely, I'm shaking.",
    type: 'conversational',
    next_script_id: 'starball_021_02',
  },
  {
    id: 'starball_021_02',
    animation: 'cry',
    text_jp: '一緒にぶるぶる遊んでほしいスタ！',
    text_en: 'Please, please play with me...!',
    type: 'conversational',
  },
  {
    id: 'starball_022_01',
    move_to: 'c',
    text_jp: 'そろそろおトイレにつれて\nいってほしいスタ★',
    text_en: 'I want you to take me to the bathroom.',
    type: 'conversational',
  },
  {
    id: 'starball_023_01',
    move_to: 'c',
    text_jp: '{player_name}！\nトイレにいきたいスタ...！',
    text_en: '{player_name}!\nI want to go pee...!',
    type: 'conversational',
    next_script_id: 'starball_023_02',
  },
  {
    id: 'starball_023_02',
    animation: 'cry',
    text_jp: 'いかないと、頂点から\nなんか漏れそうスタ...！',
    text_en: "If not, I'll leak something...!",
    type: 'conversational',
  },
  {
    id: 'starball_024_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'さっきいきなり電気が消えて\n怖かったスタ...',
    text_en: 'The lights suddenly went out. I was scared.',
    type: 'conversational',
    next_script_id: 'starball_024_02',
  },
  {
    id: 'starball_024_02',
    animation: 'cry',
    text_jp: 'なんかして落ち着かせてほしいスタ',
    text_en: 'I want you to calm me down.',
    type: 'conversational',
    next_script_id: 'starball_024_03',
  },
  {
    id: 'starball_024_03',
    animation: 'surprised',
    text_jp: '暗いのが苦手なホシもいるスタよ...',
    text_en: "I'm a star but not good at darkness...",
    type: 'conversational',
  },
  {
    id: 'starball_025_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'なんだかめまいがするスタ...',
    text_en: 'I feel dizzy...',
    type: 'conversational',
    next_script_id: 'starball_025_02',
  },
  {
    id: 'starball_025_02',
    expression: 'very_sad',
    text_jp: 'おクスリを飲ませてほしいスタ',
    text_en: 'Please give me some medicine.',
    type: 'conversational',
  },
  {
    id: 'starball_026_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: '歯が、歯がいたいスタ...！',
    text_en: 'I, I have a toothache...!',
    type: 'conversational',
    next_script_id: 'starball_026_02',
  },
  {
    id: 'starball_026_02',
    animation: 'angry',
    text_jp: 'いたくて何も手につかないスタ...！',
    text_en: "I can't do anything by the pain...!",
    type: 'conversational',
  },
  {
    id: 'starball_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ふぁ〜〜\nそろそろ眠くなってきたスタ',
    text_en: "I'm drowsy now...",
    type: 'conversational',
    next_script_id: 'starball_027_02',
  },
  {
    id: 'starball_027_02',
    animation: 'waive',
    text_jp: '明日もいっぱい遊んでほしいスタ',
    text_en: 'Please play a lot tomorrow.',
    type: 'conversational',
  },
  {
    id: 'starball_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'スタスタ？\nなんだかからだがムズムズするスタ',
    text_en: 'Sta-sta?\nMy body feels kind of mushy.',
    type: 'conversational',
  },
  {
    id: 'starball_029_01',
    move_to: 'c',
    text_jp: 'しんじゃったスタ…',
    text_en: 'I’m dead…',
    type: 'conversational',
    next_script_id: 'starball_029_02',
  },
  {
    id: 'starball_029_02',
    text_jp:
      '短いあいだだったスタけど、\nこれまで優しくしてくれて\nどうもありがとスタ',
    text_en: 'It was only for a little while, but thanks for being nice to me.',
    type: 'conversational',
    next_script_id: 'starball_029_03',
  },
  {
    id: 'starball_029_03',
    text_jp:
      'もし生まれ変わっても、また\n{player_name}の\nところの子になりたいスタ',
    text_en: 'If I get reborn, I want to be your pet again,\n{player_name}.',
    type: 'conversational',
  },
  {
    id: 'starball_030_01',
    move_to: 'c',
    text_jp: 'これ、やばいスタ\nほっとくとしんじゃうスタ',
    text_en: 'This is bad.\nI’m going to die if you don’t do something.',
    type: 'conversational',
    next_script_id: 'starball_030_02',
  },
  {
    id: 'starball_030_02',
    text_jp: '万能コロンをシュッシュして\n欲しいスタ〜',
    text_en: 'Please spray me with the Magic Potion!',
    type: 'conversational',
  },
  {
    id: 'starball_031_01',
    move_to: 'c',
    text_jp: 'おでかけしたいスタ\nおでかけしたいスタ',
    text_en: 'I wanna go out!\nI wanna go out!',
    type: 'conversational',
    next_script_id: 'starball_031_02',
  },
  {
    id: 'starball_031_02',
    text_jp: 'お友だちと星について\n語りあいたいスタ〜',
    text_en: 'I want to talk to my friend about stars!',
    type: 'conversational',
  },
  {
    id: 'starball_032_01',
    move_to: 'c',
    text_jp: '{friend.player_name}が\nあそびに来てくれたスタ',
    text_en: '{friend.player_name} came over to play!',
    type: 'conversational',
    next_script_id: 'starball_032_02',
  },
  {
    id: 'starball_032_02',
    text_jp:
      'いっぱいあそんでくれて\nいいやつだったスタ\n今度あそびに行ってみるスタ',
    text_en:
      'We played a lot!\nThey were very nice!\nYou should visit them sometime.',
    type: 'conversational',
  },
  {
    id: 'starball_033_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きなアニメを聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite anime is.',
    type: 'conversational',
    next_script_id: 'starball_033_02',
  },
  {
    id: 'starball_033_02',
    text_jp: '{friend.fav_anime}\nって言ってたスタ！',
    text_en: 'They said it’s {friend.fav_anime}!',
    type: 'conversational',
    next_script_id: 'starball_033_03',
  },
  {
    id: 'starball_033_03',
    text_jp: 'それって有名なアニメスタ？\n{pet_name}、\n聞いたこと無いスタけど',
    text_en: 'Is that famous?\n{pet_name} has never heard of it.',
    type: 'conversational',
  },
  {
    id: 'starball_034_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は\n昨日は',
    text_en: 'I think that {friend.player_name}…',
    type: 'conversational',
    case: 'friend.sleep_well',
    next_script_id_1: 'starball_034_02',
    next_script_id_2: 'starball_034_03',
  },
  {
    id: 'starball_034_02',
    text_jp: 'よく眠れたみたいスタ\nやっぱり睡眠が一番大事スタね！',
    text_en:
      '…got a good night’s sleep last night!\nNothing’s more important than that!',
    type: 'conversational',
  },
  {
    id: 'starball_034_03',
    expression: 'sad',
    text_jp:
      'あまりよく眠れなかったみたいスタ\n忙しいのスタかね？\n{pet_name}、心配スタ…',
    text_en:
      '…didn’t sleep very well last night.\n{pet_name} is worried about them…',
    type: 'conversational',
  },
  {
    id: 'starball_035_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は\n梅干しか一夜干しかで言うと',
    text_en:
      'Between sour plums and salted fish, {friend.player_name} feels like…',
    type: 'conversational',
    case: 'friend.plum_or_fish',
    next_script_id_1: 'starball_035_02',
    next_script_id_2: 'starball_035_03',
  },
  {
    id: 'starball_035_02',
    text_jp: '梅干しの気分らしいスタ！\n疲れた体にはクエン酸スタ！',
    text_en: '…a sour plum! \nGet that citric acid in you!',
    type: 'conversational',
  },
  {
    id: 'starball_035_03',
    animation: 'joy',
    text_jp: '一夜干しの気分らしいスタ！\n干すことで旨みアップスタ！',
    text_en: '...salted fish!\nDrying it out increases the flavor!',
    type: 'conversational',
  },
  {
    id: 'starball_036_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n目玉焼きにかけるなら',
    text_en: 'When it comes to fried eggs, {friend.player_name} prefers…',
    type: 'conversational',
    case: 'friend.sunny_side_up',
    next_script_id_1: 'starball_036_02',
    next_script_id_2: 'starball_036_03',
    next_script_id_3: 'starball_036_04',
  },
  {
    id: 'starball_036_02',
    text_jp: 'しょう油らしいスタ！\n妥当なところスタ！',
    text_en: 'Soy sauce!\nA classic for good reason!',
    type: 'conversational',
  },
  {
    id: 'starball_036_03',
    text_jp:
      'ソースらしいスタ！\nしょう油ほどメジャーじゃないけど\nこれもおいしいスタ！',
    text_en:
      'Worcestershire sauce! \nNot as popular as soy sauce, but a great choice!',
    type: 'conversational',
  },
  {
    id: 'starball_036_04',
    animation: 'anxious',
    text_jp: 'しょう油でもソースでもない\nらしいスタ！\n謎は深まるばかりスタ…',
    text_en: '…neither soy sauce or Worcestershire sauce!\nWhat a mystery…',
    type: 'conversational',
  },
  {
    id: 'starball_037_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}は、\nアフリカでサファリか\nアラスカでオーロラかだと、',
    text_en:
      'Between an African safari or the Alaskan aurora, {friend.player_name} would choose…',
    type: 'conversational',
    case: 'friend.safari_or_aurora',
    next_script_id_1: 'starball_037_02',
    next_script_id_2: 'starball_037_03',
  },
  {
    id: 'starball_037_02',
    text_jp:
      'アフリカでサファリに行って\nみたいらしいスタ！\nワイルドだろスタ〜？',
    text_en: 'An African safari!\nWhat an adventurer!',
    type: 'conversational',
  },
  {
    id: 'starball_037_03',
    text_jp: 'アラスカでオーロラを見たい\nらしいスタ！\nロマンチックだスタ…',
    text_en: 'The Alaskan aurora!\nWhat a romantic!',
    type: 'conversational',
  },
  {
    id: 'starball_038_01',
    move_to: 'c',
    text_jp: 'ひ…\nだれスタ？',
    text_en: 'Eep!\nWho is it?',
    type: 'conversational',
  },
  {
    id: 'starball_039_01',
    animation: 'waive',
    text_jp: 'あそびに来たスタ〜！',
    text_en: 'I’m here to play!',
    type: 'conversational',
  },
  {
    id: 'starball_040_01',
    animation: 'waive',
    text_jp: 'よく来たスタ〜！\nゆっくりしてくスタ〜！',
    text_en: 'Thanks for coming!\nMake yourself at home!',
    type: 'conversational',
  },
  {
    id: 'starball_041_01',
    move_to: 'c',
    text_jp: 'ほんの感謝の気持ちスタ',
    text_en: 'Here’s a little thank-you gift!',
    type: 'conversational',
  },
  {
    id: 'starball_042_01',
    animation: 'waive',
    text_jp: 'そろそろおうち帰るスタね\nまたあそびに来るスタよ',
    text_en: 'Time for me to get going.\nI’ll come over again sometime!',
    type: 'conversational',
  },
  {
    id: 'starball_043_01',
    animation: 'waive',
    text_jp: 'またいつでも来てねスタ〜',
    text_en: 'Come back any time!',
    type: 'conversational',
  },
  {
    id: 'starball_044_01',
    text_jp: 'どうやら\n{friend.player_name}が\n帰ってきたみたいスタね',
    text_en: 'Looks like {friend.player_name} is home.',
    type: 'conversational',
    next_script_id: 'starball_044_02',
  },
  {
    id: 'starball_044_02',
    animation: 'waive',
    text_jp: 'またあそびに来るスタ〜\nじゃーねスタ〜',
    text_en: "I'll come back another time!\nSee you later!",
    type: 'conversational',
  },
  {
    id: 'starball_045_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないスタ',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'starball_046_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないスタ',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'starball_047_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今はそんな余裕無いスタ〜\n万能コロンをかけて欲しいスタ…',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'starball_048_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないスタ〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'starball_049_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったスタ！\nどうもありがとスタ！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'starball_050_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったスタ！\nどうもありがとスタ！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'starball_051_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'なんとか助かったスタ！\n{player_name}は\n命の恩人スタ〜！',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'starball_052_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったスタ…\nもう1回試してみて欲しいスタ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'starball_053_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったスタ…\nもう1回試してみて欲しいスタ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'starball_054_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったスタ…\nもう1回試してみて欲しいスタ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'hamster_001_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'おハムハム〜',
    text_en: 'Ham-Hamuuu.',
    type: 'conversational',
    next_script_id: 'hamster_001_02',
  },
  {
    id: 'hamster_001_02',
    animation: 'play',
    text_jp: '今日もいっぱいかまってほしいハム',
    text_en: 'Please play with me a lot.',
    type: 'conversational',
  },
  {
    id: 'hamster_002_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'イベリコ豚ってあるけど',
    text_en: 'There is Iberico pork.',
    type: 'conversational',
    next_script_id: 'hamster_002_02',
  },
  {
    id: 'hamster_002_02',
    expression: 'happy',
    text_jp: 'イベリ★子豚だと思ってたハム',
    text_en: 'I thought it was an Iberian piglet.',
    type: 'conversational',
  },
  {
    id: 'hamster_003_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '穴があると...\nつい入ってしまうハム',
    text_en: "When I find a hole, I can't help getting in it.",
    type: 'conversational',
    next_script_id: 'hamster_003_02',
  },
  {
    id: 'hamster_003_02',
    animation: 'joy',
    text_jp: '入りたいと言うか...\nハマりたいという願望に近いハム',
    text_en: "It's more like a desire to get in, or a desire to get hooked.",
    type: 'conversational',
  },
  {
    id: 'hamster_004_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'こないだトイレットペーパーの\n芯に入ってみたハム',
    text_en: 'I got into the toilet paper core the other day.',
    type: 'conversational',
    next_script_id: 'hamster_004_02',
  },
  {
    id: 'hamster_004_02',
    animation: 'joy',
    text_jp: '絶妙なフィット感だったハム',
    text_en: 'It was an exquisite fit.',
    type: 'conversational',
  },
  {
    id: 'hamster_005_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'プラスチックの卵パックって',
    text_en: 'You know those plastic egg cartons?',
    type: 'conversational',
    next_script_id: 'hamster_005_02',
  },
  {
    id: 'hamster_005_02',
    expression: 'happy',
    text_jp: '最高のお昼寝スポットハム',
    text_en: 'That is the best napping spot for me.',
    type: 'conversational',
  },
  {
    id: 'hamster_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '好きな食べ物は、隠しておいて\n後で食べるほうハム',
    text_en: 'I prefer to hide my favorite food and eat it later.',
    type: 'conversational',
    next_script_id: 'hamster_006_02',
  },
  {
    id: 'hamster_006_02',
    expression: 'very_sad',
    text_jp: 'でも、よくどこに隠したか\n忘れてしまうハム...',
    text_en: 'But I often forget where I hid it...',
    type: 'conversational',
  },
  {
    id: 'hamster_007_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '隠しておいた食べ物を',
    text_en: 'Sometimes I hid my food',
    type: 'conversational',
    next_script_id: 'hamster_007_02',
  },
  {
    id: 'hamster_007_02',
    animation: 'cry',
    text_jp: '隠したことすら忘れてしまう\nことがあるハム...',
    text_en: 'And completely forgot that I even hid it...',
    type: 'conversational',
  },
  {
    id: 'hamster_008_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'こないだ寝癖が...',
    text_en: 'The other day, I woke up and found',
    type: 'conversational',
    next_script_id: 'hamster_008_02',
  },
  {
    id: 'hamster_008_02',
    animation: 'sleep',
    text_jp: '偶然リーゼントみたいに\nなってたハム',
    text_en: 'My hair was accidentally turned into a regent style.',
    type: 'conversational',
  },
  {
    id: 'hamster_009_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'プディングって言うけど...',
    text_en: "It's called pudding,",
    type: 'conversational',
    next_script_id: 'hamster_009_02',
  },
  {
    id: 'hamster_009_02',
    expression: 'happy',
    text_jp: 'プリンって言ったほうが\nおいしそうに感じるハム',
    text_en: "But I feel it tastes better when it's called *Purin*.",
    type: 'conversational',
  },
  {
    id: 'hamster_010_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ア●ゾンのダンボールに\n書いてある矢印のマークが',
    text_en: 'The symbol on the Am**on cardboard box looks like',
    type: 'conversational',
    next_script_id: 'hamster_010_02',
  },
  {
    id: 'hamster_010_02',
    animation: 'anxious',
    text_jp: 'なんか企んでる人の顔に\n見えて怖いハム...',
    text_en: 'Someone is up to something.\nThat scares me...',
    type: 'conversational',
  },
  {
    id: 'hamster_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_011_02',
  },
  {
    id: 'hamster_011_02',
    expression: 'happy',
    text_jp:
      'ハムの語源は「豚さんのももの肉」\nらしいハム。今では魚や羊さん\nでも作られるハム...',
    text_en: 'The origin of the word "ham" is "pig thigh meat."',
    type: 'conversational',
  },
  {
    id: 'hamster_012_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_012_02',
  },
  {
    id: 'hamster_012_02',
    expression: 'normal',
    text_jp: 'ぶりっ子な女子のことを\n「かまとと」というハム',
    text_en: 'A girl with a "burikko" attitude is called a "kamatoto."',
    type: 'conversational',
    next_script_id: 'hamster_012_03',
  },
  {
    id: 'hamster_012_03',
    expression: 'happy',
    text_jp:
      'かまぼこの材料が魚(とと)だと\n知ってるのに、知らないフリを\nしてる女子が語源らしいハム',
    text_en:
      'She knows that kamaboko is made from fish (toto) but pretends not to know.',
    type: 'conversational',
  },
  {
    id: 'hamster_013_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ドイツの白ソーセージは\n必ず朝のうちに食べるらしいハム',
    text_en: 'German white sausage is always eaten in the morning.',
    type: 'conversational',
    next_script_id: 'hamster_013_02',
  },
  {
    id: 'hamster_013_02',
    expression: 'normal',
    text_jp: 'その理由は塩を使ってないので\n早く食べないと傷むからハム',
    text_en: 'Because it is not made with salt and will get damaged soon.',
    type: 'conversational',
    next_script_id: 'hamster_013_03',
  },
  {
    id: 'hamster_013_03',
    animation: 'surprised',
    text_jp: '白ソーセージに正午の鐘を\n聞かせてはいけない、らしいハム！',
    text_en: 'They say, "Never let the white sausage hear the noon bell."',
    type: 'conversational',
  },
  {
    id: 'hamster_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「サラミ」と「カルパス」\n何が違うか知ってるハム？',
    text_en: '"Salami" and "Kalpas."\nDo you know what the difference is?',
    type: 'conversational',
    next_script_id: 'hamster_014_02',
  },
  {
    id: 'hamster_014_02',
    expression: 'happy',
    text_jp:
      'すっごく大雑把に言うと、\nサラミはイタリア発祥、\nカルパスはロシア発祥らしいハム',
    text_en:
      'Roughly speaking, salami is originated in Italy, while kalpas is originated in Russia.',
    type: 'conversational',
  },
  {
    id: 'hamster_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ソーセージとウィンナー、\n何が違うか知ってるハム？',
    text_en: '*Sausage* and *Wiener."\nDo you know what the difference is?',
    type: 'conversational',
    next_script_id: 'hamster_015_02',
  },
  {
    id: 'hamster_015_02',
    expression: 'normal',
    text_jp: 'ソーセージは塩漬けにしたお肉を\n腸詰めにした食べ物の総称で',
    text_en:
      'Sausage is a general term for food made of salted meat stuffed in the intestines,',
    type: 'conversational',
    next_script_id: 'hamster_015_03',
  },
  {
    id: 'hamster_015_03',
    expression: 'happy',
    text_jp: 'ウィンナーは、そのうち羊さんの\n腸にお肉を詰めたものをいうハム',
    text_en: 'While "Wiener" uses a sheep\'s intestine stuffed with meat.',
    type: 'conversational',
  },
  {
    id: 'hamster_016_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '魚肉ソーセージって\n何で作られてると思うハム？',
    text_en: 'Do you know what fish sausage is made of?',
    type: 'conversational',
    next_script_id: 'hamster_016_02',
  },
  {
    id: 'hamster_016_02',
    expression: 'happy',
    text_jp: '答えは\nスケソウダラ\nハム！',
    text_en: 'The answer is Alaska Pollack!!',
    type: 'conversational',
    next_script_id: 'hamster_016_03',
  },
  {
    id: 'hamster_016_03',
    expression: 'normal',
    text_jp: 'カニカマやかまぼこも\nスケソウダラから\n作られることが多いハム',
    text_en:
      'Crab cakes and fish cakes are also are often made from Alaska Pollack.',
    type: 'conversational',
  },
  {
    id: 'hamster_017_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '生ハムとプロシュートの違い\nって何か知ってるハム？',
    text_en:
      'Do you know what the difference is between cured ham and prosciutto?',
    type: 'conversational',
    next_script_id: 'hamster_017_02',
  },
  {
    id: 'hamster_017_02',
    expression: 'normal',
    text_jp: '生ハムをオシャレな呼び方に\nしたのがプロシュート、ハム',
    text_en: 'Prosciutto is a fashionable name for cured ham.',
    type: 'conversational',
    next_script_id: 'hamster_017_03',
  },
  {
    id: 'hamster_017_03',
    expression: 'happy',
    text_jp:
      '...うそハム\n燻製をしているのが生ハム\nしていないのがプロシュートハム',
    text_en:
      "...It's a lie.\nSmoked one is cured ham, not smoked one is prosciutto.",
    type: 'conversational',
  },
  {
    id: 'hamster_018_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カリカリベーコンを\n簡単に作る裏ワザ知ってるハム？',
    text_en: 'Do you know the secret to making crispy bacon easily?',
    type: 'conversational',
    next_script_id: 'hamster_018_02',
  },
  {
    id: 'hamster_018_02',
    expression: 'normal',
    text_jp: 'フライパンに砂糖を1つまみ入れて\n後は普通に焼くだけハム',
    text_en:
      'Just add a pinch of sugar to the pan and bake the rest as normal.',
    type: 'conversational',
    next_script_id: 'hamster_018_03',
  },
  {
    id: 'hamster_018_03',
    expression: 'happy',
    text_jp: '試してみるハム',
    text_en: "Let's try it!",
    type: 'conversational',
  },
  {
    id: 'hamster_019_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「食べると変な夢を見る」\nというチーズがあるハム',
    text_en: 'There is a cheese that when you eat it, you have weird dreams.',
    type: 'conversational',
    next_script_id: 'hamster_019_02',
  },
  {
    id: 'hamster_019_02',
    expression: 'normal',
    text_jp: 'イギリス産のスティルトンと\nいうチーズがそれハム',
    text_en: 'A cheese called Stilton from England is it.',
    type: 'conversational',
    next_script_id: 'hamster_019_03',
  },
  {
    id: 'hamster_019_03',
    animation: 'surprised',
    text_jp:
      'ある調査によると、寝る前にこの\nチーズを食べた70％の人が、\n変な夢を見た、と答えたらしいハム',
    text_en:
      'According to a survey, 70% of people who ate it before sleeping said they had strange dreams.',
    type: 'conversational',
  },
  {
    id: 'hamster_020_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ちくわは昔はかまぼこだったハム',
    text_en: 'Chikuwa used to be kamaboko.',
    type: 'conversational',
    next_script_id: 'hamster_020_02',
  },
  {
    id: 'hamster_020_02',
    expression: 'normal',
    text_jp:
      '意味不明ハム？\nちくわはガマの穂に見た目が似てた\nので、かまぼこと呼ばれていたハム',
    text_en:
      'Not sure? Chikuwa was called kamaboko because it looked like an ear of kama.',
    type: 'conversational',
    next_script_id: 'hamster_020_03',
  },
  {
    id: 'hamster_020_03',
    expression: 'happy',
    text_jp:
      'ところが後からできた板付き\nかまぼこに名前を取られて、ちくわ\nに名前を変える羽目になったハム',
    text_en:
      'However, the name was taken by a later product, kamaboko with a plate.',
    type: 'conversational',
  },
  {
    id: 'hamster_021_01',
    move_to: 'c',
    text_jp: 'どっちが好きハム？',
    text_en: 'Which do you like better?',
    type: 'selectional',
    answer_var: 'sunflower_or_morningglory',
    option_1_jp: 'ひまわり',
    option_1_en: 'Sunflower',
    option_2_jp: 'あさがお',
    option_2_en: 'Morning glory',
    case: 'sunflower_or_morningglory',
    next_script_id_1: 'hamster_021_02',
    next_script_id_2: 'hamster_021_04',
  },
  {
    id: 'hamster_021_02',
    expression: 'happy',
    text_jp: '{pet_name}\nもハム〜',
    text_en: 'Me too :)',
    type: 'conversational',
    next_script_id: 'hamster_021_03',
  },
  {
    id: 'hamster_021_03',
    animation: 'joy',
    text_jp: 'だってひまわりの種は\nおいしいからハム',
    text_en: 'Because sunflower seeds are delicious.',
    type: 'conversational',
  },
  {
    id: 'hamster_021_04',
    expression: 'normal',
    text_jp: 'あさがおハムか〜',
    text_en: 'Morning glory?',
    type: 'conversational',
    next_script_id: 'hamster_021_05',
  },
  {
    id: 'hamster_021_05',
    animation: 'cry',
    text_jp: '{pet_name}は\n早起きが苦手ハム...',
    text_en: "I'm not an early riser...",
    type: 'conversational',
  },
  {
    id: 'hamster_022_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'エビフライのしっぽは食べるハム？',
    text_en: 'Do you eat fried shrimp tails?',
    type: 'selectional',
    answer_var: 'friedshrimp',
    option_1_jp: '食べる',
    option_1_en: 'Eat',
    option_2_jp: '食べない',
    option_2_en: 'Not eat',
    case: 'friedshrimp',
    next_script_id_1: 'hamster_022_02',
    next_script_id_2: 'hamster_022_04',
  },
  {
    id: 'hamster_022_02',
    expression: 'happy',
    text_jp: 'いいと思うハム〜',
    text_en: 'Good thought :)',
    type: 'conversational',
    next_script_id: 'hamster_022_03',
  },
  {
    id: 'hamster_022_03',
    expression: 'happy',
    text_jp: 'エビフライのしっぽは\nアンチエイジング効果も\nあるらしいハム！',
    text_en: 'Fried shrimp tails are also said to have anti-aging properties!',
    type: 'conversational',
  },
  {
    id: 'hamster_022_04',
    expression: 'normal',
    text_jp: 'そうハムか〜\n{pet_name}は\n食べる派ハム！',
    text_en: 'I see. Btw, I would eat it!',
    type: 'conversational',
  },
  {
    id: 'hamster_023_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'バスタオルは毎回洗うハム？',
    text_en: 'Do you wash bath towels every time?',
    type: 'selectional',
    answer_var: 'wash_bathtowels',
    option_1_jp: '毎回洗う',
    option_1_en: 'Wash every time',
    option_2_jp: '毎回は洗わない',
    option_2_en: 'Not wash every time',
    case: 'wash_bathtowels',
    next_script_id_1: 'hamster_023_02',
    next_script_id_2: 'hamster_023_03',
  },
  {
    id: 'hamster_023_02',
    expression: 'normal',
    text_jp: 'きれい好きハムね〜\n毎回はめんどくさくないハムか？',
    text_en: "You like cleanliness. But isn't it a hassle every time?",
    type: 'conversational',
  },
  {
    id: 'hamster_023_03',
    expression: 'happy',
    text_jp: 'ハムハム\n実は毎回洗わないが、多数派ハム',
    text_en: 'Hm, hmm. Actually, the majority do not wash every time.',
    type: 'conversational',
    next_script_id: 'hamster_023_04',
  },
  {
    id: 'hamster_023_04',
    animation: 'joy',
    text_jp: '地球にやさしくて\nエコでもあるハムね〜',
    text_en: "It's good because it's also eco-friendly.",
    type: 'conversational',
  },
  {
    id: 'hamster_024_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちに行きたいハム？',
    text_en: 'Which do you want to go?',
    type: 'selectional',
    answer_var: 'zoo_or_aquarium',
    option_1_jp: '動物園',
    option_1_en: 'Zoo',
    option_2_jp: '水族館',
    option_2_en: 'Aquarium',
    case: 'zoo_or_aquarium',
    next_script_id_1: 'hamster_024_02',
    next_script_id_2: 'hamster_024_04',
  },
  {
    id: 'hamster_024_02',
    expression: 'happy',
    text_jp: 'いい選択ハム！',
    text_en: 'Good choice!',
    type: 'conversational',
    next_script_id: 'hamster_024_03',
  },
  {
    id: 'hamster_024_03',
    animation: 'joy',
    text_jp:
      '{pet_name}は\nお仲間のプレーリードッグさん\nを見に行くのが好きハム',
    text_en: "I'd love to go see my fellow prairie dogs.",
    type: 'conversational',
  },
  {
    id: 'hamster_024_04',
    expression: 'happy',
    text_jp: 'いい選択ハム！',
    text_en: 'Good choice!',
    type: 'conversational',
    next_script_id: 'hamster_024_05',
  },
  {
    id: 'hamster_024_05',
    animation: 'joy',
    text_jp: '{pet_name}は\nクラゲさんの水槽を日がな一日\n眺めていたいハム',
    text_en: 'I want to spend all day long looking at a tank of jellyfish.',
    type: 'conversational',
  },
  {
    id: 'hamster_025_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちが得意ハム？',
    text_en: 'Which are you better at?',
    type: 'selectional',
    answer_var: 'marathon_or_100m',
    option_1_jp: 'マラソン',
    option_1_en: 'Marathon',
    option_2_jp: '100メートル走',
    option_2_en: '100-meter race',
    case: 'marathon_or_100m',
    next_script_id_1: 'hamster_025_02',
    next_script_id_2: 'hamster_025_03',
  },
  {
    id: 'hamster_025_02',
    expression: 'happy',
    text_jp: 'マラソンハムか〜\n{player_name}は\nスタミナあるハムね〜',
    text_en: 'Hmm, that means you have great stamina!!',
    type: 'conversational',
  },
  {
    id: 'hamster_025_03',
    expression: 'happy',
    text_jp: '100メートル走ハムか〜',
    text_en: "Hmm, you're a sprinter, aren't you?",
    type: 'conversational',
    next_script_id: 'hamster_025_04',
  },
  {
    id: 'hamster_025_04',
    animation: 'play',
    text_jp:
      '{pet_name}は\n回し車で走るのが得意ハムけど\nすぐ疲れちゃうハム...',
    text_en: "I'm good at spinning wheels, but I tire easily.",
    type: 'conversational',
  },
  {
    id: 'hamster_026_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '今年の夏はどっちにいきたいハム？',
    text_en: 'Which do you want to go this summer?',
    type: 'selectional',
    answer_var: 'mountain_or_ocean',
    option_1_jp: '山',
    option_1_en: 'Mountain',
    option_2_jp: '海',
    option_2_en: 'Ocean',
    case: 'mountain_or_ocean',
    next_script_id_1: 'hamster_026_02',
    next_script_id_2: 'hamster_026_04',
  },
  {
    id: 'hamster_026_02',
    expression: 'happy',
    text_jp: '山はいいハムね〜',
    text_en: 'Mountain is a good choice :)',
    type: 'conversational',
    next_script_id: 'hamster_026_03',
  },
  {
    id: 'hamster_026_03',
    animation: 'eat',
    text_jp: '山頂で食べるごはんは\nなんであんなにおいしいハムね？',
    text_en: 'Food at the top of the mountain tastes exceptionally good!',
    type: 'conversational',
  },
  {
    id: 'hamster_026_04',
    expression: 'happy',
    text_jp: '海はいいハムね〜',
    text_en: 'Ocean is a good choice :)',
    type: 'conversational',
    next_script_id: 'hamster_026_05',
  },
  {
    id: 'hamster_026_05',
    animation: 'play',
    text_jp: '{pet_name}は\nゴムのアヒルさんを\n浮き輪にするハム',
    text_en: 'I would use rubber ducks as floats.',
    type: 'conversational',
  },
  {
    id: 'hamster_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちを食べたいハム？',
    text_en: 'Which do you want to eat?',
    type: 'selectional',
    answer_var: 'icecream_or_shavedice',
    option_1_jp: 'アイスクリーム',
    option_1_en: 'Icecream',
    option_2_jp: 'かき氷',
    option_2_en: 'Shaved ice',
    case: 'icecream_or_shavedice',
    next_script_id_1: 'hamster_027_02',
    next_script_id_2: 'hamster_027_04',
  },
  {
    id: 'hamster_027_02',
    expression: 'happy',
    text_jp: 'アイスクリーム、いいハムね〜',
    text_en: "Icecream!\nThat's a good choice.",
    type: 'conversational',
    next_script_id: 'hamster_027_03',
  },
  {
    id: 'hamster_027_03',
    animation: 'joy',
    text_jp: '{pet_name}は\n断然カップよりコーン派ハム',
    text_en: "I'm definitely more of a cone than a cup person.",
    type: 'conversational',
  },
  {
    id: 'hamster_027_04',
    expression: 'happy',
    text_jp: 'かき氷、いいハムね〜',
    text_en: "Shaved ice!\nThat's a good choice.",
    type: 'conversational',
    next_script_id: 'hamster_027_05',
  },
  {
    id: 'hamster_027_05',
    expression: 'normal',
    text_jp: 'ところでブルーハワイって\nいったい何の味ハムね？',
    text_en: 'By the way, what flavor is Blue Hawaii actually?',
    type: 'conversational',
  },
  {
    id: 'hamster_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '朝食はどっち派ハム？',
    text_en: 'Which breakfast do you prefer?',
    type: 'selectional',
    answer_var: 'rice_or_bread',
    option_1_jp: 'お米',
    option_1_en: 'Rice',
    option_2_jp: 'パン',
    option_2_en: 'Bread',
    case: 'rice_or_bread',
    next_script_id_1: 'hamster_028_02',
    next_script_id_2: 'hamster_028_04',
  },
  {
    id: 'hamster_028_02',
    expression: 'happy',
    text_jp: 'ごはん党ハムか〜',
    text_en: 'Hmm, you prefer rice.',
    type: 'conversational',
    next_script_id: 'hamster_028_03',
  },
  {
    id: 'hamster_028_03',
    animation: 'joy',
    text_jp: '{pet_name}の\nごはんのおともは\nふりかけハム',
    text_en: 'I like to eat rice with furikake!',
    type: 'conversational',
  },
  {
    id: 'hamster_028_04',
    expression: 'happy',
    text_jp: 'パン党ハムか〜',
    text_en: 'Hmm, you prefer bread.',
    type: 'conversational',
    next_script_id: 'hamster_028_05',
  },
  {
    id: 'hamster_028_05',
    animation: 'joy',
    text_jp: '{pet_name}は\nピーナッツバターを塗りたくって\n食べるのが好きハム',
    text_en: 'I like to spread peanut butter on it!!',
    type: 'conversational',
  },
  {
    id: 'hamster_029_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n何の花が好きハム？',
    text_en: '{player_name},\nWhat is your favorite flower?',
    type: 'descriptive',
    answer_var: 'fav_flower',
    question_jp: '好きな花',
    question_en: 'Favorite flower',
    max_len: 12,
    next_script_id: 'hamster_029_02',
  },
  {
    id: 'hamster_029_02',
    expression: 'happy',
    text_jp: '{fav_flower}ハムか〜\n{pet_name}は\nひまわりが好きハム',
    text_en: 'Hm, {fav_flower}.\nI like sunflower.',
    type: 'conversational',
    next_script_id: 'hamster_029_03',
  },
  {
    id: 'hamster_029_03',
    animation: 'joy',
    text_jp: '理由は種が食べられるからハム！',
    text_en: 'Because its seeds are edible!',
    type: 'conversational',
  },
  {
    id: 'hamster_030_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}を\n妖怪に例えるとなにハム？',
    text_en: 'What kind of yokai do you resemble?',
    type: 'descriptive',
    answer_var: 'similar_yokai',
    question_jp: '似ている妖怪',
    question_en: 'Similar Yokai',
    max_len: 14,
    next_script_id: 'hamster_030_02',
  },
  {
    id: 'hamster_030_02',
    expression: 'normal',
    text_jp: '{similar_yokai}？\nそう見えなくもないハム...',
    text_en: '{similar_yokai}? If you say so, that may be true.',
    type: 'conversational',
    next_script_id: 'hamster_030_03',
  },
  {
    id: 'hamster_030_03',
    animation: 'surprised',
    text_jp:
      '{pet_name}は\nケサランパサランて言われるハム\n...けど、どんなのか知らないハム',
    text_en:
      "I was told I would look like Kesaran-Pasaran.\nI don't even know what that is, though...",
    type: 'conversational',
  },
  {
    id: 'hamster_031_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n得意技は何ハム？',
    text_en: 'What is your specialty?',
    type: 'descriptive',
    answer_var: 'speciality',
    question_jp: '得意技',
    question_en: 'Speciality',
    max_len: 14,
    next_script_id: 'hamster_031_02',
  },
  {
    id: 'hamster_031_02',
    expression: 'happy',
    text_jp: '{pet_name}の\n得意技は、高速かりかりハム！',
    text_en: 'My special skill is repetitive jumping!',
    type: 'conversational',
  },
  {
    id: 'hamster_032_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'なんの天気がお気に入りハム？',
    text_en: 'What is your favorite weather?',
    type: 'descriptive',
    answer_var: 'fav_weather',
    question_jp: '好きな天気',
    question_en: 'Favorite weather',
    max_len: 14,
    next_script_id: 'hamster_032_02',
  },
  {
    id: 'hamster_032_02',
    expression: 'happy',
    text_jp: 'なるハム〜\n{pet_name}は\n晴れた空にわたわたの雲が好きハム',
    text_en: 'Hum, hmm,\nI like fluffy clouds in a clear sky.',
    type: 'conversational',
  },
  {
    id: 'hamster_033_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きな自分の体の部分はどこハム？',
    text_en: 'What is your favorite part of your body?',
    type: 'descriptive',
    answer_var: 'fav_bodypart',
    question_jp: '好きな体のパーツ',
    question_en: 'Favorite body part',
    max_len: 13,
    next_script_id: 'hamster_033_02',
  },
  {
    id: 'hamster_033_02',
    animation: 'surprised',
    text_jp: '{fav_bodypart}とは\n逆にマニアハムね〜',
    text_en: "{fav_bodypart}?\nThat's a mania.",
    type: 'conversational',
    next_script_id: 'hamster_033_03',
  },
  {
    id: 'hamster_033_03',
    expression: 'happy',
    text_jp: '{pet_name}は\nだんぜんほほ袋ハム\nいっぱいためこめるハム〜',
    text_en: 'I like my cheek pouch because I can store a lot of things in it.',
    type: 'conversational',
  },
  {
    id: 'hamster_034_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '最近幸せだった\n時ってなにハム？',
    text_en: "What's the happiest time you've had lately?",
    type: 'descriptive',
    answer_var: 'happy_moment',
    question_jp: '幸せだった時',
    question_en: 'Happy moment',
    max_len: 14,
    next_script_id: 'hamster_034_02',
  },
  {
    id: 'hamster_034_02',
    expression: 'happy',
    text_jp: 'そうハムか〜\n{pet_name}は\n新しい毛布に包まれた時ハム',
    text_en:
      'I see. In my case, the moment I was wrapped in a brand-new blanket.',
    type: 'conversational',
    next_script_id: 'hamster_034_03',
  },
  {
    id: 'hamster_034_03',
    animation: 'joy',
    text_jp: 'ふかふかしてたハム〜',
    text_en: 'That was sooo fluffy!',
    type: 'conversational',
  },
  {
    id: 'hamster_035_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '最近痛かった時ってなにハム？',
    text_en: "What's the painful time you've had lately?",
    type: 'descriptive',
    answer_var: 'painful_moment',
    question_jp: '痛かった時',
    question_en: 'Painful moment',
    max_len: 14,
    next_script_id: 'hamster_035_02',
  },
  {
    id: 'hamster_035_02',
    animation: 'surprised',
    text_jp: '{painful_moment}..！\nそうだったハムか...',
    text_en: '{painful_moment}..!\nOh my goodness.',
    type: 'conversational',
    next_script_id: 'hamster_035_03',
  },
  {
    id: 'hamster_035_03',
    animation: 'angry',
    text_jp: 'ちなみに\n{pet_name}は\n夜中にレゴを踏んだ時ハム..！',
    text_en: 'In my case, the moment stepped on a lego block..!',
    type: 'conversational',
  },
  {
    id: 'hamster_036_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'お母さんの旧姓は何ハム？',
    text_en: "What is your mom's maiden name?",
    type: 'descriptive',
    answer_var: 'maiden_name',
    question_jp: '母の旧姓',
    question_en: "Mom's maiden name",
    max_len: 14,
    next_script_id: 'hamster_036_02',
  },
  {
    id: 'hamster_036_02',
    expression: 'happy',
    text_jp: 'なんて、"秘密の質問"みたいな\n質問をしてみただけハム★',
    text_en: 'I just felt up to ask you a question like a "Secret Question."',
    type: 'conversational',
  },
  {
    id: 'hamster_037_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{pet_name}は\nほほ袋の中に何個ぐらいひまわりの\n種を入れられると思うハム？',
    text_en: 'How many sunflower seeds do you think I could fit in my cheek"',
    type: 'selectional',
    answer_var: 'cheek_pocket',
    option_1_jp: '20個',
    option_1_en: '20 seeds',
    option_2_jp: '50個',
    option_2_en: '50 seeds',
    option_3_jp: '100個',
    option_3_en: '100 seeds',
    next_script_id: 'hamster_037_02',
  },
  {
    id: 'hamster_037_02',
    expression: 'normal',
    text_jp: '正解は…',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'hamster_037_03',
  },
  {
    id: 'hamster_037_03',
    expression: 'happy',
    text_jp: '100個ハム！\n片方に50個くらいいけるハム\n意外と入るハムよ〜',
    text_en: '100!\nI can fit about 50 on each side.',
    type: 'conversational',
  },
  {
    id: 'hamster_038_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ハムがなる木はなんの木ハム？',
    text_en: 'What is the tree that produces the ham?',
    type: 'selectional',
    answer_var: 'ham_tree',
    option_1_jp: 'まつ',
    option_1_en: 'Pine tree',
    option_2_jp: 'すぎ',
    option_2_en: 'Cedar',
    option_3_jp: 'さくら',
    option_3_en: 'Cherry blossam',
    case: 'ham_tree',
    next_script_id_1: 'hamster_038_03',
    next_script_id_2: 'hamster_038_02',
    next_script_id_3: 'hamster_038_02',
  },
  {
    id: 'hamster_038_02',
    expression: 'sad',
    text_jp: 'はずれハム...\n漢字にしてみるとわかるハム',
    text_en: 'Incorrect...\nPlease put it into Kanji.',
    type: 'conversational',
  },
  {
    id: 'hamster_038_03',
    expression: 'happy',
    text_jp: '正解ハム！\n"松"の右側はハムになってるハム',
    text_en: 'Correct!!\nThe kanji, 松 consits of tree and ham.',
    type: 'conversational',
  },
  {
    id: 'hamster_039_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ハム、サラミ、チーズ、\nこの中で新製品はどれハム？',
    text_en: 'Ham, Salame, Cheese,\nWhich one is the new product?',
    type: 'selectional',
    answer_var: 'ham_salame_cheese',
    option_1_jp: 'ハム',
    option_1_en: 'Ham',
    option_2_jp: 'サラミ',
    option_2_en: 'Salame',
    option_3_jp: 'チーズ',
    option_3_en: 'Cheese',
    case: 'ham_salame_cheese',
    next_script_id_1: 'hamster_039_02',
    next_script_id_2: 'hamster_039_02',
    next_script_id_3: 'hamster_039_03',
  },
  {
    id: 'hamster_039_02',
    expression: 'sad',
    text_jp: 'はずれハム...\nヒントは原材料ハム',
    text_en: 'Incorrect...\nThe hint is the ingredient :)',
    type: 'conversational',
  },
  {
    id: 'hamster_039_03',
    expression: 'happy',
    text_jp: '正解ハム！\nチーズだけ乳(NEW)製品\nだからハム',
    text_en: 'Correct!!\nBecause only cheese is the NEW (=milk) product.',
    type: 'conversational',
  },
  {
    id: 'hamster_040_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '昔実際にあった、バターの\n変わった用途はなにハム？',
    text_en:
      'What are some of the unusual uses of butter that existed in the past?',
    type: 'selectional',
    answer_var: 'butter_use',
    option_1_jp: '塗り薬',
    option_1_en: 'Ointment',
    option_2_jp: '鎮痛剤',
    option_2_en: 'Painkiller',
    option_3_jp: 'シャンプー',
    option_3_en: 'Shampoo',
    next_script_id_1: 'hamster_040_03',
    next_script_id_2: 'hamster_040_02',
    next_script_id_3: 'hamster_040_02',
  },
  {
    id: 'hamster_040_02',
    expression: 'sad',
    text_jp: 'はずれハム...\nまた挑戦してほしいハム',
    text_en: 'Incorrect...\nPleace try again!',
    type: 'conversational',
  },
  {
    id: 'hamster_040_03',
    expression: 'happy',
    text_jp: '正解ハム！\n昔は傷の手当に使われていた\nことがあるハム',
    text_en: 'Correct!!\nIn the past, it was used to treat wounds.',
    type: 'conversational',
  },
  {
    id: 'hamster_041_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'サラダ味といえば\n何味のことかわかるハム？',
    text_en: 'What flavor is the "Salad flavor"?',
    type: 'selectional',
    answer_var: 'salada_taste',
    option_1_jp: 'ドレッシング',
    option_1_en: 'Dressing',
    option_2_jp: 'しお',
    option_2_en: 'Salt',
    option_3_jp: 'サラダ油',
    option_3_en: 'Salada oil',
    next_script_id_1: 'hamster_041_02',
    next_script_id_2: 'hamster_041_02',
    next_script_id_3: 'hamster_041_03',
  },
  {
    id: 'hamster_041_02',
    expression: 'sad',
    text_jp: 'はずれハム...\n今度はきっと正解するハム',
    text_en: 'Incorrect...\nYou will get a right answer next time.',
    type: 'conversational',
  },
  {
    id: 'hamster_041_03',
    expression: 'happy',
    text_jp: '正解ハム！\nサラダ油で味付けしたのが\nサラダ味ハム',
    text_en: 'Correct!!\nSalad flavor is seasoned with salad oil.',
    type: 'conversational',
  },
  {
    id: 'hamster_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'バターとマーガリンの\n違いはなにハム？',
    text_en: 'What is the difference between butter and margarine?',
    type: 'selectional',
    answer_var: 'butter_margarine',
    option_1_jp: '乳の種類',
    option_1_en: 'Type of milk',
    option_2_jp: '動物性か植物性か',
    option_2_en: 'Animal or plant-based',
    option_3_jp: '名前が違うだけ',
    option_3_en: 'Name only',
    next_script_id_1: 'hamster_042_02',
    next_script_id_2: 'hamster_042_03',
    next_script_id_3: 'hamster_042_02',
  },
  {
    id: 'hamster_042_02',
    expression: 'sad',
    text_jp: 'はずれハム...\nむずかしかったハム？',
    text_en: 'Incorrect...\nWas that difficult..?',
    type: 'conversational',
  },
  {
    id: 'hamster_042_03',
    expression: 'happy',
    text_jp: '正解ハム！\nバターは牛乳、マーガリンは\n植物油でできてるハム',
    text_en:
      'Correct!!\nButter is made from milk and margarine is from vegetable oil.',
    type: 'conversational',
  },
  {
    id: 'hamster_043_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}の\nくつしたはいい寝袋になるハム',
    text_en: 'Your sock can be the good sleeping bag :)',
    type: 'conversational',
  },
  {
    id: 'hamster_044_01',
    expression: 'sad',
    move_to: 'tr',
    text_jp: '隠した食べ物...',
    text_en: 'Foods, I hid...',
    type: 'conversational',
    next_script_id: 'hamster_044_02',
  },
  {
    id: 'hamster_044_02',
    move_to: 'bl',
    animation: 'cry',
    text_jp: 'またどこに隠したか\n忘れたハム...',
    text_en: 'I forgot where they were again...',
    type: 'conversational',
  },
  {
    id: 'hamster_045_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'シャンプーと\nコンディショナーって',
    text_en: 'Shampoo and conditioner',
    type: 'conversational',
    next_script_id: 'hamster_045_02',
  },
  {
    id: 'hamster_045_02',
    animation: 'angry',
    text_jp: 'どうして減り方のバランスが\n同じにならないハム？',
    text_en: "Why can't those decreases be the same?",
    type: 'conversational',
  },
  {
    id: 'hamster_046_01',
    expression: 'happy',
    move_to: 'tl',
    text_jp: 'ハムハム〜',
    text_en: 'Ham-Hamuuu.',
    type: 'conversational',
    next_script_id: 'hamster_046_02',
  },
  {
    id: 'hamster_046_02',
    move_to: 'tr',
    text_jp: 'ハムハム〜',
    text_en: 'Ham-Hamuuu.',
    type: 'conversational',
    next_script_id: 'hamster_046_03',
  },
  {
    id: 'hamster_046_03',
    move_to: 'bc',
    animation: 'play',
    text_jp: '運動してみたハム★',
    text_en: 'I just had an exercise.',
    type: 'conversational',
  },
  {
    id: 'hamster_047_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'あ★',
    text_en: 'Oops,',
    type: 'conversational',
    next_script_id: 'hamster_047_02',
  },
  {
    id: 'hamster_047_02',
    animation: 'eat',
    text_jp: 'ほっぺたの中に1つ\nひまわりの種が残ってたハム',
    text_en: 'There was one sunflower seed left in my cheek.',
    type: 'conversational',
  },
  {
    id: 'hamster_048_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カップアイスは',
    text_en: 'A cup of ice cream',
    type: 'conversational',
    next_script_id: 'hamster_048_02',
  },
  {
    id: 'hamster_048_02',
    expression: 'happy',
    text_jp: 'スプーンより\n木べらで食べたほうが\nおいしく感じるハム',
    text_en: 'Tastes better with a wooden spatula than with a spoon!',
    type: 'conversational',
  },
  {
    id: 'hamster_049_01',
    move_to: 'bc',
    animation: 'sleep',
    text_jp: 'なでなでしてほしいハム★',
    text_en: 'I want you to stroke me.',
    type: 'conversational',
  },
  {
    id: 'hamster_050_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_050_02',
  },
  {
    id: 'hamster_050_02',
    animation: 'surprised',
    text_jp: '日本にはコンビニより\n歯医者のほうが数が多いハム',
    text_en: 'There are more dentists than convenience stores in Japan.',
    type: 'conversational',
  },
  {
    id: 'hamster_051_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_051_02',
  },
  {
    id: 'hamster_051_02',
    animation: 'surprised',
    text_jp: 'ナタデココって実は\n発酵食品ハム',
    text_en: '"Nata de coco" is actually a fermented food.',
    type: 'conversational',
  },
  {
    id: 'hamster_052_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_052_02',
  },
  {
    id: 'hamster_052_02',
    animation: 'surprised',
    text_jp: 'カニカマにはカニ肉はおろか\nカニのエキスすら入っていないハム',
    text_en: 'Crab cakes do not contain crab meat or even crab extract.',
    type: 'conversational',
  },
  {
    id: 'hamster_053_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_053_02',
  },
  {
    id: 'hamster_053_02',
    expression: 'happy',
    text_jp: 'チーズに空いてる穴には\n"チーズアイ"\nっていう名前があるハム',
    text_en: 'The holes in the cheese are called "cheese eyes." ',
    type: 'conversational',
  },
  {
    id: 'hamster_054_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるハム？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'hamster_054_02',
  },
  {
    id: 'hamster_054_02',
    animation: 'surprised',
    text_jp: '豆腐と油揚げともやしの味噌汁は\n全部大豆でできてるハム',
    text_en:
      'Miso soup with tofu, deep-fried tofu and bean sprouts is made entirely from soybeans.',
    type: 'conversational',
  },
  {
    id: 'hamster_055_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'おばけはいると思うハム？',
    text_en: 'Do you think there are ghosts?',
    type: 'selectional',
    answer_var: 'ghost_exist',
    option_1_jp: 'いる',
    option_1_en: 'Yes',
    option_2_jp: 'いない',
    option_2_en: 'No',
    case: 'ghost_exist',
    next_script_id_1: 'hamster_055_02',
    next_script_id_2: 'hamster_055_04',
  },
  {
    id: 'hamster_055_02',
    expression: 'happy',
    text_jp: '{pet_name}も\nいると思うハム！',
    text_en: 'I believe that too!',
    type: 'conversational',
    next_script_id: 'hamster_055_03',
  },
  {
    id: 'hamster_055_03',
    animation: 'anxious',
    text_jp: 'でも会いたくはないハム...',
    text_en: "But I don't want to see them...",
    type: 'conversational',
  },
  {
    id: 'hamster_055_04',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n現実的なタイプハムね',
    text_en: 'Hmm, you are such a realistic person.',
    type: 'conversational',
  },
  {
    id: 'hamster_056_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'かくれんぼは好きハム？',
    text_en: 'Do you lke hide-and-seek?',
    type: 'selectional',
    answer_var: 'hide_and_seek',
    option_1_jp: '好き',
    option_1_en: 'Like',
    option_2_jp: 'きらい',
    option_2_en: 'Dislike',
    case: 'hide_and_seek',
    next_script_id_1: 'hamster_056_02',
    next_script_id_2: 'hamster_056_03',
  },
  {
    id: 'hamster_056_02',
    animation: 'play',
    text_jp: 'なら一緒にやってほしいハム！',
    text_en: "Ok, let's do it together!",
    type: 'conversational',
  },
  {
    id: 'hamster_056_03',
    expression: 'very_sad',
    text_jp: '...一緒にやりたかったハム',
    text_en: '...I wanted to play with you.',
    type: 'conversational',
  },
  {
    id: 'hamster_057_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '朝型、夜型\nどっちハム？',
    text_en: 'Are you an early bird or a night owl?',
    type: 'selectional',
    answer_var: 'earlybird_nightowl',
    option_1_jp: '朝型',
    option_1_en: 'Early bird',
    option_2_jp: '夜型',
    option_2_en: 'Night owl',
    case: 'earlybird_nightowl',
    next_script_id_1: 'hamster_057_02',
    next_script_id_2: 'hamster_057_03',
  },
  {
    id: 'hamster_057_02',
    expression: 'normal',
    text_jp: 'そうハムか〜\n{pet_name}は\n朝は苦手ハム',
    text_en: "Ham-hmm\nI'm not good at morning...",
    type: 'conversational',
  },
  {
    id: 'hamster_057_03',
    expression: 'happy',
    text_jp: '同じハム〜\n実は夜行性ハムよ',
    text_en: "Me either.\nActually, I'm nocturnal.",
    type: 'conversational',
  },
  {
    id: 'hamster_058_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'インドア派？アウトドア派？',
    text_en: 'Are you indoorsy or Outdoorsy? ',
    type: 'selectional',
    answer_var: 'indoor_outdoor',
    option_1_jp: 'インドア',
    option_1_en: 'Indoor',
    option_2_jp: 'アウトドア',
    option_2_en: 'Outdoor',
    case: 'indoor_outdoor',
    next_script_id_1: 'hamster_058_02',
    next_script_id_2: 'hamster_058_03',
  },
  {
    id: 'hamster_058_02',
    animation: 'play',
    text_jp: '一緒ハム〜\n回し車さえがあれば\n1日中回ってられるハム',
    text_en:
      'Me too. If I only had a spinning wheel I could spin all day long.',
    type: 'conversational',
  },
  {
    id: 'hamster_058_03',
    expression: 'happy',
    text_jp: 'いいハムね〜\n{pet_name}は\nキャンプに憧れがあるハム',
    text_en: 'Sounds good. I have a longing to camp.',
    type: 'conversational',
  },
  {
    id: 'hamster_059_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '行ってみたい国はどこハム？',
    text_en: 'What country do you want to  go?',
    type: 'descriptive',
    answer_var: 'goto_country',
    question_jp: '行ってみたい国',
    question_en: 'Country you want to go',
    max_len: 14,
    next_script_id: 'hamster_059_02',
  },
  {
    id: 'hamster_059_02',
    expression: 'happy',
    text_jp: '{goto_country}\nハムか〜',
    text_en: 'Hmm,\n{goto_country}!!',
    type: 'conversational',
    next_script_id: 'hamster_059_03',
  },
  {
    id: 'hamster_059_03',
    expression: 'happy',
    text_jp: '{pet_name}は\n太陽の国スペインに\n行ってみたいハム！',
    text_en: "In my case, I'd like to go to the country of sun, Spain!",
    type: 'conversational',
  },
  {
    id: 'hamster_060_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '好きな物語はなにハム？',
    text_en: 'What is your favorite story?',
    type: 'descriptive',
    answer_var: 'fav_story',
    question_jp: '好きな物語',
    question_en: 'Favorite story',
    max_len: 14,
    next_script_id: 'hamster_060_02',
  },
  {
    id: 'hamster_060_02',
    animation: 'surprised',
    text_jp: '{fav_story}？\nそれは意表を突かれたハム',
    text_en: '{fav_story}?\nThat was unexpectated.',
    type: 'conversational',
    next_script_id: 'hamster_060_03',
  },
  {
    id: 'hamster_060_03',
    expression: 'happy',
    text_jp: 'ちなみに\n{pet_name}は\nハムレットが好きハム！',
    text_en: 'Btw, I like "Hamlet!!"',
    type: 'conversational',
  },
  {
    id: 'hamster_061_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'パンケーキとホットケーキの\n違いはなにハム？',
    text_en: 'What is the difference between pancake and hotcake?',
    type: 'selectional',
    answer_var: 'pancake_hotcake',
    option_1_jp: '材料',
    option_1_en: 'Ingredient',
    option_2_jp: '作り方',
    option_2_en: 'How to cook',
    option_3_jp: '同じ',
    option_3_en: 'Same',
    case: 'pancake_hotcake',
    next_script_id_1: 'hamster_061_02',
    next_script_id_2: 'hamster_061_02',
    next_script_id_3: 'hamster_061_03',
  },
  {
    id: 'hamster_061_02',
    expression: 'sad',
    text_jp: 'はずれハム...\nまた挑戦してほしいハム',
    text_en: 'Incorrect...\nPlease challenge me again.',
    type: 'conversational',
  },
  {
    id: 'hamster_061_03',
    expression: 'happy',
    text_jp:
      '正解ハム！\nホットケーキは和製英語で\n海外ではパンケーキっていうハム',
    text_en:
      'Correct!!\n"Hotcake" is Japanese-English and is called "pancake" in other countries',
    type: 'conversational',
  },
  {
    id: 'hamster_062_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ホットドッグの名前の\n由来はなにハム？',
    text_en: 'What is the origin of the name "hot dog"?',
    type: 'selectional',
    answer_var: 'hotdog_name',
    option_1_jp: '犬の餌だった',
    option_1_en: 'Dog foods',
    option_2_jp: '形が犬に似てる',
    option_2_en: 'Similar to dog',
    option_3_jp: '犬とは関係ない',
    option_3_en: 'Nothing to do with dogs',
    case: 'hotdog_name',
    next_script_id_1: 'hamster_062_02',
    next_script_id_2: 'hamster_062_03',
    next_script_id_3: 'hamster_062_02',
  },
  {
    id: 'hamster_062_02',
    expression: 'sad',
    text_jp: 'はずれハム...\n残念だったハム',
    text_en: 'Incorrect...\nPlease try again.',
    type: 'conversational',
  },
  {
    id: 'hamster_062_03',
    expression: 'happy',
    text_jp: '正解ハム！\nソーセージの形がダックスフンドに\n似ていたから、ハム',
    text_en:
      'Correct!!\nBecause the shape of the sausage resembles a dachshund.',
    type: 'conversational',
  },
  {
    id: 'hamster_063_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'チキンナゲットのナゲットって\nどういう意味ハム？',
    text_en: 'What does "nugget" in chicken nugget mean?',
    type: 'selectional',
    answer_var: 'chicken_nugget',
    option_1_jp: '金塊',
    option_1_en: 'Gold nugget',
    option_2_jp: '心臓',
    option_2_en: 'Heart',
    option_3_jp: '岩塩',
    option_3_en: 'Rock salt',
    case: 'chicken_nugget',
    next_script_id_1: 'hamster_063_03',
    next_script_id_2: 'hamster_063_02',
    next_script_id_3: 'hamster_063_02',
  },
  {
    id: 'hamster_063_02',
    expression: 'happy',
    text_jp: 'はずれハム...\n落ち込むことないハム',
    text_en: "Incorrect...\nDon't be depressed.",
    type: 'conversational',
  },
  {
    id: 'hamster_063_03',
    expression: 'happy',
    text_jp:
      '正解ハム！\n揚げたチキンの色や形が\n金塊のように見えたからだそうハム',
    text_en:
      'Correct!! Because the color and shape of the fried chicken looked like a gold nugget.',
    type: 'conversational',
  },
  {
    id: 'hamster_064_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '{player_name}さん\nそろそろお腹が減ってきたハム',
    text_en: "{player_name},\nI've got hungry...",
    type: 'conversational',
  },
  {
    id: 'hamster_065_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '小腹が空いたハム',
    text_en: 'My stomach is about to be empty.',
    type: 'conversational',
    next_script_id: 'hamster_065_02',
  },
  {
    id: 'hamster_065_02',
    expression: 'happy',
    text_jp: 'なんか食べさせてほしいハム',
    text_en: 'Please feed me!',
    type: 'conversational',
  },
  {
    id: 'hamster_066_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'お腹が空いたハム...',
    text_en: "I'm hungry...",
    type: 'conversational',
    next_script_id: 'hamster_066_02',
  },
  {
    id: 'hamster_066_02',
    animation: 'anxious',
    text_jp: 'お腹と背中がくっつくハム',
    text_en: 'My belly and back are attached to each other.',
    type: 'conversational',
  },
  {
    id: 'hamster_067_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'お、お腹減ったハム...',
    text_en: "I'm, I'm starving...",
    type: 'conversational',
    next_script_id: 'hamster_067_02',
  },
  {
    id: 'hamster_067_02',
    animation: 'sleep',
    text_jp: 'なんだか幻覚が見えてきたハム...',
    text_en: "I'm starting to hallucinate something.",
    type: 'conversational',
  },
  {
    id: 'hamster_068_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ん？なんかにおわないハム？',
    text_en: 'Hm? Do you smell something?',
    type: 'conversational',
    next_script_id: 'hamster_068_02',
  },
  {
    id: 'hamster_068_02',
    animation: 'anxious',
    text_jp: 'って自分の体臭だったハム...\nそろそろお風呂に入るハム',
    text_en: "Gosh, It's my own body...\nTake me to the bath.",
    type: 'conversational',
  },
  {
    id: 'hamster_069_01',
    move_to: 'c',
    animation: 'play',
    text_jp: '汗をかいたハム\nシャワーを浴びたい気分ハム',
    text_en: 'I sweated. I want to take a shower.',
    type: 'conversational',
  },
  {
    id: 'hamster_070_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '体がかゆいハム...！',
    text_en: "I'm itchy...!",
    type: 'conversational',
    next_script_id: 'hamster_070_02',
  },
  {
    id: 'hamster_070_02',
    animation: 'anxious',
    text_jp: '至急お風呂に入れてほしいハム！',
    text_en: 'I want you to take me to the bath ASAP.',
    type: 'conversational',
  },
  {
    id: 'hamster_071_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '自慢の毛並みがととのわなく\nなってきたハム',
    text_en: 'My fur is not in perfect condition.',
    type: 'conversational',
    next_script_id: 'hamster_071_02',
  },
  {
    id: 'hamster_071_02',
    animation: 'anxious',
    text_jp: 'シャンプータイムに\nしてほしいハム...！',
    text_en: 'I need you to shampoo my body.',
    type: 'conversational',
  },
  {
    id: 'hamster_072_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: '{player_name}！',
    text_en: '{player_name}!!',
    type: 'conversational',
    next_script_id: 'hamster_072_02',
  },
  {
    id: 'hamster_072_02',
    animation: 'cry',
    text_jp: '最近かまってくれてない\n気がするハム...',
    text_en: "You haven't been paying attention to me lately...",
    type: 'conversational',
  },
  {
    id: 'hamster_073_01',
    move_to: 'c',
    animation: 'play',
    text_jp: '遊ぼうハム〜\n遊ぼうハム〜',
    text_en: 'Play with me!\nPlay with me!',
    type: 'conversational',
    next_script_id: 'hamster_073_02',
  },
  {
    id: 'hamster_073_02',
    animation: 'play',
    text_jp: 'もひとつおまけに\n遊ぼうハム〜〜',
    text_en: 'And once more!\nPlay with me!!!',
    type: 'conversational',
  },
  {
    id: 'hamster_074_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'うぅぅぅ...',
    text_en: 'Hmmm,',
    type: 'conversational',
    next_script_id: 'hamster_074_02',
  },
  {
    id: 'hamster_074_02',
    animation: 'cry',
    text_jp:
      '寂しいハム...\nちっともかまってもらってないハム\n愛が届いてないハム...',
    text_en:
      'I feel lonely... You left me alone too much... I need you to love me more...',
    type: 'conversational',
  },
  {
    id: 'hamster_075_01',
    move_to: 'c',
    animation: 'joy',
    text_jp: 'なでなでしてほしいハム〜♪\nさすさすしたいハム〜♪',
    text_en: 'I want you to pat me down.',
    type: 'conversational',
    next_script_id: 'hamster_075_02',
  },
  {
    id: 'hamster_075_02',
    animation: 'angry',
    text_jp: 'してくれないなら家出するハム〜♪',
    text_en: "If you don't, I'll run away from home!",
    type: 'conversational',
  },
  {
    id: 'hamster_076_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'そろそろ...\nトイレタイム\nハム！',
    text_en: 'Now, time to go to the bathroom!',
    type: 'conversational',
  },
  {
    id: 'hamster_077_01',
    move_to: 'c',
    animation: 'play',
    text_jp: 'おしっこ♪ おしっこ♪',
    text_en: 'Pee, pee...',
    type: 'conversational',
    next_script_id: 'hamster_077_02',
  },
  {
    id: 'hamster_077_02',
    animation: 'play',
    text_jp: 'トイレに行きたいハム〜',
    text_en: 'I have to go to the bathroom.',
    type: 'conversational',
  },
  {
    id: 'hamster_078_01',
    move_to: 'bc',
    animation: 'angry',
    text_jp: 'ト、トイレ...！\n大急ぎで連れてってほしいハム...！',
    text_en: 'B, bathroom...!\nPlease take me there NOW!!',
    type: 'conversational',
  },
  {
    id: 'hamster_079_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'やばいハム...！\nもれちゃうハム...！',
    text_en: "No way..!\nIt's coming out...!",
    type: 'conversational',
    next_script_id: 'hamster_079_02',
  },
  {
    id: 'hamster_079_02',
    animation: 'surprised',
    text_jp: '緊急事態宣言ハム...！',
    text_en: "It's an emergency!",
    type: 'conversational',
  },
  {
    id: 'hamster_080_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'TVでこわい映画を見ちゃったハム',
    text_en: 'I watched a scary movie on TV...',
    type: 'conversational',
    next_script_id: 'hamster_080_02',
  },
  {
    id: 'hamster_080_02',
    animation: 'anxious',
    text_jp: '気を紛らわせてほしいハム',
    text_en: 'I want you to calm me down.',
    type: 'conversational',
  },
  {
    id: 'hamster_081_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: 'ん？\nなんか聞こえなかったハム？',
    text_en: 'Hm? Did you hear the sound?',
    type: 'conversational',
    next_script_id: 'hamster_081_02',
  },
  {
    id: 'hamster_081_02',
    animation: 'anxious',
    text_jp: 'こわいので気を紛らせてほしいハム',
    text_en: "I'm scared... Please calm me down.",
    type: 'conversational',
  },
  {
    id: 'hamster_082_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'なんだかお腹がしくしく痛いハム...',
    text_en: 'I have a stomachache...',
    type: 'conversational',
    next_script_id: 'hamster_082_02',
  },
  {
    id: 'hamster_082_02',
    expression: 'very_sad',
    text_jp: 'おクスリ飲ませてもらえないハム？',
    text_en: 'Can I have some medicine?',
    type: 'conversational',
  },
  {
    id: 'hamster_083_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '頭がずきずきするハム...',
    text_en: 'I have a bad headache...',
    type: 'conversational',
    next_script_id: 'hamster_083_02',
  },
  {
    id: 'hamster_083_02',
    expression: 'very_sad',
    text_jp: 'おクスリ持ってないハム...？',
    text_en: "Don't you have a medicine?",
    type: 'conversational',
  },
  {
    id: 'hamster_084_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: '歯が、歯が痛いハム...',
    text_en: 'I, I have a toothache...',
    type: 'conversational',
    next_script_id: 'hamster_084_02',
  },
  {
    id: 'hamster_084_02',
    animation: 'surprised',
    text_jp: '歯みがきサボったからハム？',
    text_en: "Maybe it's because I skipped brushing my teeth.",
    type: 'conversational',
  },
  {
    id: 'hamster_085_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ほほ袋になにも入れてないのに\nパンパンハム...',
    text_en:
      "My cheek pocket is full even though I don't have any foods in it...",
    type: 'conversational',
    next_script_id: 'hamster_085_02',
  },
  {
    id: 'hamster_085_02',
    animation: 'surprised',
    text_jp: 'これは虫歯に違いないハム...',
    text_en: 'This should be a tooth decay...',
    type: 'conversational',
  },
  {
    id: 'hamster_086_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '目がとろんとしてきたハム...',
    text_en: "I can't keep my eyes open...",
    type: 'conversational',
    next_script_id: 'hamster_086_02',
  },
  {
    id: 'hamster_086_02',
    animation: 'waive',
    text_jp: 'そろそろ寝るハム\nおやすみ\n{player_name}',
    text_en: "I'll go asleep.\nGood night,\n{player_name}",
    type: 'conversational',
  },
  {
    id: 'hamster_087_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ん？からだが\nムズムズするハム…',
    text_en: 'Ham-hmm. My body is mushy.',
    type: 'conversational',
  },
  {
    id: 'hamster_088_01',
    move_to: 'c',
    text_jp:
      'しんじゃったハム…\nこれまでお世話してくれて、\nどうもありがとうハム',
    text_en: 'I’m dead…\nThanks for playing with me until now.',
    type: 'conversational',
    next_script_id: 'hamster_088_02',
  },
  {
    id: 'hamster_088_02',
    text_jp: '{player_name}の\nこと、ずっとずっと忘れないハム',
    text_en: 'I’ll never, ever forget you, {player_name}.',
    type: 'conversational',
    next_script_id: 'hamster_088_03',
  },
  {
    id: 'hamster_088_03',
    text_jp: 'もしまたどこかで会えたら、\n一緒にあそぶハム',
    text_en:
      'If we ever see each other again someday, let’s play together again.',
    type: 'conversational',
  },
  {
    id: 'hamster_089_01',
    move_to: 'c',
    text_jp: 'うーん。これはいかんハム\nほっとくとしんじゃうハム…',
    text_en:
      'Ohhh… This isn’t good…\nI’m going to die if you don’t do something.',
    type: 'conversational',
    next_script_id: 'hamster_089_02',
  },
  {
    id: 'hamster_089_02',
    text_jp: '万能コロンを使うと\n治るかもしれないって\n聞いたことあるハム…',
    text_en: 'I’ve heard that the Magic Potion might work…',
    type: 'conversational',
  },
  {
    id: 'hamster_090_01',
    move_to: 'c',
    text_jp: 'おでかけしたいハム〜',
    text_en: 'I wanna go outside!',
    type: 'conversational',
    next_script_id: 'hamster_090_02',
  },
  {
    id: 'hamster_090_02',
    text_jp: 'お友だちと一緒に\nハムハムしたいハム〜',
    text_en: 'I wanna snuggle with my friend!',
    type: 'conversational',
  },
  {
    id: 'hamster_091_01',
    move_to: 'c',
    text_jp: '{friend.player_name}が\nあそびに来てたハムよ',
    text_en: '{friend.player_name} came over to play!',
    type: 'conversational',
    next_script_id: 'hamster_091_02',
  },
  {
    id: 'hamster_091_02',
    text_jp: 'かなりしっかりめに\nあそんでくれたハム\n楽しかったハム！',
    text_en: 'We played a lot together!\nIt was fun!',
    type: 'conversational',
  },
  {
    id: 'hamster_092_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きは花は何か聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite flower is!',
    type: 'conversational',
    next_script_id: 'hamster_092_02',
  },
  {
    id: 'hamster_092_02',
    text_jp: '{friend.fav_flower}って\n言ってたハム！',
    text_en: 'They said it’s {friend.fav_flower}!',
    type: 'conversational',
    next_script_id: 'hamster_092_03',
  },
  {
    id: 'hamster_092_03',
    animation: 'play',
    text_jp: '今度プレゼント\nしてみるハムかね？',
    text_en: 'Maybe I’ll get them some next time!',
    type: 'conversational',
  },
  {
    id: 'hamster_093_01',
    move_to: 'c',
    text_jp: '{friend.player_name}は\n妖怪に例えると何かって\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} what kind of yokai they would be!',
    type: 'conversational',
    next_script_id: 'hamster_093_02',
  },
  {
    id: 'hamster_093_02',
    text_jp: '{friend.similar_yokai}って\n言ってたハム！',
    text_en: 'They said {friend.similar_yokai}!',
    type: 'conversational',
    next_script_id: 'hamster_093_03',
  },
  {
    id: 'hamster_093_03',
    animation: 'waive',
    text_jp: 'たしかに、言われてみると…\nうーん。どうハムかね？',
    text_en: 'I mean, if I had to pick one…\nI guess so? What do you think?',
    type: 'conversational',
  },
  {
    id: 'hamster_094_01',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n得意技を聞いたら、',
    text_en: 'I asked {friend.player_name} what their special talent is!',
    type: 'conversational',
    next_script_id: 'hamster_094_02',
  },
  {
    id: 'hamster_094_02',
    text_jp: '{friend.speciality}って\n言ってたハム！',
    text_en: 'They said {friend.speciality}!',
    type: 'conversational',
    next_script_id: 'hamster_094_03',
  },
  {
    id: 'hamster_094_03',
    animation: 'joy',
    text_jp: '今度見せてもらうハム！',
    text_en: 'Have them show you sometime!',
    type: 'conversational',
  },
  {
    id: 'hamster_095_01',
    move_to: 'c',
    text_jp: '{friend.player_name}の\nお気に入りのお天気を\n聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite weather is!',
    type: 'conversational',
    next_script_id: 'hamster_095_02',
  },
  {
    id: 'hamster_095_02',
    text_jp: '{friend.fav_weather}って\n言ってたハム！',
    text_en: 'They said {friend.fav_weather}!',
    type: 'conversational',
    next_script_id: 'hamster_095_03',
  },
  {
    id: 'hamster_095_03',
    text_jp: '{friend.player_name}\nらしいハムね！',
    text_en: 'That’s {friend.player_name} for you!',
    type: 'conversational',
  },
  {
    id: 'hamster_096_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n自分の体の好きな部分を\n聞いたら、',
    text_en:
      'I asked {friend.player_name} what their favorite part of their body is.',
    type: 'conversational',
    next_script_id: 'hamster_096_02',
  },
  {
    id: 'hamster_096_02',
    text_jp: '{friend.fav_bodypart}って\n言ってたハム！',
    text_en: 'They said it’s {friend.fav_bodypart}!',
    type: 'conversational',
    next_script_id: 'hamster_096_03',
  },
  {
    id: 'hamster_096_03',
    text_jp: 'たしかに、とっても\n魅力的ハムよね！',
    text_en: 'Very nice!',
    type: 'conversational',
  },
  {
    id: 'hamster_097_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n最近幸せだったときって\nいつだったか聞いたら、',
    text_en: 'I asked {friend.player_name} if they had a happy moment lately!',
    type: 'conversational',
    next_script_id: 'hamster_097_02',
  },
  {
    id: 'hamster_097_02',
    text_jp: '{friend.happy_moment}って\n言ってたハム！',
    text_en: 'They said {friend.happy_moment}!',
    type: 'conversational',
    next_script_id: 'hamster_097_03',
  },
  {
    id: 'hamster_097_03',
    text_jp:
      '何気ないひとときに\n幸せを感じられる…\nそんなハムになりたいハム！',
    text_en:
      'That sure does sound like a nice moment!\nI want something like that to happen!',
    type: 'conversational',
  },
  {
    id: 'hamster_098_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n最近痛かった瞬間を聞いたら、',
    text_en:
      'I asked {friend.player_name} if they had a painful moment lately!',
    type: 'conversational',
    next_script_id: 'hamster_098_02',
  },
  {
    id: 'hamster_098_02',
    text_jp: '{friend.painful_moment}って\n言ってたハム！',
    text_en: 'They said {friend.painful_moment}!',
    type: 'conversational',
    next_script_id: 'hamster_098_03',
  },
  {
    id: 'hamster_098_03',
    text_jp: '聞いてるだけで\n痛くなっちゃうハム…',
    text_en: 'That sounds painful just hearing about it!',
    type: 'conversational',
  },
  {
    id: 'hamster_099_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nお母さんの旧姓を聞いたハム',
    text_en: 'I asked {friend.player_name} what their mom’s maiden name is!',
    type: 'conversational',
    next_script_id: 'hamster_099_02',
  },
  {
    id: 'hamster_099_02',
    text_jp: 'え？なんで聞いたかって？',
    text_en: 'Huh? Why did I ask?',
    type: 'conversational',
    next_script_id: 'hamster_099_03',
  },
  {
    id: 'hamster_099_03',
    text_jp:
      'ユーザー登録でよくある\n「秘密の質問」ごっこを\nしたかっただけハム',
    text_en:
      'I just wanted to play the “secret question” game they make you do when you make an account.',
    type: 'conversational',
  },
  {
    id: 'hamster_100_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n行ってみたい国を聞いてみたら、',
    text_en:
      'When I asked {friend.player_name} what country they want to visit…',
    type: 'conversational',
    next_script_id: 'hamster_100_02',
  },
  {
    id: 'hamster_100_02',
    text_jp: '{friend.goto_country}って\n行ってたハム！',
    text_en: 'They said {friend.goto_country}!',
    type: 'conversational',
    next_script_id: 'hamster_100_03',
  },
  {
    id: 'hamster_100_03',
    text_jp: '{pet_name}も\nいつか一緒に行ってみたいハム',
    text_en: '{pet_name} wants to go someday, too!',
    type: 'conversational',
  },
  {
    id: 'hamster_101_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな物語を聞いてみたら、',
    text_en: 'When I asked {friend.player_name} what their favorite story is…',
    type: 'conversational',
    next_script_id: 'hamster_101_02',
  },
  {
    id: 'hamster_101_02',
    text_jp: '{friend.fav_story}って\n言ってたハム！',
    text_en: 'They said {friend.fav_story}!',
    type: 'conversational',
    next_script_id: 'hamster_101_03',
  },
  {
    id: 'hamster_101_03',
    text_jp: 'それって有名なお話ハム？',
    text_en: 'Is that a famous story?',
    type: 'conversational',
  },
  {
    id: 'hamster_102_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nひまわりとあさがお、\nどっちが好きか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they like sunflowers or hydrangeas better!',
    type: 'conversational',
    case: 'friend.sunflower_or_morningglory',
    next_script_id_1: 'hamster_102_02',
    next_script_id_2: 'hamster_102_03',
  },
  {
    id: 'hamster_102_02',
    animation: 'joy',
    text_jp: 'ひまわりが好きって言ってたハム！\nさすが、分かってるハム！',
    text_en: 'They said sunflowers!\nExcellent choice!',
    type: 'conversational',
  },
  {
    id: 'hamster_102_03',
    expression: 'normal',
    text_jp:
      'あさがおが好きって言ってたハム！\nまあ、あさがおの蜜も\n美味しいハムけどね〜',
    text_en: 'They said hydrangeas!\nI guess they do have a sweetness to them!',
    type: 'conversational',
  },
  {
    id: 'hamster_103_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nエビフライのしっぽを\n食べるかどうか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they eat the tail on fried shrimp!',
    type: 'conversational',
    case: 'friend.friedshrimp',
    next_script_id_1: 'hamster_103_02',
    next_script_id_2: 'hamster_103_03',
  },
  {
    id: 'hamster_103_02',
    text_jp: '普通に食べるって言ってたハム！\n{pet_name}も食べるハム！',
    text_en: 'They said they eat it!\nSo does {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'hamster_103_03',
    expression: 'normal',
    text_jp:
      '食べないって言ってたハム！\n美味しくて栄養もあるのに、\nもったいないハムよね〜',
    text_en:
      "They said they don' t eat it!\nWhat a waste! It’s full of protein!",
    type: 'conversational',
  },
  {
    id: 'hamster_104_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nバスタオルは毎回洗うか\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they wash their bath towel every time!',
    type: 'conversational',
    case: 'friend.wash_bathtowels',
    next_script_id_1: 'hamster_104_02',
    next_script_id_2: 'hamster_104_03',
  },
  {
    id: 'hamster_104_02',
    text_jp: '毎回洗うって言ってたハム！\nこれはかなりのきれい好きハム！',
    text_en: 'They said they do!\nWhat a clean freak!',
    type: 'conversational',
  },
  {
    id: 'hamster_104_03',
    text_jp: '毎回は洗わないって言ってたハム！\nエコで良いと思うハム！',
    text_en: 'They said they don’t!\nProbably better for the environment!',
    type: 'conversational',
  },
  {
    id: 'hamster_105_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n動物園と水族館、どっちに\n行きたいか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they like zoos or aquariums better!',
    type: 'conversational',
    case: 'friend.zoo_or_aquarium',
    next_script_id_1: 'hamster_105_02',
    next_script_id_2: 'hamster_105_03',
  },
  {
    id: 'hamster_105_02',
    text_jp: '動物園に行きたいって\n言ってたハム！\n今度誘ってみたらどうハム？',
    text_en: 'They said they like zoos!\nWhy not ask them to go sometime?',
    type: 'conversational',
  },
  {
    id: 'hamster_105_03',
    text_jp: '水族館に行きたいって\n言ってたハム！\n今度誘ってみたらどうハム？',
    text_en: 'They said they like aquariums!\nWhy not ask them to go sometime?',
    type: 'conversational',
  },
  {
    id: 'hamster_106_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nマラソンと100m走で\nどっちが得意か聞いたら、',
    text_en:
      'I asked {friend.player_name} whether they’re better at marathons or the 100m dash!',
    type: 'conversational',
    case: 'friend.marathon_or_100m',
    next_script_id_1: 'hamster_106_02',
    next_script_id_2: 'hamster_106_03',
  },
  {
    id: 'hamster_106_02',
    text_jp: 'マラソンが得意って言ってたハム！\nあふれる無限の体力ハム！',
    text_en: 'They said marathons!\nThey’ve got infinite energy!',
    type: 'conversational',
  },
  {
    id: 'hamster_106_03',
    text_jp: '100m走が得意って言ってたハム！\n目にもとまらぬ速さハム！',
    text_en:
      'They said the 100m dash!\nThat means they’re almost too fast to see!',
    type: 'conversational',
  },
  {
    id: 'hamster_107_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n山と海どっちに行きたいか\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} whether they like the mountains or ocean better!',
    type: 'conversational',
    case: 'friend.mountain_or_ocean',
    next_script_id_1: 'hamster_107_02',
    next_script_id_2: 'hamster_107_03',
  },
  {
    id: 'hamster_107_02',
    text_jp: '山に行きたいって言ってたハム！\n今度誘ってみたらいいハム！',
    text_en:
      'They said they like the mountains!\nWhy not ask them to go sometime?',
    type: 'conversational',
  },
  {
    id: 'hamster_107_03',
    text_jp: '海に行きたいって言ってたハム！\n今度誘ってみたらいいハム！',
    text_en: 'They said they like the ocean!\nWhy not ask them to go sometime?',
    type: 'conversational',
  },
  {
    id: 'hamster_108_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nアイスクリームとかき氷、\nどっちが好きか聞いてみたら、',
    text_en:
      'I asked {friend.player_name} whether they like ice cream or shaved ice better!',
    type: 'conversational',
    case: 'friend.icecream_or_shavedice',
    next_script_id_1: 'hamster_108_02',
    next_script_id_2: 'hamster_108_03',
  },
  {
    id: 'hamster_108_02',
    text_jp:
      'アイスが好きって言ってたハム！\n{pet_name}は\nチョコレート味が好きハム！',
    text_en: 'They said they like ice cream!\n{pet_name} likes chocolate!',
    type: 'conversational',
  },
  {
    id: 'hamster_108_03',
    text_jp:
      'かき氷が好きって言ってたハム！\n{pet_name}は\nいちごミルクが好きハム！',
    text_en:
      'They said they like shaved ice!\n{pet_name} likes strawberry milk flavor!',
    type: 'conversational',
  },
  {
    id: 'hamster_109_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n朝ごはんはご飯かパンか\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they prefer rice or bread for breakfast!',
    type: 'conversational',
    case: 'friend.rice_or_bread',
    next_script_id_1: 'hamster_109_02',
    next_script_id_2: 'hamster_109_03',
  },
  {
    id: 'hamster_109_02',
    text_jp:
      'ご飯って言ってたハム！\n{pet_name}は\n両方好きすぎて決められないハム！',
    text_en: 'They said rice!\n{pet_name} likes both too much to choose!',
    type: 'conversational',
  },
  {
    id: 'hamster_109_03',
    text_jp:
      'パンって言ってたハム！\n{pet_name}は\n両方好きすぎて決められないハム！',
    text_en: 'They said bread!\n{pet_name} likes both too much to choose!',
    type: 'conversational',
  },
  {
    id: 'hamster_110_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nおばけはいると思うか\nどうか聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they think ghosts exist!',
    type: 'conversational',
    case: 'friend.ghost_exist',
    next_script_id_1: 'hamster_110_02',
    next_script_id_2: 'hamster_110_03',
  },
  {
    id: 'hamster_110_02',
    animation: 'joy',
    text_jp:
      'いると思うって言ってたハム！\n{pet_name}も\n実はいると思ってるハム！',
    text_en:
      'They said they think ghosts exist!\n{pet_name} actually thinks they do, too!',
    type: 'conversational',
  },
  {
    id: 'hamster_110_03',
    expression: 'normal',
    text_jp:
      'いないと思うって言ってたハム！\nいてもおかしくないと\n思うハムけどね〜',
    text_en:
      'They said they think ghosts don’t exist!\nI think they do, though!',
    type: 'conversational',
  },
  {
    id: 'hamster_111_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nかくれんぼ好きかどうか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they like playing hide-and-seek!',
    type: 'conversational',
    case: 'friend.hide_and_seek',
    next_script_id_1: 'hamster_111_02',
    next_script_id_2: 'hamster_111_03',
  },
  {
    id: 'hamster_111_02',
    animation: 'play',
    text_jp: '好きって言ってたハム！\n今度一緒にやってみるハム！',
    text_en:
      'They said they like hide-and-seek!\nYou should play together sometime!',
    type: 'conversational',
  },
  {
    id: 'hamster_111_03',
    expression: 'normal',
    text_jp:
      'そうでもないって言ってたハム！\nかくれんぼよりは鬼ごっこ派\nなのかもしれないハムね…',
    text_en:
      'They said they didn’t really like hide-and-seek!\nMaybe they like playing Tag more!',
    type: 'conversational',
  },
  {
    id: 'hamster_112_01',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n朝型か夜型か聞いてみたら',
    text_en:
      "I asked {friend.player_name} if they're an early bird or a night owl!",
    type: 'conversational',
    case: 'friend.earlybird_nightowl',
    next_script_id_1: 'hamster_112_02',
    next_script_id_2: 'hamster_112_03',
  },
  {
    id: 'hamster_112_02',
    text_jp: '朝型だって言ってたハム！\n早起きは三文の得ハム！',
    text_en: 'They said they’re an early bird!\nI guess they get the worm!',
    type: 'conversational',
  },
  {
    id: 'hamster_112_03',
    text_jp: '夜型だって言ってたハム！\nただの夜ふかしの可能性も\nあるハム！',
    text_en:
      'They said they’re a night owl!\nMaybe they’re just staying up too late?',
    type: 'conversational',
  },
  {
    id: 'hamster_113_01',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nインドア派かアウトドア派か\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they’re an indoor, or outdoor person!',
    type: 'conversational',
    case: 'friend.indoor_outdoor',
    next_script_id_1: 'hamster_113_02',
    next_script_id_2: 'hamster_113_03',
  },
  {
    id: 'hamster_113_02',
    text_jp: 'インドア派だって言ってたハム！\nやっぱりおうちが一番ハム！',
    text_en:
      "They said they're an indoor person!\nNothing beats your own home!",
    type: 'conversational',
  },
  {
    id: 'hamster_113_03',
    text_jp:
      'アウトドア派だって言ってたハム！\n意外とアクティブなとこ\nあるハムね！',
    text_en:
      "They said they're an outdoor person!\nSurprisingly active, right?",
    type: 'conversational',
  },
  {
    id: 'hamster_114_01',
    move_to: 'c',
    text_jp: 'おっきくなったハム！',
    text_en: "I've gotten bigger!",
    type: 'conversational',
  },
  {
    id: 'hamster_115_01',
    animation: 'waive',
    text_jp: 'あそびに来たハム〜\nおじゃまするハム〜',
    text_en: 'I’m here to play!\nWhat should we do first?',
    type: 'conversational',
  },
  {
    id: 'hamster_116_01',
    animation: 'waive',
    text_jp: 'いらっしゃいハム〜\nなにしてあそぶハム？',
    text_en: 'Welcome! \nWhat should we do first?',
    type: 'conversational',
  },
  {
    id: 'hamster_117_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      'これ、つまらないものハムけど、\nいろいろおせわしてもらったから、\nほんの感謝の気持ちハム',
    text_en: 'As thanks for hanging out with me, here’s a little gift!',
    type: 'conversational',
  },
  {
    id: 'hamster_118_01',
    text_jp: 'そろそろ帰るハムね〜\n今日は楽しかったハム\nどうもありがとハム〜',
    text_en: 'I’ve got to get going.\nToday was a lot of fun!\nThanks!',
    type: 'conversational',
  },
  {
    id: 'hamster_119_01',
    text_jp: 'またいつでも来てくれハム〜',
    text_en: 'Come back any time!',
    type: 'conversational',
  },
  {
    id: 'hamster_120_01',
    text_jp: '{friend.player_name}が\n帰ってきたハムね',
    text_en: '{friend.player_name} is back!',
    type: 'conversational',
    next_script_id: 'hamster_120_02',
  },
  {
    id: 'hamster_120_02',
    animation: 'waive',
    text_jp: 'そろそろ帰るハムね\nまたねハム〜',
    text_en: 'It’s about time for me to go!\nSee you soon!',
    type: 'conversational',
  },
  {
    id: 'hamster_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないハム',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'hamster_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないハム',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'hamster_123_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今はそんな余裕無いハム〜\n万能コロンをかけて欲しいハム…',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'hamster_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないハム〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'hamster_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったハム！\nどうもありがとハム！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'hamster_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったハム！\nどうもありがとハム！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'hamster_127_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'なんとか助かったハム！\nどうもありがとハム！',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'hamster_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったハム…\nもう1回試してみて欲しいハム',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'hamster_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったハム…\nもう1回試してみて欲しいハム',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'hamster_130_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったハム…\nもう1回試してみて欲しいハム',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'turtle_001_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'カメ〜〜',
    text_en: 'Kame~~~',
    type: 'conversational',
    next_script_id: 'turtle_001_02',
  },
  {
    id: 'turtle_001_02',
    animation: 'play',
    text_jp: '早速遊ぼうじゃないカメ〜',
    text_en: "Let's play together now.",
    type: 'conversational',
  },
  {
    id: 'turtle_002_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '部屋の隅のホコリを\nちょっと取るだけのつもりが',
    text_en: 'I was just going to get a little dust in the corner of my room',
    type: 'conversational',
    next_script_id: 'turtle_002_02',
  },
  {
    id: 'turtle_002_02',
    animation: 'sleep',
    text_jp: '大掃除になったカメ',
    text_en: 'But it turned out to be a big cleaning job.',
    type: 'conversational',
  },
  {
    id: 'turtle_003_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カップの味噌汁の\nプラスチックのフタ',
    text_en: 'Plastic lids on cups of miso soup',
    type: 'conversational',
    next_script_id: 'turtle_003_02',
  },
  {
    id: 'turtle_003_02',
    expression: 'normal',
    text_jp: 'あれ、なくてもよくないカメ？',
    text_en: "I don't think that are necessary.",
    type: 'conversational',
  },
  {
    id: 'turtle_004_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '一句できたカメ',
    text_en: "I've got a poem.",
    type: 'conversational',
    next_script_id: 'turtle_004_02',
  },
  {
    id: 'turtle_004_02',
    expression: 'happy',
    text_jp: 'デジャヴかな？\nノンノンただの\nもの忘れ',
    text_en: "Is it deja vu?\nNo, no, that's just forgetting things.",
    type: 'conversational',
  },
  {
    id: 'turtle_005_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '日本人の好きなもの\nランキング1位は',
    text_en: 'I think the ranked #1 favorite thing of Japanese people is',
    type: 'conversational',
    next_script_id: 'turtle_005_02',
  },
  {
    id: 'turtle_005_02',
    animation: 'surprised',
    text_jp: '「ランキング」じゃないかと\n思うカメ',
    text_en: '"Ranking."',
    type: 'conversational',
  },
  {
    id: 'turtle_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'パフュームと\nバキュームと\n白昼夢は',
    text_en: 'Perfume, vacuums and daydreams (hakuchu-mu)',
    type: 'conversational',
    next_script_id: 'turtle_006_02',
  },
  {
    id: 'turtle_006_02',
    expression: 'happy',
    text_jp: 'よく似ていると思うカメ',
    text_en: 'I think they are very similar.',
    type: 'conversational',
  },
  {
    id: 'turtle_007_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '洗濯機と\nケンタッキーは',
    text_en: 'Laundry machine (sentakki) and Kentucky',
    type: 'conversational',
    next_script_id: 'turtle_007_02',
  },
  {
    id: 'turtle_007_02',
    expression: 'happy',
    text_jp: 'よく似ていると思うカメ',
    text_en: 'I think they are very similar.',
    type: 'conversational',
  },
  {
    id: 'turtle_008_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '灯台下暗しと\n大正デモクラシーは',
    text_en: 'Darkness under the Lamp and Taisho Democracy,',
    type: 'conversational',
    next_script_id: 'turtle_008_02',
  },
  {
    id: 'turtle_008_02',
    expression: 'happy',
    text_jp: '少し似ていると思うカメ',
    text_en: 'I think they are very similar.',
    type: 'conversational',
  },
  {
    id: 'turtle_009_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'この人老けたな〜\nと思う時は',
    text_en: 'When you think, "This person is getting old,"',
    type: 'conversational',
    next_script_id: 'turtle_009_02',
  },
  {
    id: 'turtle_009_02',
    expression: 'sad',
    text_jp: '自分も同じように老けて\nいってることを知るといいカメ',
    text_en: "Know that you're getting old as well.",
    type: 'conversational',
  },
  {
    id: 'turtle_010_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '夜中に突然',
    text_en: 'Sometimes in the middle of the night,',
    type: 'conversational',
    next_script_id: 'turtle_010_02',
  },
  {
    id: 'turtle_010_02',
    expression: 'happy',
    text_jp: '無性にピザが食べたくなる\nことがあるカメ',
    text_en: 'I suddenly have an uncontrollable craving for pizza.',
    type: 'conversational',
  },
  {
    id: 'turtle_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ダンゴムシは実は',
    text_en: 'Dung beetles are actually',
    type: 'conversational',
    next_script_id: 'turtle_011_02',
  },
  {
    id: 'turtle_011_02',
    animation: 'surprised',
    text_jp: '明治期に日本にきた外来種カメ\n意外じゃないカメ？',
    text_en: 'an introduced species that came to Japan in the 19th century.',
    type: 'conversational',
  },
  {
    id: 'turtle_012_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ナメクジも\nカタツムリも\nダンゴムシも',
    text_en: 'Slugs, snails and Dung beetles',
    type: 'conversational',
    next_script_id: 'turtle_012_02',
  },
  {
    id: 'turtle_012_02',
    animation: 'surprised',
    text_jp:
      'コンクリートを食べるカメ\n手軽にカルシウムが取れるから\n実は大人気カメ',
    text_en:
      'All of these eat concrete. They are very popular because it is an easy way to get calcium.',
    type: 'conversational',
  },
  {
    id: 'turtle_013_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'お店の前にする盛り塩',
    text_en: 'Salt in front of the stores',
    type: 'conversational',
    next_script_id: 'turtle_013_02',
  },
  {
    id: 'turtle_013_02',
    expression: 'happy',
    text_jp:
      'あれは金持ちが乗る牛車の\n牛を店の前に足止めさせる\nためのものだったカメ',
    text_en:
      "That was to keep the oxen in the rich man's ox carts stranded in front of the store.",
    type: 'conversational',
  },
  {
    id: 'turtle_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'マグロが泳ぐスピードは',
    text_en: 'Tuna swim at speeds of',
    type: 'conversational',
    next_script_id: 'turtle_014_02',
  },
  {
    id: 'turtle_014_02',
    expression: 'happy',
    text_jp: '時速80〜90kmもあるカメ',
    text_en: '80 to 90 kilometers per hour.',
    type: 'conversational',
    next_script_id: 'turtle_014_03',
  },
  {
    id: 'turtle_014_03',
    animation: 'surprised',
    text_jp: '体重は400kgもあるので\nちょっとした魚雷みたいなものカメ',
    text_en: "It weighs 400 kg, so it's like a torpedo.",
    type: 'conversational',
  },
  {
    id: 'turtle_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ナマケモノは怠け者\nではないカメ',
    text_en: 'Sloths are not lazy.',
    type: 'conversational',
    next_script_id: 'turtle_015_02',
  },
  {
    id: 'turtle_015_02',
    expression: 'happy',
    text_jp: '敵に見つからないための擬態と\n省エネのためゆっくり動くだけカメ',
    text_en:
      'They only move slowly because of mimicry and energy conservation.',
    type: 'conversational',
    next_script_id: 'turtle_015_03',
  },
  {
    id: 'turtle_015_03',
    animation: 'play',
    text_jp: 'その気持ちよくわかるカメ',
    text_en: 'I can fully understand that feeling.',
    type: 'conversational',
  },
  {
    id: 'turtle_016_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'たぬき寝入りを見破る方法を\n知ってるカメ？',
    text_en: 'Do you know how to spot a pretend sleeper?',
    type: 'conversational',
    next_script_id: 'turtle_016_02',
  },
  {
    id: 'turtle_016_02',
    expression: 'happy',
    text_jp:
      'ノドを見るカメ\nもしもツバを飲み込んでいたら\nその人は本当は起きてるカメ',
    text_en:
      'Look at their throat.\nIf they are swallowing spit, they are really awake.',
    type: 'conversational',
  },
  {
    id: 'turtle_017_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '童話「ウサギとカメ」には\n続きがあるカメ',
    text_en: 'The fairy tale "The Hare and the Tortoise" has a sequel.',
    type: 'conversational',
    next_script_id: 'turtle_017_02',
  },
  {
    id: 'turtle_017_02',
    expression: 'happy',
    text_jp:
      '仲間外れにされた負けウサギが\n名誉挽回のためにオオカミを\n撃退する話カメ',
    text_en:
      'A story about a defeated rabbit fights off a wolf to regain his honor.',
    type: 'conversational',
  },
  {
    id: 'turtle_018_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カメといえばよく長寿と\n言われるカメが、',
    text_en: 'Turtles are often said to have longevity.',
    type: 'conversational',
    next_script_id: 'turtle_018_02',
  },
  {
    id: 'turtle_018_02',
    animation: 'surprised',
    text_jp:
      '最高齢のカメはなんと190歳カメ\nここまできたら\n200歳まで生きてほしいカメ',
    text_en:
      'The oldest turtle is a 190 years old. I hope he will live to be 200 years old.',
    type: 'conversational',
  },
  {
    id: 'turtle_019_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ノドが痛い時には',
    text_en: 'When you have a sore throat, I recommend to eat marshmallows.',
    type: 'conversational',
    next_script_id: 'turtle_019_02',
  },
  {
    id: 'turtle_019_02',
    expression: 'happy',
    text_jp:
      'マシュマロを食べるといいカメ\nゼラチン質が炎症してるノドを\n保護してくれるカメ',
    text_en: 'The gelatinous substance protects the inflamed throat.',
    type: 'conversational',
  },
  {
    id: 'turtle_020_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'サハラ砂漠のサハラとは',
    text_en: '"Sahara" in Sahara Desert means desert.',
    type: 'conversational',
    next_script_id: 'turtle_020_02',
  },
  {
    id: 'turtle_020_02',
    animation: 'surprised',
    text_jp: '砂漠という意味カメ\nつまり砂漠砂漠ということカメ',
    text_en: 'In other words, it means Desert Desert.',
    type: 'conversational',
  },
  {
    id: 'turtle_021_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'おにぎりの海苔は\nパリパリ派？しっとり派？',
    text_en: 'Do you prefer dry or wet nori for rice balls?',
    type: 'selectional',
    answer_var: 'riceball_type',
    option_1_jp: 'パリパリ派',
    option_1_en: 'Dry type',
    option_2_jp: 'しっとり派',
    option_2_en: 'Wet type',
    case: 'riceball_type',
    next_script_id_1: 'turtle_021_02',
    next_script_id_2: 'turtle_021_03',
  },
  {
    id: 'turtle_021_02',
    expression: 'happy',
    text_jp: 'パリパリ派カメか〜\n全国的にもこっちが多数派カメ',
    text_en: 'You like crispy one. Nationally, this is the majority.',
    type: 'conversational',
  },
  {
    id: 'turtle_021_03',
    animation: 'play',
    text_jp: '{pet_name}も\nしっとり派カメ\nお米との一体感があって好きカメ',
    text_en:
      'Me too~~.\nI like it because it gives me a sense of unity with the rice.',
    type: 'conversational',
  },
  {
    id: 'turtle_022_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「きのこ」派？「たけのこ」派？',
    text_en: 'Are you a "mushroom" person or a "bamboo shoot" person?',
    type: 'selectional',
    answer_var: 'mush_bamboo',
    option_1_jp: '「きのこ」派',
    option_1_en: 'Mushroom',
    option_2_jp: '「たけのこ」派',
    option_2_en: 'Bamboo shoot',
    case: 'mush_bamboo',
    next_script_id_1: 'turtle_022_02',
    next_script_id_2: 'turtle_022_03',
  },
  {
    id: 'turtle_022_02',
    animation: 'joy',
    text_jp:
      '「きのこ」派カメ〜\nどっちかというと少数派だけど\nカリカリしててうまいカメ',
    text_en:
      'Oh, you\'re "mushroom" person. It\'s more of a minority but I like the crisp as well.',
    type: 'conversational',
  },
  {
    id: 'turtle_022_03',
    expression: 'happy',
    text_jp: '「たけのこ」派カメ〜\nクッキー部分が人気の秘訣カメ',
    text_en: 'Oh, you\'re "bamboo shoot" person. The cookie part is the best.',
    type: 'conversational',
  },
  {
    id: 'turtle_023_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'そばとうどん\nどっちが好きカメ？',
    text_en: 'Which do you prefer, soba or udon?',
    type: 'selectional',
    answer_var: 'soba_udon',
    option_1_jp: 'そば',
    option_1_en: 'Soba',
    option_2_jp: 'うどん',
    option_2_en: 'Udon',
    case: 'soba_udon',
    next_script_id_1: 'turtle_023_02',
    next_script_id_2: 'turtle_023_03',
  },
  {
    id: 'turtle_023_02',
    expression: 'happy',
    text_jp: 'そばカメ〜\nもしやおぬし江戸っ子カメ？',
    text_en: 'You like soba! Are you originally from Tokyo?',
    type: 'conversational',
  },
  {
    id: 'turtle_023_03',
    animation: 'joy',
    text_jp: 'うどんカメ〜\n{pet_name}は\nおかめうどんが大好きカメ',
    text_en: 'You like udon! On a hot day, cold udon is irresistible!',
    type: 'conversational',
  },
  {
    id: 'turtle_024_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '納豆は食べる？食べない？',
    text_en: 'Do you eat natto?',
    type: 'selectional',
    answer_var: 'like_natto',
    option_1_jp: '食べる',
    option_1_en: 'Yes',
    option_2_jp: '食べない',
    option_2_en: 'No',
    case: 'like_natto',
    next_script_id_1: 'turtle_024_02',
    next_script_id_2: 'turtle_024_03',
  },
  {
    id: 'turtle_024_02',
    expression: 'happy',
    text_jp: 'いいカメね〜\n{pet_name}も\nネバネバの食べ物好きカメ〜',
    text_en: 'How nice! I like sticky foods too~~~.',
    type: 'conversational',
  },
  {
    id: 'turtle_024_03',
    animation: 'surprised',
    text_jp:
      'そうカメ？\n納豆は安くて、体にいいけど\n好き嫌いは分かれるカメね〜',
    text_en:
      "Really? Natto is a cheep and healthy food but many people don't like that smell.",
    type: 'conversational',
  },
  {
    id: 'turtle_025_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '赤いコードと青いコード、\nどっちを切るカメ？',
    text_en: 'A red cord or a blue cord.\nWhich will you cut?',
    type: 'selectional',
    answer_var: 'red_blue',
    option_1_jp: '赤いコード',
    option_1_en: 'Red cord',
    option_2_jp: '青いコード',
    option_2_en: 'Blue cord',
    case: 'red_blue',
    next_script_id_1: 'turtle_025_02',
    next_script_id_2: 'turtle_025_04',
  },
  {
    id: 'turtle_025_02',
    animation: 'angry',
    text_jp: 'ドカーーン！',
    text_en: 'Boom!',
    type: 'conversational',
    next_script_id: 'turtle_025_03',
  },
  {
    id: 'turtle_025_03',
    animation: 'cry',
    text_jp: '赤はハズレだったカメ...',
    text_en: 'Red was a wrong one...',
    type: 'conversational',
  },
  {
    id: 'turtle_025_04',
    animation: 'anxious',
    text_jp: '………',
    text_en: '......',
    type: 'conversational',
    next_script_id: 'turtle_025_05',
  },
  {
    id: 'turtle_025_05',
    expression: 'happy',
    text_jp: '喜ぶカメ！\n青がセーフだったカメ♪',
    text_en: 'Lucky you! Blue was the right one!!',
    type: 'conversational',
  },
  {
    id: 'turtle_026_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '映画はエンドロールの最後まで\n観る？観ない？',
    text_en: 'Do you watch a movie until the end of the end roll?',
    type: 'selectional',
    answer_var: 'end_roll',
    option_1_jp: '最後まで観る',
    option_1_en: 'Watch till the end',
    option_2_jp: '観ない',
    option_2_en: 'Not watch',
    case: 'end_roll',
    next_script_id_1: 'turtle_026_02',
    next_script_id_2: 'turtle_026_03',
  },
  {
    id: 'turtle_026_02',
    expression: 'happy',
    text_jp: 'それがいいカメ\n{pet_name}は\n明るくなるまで動かないカメ',
    text_en: "Good choice. I don't move until it gets light.",
    type: 'conversational',
  },
  {
    id: 'turtle_026_03',
    animation: 'surprised',
    text_jp: 'せっかちな方カメ？',
    text_en: 'Are you impatient?',
    type: 'conversational',
    next_script_id: 'turtle_026_04',
  },
  {
    id: 'turtle_026_04',
    expression: 'happy',
    text_jp: 'たまにエンドロールの後に\n続きがあることがあるカメよ〜',
    text_en: "Sometimes there's more after the end roll!",
    type: 'conversational',
  },
  {
    id: 'turtle_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏は\n年上好き？年下好き？',
    text_en: 'Do you prefer older or younger?',
    type: 'selectional',
    answer_var: 'older_younger',
    option_1_jp: '年上好き',
    option_1_en: 'Older',
    option_2_jp: '年下好き',
    option_2_en: 'Younger',
    case: 'older_younger',
    next_script_id_1: 'turtle_027_02',
    next_script_id_2: 'turtle_027_03',
  },
  {
    id: 'turtle_027_02',
    expression: 'happy',
    text_jp: 'ほんとカメ？\n{pet_name}は\n老けて見えるのでうれしいカメ〜',
    text_en: "Are you sure? \nI'm glad because I look older!",
    type: 'conversational',
  },
  {
    id: 'turtle_027_03',
    expression: 'happy',
    text_jp: 'ほんとカメ？\n{pet_name}は\n年下なのでうれしいカメ〜',
    text_en: "Are you sure? \nI'm glad because I'm younger than you!",
    type: 'conversational',
  },
  {
    id: 'turtle_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '都会と田舎、\nどっちに住みたいカメ？',
    text_en: 'City or country, which would you rather live in?',
    type: 'selectional',
    answer_var: 'city_country',
    option_1_jp: '都会',
    option_1_en: 'City',
    option_2_jp: '田舎',
    option_2_en: 'Country',
    case: 'city_country',
    next_script_id_1: 'turtle_028_02',
    next_script_id_2: 'turtle_028_04',
  },
  {
    id: 'turtle_028_02',
    expression: 'happy',
    text_jp: 'う〜ん\n確かに都会は便利カメね〜\n',
    text_en: "Hmmm, that's true city is so convenient.",
    type: 'conversational',
    next_script_id: 'turtle_028_03',
  },
  {
    id: 'turtle_028_03',
    expression: 'normal',
    text_jp: 'でも{pet_name}\nは、田舎でスローなライフを\n送りたいカメ〜〜',
    text_en: 'But I would love to spend a slow life in a rural place.',
    type: 'conversational',
  },
  {
    id: 'turtle_028_04',
    expression: 'happy',
    text_jp: '一緒カメ！\n田舎でスローに暮らそう\nじゃないカメ〜〜',
    text_en: "Me either! Why don't we spend a slow life in a rural place!",
    type: 'conversational',
  },
  {
    id: 'turtle_029_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏は\n今何ラーメンが食べたい気分カメ？',
    text_en: 'What ramen do you want to eat now?',
    type: 'descriptive',
    answer_var: 'preferable_ramen',
    question_jp: '何ラーメンが食べたい？',
    question_en: 'What ramen do you want now?',
    max_len: 13,
    next_script_id: 'turtle_029_02',
  },
  {
    id: 'turtle_029_02',
    animation: 'surprised',
    text_jp: '{preferable_ramen}とは\n予想外カメ\n{pet_name}は今',
    text_en: "{preferable_ramen}?\nIt's unexpected. Me?",
    type: 'conversational',
    next_script_id: 'turtle_029_03',
  },
  {
    id: 'turtle_029_03',
    animation: 'joy',
    text_jp: 'コーンともやしをたっぷり乗せた\n味噌バターラーメンが食べたいカメ',
    text_en:
      "I'd like to try the Miso Butter Ramen with lots of corn and bean sprouts on top.",
    type: 'conversational',
  },
  {
    id: 'turtle_030_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏は\nどんなスポーツが好きカメ？',
    text_en: 'What sport do you like to play?',
    type: 'descriptive',
    answer_var: 'favorite_sport',
    question_jp: 'なんのスポーツが好き？',
    question_en: 'What sport do you like to play?',
    max_len: 14,
    next_script_id: 'turtle_030_02',
  },
  {
    id: 'turtle_030_02',
    expression: 'happy',
    text_jp: '{favorite_sport}とは\nかっこいいカメ',
    text_en: 'Wow,\n{favorite_sport}\nsounds so cool~.',
    type: 'conversational',
    next_script_id: 'turtle_030_03',
  },
  {
    id: 'turtle_030_03',
    animation: 'play',
    text_jp: '{pet_name}は\nランニングが好きカメ\nウサギに勝ったこともあるカメ',
    text_en: 'I like running. I even beat a rabbit once.',
    type: 'conversational',
  },
  {
    id: 'turtle_031_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏の\n好きなマンガは何カメ？',
    text_en: 'What is your favorite manga?',
    type: 'descriptive',
    answer_var: 'favorite_manga',
    question_jp: '好きな漫画は？',
    question_en: 'Favoite manga',
    max_len: 14,
    next_script_id: 'turtle_031_02',
  },
  {
    id: 'turtle_031_02',
    expression: 'normal',
    text_jp: 'フムフム\n{favorite_manga}が\n好きカメね',
    text_en: 'Hmm, hum. You like\n{favorite_manga}?',
    type: 'conversational',
    next_script_id: 'turtle_031_03',
  },
  {
    id: 'turtle_031_03',
    expression: 'happy',
    text_jp: 'ちなみに\n{pet_name}は\nこち亀が好きカメ',
    text_en: 'By the way, my favorite is "Kochi-kame!"',
    type: 'conversational',
  },
  {
    id: 'turtle_032_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '休日はどうやって過ごすカメ？',
    text_en: 'How do you spend your holidays?',
    type: 'descriptive',
    answer_var: 'holiday_life',
    question_jp: '休日の過ごし方',
    question_en: 'How to spend your holidays',
    max_len: 13,
    next_script_id: 'turtle_032_02',
  },
  {
    id: 'turtle_032_02',
    expression: 'happy',
    text_jp: '{holiday_life}？\nそれもいいカメね〜',
    text_en: '{holiday_life}?\nThat sounds good~.',
    type: 'conversational',
    next_script_id: 'turtle_032_03',
  },
  {
    id: 'turtle_032_03',
    animation: 'sleep',
    text_jp: '{pet_name}は\n日がな一日甲羅干し、\nこれに限るカメ〜',
    text_en: "I'd like to dry my shell all day long.",
    type: 'conversational',
  },
  {
    id: 'turtle_033_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏の\n好きな乗り物は何カメ？',
    text_en: 'What is your favorite vehicle?',
    type: 'descriptive',
    answer_var: 'favorite_vehicle',
    question_jp: '好きな乗り物',
    question_en: 'Favorite vehicle',
    max_len: 14,
    next_script_id: 'turtle_033_02',
  },
  {
    id: 'turtle_033_02',
    expression: 'normal',
    text_jp: '{favorite_vehicle}〜\nそうくるカメ',
    text_en: '{favorite_vehicle}?\nI see~.',
    type: 'conversational',
    next_script_id: 'turtle_033_03',
  },
  {
    id: 'turtle_033_03',
    expression: 'happy',
    text_jp: 'ならば\n{pet_name}は\nルンバが好きカメ〜',
    text_en: 'You know what? My favorite is a roomba!',
    type: 'conversational',
  },
  {
    id: 'turtle_034_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏の\n好きな昆虫は何カメ？',
    text_en: 'What is your favorite insect?',
    type: 'descriptive',
    answer_var: 'favorite_insect',
    question_jp: '好きな昆虫',
    question_en: 'Favorite insect',
    max_len: 14,
    next_script_id: 'turtle_034_02',
  },
  {
    id: 'turtle_034_02',
    expression: 'normal',
    text_jp: '{favorite_insect}？\nフフフ、そう言うと思ったカメ',
    text_en: "{favorite_insect}?\nHuh, I knew you'd say that.",
    type: 'conversational',
    next_script_id: 'turtle_034_03',
  },
  {
    id: 'turtle_034_03',
    expression: 'happy',
    text_jp: '{pet_name}の\nお気に入りはもちろん\nカメムシカメ〜',
    text_en: 'My favorite is, of course, shield bugs.',
    type: 'conversational',
  },
  {
    id: 'turtle_035_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'お風呂で最初にどこから洗うカメ？',
    text_en: 'Where do you wash first in the bath?',
    type: 'descriptive',
    answer_var: 'wash_body_part',
    question_jp: 'お風呂で最初に洗う場所',
    question_en: 'Where do you wash first?',
    max_len: 14,
    next_script_id: 'turtle_035_02',
  },
  {
    id: 'turtle_035_02',
    expression: 'sad',
    text_jp: 'うらやましいカメ...',
    text_en: "I'm jealous...",
    type: 'conversational',
    next_script_id: 'turtle_035_03',
  },
  {
    id: 'turtle_035_03',
    expression: 'very_sad',
    text_jp:
      '{pet_name}は\n洗いたくても手が届かないカメ...\nだから洗ってほしいカメ',
    text_en: "I can't reach where I want to wash.\nPlease wash me!",
    type: 'conversational',
  },
  {
    id: 'turtle_036_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏の\n星座は何カメ？',
    text_en: 'What is your star sign?',
    type: 'descriptive',
    answer_var: 'star_sign',
    question_jp: 'あなたの星座',
    question_en: 'Your star sign',
    max_len: 14,
    next_script_id: 'turtle_036_02',
  },
  {
    id: 'turtle_036_02',
    animation: 'surprised',
    text_jp: '{star_sign}！\n今月の運勢ダントツ1位カメ！！',
    text_en: "{star_sign}!!\nIt's the #1 sign of luck this month.",
    type: 'conversational',
    next_script_id: 'turtle_036_03',
  },
  {
    id: 'turtle_036_03',
    expression: 'normal',
    text_jp: '...って朝のTVで言ってたカメ',
    text_en: '...I heard so on morning show.',
    type: 'conversational',
  },
  {
    id: 'turtle_037_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'カニ、エビ、カメ、\nこの中でいつも早食いを\n注意されてるのはどれカメ？',
    text_en:
      'Crab, Shrimp and Turtle,\nwhich is the one always been warned about eating too fast?',
    type: 'selectional',
    answer_var: 'crab_shrimp_turtle',
    option_1_jp: 'カニ',
    option_1_en: 'Crab',
    option_2_jp: 'エビ',
    option_2_en: 'Shrimp',
    option_3_jp: 'カメ',
    option_3_en: 'Turtle',
    case: 'crab_shrimp_turtle',
    next_script_id_1: 'turtle_037_02',
    next_script_id_2: 'turtle_037_02',
    next_script_id_3: 'turtle_037_03',
  },
  {
    id: 'turtle_037_02',
    expression: 'sad',
    text_jp: 'はずれカメ...\nひらがなにしてみるといいカメ',
    text_en: 'Incorrect...\nTry converting it to hiragana.',
    type: 'conversational',
  },
  {
    id: 'turtle_037_03',
    expression: 'happy',
    text_jp: '正解カメ！\n「かめ！」といつも\n言われちゃうカメ',
    text_en: 'Correct!\nI was always told "Bite!" (=Kame).',
    type: 'conversational',
    next_script_id: 'turtle_037_04',
  },
  {
    id: 'turtle_037_04',
    animation: 'eat',
    text_jp: '実際にはめちゃくちゃ\nゆっくり食べるほうカメ',
    text_en: "But in fact, I'm a slow eater.",
    type: 'conversational',
  },
  {
    id: 'turtle_038_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ラクダ、カメ、サイで\n一緒に買物に言ったカメ\n何を買ったカメ？',
    text_en:
      'Camel, Turtle and Rhino,\nwhat did they buy when they went out for shopping?',
    type: 'selectional',
    answer_var: 'camel_turtle_rhino',
    option_1_jp: 'スマホ',
    option_1_en: 'Smart phone',
    option_2_jp: 'カメラ',
    option_2_en: 'Camera',
    option_3_jp: 'パソコン',
    option_3_en: 'PC',
    case: 'camel_turtle_rhino',
    next_script_id_1: 'turtle_038_02',
    next_script_id_2: 'turtle_038_03',
    next_script_id_3: 'turtle_038_02',
  },
  {
    id: 'turtle_038_02',
    expression: 'sad',
    text_jp: 'はずれカメ...\n並べ替えてみるといいカメ',
    text_en: "Incorrect...\nWhy don't you sort the order?",
    type: 'conversational',
  },
  {
    id: 'turtle_038_03',
    expression: 'happy',
    text_jp: '正解カメ！\n並べ替えると「カメラください」\nになるカメ',
    text_en:
      'Correct!!\nIf you sort them as "Kame Rakuda Sai", that means "Please give me a camera."',
    type: 'conversational',
  },
  {
    id: 'turtle_039_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次のうち長寿と最も関係が深い\n身体的な特徴はどれカメ？',
    text_en:
      'Which of the following physical characteristics is most associated with longevity?',
    type: 'selectional',
    answer_var: 'vital_sign',
    option_1_jp: '肺活量',
    option_1_en: 'Spirometry',
    option_2_jp: '血圧',
    option_2_en: 'Blood presure',
    option_3_jp: '心拍数',
    option_3_en: 'Heartbeat Count',
    case: 'vital_sign',
    next_script_id_1: 'turtle_039_02',
    next_script_id_2: 'turtle_039_02',
    next_script_id_3: 'turtle_039_03',
  },
  {
    id: 'turtle_039_02',
    expression: 'sad',
    text_jp: 'はずれカメ...\nまた挑戦するカメよ...',
    text_en: 'Incorrect...\nPlease challenge me again...',
    type: 'conversational',
  },
  {
    id: 'turtle_039_03',
    expression: 'happy',
    text_jp:
      '正解カメ！\n心拍数が早い生き物ほど寿命は短く\n少ない生き物ほど寿命は長いカメ',
    text_en:
      'Correct!!\nThe creature with the lowest heart rate has a longer lifespan.',
    type: 'conversational',
  },
  {
    id: 'turtle_040_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '60歳のお祝いは還暦、\n70歳のお祝いは古希、\nでは77歳はなんというカメ？',
    text_en:
      'The celebration of age 60 is called "Kanreki", age 70 is "Koki". Then, what is the age 77?',
    type: 'selectional',
    answer_var: '77_celemony',
    option_1_jp: '喜寿',
    option_1_en: 'Kiju',
    option_2_jp: '傘寿',
    option_2_en: 'Sanju',
    option_3_jp: '米寿',
    option_3_en: 'Beiju',
    case: '77_celemony',
    next_script_id_1: 'turtle_040_03',
    next_script_id_2: 'turtle_040_02',
    next_script_id_3: 'turtle_040_02',
  },
  {
    id: 'turtle_040_02',
    expression: 'normal',
    text_jp: 'はずれカメ...\nちょっと難しかったカメ？',
    text_en: 'Incorrect...\nIt might be a bit hard.',
    type: 'conversational',
  },
  {
    id: 'turtle_040_03',
    expression: 'happy',
    text_jp: '正解カメ！\n理由は「喜」の字が七が重なった\nように見えるからカメ',
    text_en:
      'Correct!!\nThe reason is that the character for "Ki" (喜) looks like seven (七).',
    type: 'conversational',
  },
  {
    id: 'turtle_041_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次のうち世界遺産に\n登録されていないのは\nどの滝カメ？',
    text_en:
      'Which of the following waterfalls is not on the World Heritage List?',
    type: 'selectional',
    answer_var: 'fall_heritage',
    option_1_jp: 'ナイアガラの滝',
    option_1_en: 'Niagara Falls',
    option_2_jp: 'イグアスの滝',
    option_2_en: 'Iguazu Falls',
    option_3_jp: 'ビクトリアの滝',
    option_3_en: 'Victoria Falls',
    case: 'fall_heritage',
    next_script_id_1: 'turtle_041_03',
    next_script_id_2: 'turtle_041_02',
    next_script_id_3: 'turtle_041_02',
  },
  {
    id: 'turtle_041_02',
    expression: 'normal',
    text_jp: 'はずれカメ...\n意外な答えかもしれないカメ',
    text_en: 'Incorrect...\nThe answer might be unexpected.',
    type: 'conversational',
  },
  {
    id: 'turtle_041_03',
    expression: 'happy',
    text_jp:
      '正解カメ！\n世界三大瀑布の中でナイアガラ\nだけ世界遺産じゃないカメ',
    text_en:
      "Correct!! Of the world's three great waterfalls, Niagara is the only one that is not in the list.",
    type: 'conversational',
  },
  {
    id: 'turtle_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次の音楽記号のうち、一番\nゆっく〜りなのはどれカメ？',
    text_en: 'Which music symbol is the slowest?',
    type: 'selectional',
    answer_var: 'slow_tempo',
    option_1_jp: 'アダージョ',
    option_1_en: 'Adagio',
    option_2_jp: 'ラルゴ',
    option_2_en: 'Largo',
    option_3_jp: 'グラーヴェ',
    option_3_en: 'Grave',
    case: 'slow_tempo',
    next_script_id_1: 'turtle_042_02',
    next_script_id_2: 'turtle_042_02',
    next_script_id_3: 'turtle_042_03',
  },
  {
    id: 'turtle_042_02',
    expression: 'normal',
    text_jp: 'はずれカメ...\nゆっくり考えるといいカメ',
    text_en: 'Incorrect...\nPlease think slowly.',
    type: 'conversational',
  },
  {
    id: 'turtle_042_03',
    expression: 'happy',
    text_jp: '正解カメ！\n「重々しく」という意味で\nすごくゆっくりカメ',
    text_en: 'Correct!!\nThat means "Gravely" in Italian.',
    type: 'conversational',
    next_script_id: 'turtle_042_04',
  },
  {
    id: 'turtle_042_04',
    animation: 'sleep',
    text_jp: '{pet_name}には\nこれくらいのテンポが\nぴったりカメ〜',
    text_en: 'For me, this tempo fits the best.',
    type: 'conversational',
  },
  {
    id: 'turtle_043_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '卵の黄身が2つだった時',
    text_en: 'I feel happy when',
    type: 'conversational',
    next_script_id: 'turtle_043_02',
  },
  {
    id: 'turtle_043_02',
    expression: 'happy',
    text_jp: 'しあわせを感じるカメ',
    text_en: 'the yolk of an egg is a twin.',
    type: 'conversational',
  },
  {
    id: 'turtle_044_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '朝にメールが50通近く\n届いていたカメ♪',
    text_en: 'I got nearly 50 e-mails in the morning.',
    type: 'conversational',
    next_script_id: 'turtle_044_02',
  },
  {
    id: 'turtle_044_02',
    expression: 'very_sad',
    text_jp: 'そのうち50通近くが\n迷惑メールだったカメ...',
    text_en: 'Nealy 50 of them were spam mails...',
    type: 'conversational',
  },
  {
    id: 'turtle_045_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '頭が大きすぎて\nTシャツが着られないカメ...',
    text_en: 'My head is too big to wear a T-shirt...',
    type: 'conversational',
    next_script_id: 'turtle_045_02',
  },
  {
    id: 'turtle_045_02',
    expression: 'sad',
    text_jp: 'タートルネックなんて\nもってのほかカメ',
    text_en: 'Let alone a turtle neck...!',
    type: 'conversational',
  },
  {
    id: 'turtle_046_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '...あれ？\n今何をしようとしてたカメ？',
    text_en: '... Huh?\nWhat was I trying to do now?',
    type: 'conversational',
    next_script_id: 'turtle_046_02',
  },
  {
    id: 'turtle_046_02',
    expression: 'normal',
    text_jp: '...ってことが最近\nめっきり増えたカメ',
    text_en: '...This has been happening more and more recently.',
    type: 'conversational',
  },
  {
    id: 'turtle_047_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「鉄観音茶」って',
    text_en: '"Tieguanyin tea"',
    type: 'conversational',
    next_script_id: 'turtle_047_02',
  },
  {
    id: 'turtle_047_02',
    expression: 'happy',
    text_jp: 'なんだかすごく強そうな\n名前だと思うカメ',
    text_en: "I think it's a very strong name.",
    type: 'conversational',
  },
  {
    id: 'turtle_048_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '一句できたカメ',
    text_en: "I've got a poem.",
    type: 'conversational',
    next_script_id: 'turtle_048_02',
  },
  {
    id: 'turtle_048_02',
    expression: 'happy',
    text_jp: '「エコだから」\nまとめ買いして\nロスになる',
    text_en: 'Buy in bulk for "eco-friendly" reasons and lose money.',
    type: 'conversational',
  },
  {
    id: 'turtle_049_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '仰向けと\nうつ伏せって',
    text_en: 'On your back\nor\nFace down',
    type: 'conversational',
    next_script_id: 'turtle_049_02',
  },
  {
    id: 'turtle_049_02',
    animation: 'surprised',
    text_jp: '急に言われると\nどっちか迷うカメ',
    text_en: "When people say either of them suddenly, I'll be confuesed.",
    type: 'conversational',
  },
  {
    id: 'turtle_050_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '非常口のサインとかに\n描かれている人の名前は',
    text_en: 'The name of the person depicted on the emergency exit sign is',
    type: 'conversational',
    next_script_id: 'turtle_050_02',
  },
  {
    id: 'turtle_050_02',
    expression: 'normal',
    text_jp: 'ピクトさん、というカメ',
    text_en: 'Mr. Picto.',
    type: 'conversational',
    next_script_id: 'turtle_050_03',
  },
  {
    id: 'turtle_050_03',
    expression: 'happy',
    text_jp: 'いつも危ない目にあっていて\n大変な仕事カメ',
    text_en: "It's a tough job.",
    type: 'conversational',
  },
  {
    id: 'turtle_051_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '伯方の塩の塩は',
    text_en: 'The salt of "Hakata salt" is imported from',
    type: 'conversational',
    next_script_id: 'turtle_051_02',
  },
  {
    id: 'turtle_051_02',
    expression: 'happy',
    text_jp: 'メキシコやオーストラリアから\n輸入されているカメ',
    text_en: 'Mexico and Australia.',
    type: 'conversational',
  },
  {
    id: 'turtle_052_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるカメ？',
    text_en: 'You know what?',
    type: 'conversational',
    next_script_id: 'turtle_052_02',
  },
  {
    id: 'turtle_052_02',
    expression: 'normal',
    text_jp: 'エアコンの室外機を日光に\n当たらないようにすると、',
    text_en: 'Keeping the outdoor unit of your air conditioner out of the sun',
    type: 'conversational',
    next_script_id: 'turtle_052_03',
  },
  {
    id: 'turtle_052_03',
    expression: 'happy',
    text_jp: '電気代を節約できるカメ',
    text_en: 'will save you money on your electric bill!',
    type: 'conversational',
  },
  {
    id: 'turtle_053_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '唯一空を飛べる哺乳類は\nなんだか知ってるカメ？',
    text_en: 'Do you know what is the only mammal that can fly?',
    type: 'conversational',
    next_script_id: 'turtle_053_02',
  },
  {
    id: 'turtle_053_02',
    expression: 'happy',
    text_jp: '答えはコウモリカメ！',
    text_en: 'The answer is bats!',
    type: 'conversational',
  },
  {
    id: 'turtle_054_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「バナナ」という名前の',
    text_en: 'There is a grape named "Banana."',
    type: 'conversational',
    next_script_id: 'turtle_054_02',
  },
  {
    id: 'turtle_054_02',
    expression: 'normal',
    text_jp: 'ぶどうがあるカメ\nぶどうの房に形が似てるらしいカメ',
    text_en: "Because the shape is similar t to grape's bunch.",
    type: 'conversational',
    next_script_id: 'turtle_054_03',
  },
  {
    id: 'turtle_054_03',
    animation: 'surprised',
    text_jp: 'ややこしいカメ！',
    text_en: "It's confusing!",
    type: 'conversational',
  },
  {
    id: 'turtle_055_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'トイレットペーパーは\nシングル派？ダブル派？',
    text_en: 'Do you prefer double or single of toilet papers?',
    type: 'selectional',
    answer_var: 'tp_single_double',
    option_1_jp: 'シングル派',
    option_1_en: 'Single',
    option_2_jp: 'ダブル',
    option_2_en: 'Double',
    case: 'tp_single_double',
    next_script_id_1: 'turtle_055_02',
    next_script_id_2: 'turtle_055_04',
  },
  {
    id: 'turtle_055_02',
    expression: 'happy',
    text_jp: 'そうカメ〜\nシングルのほうが長く使えて\n経済的カメ〜',
    text_en: 'Indeed~. The single is so economical since you can use longer.',
    type: 'conversational',
    next_script_id: 'turtle_055_03',
  },
  {
    id: 'turtle_055_03',
    animation: 'surprised',
    text_jp: 'でも、たまに薄すぎて破れる\nことがあるので要注意カメ...！',
    text_en: 'But be careful! Sometimes it is too thin and tear.',
    type: 'conversational',
  },
  {
    id: 'turtle_055_04',
    expression: 'happy',
    text_jp: 'そうカメ〜\n{player_name}氏は\nふんわり拭き取る派カメね♪',
    text_en: 'Indeed~. You like to wipe out softly.',
    type: 'conversational',
  },
  {
    id: 'turtle_056_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'お好み焼きを切る時は\nピザと同じに切るカメ？\n格子状に切るカメ？',
    text_en:
      'When you cut okonomiyaki, do you cut it like a pizza or in a grid pattern?',
    type: 'selectional',
    answer_var: 'okonomi_cut',
    option_1_jp: 'ピザと同じ',
    option_1_en: 'Like a pizza',
    option_2_jp: '格子状',
    option_2_en: 'Grid pattern',
    case: 'okonomi_cut',
    next_script_id_1: 'turtle_056_02',
    next_script_id_2: 'turtle_056_03',
  },
  {
    id: 'turtle_056_02',
    expression: 'normal',
    text_jp: 'ってことは\n{player_name}氏は\n関西以外の出身カメ？',
    text_en: "That means you're from outside of Kansai, aren't you?",
    type: 'conversational',
  },
  {
    id: 'turtle_056_03',
    expression: 'happy',
    text_jp: 'ってことは\n{player_name}氏は\n関西人カメ？',
    text_en: 'That means are you from Kansai?',
    type: 'conversational',
  },
  {
    id: 'turtle_057_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏は\nカメハメ派？ゴムゴム派？',
    text_en: 'Which do you prefer, Kamehame-ha or Gomu-gomu?',
    type: 'selectional',
    answer_var: 'goku_luffy',
    option_1_jp: 'カメハメ派',
    option_1_en: 'Kamehame-ha',
    option_2_jp: 'ゴムゴム派',
    option_2_en: 'Gomu-gomu',
    case: 'goku_luffy',
    next_script_id_1: 'turtle_057_02',
    next_script_id_2: 'turtle_057_03',
  },
  {
    id: 'turtle_057_02',
    animation: 'joy',
    text_jp: 'わかるカメ\nこの世はでっかい宝島カメ！',
    text_en: 'I agree! This world is a big treasure island!',
    type: 'conversational',
  },
  {
    id: 'turtle_057_03',
    animation: 'play',
    text_jp: '{player_name}氏も\nなんかの王を目指すカメ',
    text_en: 'I wish you will aim for some kind of king.',
    type: 'conversational',
  },
  {
    id: 'turtle_058_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏は\nボケ？ツッコミ？',
    text_en: 'Are you "Boke" or "Tsukkomi?"',
    type: 'selectional',
    answer_var: 'boke_tsukkomi',
    option_1_jp: 'ボケ',
    option_1_en: 'Boke',
    option_2_jp: 'ツッコミ',
    option_2_en: 'Tsukkomi',
    case: 'boke_tsukkomi',
    next_script_id_1: 'turtle_058_02',
    next_script_id_2: 'turtle_058_04',
  },
  {
    id: 'turtle_058_02',
    expression: 'happy',
    text_jp: '{pet_name}も\nボケカメ\n最近もの忘れとかひどいカメ',
    text_en: 'I\'m a "Boke" type too. I\'ve been forgetting things lately.',
    type: 'conversational',
    next_script_id: 'turtle_058_03',
  },
  {
    id: 'turtle_058_03',
    animation: 'surprised',
    text_jp: '...そういうボケではないカメ？',
    text_en: 'You don\'t mean that "Boke?"',
    type: 'conversational',
  },
  {
    id: 'turtle_058_04',
    expression: 'happy',
    text_jp: '{player_name}氏は\nツッコミだったカメ\n今日からコンビ結成カメ！',
    text_en: 'Oh, you\'re "Tsukkomi" type.\nLet\'s form a duo today!',
    type: 'conversational',
  },
  {
    id: 'turtle_059_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏は\n昨日の夜、何食べたカメ？',
    text_en: '{player_name},\nwhat did you eat last night?',
    type: 'descriptive',
    answer_var: 'last_dinner',
    question_jp: '昨日の晩ごはん',
    question_en: "Last night's dinner",
    max_len: 14,
    next_script_id: 'turtle_059_02',
  },
  {
    id: 'turtle_059_02',
    expression: 'happy',
    text_jp: '{last_dinner}？\nそうカメ〜\n{pet_name}は',
    text_en: '{last_dinner}?\nI see~.\nIn my case,',
    type: 'conversational',
    next_script_id: 'turtle_059_03',
  },
  {
    id: 'turtle_059_03',
    expression: 'normal',
    text_jp: '... ... ...\nあれ？思い出せないカメ...',
    text_en: "... ... ...\nI can't remember...",
    type: 'conversational',
  },
  {
    id: 'turtle_060_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏の\n住んでみたいところはどこカメ？',
    text_en: 'Where do you want to live?',
    type: 'descriptive',
    answer_var: 'where_to_live',
    question_jp: 'どこに住みたい？',
    question_en: 'Where to live?',
    max_len: 14,
    next_script_id: 'turtle_060_02',
  },
  {
    id: 'turtle_060_02',
    expression: 'happy',
    text_jp: '{where_to_live}？\nいいと思うカメ',
    text_en: '{where_to_live}?\nThat sounds nice.',
    type: 'conversational',
    next_script_id: 'turtle_060_03',
  },
  {
    id: 'turtle_060_03',
    animation: 'joy',
    text_jp: '{pet_name}は\nいつか竜宮城に住んでみたいカメ',
    text_en: "I'd like to live in the Dragon's Palace someday.",
    type: 'conversational',
  },
  {
    id: 'turtle_061_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '80歳のお祝いは傘寿、\n88歳のお祝いは米寿、\nでは90歳はなんというカメ？',
    text_en:
      'The celebration of age 80 is called "Sanju", 70 is "Beiju". Then, what is the age 90?',
    type: 'selectional',
    answer_var: '90_celemony',
    option_1_jp: '喜寿',
    option_1_en: 'Kiju',
    option_2_jp: '白寿',
    option_2_en: 'Hakuju',
    option_3_jp: '卒寿',
    option_3_en: 'Sotsuju',
    case: '90_celemony',
    next_script_id_1: 'turtle_061_02',
    next_script_id_2: 'turtle_061_02',
    next_script_id_3: 'turtle_061_03',
  },
  {
    id: 'turtle_061_02',
    expression: 'sad',
    text_jp: 'はずれカメ...\n知ってるとお年寄りに\n感心されるカメ',
    text_en:
      'Incorrect...\nIf you know the right answer, elderly people will admire you.',
    type: 'conversational',
  },
  {
    id: 'turtle_061_03',
    expression: 'happy',
    text_jp:
      '正解カメ！\n由来は「卒」の略字の「卆」、\nつまり九十になるからカメ',
    text_en:
      'Correct!!\nThe reason is that the character for "Sotsu" (卆) can be read as 90.',
    type: 'conversational',
  },
  {
    id: 'turtle_062_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「トラウマ」って何語に\n由来するか知ってるカメ？',
    text_en: 'Do you know what language the word "trauma" comes from?',
    type: 'selectional',
    answer_var: 'trauma_origin',
    option_1_jp: '日本語',
    option_1_en: 'Japanese',
    option_2_jp: 'フランス語',
    option_2_en: 'French',
    option_3_jp: 'ギリシャ語',
    option_3_en: 'Greek',
    case: 'trauma_origin',
    next_script_id_1: 'turtle_062_02',
    next_script_id_2: 'turtle_062_02',
    next_script_id_3: 'turtle_062_03',
  },
  {
    id: 'turtle_062_02',
    expression: 'sad',
    text_jp: 'はずれカメ...\nちなみに虎でも馬でもないカメ',
    text_en: "Incorrect...\nIt's nothing to do with a tiger and a horse.",
    type: 'conversational',
  },
  {
    id: 'turtle_062_03',
    expression: 'happy',
    text_jp: '正解カメ！\nギリシャ語で「傷」を\n意味する言葉カメ',
    text_en: 'Correct!\nTrauma is a Greek word meaning "wound."',
    type: 'conversational',
  },
  {
    id: 'turtle_063_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'パフェとサンデーの\n違いは何カメ？',
    text_en: 'What is the difference between Parfait and Sundaes?',
    type: 'selectional',
    answer_var: 'parfait_sundaes',
    option_1_jp: '乗っている具',
    option_1_en: 'Ingredients',
    option_2_jp: '作られた国',
    option_2_en: 'Created country',
    option_3_jp: '容器',
    option_3_en: 'Cups',
    case: 'parfait_sundaes',
    next_script_id_1: 'turtle_063_02',
    next_script_id_2: 'turtle_063_03',
    next_script_id_3: 'turtle_063_02',
  },
  {
    id: 'turtle_063_02',
    expression: 'sad',
    text_jp: 'はずれカメ...\nもう一度考えてみるカメ',
    text_en: 'Incorrect...\nPlease think again.',
    type: 'conversational',
  },
  {
    id: 'turtle_063_03',
    expression: 'happy',
    text_jp: '正解カメ！\nパフェはフランス、\nサンデーはアメリカで生まれたカメ',
    text_en:
      'Correct!\nThe parfait was born in France and the sundae in the U.S.',
    type: 'conversational',
    next_script_id: 'turtle_063_04',
  },
  {
    id: 'turtle_063_04',
    expression: 'normal',
    text_jp: '中身に大きな違いはないカメ',
    text_en: 'No major differences in ingredients.',
    type: 'conversational',
  },
  {
    id: 'turtle_064_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '{player_name}氏\n少々お腹が減ってきたカメ',
    text_en: "{player_name},\nI've got hungry...",
    type: 'conversational',
  },
  {
    id: 'turtle_065_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'いささか小腹が空いたカメ',
    text_en: 'My stomach is about to be empty.',
    type: 'conversational',
    next_script_id: 'turtle_065_02',
  },
  {
    id: 'turtle_065_02',
    expression: 'sad',
    text_jp: '何か食べたい時分カメ',
    text_en: 'I feel up to eat something.',
    type: 'conversational',
  },
  {
    id: 'turtle_066_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '...猛烈にお腹が空いたカメ',
    text_en: "I'm very hungry...",
    type: 'conversational',
    next_script_id: 'turtle_066_02',
  },
  {
    id: 'turtle_066_02',
    animation: 'surprised',
    text_jp: '何か食すものがほしいカメ...！',
    text_en: 'Please please feed me something!',
    type: 'conversational',
  },
  {
    id: 'turtle_067_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '腹が、腹が減ったカメ...',
    text_en: "I'm, I'm starving...",
    type: 'conversational',
    next_script_id: 'turtle_067_02',
  },
  {
    id: 'turtle_067_02',
    animation: 'sleep',
    text_jp: 'もはや立ってられんカメ...',
    text_en: "I can't even stand now...",
    type: 'conversational',
  },
  {
    id: 'turtle_068_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ほんのり漂うこの芳香...',
    text_en: 'I can smell something...',
    type: 'conversational',
    next_script_id: 'turtle_068_02',
  },
  {
    id: 'turtle_068_02',
    expression: 'very_sad',
    move_to: 'br',
    text_jp: '自分の体臭カメ！\nそろそろお風呂に入るカメ',
    text_en: "It's my own odor!!\nTake me to the bath.",
    type: 'conversational',
  },
  {
    id: 'turtle_069_01',
    move_to: 'c',
    animation: 'play',
    text_jp: 'ふぅ...',
    text_en: 'Phew...',
    type: 'conversational',
    next_script_id: 'turtle_069_02',
  },
  {
    id: 'turtle_069_02',
    expression: 'happy',
    move_to: 'c',
    text_jp: '汗をかいたので、\n行水がしたいカメ',
    text_en: 'I sweated. I want to take a bath.',
    type: 'conversational',
  },
  {
    id: 'turtle_070_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '甲羅がかゆいカメ...！',
    text_en: 'My shell is itchy...!',
    type: 'conversational',
    next_script_id: 'turtle_070_02',
  },
  {
    id: 'turtle_070_02',
    animation: 'cry',
    text_jp: 'お風呂で磨いてほしいカメ！',
    text_en: 'Please polish it in the bath.',
    type: 'conversational',
  },
  {
    id: 'turtle_071_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'なんだかカメくさいカメ！',
    text_en: 'It smells like turtle...',
    type: 'conversational',
    next_script_id: 'turtle_071_02',
  },
  {
    id: 'turtle_071_02',
    expression: 'sad',
    text_jp: 'たっぷりのお湯で\n洗い流したいカメ...！',
    text_en: 'I want to flush them with a hot bath...!',
    type: 'conversational',
  },
  {
    id: 'turtle_072_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: '{player_name}氏！',
    text_en: '{player_name}!!',
    type: 'conversational',
    next_script_id: 'turtle_072_02',
  },
  {
    id: 'turtle_072_02',
    animation: 'cry',
    text_jp: '最近放置気味じゃないカメ？',
    text_en: "I think you've left me alone, haven't you?",
    type: 'conversational',
  },
  {
    id: 'turtle_073_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '戯れたいカメ...',
    text_en: 'I want...',
    type: 'conversational',
    next_script_id: 'turtle_073_02',
  },
  {
    id: 'turtle_073_02',
    animation: 'cry',
    text_jp: '{player_name}氏と\n戯れたいカメ...！',
    text_en: 'Play with you,\n{player_name}!',
    type: 'conversational',
  },
  {
    id: 'turtle_074_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'むむむ〜',
    text_en: 'Hmmm,',
    type: 'conversational',
    next_script_id: 'turtle_074_02',
  },
  {
    id: 'turtle_074_02',
    animation: 'cry',
    text_jp: '1人は寂しいカメ...！\nかまってほしいカメ...！',
    text_en: 'I feel lonely... Play with me, please!',
    type: 'conversational',
  },
  {
    id: 'turtle_075_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'さ、さみしくなんかないんだカメ',
    text_en: "I, I don't feel lonely.",
    type: 'conversational',
    next_script_id: 'turtle_075_02',
  },
  {
    id: 'turtle_075_02',
    animation: 'angry',
    text_jp: 'む、むしろほっておいて\nほしいんだカメ...！',
    text_en: 'R, rather, I want you to leave me alone...!',
    type: 'conversational',
  },
  {
    id: 'turtle_076_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '...どうやら少し\n催してきたみたいカメ...',
    text_en: 'Now, time to go to the bathroom.',
    type: 'conversational',
  },
  {
    id: 'turtle_077_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}氏...\n小用にいきたいカメ',
    text_en: "It seems it's a pee time.",
    type: 'conversational',
  },
  {
    id: 'turtle_078_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '...そろそろお手洗いに\n行きたいカメ',
    text_en: 'I have to go to the bathroom.',
    type: 'conversational',
  },
  {
    id: 'turtle_079_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '今一番行きたい場所は...',
    text_en: 'The place I want to go now is...',
    type: 'conversational',
    next_script_id: 'turtle_079_02',
  },
  {
    id: 'turtle_079_02',
    animation: 'angry',
    text_jp: 'お便所カメ...！\nは、はやく...！',
    text_en: 'A bathroom!\nH, hurry...!',
    type: 'conversational',
  },
  {
    id: 'turtle_080_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '...想像力が豊かゆえに',
    text_en: 'I have a very vivid imagination,',
    type: 'conversational',
    next_script_id: 'turtle_080_02',
  },
  {
    id: 'turtle_080_02',
    animation: 'surprised',
    text_jp: 'いろんなことを想像して\n怖くなるカメ...!',
    text_en: 'so I imagine all kinds of things that scare me...!',
    type: 'conversational',
  },
  {
    id: 'turtle_081_01',
    move_to: 'bc',
    animation: 'surprised',
    text_jp: 'あの物音は何カメ？',
    text_en: 'What that sound?',
    type: 'conversational',
    next_script_id: 'turtle_081_02',
  },
  {
    id: 'turtle_081_02',
    animation: 'surprised',
    text_jp: 'う、うしろを振り返るのが\nこわいカメ',
    text_en: 'I, I cant turn around...',
    type: 'conversational',
  },
  {
    id: 'turtle_082_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '気のせいだといいが...',
    text_en: 'It might be just a imagination',
    type: 'conversational',
    next_script_id: 'turtle_082_02',
  },
  {
    id: 'turtle_082_02',
    expression: 'sad',
    text_jp: 'ちょっと熱っぽいカメ...',
    text_en: 'But I may be a little feverish...',
    type: 'conversational',
  },
  {
    id: 'turtle_083_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '病は気からというのは\nまさに今の状態カメ...',
    text_en: 'Sickness and health start with the mind',
    type: 'conversational',
    next_script_id: 'turtle_083_02',
  },
  {
    id: 'turtle_083_02',
    animation: 'anxious',
    text_jp: '薬をもらえぬカメ？',
    text_en: "Don't you have a medicine?",
    type: 'conversational',
  },
  {
    id: 'turtle_084_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '歯が、歯が痛いカメ...',
    text_en: 'I, I have a toothache...',
    type: 'conversational',
    next_script_id: 'turtle_084_02',
  },
  {
    id: 'turtle_084_02',
    expression: 'very_sad',
    text_jp: '痛み止め持ってないカメ？',
    text_en: "Don't you have a pain killer?",
    type: 'conversational',
  },
  {
    id: 'turtle_085_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '歯が痛くて何もカメないカメ...',
    text_en: "I can't bite anything because of my tootheache...",
    type: 'conversational',
    next_script_id: 'turtle_085_02',
  },
  {
    id: 'turtle_085_02',
    animation: 'cry',
    text_jp: '虫歯になったみたいカメ...',
    text_en: 'This should be a tooth decay...',
    type: 'conversational',
  },
  {
    id: 'turtle_086_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '眠くなってきたカメ...',
    text_en: "I'm sleepy...",
    type: 'conversational',
    next_script_id: 'turtle_086_02',
  },
  {
    id: 'turtle_086_02',
    animation: 'waive',
    text_jp: '寝るカメ\n{player_name}氏も\nゆるりと寝るカメ',
    text_en: "I'll go asleep.\nGood night,\n{player_name}",
    type: 'conversational',
  },
  {
    id: 'turtle_087_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ん？どうも体が\nムズムズするカメ…',
    text_en: 'Hmm. My body is mushy.',
    type: 'conversational',
  },
  {
    id: 'turtle_088_01',
    move_to: 'c',
    text_jp: 'ふむ。どうやら\nしんでしまったようカメ',
    text_en: 'Hmm. Looks like I’m dead.',
    type: 'conversational',
    next_script_id: 'turtle_088_02',
  },
  {
    id: 'turtle_088_02',
    text_jp:
      'これまで大変おせわになったカメ\n{player_name}氏と\n過ごした時間、忘れないカメ',
    text_en:
      'Thanks for everything.\nI won’t forget the time I spent with you, {player_name}.',
    type: 'conversational',
    next_script_id: 'turtle_088_03',
  },
  {
    id: 'turtle_088_03',
    text_jp: 'また来世で会えたら\nうれしいカメ\nそれまでしばしのお別れカメ…',
    text_en: 'I hope we see each other in the afterlife.\nUntil then…',
    type: 'conversational',
  },
  {
    id: 'turtle_089_01',
    move_to: 'c',
    text_jp: 'これは…\nちょっと危機的状況カメ\nいつしんでもおかしくないカメ',
    text_en:
      'This… \nis a bit of a dangerous situation.\nI could die at any second.',
    type: 'conversational',
    next_script_id: 'turtle_089_02',
  },
  {
    id: 'turtle_089_02',
    text_jp: '万能コロンを少しばかり\nふりかけてはもらえないカメ？',
    text_en: 'Could you spray just a little Magic Potion on me?',
    type: 'conversational',
  },
  {
    id: 'turtle_090_01',
    move_to: 'c',
    text_jp: 'むー。\nおでかけしたくなってきたカメー',
    text_en: 'Hmm…\nI feel like going outside.',
    type: 'conversational',
    next_script_id: 'turtle_090_02',
  },
  {
    id: 'turtle_090_02',
    expression: 'happy',
    text_jp: '友がらと一緒に\nひなたぼっこしたいカメー',
    text_en: 'I want to sunbathe with my friend.',
    type: 'conversational',
  },
  {
    id: 'turtle_091_01',
    move_to: 'c',
    text_jp: '{friend.player_name}氏が\nさっきまであそびに来てたカメ',
    text_en: '{friend.player_name} was over here until a little while ago.',
    type: 'conversational',
    next_script_id: 'turtle_091_02',
  },
  {
    id: 'turtle_091_02',
    animation: 'joy',
    text_jp:
      'たいしたおかまいもせず\n申し訳なかったカメ\nでも、とっても楽しかったカメ',
    text_en: 'I’m sorry I wasn’t more fun, but I had a good time.',
    type: 'conversational',
  },
  {
    id: 'turtle_092_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\n何ラーメンが食べたい\n気分か聞いてみたら、',
    text_en: 'I asked {friend.player_name} what kind of ramen they like.',
    type: 'conversational',
    next_script_id: 'turtle_092_02',
  },
  {
    id: 'turtle_092_02',
    text_jp: '{friend.preferable_ramen}と\n言っておったカメ！',
    text_en: 'They said they like {friend.preferable_ramen}!',
    type: 'conversational',
    next_script_id: 'turtle_092_03',
  },
  {
    id: 'turtle_092_03',
    animation: 'play',
    text_jp: '今度一緒に食べに行くカメ！',
    text_en: 'You should go eat together sometime!',
    type: 'conversational',
  },
  {
    id: 'turtle_093_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n好きなスポーツを聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite sport is.',
    type: 'conversational',
    next_script_id: 'turtle_093_02',
  },
  {
    id: 'turtle_093_02',
    text_jp: '{friend.favorite_sport}と\n言っておったカメ！',
    text_en: 'They said it’s {friend.favorite_sport}.',
    type: 'conversational',
    next_script_id: 'turtle_093_03',
  },
  {
    id: 'turtle_093_03',
    expression: 'happy',
    text_jp: '今度誘ってみるといいカメ！',
    text_en: 'We should play together sometime.',
    type: 'conversational',
  },
  {
    id: 'turtle_094_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n好きなマンガを聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite manga is.',
    type: 'conversational',
    next_script_id: 'turtle_094_02',
  },
  {
    id: 'turtle_094_02',
    text_jp: '{friend.favorite_manga}と\n言っておったカメ！',
    text_en: 'They said it’s {friend.favorite_manga}.',
    type: 'conversational',
    next_script_id: 'turtle_094_03',
  },
  {
    id: 'turtle_094_03',
    animation: 'joy',
    text_jp: 'なかなかのセンスの持ち主カメ！',
    text_en: 'They’ve got great taste.',
    type: 'conversational',
  },
  {
    id: 'turtle_095_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n休日の過ごし方を聞いたら、',
    text_en: 'I asked {friend.player_name} how they spend their days off.',
    type: 'conversational',
    next_script_id: 'turtle_095_02',
  },
  {
    id: 'turtle_095_02',
    text_jp: '{friend.holiday_life}と\n言っておったカメ！',
    text_en: 'They said {friend.holiday_life}.',
    type: 'conversational',
    next_script_id: 'turtle_095_03',
  },
  {
    id: 'turtle_095_03',
    text_jp: 'みんなにはナイショカメよ？',
    text_en: 'We should probably keep that a secret.',
    type: 'conversational',
  },
  {
    id: 'turtle_096_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n好きな乗り物を聞いたら',
    text_en: 'I asked {friend.player_name} what their favorite vehicle is.',
    type: 'conversational',
    next_script_id: 'turtle_096_02',
  },
  {
    id: 'turtle_096_02',
    text_jp: '{friend.favorite_vehicle}と\n言っておったカメ！',
    text_en: 'They said it’s a {friend.favorite_vehicle}.',
    type: 'conversational',
    next_script_id: 'turtle_096_03',
  },
  {
    id: 'turtle_096_03',
    expression: 'sad',
    text_jp: '{pet_name}は\nあまり速い乗り物は\n苦手カメ〜…',
    text_en: '{pet_name} doesn’t like things that go too fast.',
    type: 'conversational',
  },
  {
    id: 'turtle_097_01',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n好きな昆虫を聞いたら',
    text_en: 'I asked {friend.player_name} what their favorite insect is.',
    type: 'conversational',
    next_script_id: 'turtle_097_02',
  },
  {
    id: 'turtle_097_02',
    text_jp: '{friend.favorite_insect}と\n言っておったカメ',
    text_en: 'They said it’s a {friend.favorite_insect}.',
    type: 'conversational',
    next_script_id: 'turtle_097_03',
  },
  {
    id: 'turtle_097_03',
    expression: 'normal',
    text_jp: '{player_name}氏は\n昆虫は好きカメ？',
    text_en: 'Do you like insects, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'turtle_098_01',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\nお風呂でどこから洗うか\n聞いてみたら',
    text_en: 'I asked {friend.player_name} where they wash first in the bath.',
    type: 'conversational',
    next_script_id: 'turtle_098_02',
  },
  {
    id: 'turtle_098_02',
    text_jp: '{friend.wash_body_part}と\n言っておったカメ',
    text_en: 'They said {friend.wash_body_part}.',
    type: 'conversational',
    next_script_id: 'turtle_098_03',
  },
  {
    id: 'turtle_098_03',
    text_jp: '{pet_name}は、\nお風呂では主に浮かんでるカメ',
    text_en: '{pet_name} usually just floats in the bath.',
    type: 'conversational',
  },
  {
    id: 'turtle_099_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏の\n星座は',
    text_en: '{friend.player_name}’s star sign is…',
    type: 'conversational',
    next_script_id: 'turtle_099_02',
  },
  {
    id: 'turtle_099_02',
    text_jp: '{friend.star_sign}\nらしいカメよ',
    text_en: '{friend.star_sign}.',
    type: 'conversational',
    next_script_id: 'turtle_099_03',
  },
  {
    id: 'turtle_099_03',
    text_jp: '{player_name}氏との\n相性はどうカメね？',
    text_en: 'I wonder how they get along with yours, {fplayer_name}.',
    type: 'conversational',
  },
  {
    id: 'turtle_100_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n昨日の晩ごはんを聞いたら',
    text_en: 'I asked {friend.player_name} what their last meal would be.',
    type: 'conversational',
    next_script_id: 'turtle_100_02',
  },
  {
    id: 'turtle_100_02',
    text_jp: '{friend.last_dinner}って\n言っておったカメ',
    text_en: 'They said they’d have {friend.last_dinner}!',
    type: 'conversational',
    next_script_id: 'turtle_100_03',
  },
  {
    id: 'turtle_100_03',
    expression: 'sad',
    text_jp:
      '昨日の晩ごはんが思い出せなく\nなってきたら、ちょっと\n脳トレを考えた方がいいカメ！',
    text_en:
      'If you can’t remember what you had for dinner last night, it’s time to start doing some mental exercises.',
    type: 'conversational',
  },
  {
    id: 'turtle_101_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\nどこに住んでみたいか聞いたら',
    text_en: 'I asked {friend.player_name} where they’d like to live someday.',
    type: 'conversational',
    next_script_id: 'turtle_101_02',
  },
  {
    id: 'turtle_101_02',
    text_jp: '{friend.where_to_live}と\n言っておったカメ',
    text_en: 'They said {friend.where_to_live}!',
    type: 'conversational',
    next_script_id: 'turtle_101_03',
  },
  {
    id: 'turtle_101_03',
    expression: 'happy',
    text_jp: 'どこでも、住めば都とは\n申しますカメ',
    text_en: 'I think home is wherever you lay your head.',
    type: 'conversational',
  },
  {
    id: 'turtle_102_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\nおにぎりの海苔はパリパリ派か\nしっとり派か聞いたら、',
    text_en:
      'I asked {friend.player_name} if they like the seaweed on their rice ball crisp or soggy.',
    type: 'conversational',
    case: 'friend.riceball_type',
    next_script_id_1: 'turtle_102_02',
    next_script_id_2: 'turtle_102_04',
  },
  {
    id: 'turtle_102_02',
    expression: 'happy',
    text_jp: 'パリパリ派と言っておったカメ！',
    text_en: 'They said they like it crisp!',
    type: 'conversational',
    next_script_id: 'turtle_102_03',
  },
  {
    id: 'turtle_102_03',
    animation: 'joy',
    text_jp:
      'いつもパリッとフレッシュな\n{friend.player_name}氏の\nイメージにぴったりカメ',
    text_en:
      'Makes sense, since {friend.player_name} is always crisp and fresh.',
    type: 'conversational',
  },
  {
    id: 'turtle_102_04',
    expression: 'happy',
    text_jp: 'しっとり派と言っておったカメ！',
    text_en: 'They said they like it soggy!',
    type: 'conversational',
    next_script_id: 'turtle_102_05',
  },
  {
    id: 'turtle_102_05',
    animation: 'joy',
    text_jp:
      'しっとり美人の\n{friend.player_name}氏の\nイメージにぴったりカメ！',
    text_en:
      'Makes sense since {friend.player_name} seems like mushy romantic.',
    type: 'conversational',
  },
  {
    id: 'turtle_103_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\nきのこ派かたけのこ派か\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they like mushrooms or bamboo shoots better.',
    type: 'conversational',
    case: 'friend.mush_bamboo',
    next_script_id_1: 'turtle_103_02',
    next_script_id_2: 'turtle_103_03',
  },
  {
    id: 'turtle_103_02',
    expression: 'happy',
    text_jp: 'きのこ派だって言っておったカメ！\nどっちも美味しいカメ！',
    text_en: 'They said they like mushrooms!\nBoth are delicious!',
    type: 'conversational',
  },
  {
    id: 'turtle_103_03',
    expression: 'happy',
    text_jp: 'たけのこ派だって言っておったカメ！\nどっちも美味しいカメ！',
    text_en: 'They said they like bamboo shoots!\nBoth are delicious!',
    type: 'conversational',
  },
  {
    id: 'turtle_104_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\nそばとうどんどっちが好きか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they like soba or udon better.',
    type: 'conversational',
    case: 'friend.soba_udon',
    next_script_id_1: 'turtle_104_02',
    next_script_id_2: 'turtle_104_03',
  },
  {
    id: 'turtle_104_02',
    expression: 'happy',
    text_jp: 'そばが好きって言っておったカメ！\n江戸っ子カメ！',
    text_en: 'They said they like soba better.\nJust like a classic Tokyoite!',
    type: 'conversational',
  },
  {
    id: 'turtle_104_03',
    expression: 'happy',
    text_jp: 'うどんが好きって\n言っておったカメ！',
    text_en: 'They said they like udon better.',
    type: 'conversational',
    next_script_id: 'turtle_104_04',
  },
  {
    id: 'turtle_104_04',
    animation: 'anxious',
    text_jp: '白シャツにカレーうどんは\n危険すぎるカメ！',
    text_en: 'Eating curry udon with a white T-shirt is dangerous.',
    type: 'conversational',
  },
  {
    id: 'turtle_105_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\n納豆を食べるかどうか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they eat natto.',
    type: 'conversational',
    case: 'friend.like_natto',
    next_script_id_1: 'turtle_105_02',
    next_script_id_2: 'turtle_105_03',
  },
  {
    id: 'turtle_105_02',
    text_jp: '食べると言っておったカメ！\n納豆は美容にも良いカメ！',
    text_en: 'They said they eat natto.\nIt’s good for your complexion.',
    type: 'conversational',
  },
  {
    id: 'turtle_105_03',
    text_jp: '食べないと言っておったカメ！\nまあ、わからんでもないカメ',
    text_en: 'They said they “do-natto.”\nWhat a lame joke.',
    type: 'conversational',
  },
  {
    id: 'turtle_106_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏は、\nああ見えて{pet_name}のこと\nすごくかわいがってくれるカメ',
    text_en:
      '{friend.player_name} looks after {pet_name} better than you might think.',
    type: 'conversational',
    next_script_id: 'turtle_106_02',
  },
  {
    id: 'turtle_106_02',
    animation: 'joy',
    text_jp: 'あんな人にお世話してもらえて\n{pet_name}は果報者カメ',
    text_en:
      '{pet_name} is quite lucky to have someone like them look after me.',
    type: 'conversational',
    next_script_id: 'turtle_106_03',
  },
  {
    id: 'turtle_106_03',
    animation: 'waive',
    text_jp: 'もちろん、\n{player_name}氏の\nことも大好きカメよ？',
    text_en: 'Of course, I like you too, {player_name}.',
    type: 'conversational',
  },
  {
    id: 'turtle_107_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\n映画のエンドロールを\n最後まで観るかどうか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they stay until the end of the credits at a movie.',
    type: 'conversational',
    case: 'friend.end_roll',
    next_script_id_1: 'turtle_107_02',
    next_script_id_2: 'turtle_107_04',
  },
  {
    id: 'turtle_107_02',
    text_jp: '最後まで観るって\n言っておったカメ！',
    text_en: 'They said they stay till the end.',
    type: 'conversational',
    next_script_id: 'turtle_107_03',
  },
  {
    id: 'turtle_107_03',
    text_jp:
      '{friend.player_name}氏と\n映画に行くときは、途中で\n立たないほうが良さそうカメ',
    text_en:
      'Guess you shouldn’t leave before {friend.player_name} when you see a movie together.',
    type: 'conversational',
  },
  {
    id: 'turtle_107_04',
    animation: 'surprised',
    text_jp: '最後まで観ないって\n言っておったカメ！',
    text_en: 'They said they don’t stay till the end.',
    type: 'conversational',
    next_script_id: 'turtle_107_05',
  },
  {
    id: 'turtle_107_05',
    text_jp:
      '{friend.player_name}氏と\n映画に行くときは、あらかじめ\n観たいって言っておくカメ！',
    text_en:
      'Guess you should tell {friend.player_name} that you’d rather stay.',
    type: 'conversational',
  },
  {
    id: 'turtle_108_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\n年上と年下、どっちが\n好きか聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they prefer younger or older people.',
    type: 'conversational',
    case: 'friend.older_younger',
    next_script_id_1: 'turtle_108_02',
    next_script_id_2: 'turtle_108_03',
  },
  {
    id: 'turtle_108_02',
    expression: 'happy',
    text_jp:
      '年上が好きって言っておったカメ！\nまあ、ある程度年を食えば、\n多少の差は関係なくなるカメよ…',
    text_en:
      'They said they like older people.\nOnce you get to a certain age, a few years either way doesn’t matter that much.',
    type: 'conversational',
  },
  {
    id: 'turtle_108_03',
    expression: 'happy',
    text_jp:
      '年下が好きって言っておったカメ！\nまあ、ある程度年を食えば、\n多少の差は関係なくなるカメよ…',
    text_en:
      'They said they like younger people.\nOnce you get to a certain age, a few years either way doesn’t matter that much.',
    type: 'conversational',
  },
  {
    id: 'turtle_109_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\n都会と田舎、どっちに\n住みたいか聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they’d rather live in the city or the countryside.',
    type: 'conversational',
    case: 'friend.city_country',
    next_script_id_1: 'turtle_109_02',
    next_script_id_2: 'turtle_109_03',
  },
  {
    id: 'turtle_109_02',
    text_jp:
      '都会って言っておったカメ！\nたしかに都会は便利カメけど、\n田舎のスローライフも素敵カメ',
    text_en:
      'They said they’d rather live in the city.\nIt might be more convenient, but the slow life in the countryside is great, too.',
    type: 'conversational',
  },
  {
    id: 'turtle_109_03',
    expression: 'happy',
    text_jp:
      '田舎って言っておったカメ！\n{pet_name}も、田舎で\nスローライフを送りたいカメ！',
    text_en:
      'They said they’d rather live in the countryside.\n{pet_name} prefers the slow life, too.',
    type: 'conversational',
  },
  {
    id: 'turtle_110_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\nトイレットペーパーはシングルか\nダブルどっちがいいか聞いたら、',
    text_en:
      'I asked {friend.player_name} whether they prefer single or two-ply toilet paper.',
    type: 'conversational',
    case: 'friend.tp_single_double',
    next_script_id_1: 'turtle_110_02',
    next_script_id_2: 'turtle_110_03',
  },
  {
    id: 'turtle_110_02',
    expression: 'happy',
    text_jp: 'シングルって言っておったカメ！\nエコな気がするカメ！',
    text_en: 'They said single-ply.\nThat’s pretty environmentally-friendly.',
    type: 'conversational',
  },
  {
    id: 'turtle_110_03',
    text_jp: 'ダブルって言っておったカメ！\n使いやすさ重視カメ！',
    text_en: 'They said two-ply.\nDefinitely much easier to use.',
    type: 'conversational',
  },
  {
    id: 'turtle_111_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\nお好み焼きをどう切るか聞いたら、',
    text_en: 'I asked how {friend.player_name} cuts an okonomiyaki.',
    type: 'conversational',
    case: 'friend.okonomi_cut',
    next_script_id_1: 'turtle_111_02',
    next_script_id_2: 'turtle_111_04',
  },
  {
    id: 'turtle_111_02',
    text_jp: 'ピザみたいに扇形に切るって\n言っておったカメ！',
    text_en: 'They said they cut it into slices, like a pizza.',
    type: 'conversational',
    next_script_id: 'turtle_111_03',
  },
  {
    id: 'turtle_111_03',
    expression: 'happy',
    text_jp: '大勢で分けるなら公平感が\nあって良いと思うカメ！',
    text_en: 'That’s probably fair if you’re sharing with other people.',
    type: 'conversational',
  },
  {
    id: 'turtle_111_04',
    text_jp: '格子状に切るって\n言っておったカメ！',
    text_en: 'They said they cut it into squares.',
    type: 'conversational',
    next_script_id: 'turtle_111_05',
  },
  {
    id: 'turtle_111_05',
    expression: 'happy',
    text_jp:
      'こっちの方が食べやすくて\nいいカメよね！関西では\nこちらが主流カメ！',
    text_en:
      'That makes it much easier to eat.\nIt’s the preferred style in southern Japan.',
    type: 'conversational',
  },
  {
    id: 'turtle_112_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}氏に\nカメハメ派かゴムゴム派か\n聞いてみたら、',
    text_en: 'I asked if {friend.player_name} is team Kamehameha or Gomu Gomu.',
    type: 'conversational',
    case: 'friend.goku_luffy',
    next_script_id_1: 'turtle_112_02',
    next_script_id_2: 'turtle_112_03',
  },
  {
    id: 'turtle_112_02',
    expression: 'happy',
    text_jp: 'カメハメ派だって\n言っておったカメ！\n黄金時代カメ！',
    text_en: 'They said Kamehameha.\nWhat a golden age.',
    type: 'conversational',
  },
  {
    id: 'turtle_112_03',
    expression: 'happy',
    text_jp: 'ゴムゴム派だって\n言っておったカメ！',
    text_en: 'They said Gomu Gomu.',
    type: 'conversational',
    next_script_id: 'turtle_112_04',
  },
  {
    id: 'turtle_112_04',
    text_jp: '{player_name}氏は\n何の王様になりたいカメ？',
    text_en: 'What do you want to be the king of, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'turtle_113_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}氏に\nボケかツッコミか\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they’re reactionary or try to get a reaction.',
    type: 'conversational',
    case: 'friend.boke_tsukkomi',
    next_script_id_1: 'turtle_113_02',
    next_script_id_2: 'turtle_113_03',
  },
  {
    id: 'turtle_113_02',
    expression: 'happy',
    text_jp:
      'ボケだって言ってたカメ！\n{player_name}氏が\nツッコめれば完璧カメ！',
    text_en:
      'They said they try to get a reaction.\nGuess you have to be reactionary, {player_name}.',
    type: 'conversational',
  },
  {
    id: 'turtle_113_03',
    expression: 'happy',
    text_jp:
      'ツッコミだって言ってたカメ！\n{player_name}氏、\n今度何かボケてみて欲しいカメ',
    text_en:
      'They said they’re reactionary.\nGuess you have to try to get a reaction, {player_name}.',
    type: 'conversational',
  },
  {
    id: 'turtle_114_01',
    move_to: 'c',
    text_jp: '今後ともよろしくカメ',
    text_en: "Let's do this again.",
    type: 'conversational',
  },
  {
    id: 'turtle_115_01',
    animation: 'waive',
    text_jp: 'あそびに寄らせてもらったカメ〜',
    text_en: 'I’m here to hang out.',
    type: 'conversational',
  },
  {
    id: 'turtle_116_01',
    animation: 'waive',
    text_jp: 'お〜\nよう来たカメ〜',
    text_en: 'Hey!\nWelcome.',
    type: 'conversational',
  },
  {
    id: 'turtle_117_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ほんのつまらないものカメが、\n感謝のしるしカメ',
    text_en: 'It’s not much, but here’s a little something from me.',
    type: 'conversational',
  },
  {
    id: 'turtle_118_01',
    text_jp: 'そろそろおいとまするカメ〜\n楽しかったカメ〜',
    text_en: 'It’s about time for me to go.\nI had fun!',
    type: 'conversational',
  },
  {
    id: 'turtle_119_01',
    text_jp: 'またいつでも来るカメ〜\n気長に待ってるカメ〜',
    text_en: 'Come by again any time.\nI’m pretty patient.',
    type: 'conversational',
  },
  {
    id: 'turtle_120_01',
    text_jp: 'どうやら\n{friend.player_name}氏が\n帰ってきた様子カメ',
    text_en: 'Looks like {friend.player_name} is home.',
    type: 'conversational',
    next_script_id: 'turtle_120_02',
  },
  {
    id: 'turtle_120_02',
    text_jp: 'このへんでおいとまするカメ〜\nどうもありがとうカメ〜',
    text_en: 'I guess I’ll get going.\nThanks for everything.',
    type: 'conversational',
  },
  {
    id: 'turtle_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないカメ',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'turtle_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないカメ',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'turtle_123_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今はそんな余裕無いカメよ〜\n万能コロンをかけて欲しいカメ…',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'turtle_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないカメ〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'turtle_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったカメ！\nどうもありがとうカメ！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'turtle_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったカメ！\nどうもありがとうカメ！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'turtle_127_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      'ふ〜。なんとか助かったカメ！\n{player_name}は\n命の恩人カメ！ありがとカメ！',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'turtle_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったカメ…\nもう1回試してみて欲しいカメ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'turtle_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったカメ…\nもう1回試してみて欲しいカメ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'turtle_130_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったカメ…\nもう1回試してみて欲しいカメ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'seaotter_001_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'ラッコッコ〜♪',
    text_en: 'Rakkoko~~',
    type: 'conversational',
    next_script_id: 'seaotter_001_02',
  },
  {
    id: 'seaotter_001_02',
    expression: 'happy',
    text_jp: '元気にしてるッコ？',
    text_en: 'How are you?',
    type: 'conversational',
  },
  {
    id: 'seaotter_002_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '今ひまッコ？',
    text_en: 'Are you free now?',
    type: 'conversational',
    next_script_id: 'seaotter_002_02',
  },
  {
    id: 'seaotter_002_02',
    expression: 'happy',
    text_jp: 'ちょっと遊んでいくッコ★',
    text_en: 'Please stop by :)',
    type: 'conversational',
  },
  {
    id: 'seaotter_003_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '紙コップに飲み物を入れて',
    text_en: 'If you put a drink in a paper cup and leave it alone,',
    type: 'conversational',
    next_script_id: 'seaotter_003_02',
  },
  {
    id: 'seaotter_003_02',
    expression: 'sad',
    text_jp: '放っておくとコップが\nしなしなになっちゃうッコ...',
    text_en: 'the cup will get soggy.',
    type: 'conversational',
  },
  {
    id: 'seaotter_004_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: '昨日の夜、うつぶせで寝たら',
    text_en: 'I slept on my back last night,',
    type: 'conversational',
    next_script_id: 'seaotter_004_02',
  },
  {
    id: 'seaotter_004_02',
    animation: 'sleep',
    text_jp: '首を寝違えたッコ...',
    text_en: 'and I slept on my neck wrong.',
    type: 'conversational',
  },
  {
    id: 'seaotter_005_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '全米の人たちって',
    text_en: 'People all over the US',
    type: 'conversational',
    next_script_id: 'seaotter_005_02',
  },
  {
    id: 'seaotter_005_02',
    animation: 'surprised',
    text_jp: 'よく泣くッコね〜',
    text_en: 'cry a lot.',
    type: 'conversational',
  },
  {
    id: 'seaotter_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カーリングって\nつい観ちゃうけど',
    text_en: 'I tend to watch curling,',
    type: 'conversational',
    next_script_id: 'seaotter_006_02',
  },
  {
    id: 'seaotter_006_02',
    animation: 'anxious',
    text_jp: '全然ルールはわかってないッコ',
    text_en: "but I don't understand the rules at all.",
    type: 'conversational',
  },
  {
    id: 'seaotter_007_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ヘビメタの人って',
    text_en: 'I think heavy metal people',
    type: 'conversational',
    next_script_id: 'seaotter_007_02',
  },
  {
    id: 'seaotter_007_02',
    animation: 'anxious',
    text_jp: '髪の手入れが大変そう\nだなって思うッコ',
    text_en: 'seem to have a hard time taking care of their hair.',
    type: 'conversational',
  },
  {
    id: 'seaotter_008_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ゾンビの人たちって',
    text_en: 'Why do zombies usually',
    type: 'conversational',
    next_script_id: 'seaotter_008_02',
  },
  {
    id: 'seaotter_008_02',
    animation: 'surprised',
    text_jp: 'なんで大体、両腕をこう\n前に出してるッコ？',
    text_en: 'have their arms out in front of them?',
    type: 'conversational',
  },
  {
    id: 'seaotter_009_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'フンフンフフン...♪',
    text_en: 'Hum-hum-hu-hmm...',
    type: 'conversational',
    next_script_id: 'seaotter_009_02',
  },
  {
    id: 'seaotter_009_02',
    animation: 'anxious',
    text_jp: '...鼻歌を人に聞かれると\nちょっと恥ずかしいッコ...',
    text_en: "... When people hear me humming, it's a little embarrassing.",
    type: 'conversational',
  },
  {
    id: 'seaotter_010_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '時計を見た時に',
    text_en: 'It makes me a little happy',
    type: 'conversational',
    next_script_id: 'seaotter_010_02',
  },
  {
    id: 'seaotter_010_02',
    expression: 'happy',
    text_jp: 'たまたまゾロ目だと\nちょっとうれしいッコ',
    text_en: 'when I look at my watch and the numbers happen to line up.',
    type: 'conversational',
  },
  {
    id: 'seaotter_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるッコ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'seaotter_011_02',
  },
  {
    id: 'seaotter_011_02',
    animation: 'surprised',
    text_jp:
      'ホタテには目が80個もあるッコ\n貝紐の黒い点々は実は目\nなんだッコ...！',
    text_en:
      'Scallops have 80 eyes. The black dots on the shell string are actually eyes...!',
    type: 'conversational',
  },
  {
    id: 'seaotter_012_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるッコ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'seaotter_012_02',
  },
  {
    id: 'seaotter_012_02',
    expression: 'normal',
    text_jp: 'ホタテは貝類で唯一泳げるッコ',
    text_en: 'Scallops are the only shellfish that can swim.',
    type: 'conversational',
    next_script_id: 'seaotter_012_03',
  },
  {
    id: 'seaotter_012_03',
    animation: 'joy',
    text_jp: '普段は閉じている2枚の貝殻を\nパクパクさせて泳ぐッコ',
    text_en:
      'They swim by crunching their two shells, which are normally closed.',
    type: 'conversational',
  },
  {
    id: 'seaotter_013_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるッコ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'seaotter_013_02',
  },
  {
    id: 'seaotter_013_02',
    expression: 'normal',
    text_jp: '世界最高齢とされている生き物、\n実は"貝"ッコ',
    text_en:
      "The world's oldest known living creature, in fact, is a shellfish.",
    type: 'conversational',
    next_script_id: 'seaotter_013_03',
  },
  {
    id: 'seaotter_013_03',
    animation: 'surprised',
    text_jp: 'アイスランドガイのミンは\nなんと507歳まで生きたッコ！',
    text_en: 'Min, an Iceland Shell lived to be 507 years old!!',
    type: 'conversational',
  },
  {
    id: 'seaotter_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'バカ貝ってなんでバカ貝\nっていうか知ってるッコ？',
    text_en: 'Do you know why "Baka-gai" was called stupid shellfish?',
    type: 'conversational',
    next_script_id: 'seaotter_014_02',
  },
  {
    id: 'seaotter_014_02',
    expression: 'happy',
    text_jp:
      '貝が開いている時に出てくる\nオレンジ色の足が、舌を出した\nバカ者の顔に見えるからッコ',
    text_en:
      'Because the orange leg that comes out look like a face with his tongue sticking out.',
    type: 'conversational',
  },
  {
    id: 'seaotter_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるッコ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'seaotter_015_02',
  },
  {
    id: 'seaotter_015_02',
    animation: 'surprised',
    text_jp: 'ハマグリって実は絶滅危惧種に指定されているッコ',
    text_en: 'Clam is actually listed as an endangered species.',
    type: 'conversational',
  },
  {
    id: 'seaotter_016_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カキを食べるとたまに\n当たるのはなぜか知ってるッコ？',
    text_en:
      'Do you know why you sometimes get hit with poison when you eat oysters?',
    type: 'conversational',
    next_script_id: 'seaotter_016_02',
  },
  {
    id: 'seaotter_016_02',
    expression: 'normal',
    text_jp: 'カキは吸い込む力がすごくて\n1日に200Lも海水を吸い込むッコ',
    text_en: 'Oysters inhale 200 liters of seawater per day.',
    type: 'conversational',
    next_script_id: 'seaotter_016_03',
  },
  {
    id: 'seaotter_016_03',
    animation: 'surprised',
    text_jp: 'その時に栄養と一緒に毒も\n吸い込んでしまうからッコ',
    text_en:
      'This is because at that time, they inhale poisons along with nutrients.',
    type: 'conversational',
  },
  {
    id: 'seaotter_017_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるッコ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'seaotter_017_02',
  },
  {
    id: 'seaotter_017_02',
    expression: 'normal',
    text_jp:
      'アサリの汁物を作る時、\n鍋に火を付ける前から\nアサリを入れておくと',
    text_en: 'When making a soup with clams,',
    type: 'conversational',
    next_script_id: 'seaotter_017_03',
  },
  {
    id: 'seaotter_017_03',
    expression: 'happy',
    text_jp: 'いっぱい出汁が出るッコ！',
    text_en:
      'put the clams in before the pot is heated to get a lot of broth out of them.',
    type: 'conversational',
  },
  {
    id: 'seaotter_018_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'サザエにはツノありと\nツノなしがあるッコ',
    text_en: 'There are two types of turban shells: horned and hornless.',
    type: 'conversational',
    next_script_id: 'seaotter_018_02',
  },
  {
    id: 'seaotter_018_02',
    expression: 'happy',
    text_jp: '波の荒い海で育ったサザエには\nツノが生えるらしいッコ',
    text_en: 'It is said that turban shells grown in rough seas grow horns.',
    type: 'conversational',
    next_script_id: 'seaotter_018_03',
  },
  {
    id: 'seaotter_018_03',
    expression: 'normal',
    text_jp: '味は大して変わらないッコ！',
    text_en: 'But the tastes are almost same!',
    type: 'conversational',
  },
  {
    id: 'seaotter_019_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるッコ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'seaotter_019_02',
  },
  {
    id: 'seaotter_019_02',
    animation: 'surprised',
    text_jp:
      'アワビは平べったい形を\nしているけど、ああ見えて\n実は巻き貝の1種ッコ',
    text_en:
      'Abalone is flattened, but it is actually a type of curly shellfish.',
    type: 'conversational',
  },
  {
    id: 'seaotter_020_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「ホラを吹く」ってなんで\nそういうか知ってるッコ？',
    text_en: 'Do you know why a liar is called a "Bullshit blower?"',
    type: 'conversational',
    next_script_id: 'seaotter_020_02',
  },
  {
    id: 'seaotter_020_02',
    animation: 'surprised',
    text_jp:
      'ホラ貝を楽器として吹くと\nそのサイズからは信じられない\nくらい大きな音が出るッコ',
    text_en:
      'When you blow on a whelk as a musical instrument, it produces an incredibly loud sound.',
    type: 'conversational',
    next_script_id: 'seaotter_020_03',
  },
  {
    id: 'seaotter_020_03',
    expression: 'normal',
    text_jp:
      'そこから大げさなウソを\nつく人を「ホラ吹き」と\n呼ぶようになったッコ',
    text_en:
      'So they started calling people who tell exaggerated lies "Bullshit blowers".',
    type: 'conversational',
  },
  {
    id: 'seaotter_021_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '好きなものは先に食べるッコ？\n後に食べるッコ？',
    text_en: 'Do you eat your favorite food first? Eat later?',
    type: 'selectional',
    answer_var: 'eat_first_later',
    option_1_jp: '先に食べる',
    option_1_en: 'Eat first',
    option_2_jp: '後に食べる',
    option_2_en: 'Eat later',
    case: 'eat_first_later',
    next_script_id_1: 'seaotter_021_02',
    next_script_id_2: 'seaotter_021_04',
  },
  {
    id: 'seaotter_021_02',
    expression: 'happy',
    text_jp: '{pet_name}も\n同じッコ！',
    text_en: 'Me too!',
    type: 'conversational',
    next_script_id: 'seaotter_021_03',
  },
  {
    id: 'seaotter_021_03',
    expression: 'happy',
    text_jp: '食べたいものは一番おいしい時に\n食べるに限るッコ',
    text_en: "You have to eat what you want to eat when it's at its best.",
    type: 'conversational',
  },
  {
    id: 'seaotter_021_04',
    animation: 'surprised',
    text_jp: '後に食べる派ッコね〜\n誰かに取られないか心配に\nならないッコ？',
    text_en:
      "Ah-huh, you are an eat-later type. Don't you worry the food will be taken?",
    type: 'conversational',
  },
  {
    id: 'seaotter_022_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '貝は好きッコ？',
    text_en: 'Do you like shellfish?',
    type: 'selectional',
    answer_var: 'cram_like',
    option_1_jp: '好き',
    option_1_en: 'Like',
    option_2_jp: 'そうでもない',
    option_2_en: 'Not really',
    case: 'cram_like',
    next_script_id_1: 'seaotter_022_02',
    next_script_id_2: 'seaotter_022_03',
  },
  {
    id: 'seaotter_022_02',
    expression: 'happy',
    text_jp: '同じッコ！\n一緒にハムハムするッコ',
    text_en: "Here too! Let's taste them together~.",
    type: 'conversational',
  },
  {
    id: 'seaotter_022_03',
    animation: 'surprised',
    text_jp: '貝、きらいッコ？\nじゃあ食べる役はやるので\n貝を開く役を頼むッコ',
    text_en:
      "You don't like them? Ok, I'll be in charge of eating, so please take care of opening the shells.",
    type: 'conversational',
  },
  {
    id: 'seaotter_023_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\nせっかち、のんびり\nどっちッコ？',
    text_en: '{player_name},\nAre you impatient or laid-back?',
    type: 'selectional',
    answer_var: 'hasty_slow',
    option_1_jp: 'せっかち',
    option_1_en: 'Impatient',
    option_2_jp: 'のんびり',
    option_2_en: 'Laid-back',
    case: 'hasty_slow',
    next_script_id_1: 'seaotter_023_02',
    next_script_id_2: 'seaotter_023_03',
  },
  {
    id: 'seaotter_023_02',
    animation: 'surprised',
    text_jp: 'そんなに急いでどこに行くッコ？',
    text_en: 'Where are you going in such a hurry?',
    type: 'conversational',
  },
  {
    id: 'seaotter_023_03',
    expression: 'happy',
    text_jp: '{pet_name}も\n同じッコ〜\n大体いつも横になっていたいッコ',
    text_en: 'Me either! I generally like to lie down all the time.',
    type: 'conversational',
  },
  {
    id: 'seaotter_024_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'コーヒーは好きッコ？',
    text_en: 'Do you like to drink coffee?',
    type: 'selectional',
    answer_var: 'coffee_like',
    option_1_jp: '好き',
    option_1_en: 'Like',
    option_2_jp: 'そうでもない',
    option_2_en: 'Not really',
    case: 'coffee_like',
    next_script_id_1: 'seaotter_024_02',
    next_script_id_2: 'seaotter_024_03',
  },
  {
    id: 'seaotter_024_02',
    animation: 'surprised',
    text_jp: '大人ッコね〜\n{pet_name}は\n苦くて飲めないッコ',
    text_en: "You are matured. I can't drink because it's too bitter.",
    type: 'conversational',
  },
  {
    id: 'seaotter_024_03',
    expression: 'happy',
    text_jp: '同じッコ\n砂糖とミルクを入れても\nまだ苦いッコ...',
    text_en: "Me too. I still think it's bitter even with sugar and milk.",
    type: 'conversational',
  },
  {
    id: 'seaotter_025_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちの気分ッコ？',
    text_en: 'Which way do you feel?',
    type: 'selectional',
    answer_var: 'movie_music',
    option_1_jp: '映画を観る',
    option_1_en: 'Watch a movie',
    option_2_jp: '音楽を聴く',
    option_2_en: 'Listen to music',
    case: 'movie_music',
    next_script_id_1: 'seaotter_025_02',
    next_script_id_2: 'seaotter_025_04',
  },
  {
    id: 'seaotter_025_02',
    expression: 'happy',
    text_jp: '同じッコ\n今見たいのは「ラッコ物語」ッコ',
    text_en: 'I agree. I want to watch "Sea-otter Story" now.',
    type: 'conversational',
    next_script_id: 'seaotter_025_03',
  },
  {
    id: 'seaotter_025_03',
    animation: 'surprised',
    text_jp: 'え？知らないッコ？',
    text_en: "What? You don't know that?",
    type: 'conversational',
  },
  {
    id: 'seaotter_025_04',
    expression: 'happy',
    text_jp: 'へぇ〜\n{pet_name}は\n波の音があればそれでいいッコ',
    text_en: 'Heh. All I need is the sound of the waves~~.',
    type: 'conversational',
  },
  {
    id: 'seaotter_026_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちが好きッコ？',
    text_en: 'Which do you prefer?',
    type: 'selectional',
    answer_var: 'stripe_border',
    option_1_jp: 'ストライプ',
    option_1_en: 'Vertical stripes',
    option_2_jp: 'ボーダー',
    option_2_en: 'Horizontal stripes',
    case: 'stripe_border',
    next_script_id_1: 'seaotter_026_02',
    next_script_id_2: 'seaotter_026_03',
  },
  {
    id: 'seaotter_026_02',
    expression: 'normal',
    text_jp:
      'ストライプって聞くと\nまず"スプライト"が思い浮かんで\nシュワシュワするッコ',
    text_en:
      'When I hear the word "stripes," the first thing that comes to mind is sprites.',
    type: 'conversational',
  },
  {
    id: 'seaotter_026_03',
    expression: 'normal',
    text_jp:
      'フムフム。ところで\nボーダーって海賊の下っ端が\n着ているイメージがあるッコ',
    text_en:
      'I have an image of horizontal stripes being worn by pirate lowlifes.',
    type: 'conversational',
  },
  {
    id: 'seaotter_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'スパゲッティはどっちが好きッコ？',
    text_en: 'Which spaghetti do you prefer?',
    type: 'selectional',
    answer_var: 'tomato_cream',
    option_1_jp: 'クリームソース',
    option_1_en: 'Cream sauce',
    option_2_jp: 'トマトソース',
    option_2_en: 'Tomato sauce',
    case: 'tomato_cream',
    next_script_id_1: 'seaotter_027_02',
    next_script_id_2: 'seaotter_027_03',
  },
  {
    id: 'seaotter_027_02',
    expression: 'happy',
    text_jp: 'クリームが好きッコ？\n{pet_name}も\nホタテが入ったのが好きッコ',
    text_en: 'You like the cream one? I also like the one with scallops!',
    type: 'conversational',
  },
  {
    id: 'seaotter_027_03',
    expression: 'normal',
    text_jp: 'トマトが好きッコ？\n{pet_name}は\nトマトソースのを食べると',
    text_en: 'You like the tomato one?\nWhen I eat that one,',
    type: 'conversational',
    next_script_id: 'seaotter_027_04',
  },
  {
    id: 'seaotter_027_04',
    animation: 'anxious',
    text_jp: '口の周りが血まみれみたいに\nなっちゃうッコ',
    text_en: 'it will become like blood around my mouth.',
    type: 'conversational',
  },
  {
    id: 'seaotter_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\nどっちが好きッコ？',
    text_en: '{player_name},\nWhich do you like better?',
    type: 'selectional',
    answer_var: 'koala_seaotter',
    option_1_jp: 'コアラ',
    option_1_en: 'Koala',
    option_2_jp: 'ラッコ',
    option_2_en: 'Sea otter',
    case: 'koala_seaotter',
    next_script_id_1: 'seaotter_028_02',
    next_script_id_2: 'seaotter_028_03',
  },
  {
    id: 'seaotter_028_02',
    animation: 'cry',
    text_jp:
      'か、悲しいッコ...\nコアラには負けたくなかったッコ...\nな、涙で前が見えないッコ...',
    text_en:
      "I'm so sad. I didn't want to lose to the koala. I can't see anything...",
    type: 'conversational',
  },
  {
    id: 'seaotter_028_03',
    expression: 'happy',
    text_jp: 'うれしいッコ♪\nこれからも仲良くしてほしいッコ',
    text_en: "I'm so happy! I hope we can continue to be friends.",
    type: 'conversational',
  },
  {
    id: 'seaotter_029_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '好きなブランドは何ッコ？',
    text_en: 'What is your favorite brand?',
    type: 'descriptive',
    answer_var: 'favorite_brand',
    question_jp: '好きなブランド',
    question_en: 'Favorite brand',
    max_len: 14,
    next_script_id: 'seaotter_029_02',
  },
  {
    id: 'seaotter_029_02',
    animation: 'surprised',
    text_jp: '{favorite_brand}？\nへぇ〜',
    text_en: '{favorite_brand}?\nIndeed.',
    type: 'conversational',
    next_script_id: 'seaotter_029_03',
  },
  {
    id: 'seaotter_029_03',
    expression: 'happy',
    text_jp: '{pet_name}の\n好きなブランドは\nらこすてッコ',
    text_en: 'By the way, my favorite is LACOSTE.',
    type: 'conversational',
  },
  {
    id: 'seaotter_030_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '好きな色は何ッコ？',
    text_en: 'What color do you like?',
    type: 'descriptive',
    answer_var: 'favorite_color',
    question_jp: '好きな色',
    question_en: 'Favorite color',
    max_len: 14,
    next_script_id: 'seaotter_030_02',
  },
  {
    id: 'seaotter_030_02',
    expression: 'happy',
    text_jp: '{favorite_color}？\nいい趣味ッコね〜\n{pet_name}は',
    text_en: '{favorite_color}?\nThat sounds nice.',
    type: 'conversational',
    next_script_id: 'seaotter_030_03',
  },
  {
    id: 'seaotter_030_03',
    expression: 'normal',
    text_jp: '限りなく透明に近いブルー\nが好きッコ',
    text_en: 'I like the blue as close to transparent as possible.',
    type: 'conversational',
  },
  {
    id: 'seaotter_031_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '好きなおやつは何ッコ？',
    text_en: 'What is your favorite snack?',
    type: 'descriptive',
    answer_var: 'favorite_snack',
    question_jp: '好きなおやつ',
    question_en: 'Favorite snacks',
    max_len: 14,
    case: 'favorite_snack',
    next_script_id_1: 'seaotter_031_02',
    next_script_id_2: 'seaotter_031_03',
  },
  {
    id: 'seaotter_031_02',
    expression: 'normal',
    text_jp: '{favorite_snack}？\nおいしいッコ？',
    text_en: '{favorite_snack}?\nDoes it taste good?',
    type: 'conversational',
  },
  {
    id: 'seaotter_031_03',
    expression: 'happy',
    text_jp: '{pet_name}は\nラッコセイ、じゃなくて\nラッカセイが好きッコ',
    text_en: 'My favorite is peanuts, by the way.',
    type: 'conversational',
  },
  {
    id: 'seaotter_032_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n何の宝石が好きッコ？',
    text_en: 'What kind of gem do you like?',
    type: 'descriptive',
    answer_var: 'favorite_gem',
    question_jp: '好きな宝石',
    question_en: 'Favorite gem',
    max_len: 14,
    next_script_id: 'seaotter_032_02',
  },
  {
    id: 'seaotter_032_02',
    expression: 'happy',
    text_jp: '{favorite_gem}が\n好きッコね〜',
    text_en: 'Huh, you like\n{favorite_gem}?',
    type: 'conversational',
    next_script_id: 'seaotter_032_03',
  },
  {
    id: 'seaotter_032_03',
    animation: 'joy',
    text_jp: '{pet_name}は\n真珠が好きッコ\n貝の中で作られるからッコ',
    text_en: "I like pearls. Because it's made in the shell!",
    type: 'conversational',
  },
  {
    id: 'seaotter_033_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n子供の頃の夢は何だったッコ？',
    text_en: 'What was your childhood dream?',
    type: 'descriptive',
    answer_var: 'childhood_dream',
    question_jp: '子供の頃の夢',
    question_en: 'Childhood dreams',
    max_len: 14,
    next_script_id: 'seaotter_033_02',
  },
  {
    id: 'seaotter_033_02',
    expression: 'happy',
    text_jp: 'そうッコね〜\n夢があるって大事ッコ',
    text_en: "That's important you have a dream~.",
    type: 'conversational',
    next_script_id: 'seaotter_033_03',
  },
  {
    id: 'seaotter_033_03',
    expression: 'normal',
    text_jp: '{pet_name}は\n好きな時に好きな人と\n好きに遊びことが夢ッコ',
    text_en: 'My dream is to play when I want and with whom I want.',
    type: 'conversational',
    next_script_id: 'seaotter_033_04',
  },
  {
    id: 'seaotter_033_04',
    animation: 'surprised',
    text_jp: '！...もう大体かなってるッコ',
    text_en: '!...That dream has almost come true.',
    type: 'conversational',
  },
  {
    id: 'seaotter_034_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\nマイブームって何ッコ？',
    text_en: 'What is your current obsession?',
    type: 'descriptive',
    answer_var: 'my_boom',
    question_jp: 'マイブーム',
    question_en: 'Current obsession',
    max_len: 14,
    next_script_id: 'seaotter_034_02',
  },
  {
    id: 'seaotter_034_02',
    expression: 'happy',
    text_jp: 'ふ〜ん\n{pet_name}は\n貝殻でアクセを作ることッコ',
    text_en:
      'Well, well. My current obsession is to create accessories by shells.',
    type: 'conversational',
    next_script_id: 'seaotter_034_03',
  },
  {
    id: 'seaotter_034_03',
    animation: 'joy',
    text_jp: '今度何かプレゼントするッコ♪',
    text_en: "I'll give you something next time.",
    type: 'conversational',
  },
  {
    id: 'seaotter_035_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n癖って何ッコ？',
    text_en: 'What is your peculiarity?',
    type: 'descriptive',
    answer_var: 'peculiarity',
    question_jp: 'あなたの癖',
    question_en: 'Your peculiarity',
    max_len: 14,
    next_script_id: 'seaotter_035_02',
  },
  {
    id: 'seaotter_035_02',
    expression: 'normal',
    text_jp: '{pet_name}の\n癖は語尾に「ッコ」って\nつけちゃうこと...ッコ',
    text_en: 'My one is put "ko" at the end of words......ko.',
    type: 'conversational',
  },
  {
    id: 'seaotter_036_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n嫌いな食べ物は何ッコ？',
    text_en: 'What food do you dislike?',
    type: 'descriptive',
    answer_var: 'disliked_food',
    question_jp: '嫌いな食べ物',
    question_en: 'What food do you dislike?',
    max_len: 14,
    next_script_id: 'seaotter_036_02',
  },
  {
    id: 'seaotter_036_02',
    expression: 'happy',
    text_jp: 'ふ〜ん\n{pet_name}は\nイカが苦手ッコ',
    text_en: 'I see. In my case, I hate squids.',
    type: 'conversational',
    next_script_id: 'seaotter_036_03',
  },
  {
    id: 'seaotter_036_03',
    animation: 'surprised',
    text_jp: '前は好きだったけど、こないだ\n墨をかけられたからッコ...！',
    text_en:
      'I used to like them but the other day I was showered their inks...!',
    type: 'conversational',
  },
  {
    id: 'seaotter_037_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'スーパーのお肉やお魚の下に\nしいて吸水・抗菌してくれる\n白いシートの名前は何ッコ？',
    text_en:
      'What is the name of the white sheet that is placed under meat and fish to absorb water?',
    type: 'selectional',
    answer_var: 'fresh_sheet',
    option_1_jp: 'フランケンマット',
    option_1_en: 'Franken mat',
    option_2_jp: 'ウェアウルフマット',
    option_2_en: 'Werewolf mat',
    option_3_jp: 'ドラキュラマット',
    option_3_en: 'Dracula mat',
    case: 'fresh_sheet',
    next_script_id_1: 'seaotter_037_02',
    next_script_id_2: 'seaotter_037_02',
    next_script_id_3: 'seaotter_037_03',
  },
  {
    id: 'seaotter_037_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\n難しかったッコ？',
    text_en: 'Incorrect...\nWas that difficult?',
    type: 'conversational',
  },
  {
    id: 'seaotter_037_03',
    expression: 'happy',
    text_jp:
      '正解ッコ！\nお肉やお魚の血を吸い取るから\nそういう名前がついたらしいッコ',
    text_en:
      'Correct!! That was named so because it sucks the blood out of meat and fish.',
    type: 'conversational',
  },
  {
    id: 'seaotter_038_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次のうち1つだけ\n日本語なのはどれッコ？',
    text_en: 'Which of the following is Japanese?',
    type: 'selectional',
    answer_var: 'okra_ikra_sakura',
    option_1_jp: 'オクラ',
    option_1_en: 'Okra',
    option_2_jp: 'イクラ',
    option_2_en: 'Ikra',
    option_3_jp: 'サクラ',
    option_3_en: 'Sakura',
    case: 'okra_ikra_sakura',
    next_script_id_1: 'seaotter_038_02',
    next_script_id_2: 'seaotter_038_02',
    next_script_id_3: 'seaotter_038_03',
  },
  {
    id: 'seaotter_038_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\nどれも日本語っぽいッコ？',
    text_en: 'Incorrect... All of them sound like Japanese.',
    type: 'conversational',
  },
  {
    id: 'seaotter_038_03',
    expression: 'happy',
    text_jp:
      '正解ッコ！\nオクラは英語、イクラはロシア語\nサクラだけが日本語ッコ',
    text_en:
      'Correct!! Okra is English, Ikra is Russian, and only Sakura is originally Japanese.',
    type: 'conversational',
  },
  {
    id: 'seaotter_039_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カキに当たるのは何ウイルス\nが原因かわかるッコ？',
    text_en: 'Do you know what virus the oyster has?',
    type: 'selectional',
    answer_var: 'oyster_virus',
    option_1_jp: 'ノロウイルス',
    option_1_en: 'Norovirus',
    option_2_jp: 'ロタウイルス',
    option_2_en: 'Rotavirus',
    option_3_jp: 'トロウイルス',
    option_3_en: 'Torovirus',
    case: 'oyster_virus',
    next_script_id_1: 'seaotter_039_03',
    next_script_id_2: 'seaotter_039_02',
    next_script_id_3: 'seaotter_039_02',
  },
  {
    id: 'seaotter_039_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\n次はきっと正解するッコ',
    text_en: "Incorrect... You'll get a right one next time.",
    type: 'conversational',
  },
  {
    id: 'seaotter_039_03',
    expression: 'happy',
    text_jp:
      '正解ッコ！\nノロはちゃんと加熱すると死滅\nするので火を通せばいいッコ',
    text_en:
      'Correct!! Noro is killed when properly heated, so just avoid raw.',
    type: 'conversational',
  },
  {
    id: 'seaotter_040_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ハイブリッドの語源になった\n動物はどれか知ってるッコ？',
    text_en: 'Do you know which animal is the origin of the word "hybrid?"',
    type: 'selectional',
    answer_var: 'hybrid_animal',
    option_1_jp: 'ラバ',
    option_1_en: 'Mule',
    option_2_jp: 'イノブタ',
    option_2_en: 'Wild boar piglet',
    option_3_jp: 'シマウマ',
    option_3_en: 'Zebra',
    case: 'hybrid_animal',
    next_script_id_1: 'seaotter_040_02',
    next_script_id_2: 'seaotter_040_03',
    next_script_id_3: 'seaotter_040_02',
  },
  {
    id: 'seaotter_040_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\n残念だったッコ',
    text_en: 'Incorrect...',
    type: 'conversational',
  },
  {
    id: 'seaotter_040_03',
    expression: 'happy',
    text_jp: '正解ッコ！',
    text_en: 'Correct!!',
    type: 'conversational',
    next_script_id: 'seaotter_040_04',
  },
  {
    id: 'seaotter_040_04',
    expression: 'happy',
    text_jp:
      'ハイブリッドの語源はラテン語で\nイノブタを表す「ヒュブリダ」\nからきてるッコ',
    text_en:
      'The word hybrid comes from the Latin "Hybrida", which means "boar."',
    type: 'conversational',
  },
  {
    id: 'seaotter_041_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '巻貝の一種、シッタカの特技は\n次のうちどれッコ？',
    text_en:
      'Which of the following is a special skill of the "Shittaka", a type of mollusk?',
    type: 'selectional',
    answer_var: 'shittaka_skill',
    option_1_jp: '掃除',
    option_1_en: 'Cleaning',
    option_2_jp: '料理',
    option_2_en: 'Cooking',
    option_3_jp: '洗濯',
    option_3_en: 'Laundry',
    case: 'shittaka_skill',
    next_script_id_1: 'seaotter_041_03',
    next_script_id_2: 'seaotter_041_02',
    next_script_id_3: 'seaotter_041_02',
  },
  {
    id: 'seaotter_041_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\nそんなわけないッコ',
    text_en: "Incorrect... It can't be the one.",
    type: 'conversational',
  },
  {
    id: 'seaotter_041_03',
    expression: 'happy',
    text_jp: '正解ッコ！',
    text_en: 'Correct!!',
    type: 'conversational',
    next_script_id: 'seaotter_041_04',
  },
  {
    id: 'seaotter_041_04',
    expression: 'happy',
    text_jp:
      'シッタカは水槽に入れておくと\nガラスについたコケを\nきれいに食べてくれるッコ',
    text_en:
      '”Sittaka" will eat the moss off the glass nicely if you keep it in the aquarium!',
    type: 'conversational',
  },
  {
    id: 'seaotter_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'かき氷で頭がキンキンしたら\nどうするのがいいと思うッコ？',
    text_en:
      'What do you think you should do if you get a kink in your head from shaved ice?',
    type: 'selectional',
    answer_var: 'ice_headache',
    option_1_jp: '上を向く',
    option_1_en: 'Look upward',
    option_2_jp: '冷やす',
    option_2_en: 'Chill',
    option_3_jp: '温める',
    option_3_en: 'Warm',
    case: 'ice_headache',
    next_script_id_1: 'seaotter_042_02',
    next_script_id_2: 'seaotter_042_03',
    next_script_id_3: 'seaotter_042_02',
  },
  {
    id: 'seaotter_042_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\nまた挑戦するッコ',
    text_en: 'Incorrect... Please try again someday.',
    type: 'conversational',
  },
  {
    id: 'seaotter_042_03',
    expression: 'happy',
    text_jp: '正解ッコ！',
    text_en: 'Correct!!',
    type: 'conversational',
    next_script_id: 'seaotter_042_04',
  },
  {
    id: 'seaotter_042_04',
    expression: 'happy',
    text_jp: '痛くなったところにかき氷の容器を\n当てると手っ取り早いッコ',
    text_en:
      'It is quicker to apply a container of shaved ice to the sore spot.',
    type: 'conversational',
  },
  {
    id: 'seaotter_043_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'はろはろッコ〜♪',
    text_en: 'Hello, hello,\n{player_name}~.',
    type: 'conversational',
    next_script_id: 'seaotter_043_02',
  },
  {
    id: 'seaotter_043_02',
    animation: 'play',
    text_jp: '今日の気分はアゲアゲッコ〜',
    text_en: 'I feel sooo good today!',
    type: 'conversational',
  },
  {
    id: 'seaotter_044_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '気づいたッコ',
    text_en: 'I found it.',
    type: 'conversational',
    next_script_id: 'seaotter_044_02',
  },
  {
    id: 'seaotter_044_02',
    expression: 'normal',
    text_jp: 'たまごボーロとマルコ・ポーロ\nってちょっと似ているッコ',
    text_en: 'Tamago-boro and Marco Polo sounds a bit similar.',
    type: 'conversational',
  },
  {
    id: 'seaotter_045_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'アサリの身が小さかったら\n大きいシジミだと思えばいいッコ',
    text_en: 'If an asari clam has a small body, think of it as a big shijimi.',
    type: 'conversational',
    next_script_id: 'seaotter_045_02',
  },
  {
    id: 'seaotter_045_02',
    expression: 'happy',
    text_jp: 'ハマグリの身が小さかったら\n大きいアサリだと思えばいいッコ',
    text_en: 'If a hamaguri has a small body, think of it as a big asari.',
    type: 'conversational',
  },
  {
    id: 'seaotter_046_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '今日のラッキーアイテムが\n「金のお玉」だったッコ',
    text_en: 'My today\'s lucky item was "Golden ladles."',
    type: 'conversational',
    next_script_id: 'seaotter_046_02',
  },
  {
    id: 'seaotter_046_02',
    animation: 'surprised',
    text_jp: '一体どこで手に入るッコ...',
    text_en: 'Where can I get it...?',
    type: 'conversational',
  },
  {
    id: 'seaotter_047_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'たまに',
    text_en: 'Sometimes,',
    type: 'conversational',
    next_script_id: 'seaotter_047_02',
  },
  {
    id: 'seaotter_047_02',
    expression: 'very_sad',
    text_jp: 'ビーバーと間違われるッコ...\n全然似てないッコ...！',
    text_en:
      "People misunderstand I'm a beaver. It doesn't look like me at all!",
    type: 'conversational',
  },
  {
    id: 'seaotter_048_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '金縛り！...と思ったら',
    text_en: 'I thought I had an old hag syndrome...!',
    type: 'conversational',
    next_script_id: 'seaotter_048_02',
  },
  {
    id: 'seaotter_048_02',
    expression: 'happy',
    text_jp: '昆布が体に巻き付いていたッコ',
    text_en: 'but it was just kelp wrapped around my body.',
    type: 'conversational',
  },
  {
    id: 'seaotter_049_01',
    expression: 'normal',
    move_to: 'br',
    text_jp: 'ッコッコッコ',
    text_en: 'Ko-ko-ko',
    type: 'conversational',
    next_script_id: 'seaotter_049_02',
  },
  {
    id: 'seaotter_049_02',
    expression: 'normal',
    move_to: 'bl',
    text_jp: 'ッコッコッコッコ',
    text_en: 'Ko-ko-ko-ko',
    type: 'conversational',
    next_script_id: 'seaotter_049_03',
  },
  {
    id: 'seaotter_049_03',
    expression: 'normal',
    move_to: 'br',
    text_jp: 'ッコッコッコッコッコ',
    text_en: 'Ko-ko-ko-ko-ko',
    type: 'conversational',
    next_script_id: 'seaotter_049_04',
  },
  {
    id: 'seaotter_049_04',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'ハァハァハァ...\nちょっとエクササイズッコ',
    text_en: 'Ha-ha-ha.\nI just had an exercise.',
    type: 'conversational',
  },
  {
    id: 'seaotter_050_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'クラムチャウダーに使われる\nホンビノス貝',
    text_en: 'Used in Clam Chowder\nHombinos clams',
    type: 'conversational',
    next_script_id: 'seaotter_050_02',
  },
  {
    id: 'seaotter_050_02',
    expression: 'normal',
    text_jp: '日本で発見されたのは\nたった20年位前ッコ',
    text_en: 'were discovered in Japan only about 20 years ago.',
    type: 'conversational',
    next_script_id: 'seaotter_050_03',
  },
  {
    id: 'seaotter_050_03',
    expression: 'happy',
    text_jp: 'アメリカからの貨物船の\nバラスト水にまぎれて\nやってきたッコ',
    text_en:
      'They arrived in the ballast water of cargo ships from the United States.',
    type: 'conversational',
  },
  {
    id: 'seaotter_051_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '世界最大の貝は\nオオシャコガイ\nっていうッコ',
    text_en: "The world's largest mussel is called the giant clam.",
    type: 'conversational',
    next_script_id: 'seaotter_051_02',
  },
  {
    id: 'seaotter_051_02',
    animation: 'surprised',
    text_jp:
      '体長2m、体重300kg、\n寿命100年以上、と何かにつけて\nスケールがでかいやつッコ',
    text_en:
      'With 2m body length, 300kg weight, and more than 100 years lifespan, it is something on a grand scale.',
    type: 'conversational',
  },
  {
    id: 'seaotter_052_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '二枚貝は、対になる貝殻としか\n絶対に組み合わせる\nことができないッコ',
    text_en: 'Bivalves can only ever be combined with paired shells.',
    type: 'conversational',
    next_script_id: 'seaotter_052_02',
  },
  {
    id: 'seaotter_052_02',
    expression: 'happy',
    text_jp: 'その特徴を生かして生まれたのが\n"貝合わせ"という遊びッコ',
    text_en: 'The game "Shell Matching" was born out of this characteristic.',
    type: 'conversational',
  },
  {
    id: 'seaotter_053_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '貝殻を耳に当てると、波の音が\n聞こえるって言うけど',
    text_en:
      'If you hold a shell to your ear, you can hear the sound of waves.',
    type: 'conversational',
    next_script_id: 'seaotter_053_02',
  },
  {
    id: 'seaotter_053_02',
    animation: 'surprised',
    text_jp: 'その正体は、耳の中の音が\n貝の中で反響した音、ッコ',
    text_en:
      'But what it really is is the sound in your ear reverberating in the shell.',
    type: 'conversational',
  },
  {
    id: 'seaotter_054_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '日本古来の白絵の具、胡粉は',
    text_en: 'Go-fun, an ancient Japanese white paint,',
    type: 'conversational',
    next_script_id: 'seaotter_054_02',
  },
  {
    id: 'seaotter_054_02',
    expression: 'happy',
    text_jp: 'ハマグリ、カキ、ホタテ\nなんかの貝殻で作られているッコ',
    text_en: 'is made from the shells of clams, oysters, scallops',
    type: 'conversational',
  },
  {
    id: 'seaotter_055_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '紅茶には何を入れるッコ？',
    text_en: 'What do you put in a cup of tea?',
    type: 'selectional',
    answer_var: 'tea_type',
    option_1_jp: 'レモン',
    option_1_en: 'Lemon',
    option_2_jp: 'ミルク',
    option_2_en: 'Milk',
    option_3_jp: '何も入れない',
    option_3_en: 'Straight',
    case: 'tea_type',
    next_script_id_1: 'seaotter_055_02',
    next_script_id_2: 'seaotter_055_03',
    next_script_id_3: 'seaotter_055_04',
  },
  {
    id: 'seaotter_055_02',
    expression: 'normal',
    text_jp: '{player_name}は\nレモン派ッコね〜\nすっぱいもの好きッコ？',
    text_en: 'You are a lemon-tea type. Do you like sour taste?',
    type: 'conversational',
  },
  {
    id: 'seaotter_055_03',
    expression: 'normal',
    text_jp:
      '{player_name}は\nミルクティーが好きッコね\nロイヤルなやつがいいッコ？',
    text_en: 'You like milk tea. How about a royal one?',
    type: 'conversational',
  },
  {
    id: 'seaotter_055_04',
    expression: 'happy',
    text_jp: '{player_name}は\nストレート派ッコね〜\nシンプルイズベスト、ッコ★',
    text_en: 'You are a straight type. Yup, simple is the best.',
    type: 'conversational',
  },
  {
    id: 'seaotter_056_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちが食べたいッコ？',
    text_en: 'Which do you want to eat?',
    type: 'selectional',
    answer_var: 'fried_shrimp',
    option_1_jp: 'エビ天',
    option_1_en: 'Shrimp tempura',
    option_2_jp: 'エビフライ',
    option_2_en: 'Fried shrimp',
    case: 'fried_shrimp',
    next_script_id_1: 'seaotter_056_02',
    next_script_id_2: 'seaotter_056_03',
  },
  {
    id: 'seaotter_056_02',
    expression: 'happy',
    text_jp: '天ぷらッコ〜\nサクサクしてておいしいッコね',
    text_en: "You like tempra!\nIt's so crispy and tasty~.",
    type: 'conversational',
  },
  {
    id: 'seaotter_056_03',
    expression: 'happy',
    text_jp: 'エビフライッコ〜\nカリカリしてておいしいッコね',
    text_en: "You like tempra!\nIt's so crunchy and tasty~.",
    type: 'conversational',
  },
  {
    id: 'seaotter_057_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちが食べたいッコ？',
    text_en: 'Which do you want to eat?',
    type: 'selectional',
    answer_var: 'cold_noodles',
    option_1_jp: '冷麺',
    option_1_en: 'Naengmyeon',
    option_2_jp: '冷やし中華',
    option_2_en: 'Hiyashi chuka',
    case: 'cold_noodles',
    next_script_id_1: 'seaotter_057_02',
    next_script_id_2: 'seaotter_057_03',
  },
  {
    id: 'seaotter_057_02',
    expression: 'happy',
    text_jp: 'いいッコね〜\nスイカは絶対にのせてほしいッコ！',
    text_en: 'Sounds good. I definitely want to add a watermelon on top of it!',
    type: 'conversational',
  },
  {
    id: 'seaotter_057_03',
    expression: 'happy',
    text_jp: '{pet_name}も\n冷やし中華が好きッコ',
    text_en: 'I like Hiyashi-chuka too~.',
    type: 'conversational',
    next_script_id: 'seaotter_057_04',
  },
  {
    id: 'seaotter_057_04',
    expression: 'normal',
    text_jp: '具だくさんがいいけど\nカニカマは別に\nあってもなくてもいいッコ',
    text_en: "I prefer a lot of ingredients, but I don't care the crab cakes.",
    type: 'conversational',
  },
  {
    id: 'seaotter_058_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちに行きたいッコ？',
    text_en: 'Which do you want to go?',
    type: 'selectional',
    answer_var: 'hokkaido_okinawa',
    option_1_jp: '北海道',
    option_1_en: 'Hokkaido',
    option_2_jp: '沖縄',
    option_2_en: 'Okinawa',
    case: 'hokkaido_okinawa',
    next_script_id_1: 'seaotter_058_02',
    next_script_id_2: 'seaotter_058_04',
  },
  {
    id: 'seaotter_058_02',
    expression: 'happy',
    text_jp: '{pet_name}も\n断然北海道ッコ！',
    text_en: 'I totally agree!',
    type: 'conversational',
    next_script_id: 'seaotter_058_03',
  },
  {
    id: 'seaotter_058_03',
    animation: 'eat',
    text_jp: '大粒のホタテやホッキ貝を\n食べ尽くしたいッコ！',
    text_en: 'I want to eat up large scallops in Hokkaido.',
    type: 'conversational',
  },
  {
    id: 'seaotter_058_04',
    expression: 'happy',
    text_jp: '沖縄もいいッコね〜\n青い海でプカプカしたいッコ〜',
    text_en:
      "Okinawa sounds nice too~.\nI'd like to float on the surface of ocean.",
    type: 'conversational',
  },
  {
    id: 'seaotter_059_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n得意な泳ぎ方は何ッコ？',
    text_en: 'What is your favorite way to swim?',
    type: 'descriptive',
    answer_var: 'favorite_swim',
    question_jp: '得意な泳ぎ方',
    question_en: 'Favorite way to swim',
    max_len: 14,
    next_script_id: 'seaotter_059_02',
  },
  {
    id: 'seaotter_059_02',
    expression: 'normal',
    text_jp: 'ふむふむッコ〜',
    text_en: 'Hmmm.',
    type: 'conversational',
    next_script_id: 'seaotter_059_03',
  },
  {
    id: 'seaotter_059_03',
    expression: 'happy',
    move_to: 'tl',
    text_jp: '{pet_name}は\nもちろん背泳ぎッコ',
    text_en: 'I, of course, choose backstroke.',
    type: 'conversational',
  },
  {
    id: 'seaotter_060_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きな貝は何ッコ？',
    text_en: 'What is your favorite seashell?',
    type: 'descriptive',
    answer_var: 'favorite_shell',
    question_jp: '好きな貝',
    question_en: 'Favorite shell',
    max_len: 14,
    next_script_id: 'seaotter_060_02',
  },
  {
    id: 'seaotter_060_02',
    expression: 'normal',
    text_jp: '{favorite_shell}？\nなるほどッコ〜',
    text_en: '{favorite_shell}?\nOk, ok.',
    type: 'conversational',
    next_script_id: 'seaotter_060_03',
  },
  {
    id: 'seaotter_060_03',
    animation: 'anxious',
    text_jp: '...{pet_name}は\nホタテ、カキ、アワビ...',
    text_en: 'My one?\nScallops, oysters, abalones...',
    type: 'conversational',
    next_script_id: 'seaotter_060_04',
  },
  {
    id: 'seaotter_060_04',
    animation: 'surprised',
    text_jp: '選べないッコ...！',
    text_en: "I can't choose one!",
    type: 'conversational',
  },
  {
    id: 'seaotter_061_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「別腹」って本当にあるッコ？',
    text_en: 'Is there really such a thing as a "dessert stomach?"',
    type: 'selectional',
    answer_var: 'dessert_stomach',
    question_jp: '別腹ってある？',
    question_en: 'Is there a dessert stomach?',
    option_1_jp: 'ある',
    option_1_en: 'Yes',
    option_2_jp: 'ない',
    option_2_en: 'No',
    case: 'dessert_stomach',
    next_script_id_1: 'seaotter_061_03',
    next_script_id_2: 'seaotter_061_02',
  },
  {
    id: 'seaotter_061_02',
    expression: 'sad',
    text_jp: '残念、はずれッコ…',
    text_en: 'Incorrect... It really exists.',
    type: 'conversational',
  },
  {
    id: 'seaotter_061_03',
    expression: 'happy',
    text_jp: '正解ッコ！',
    text_en: 'Correct!! Even if you are full, when you see something you like,',
    type: 'conversational',
    next_script_id: 'seaotter_061_04',
  },
  {
    id: 'seaotter_061_04',
    expression: 'normal',
    text_jp:
      '満腹でも好きな物を見ると脳から\n指令がでて小腸に空きができるッコ\nこれが別腹の正体ッコ...！',
    text_en:
      'your brain gives you a command to make room in your small intestine.',
    type: 'conversational',
  },
  {
    id: 'seaotter_062_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '七福神の中で唯一日本の神様\nなのは誰か知ってるッコ？',
    text_en:
      'Do you know who is the only Japanese god among the seven gods of good fortune?',
    type: 'selectional',
    answer_var: 'seven_gods',
    option_1_jp: '恵比寿',
    option_1_en: 'Ebisu',
    option_2_jp: '毘沙門天',
    option_2_en: 'Bishamonten',
    option_3_jp: '弁財天',
    option_3_en: 'Benzaiten',
    case: 'seven_gods',
    next_script_id_1: 'seaotter_062_03',
    next_script_id_2: 'seaotter_062_02',
    next_script_id_3: 'seaotter_062_02',
  },
  {
    id: 'seaotter_062_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\nまた挑戦してほしいッコ',
    text_en: "Sorry, it's Incorrect...",
    type: 'conversational',
  },
  {
    id: 'seaotter_062_03',
    expression: 'happy',
    text_jp: '正解ッコ！',
    text_en:
      'Correct!!\nDaikokuten, Benzaiten, and Bishamonten are Indian deities, ',
    type: 'conversational',
    next_script_id: 'seaotter_062_04',
  },
  {
    id: 'seaotter_062_04',
    expression: 'happy',
    text_jp:
      '大黒天、弁財天、毘沙門天はインド\n福禄寿、布袋、寿老人は中国の神様\nッコ★',
    text_en: 'while Fukurokuju, Hotei, and Jurojin are Chinese.',
    type: 'conversational',
  },
  {
    id: 'seaotter_063_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ハリセンボンの針の数は\n実際には何本くらいッコ？',
    text_en: 'How many needles does porcupine fish have? ',
    type: 'selectional',
    answer_var: 'porcupine_fish',
    option_1_jp: '200本',
    option_1_en: '200 needles',
    option_2_jp: '400本',
    option_2_en: '400 needles',
    option_3_jp: '1,000本',
    option_3_en: '1,000 needles',
    case: 'porcupine_fish',
    next_script_id_1: 'seaotter_063_02',
    next_script_id_2: 'seaotter_063_03',
    next_script_id_3: 'seaotter_063_02',
  },
  {
    id: 'seaotter_063_02',
    expression: 'sad',
    text_jp: 'はずれッコ…\n残念だったッコ...',
    text_en: "Sorry, it's Incorrect...",
    type: 'conversational',
  },
  {
    id: 'seaotter_063_03',
    expression: 'happy',
    text_jp: '正解ッコ！\n実際数えたら1,000本も\nないらしいッコ',
    text_en: "Correct!!\nActually, it's way less than 1,000.",
    type: 'conversational',
  },
  {
    id: 'seaotter_064_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '{player_name}...\nちょびっとお腹すいたッコ',
    text_en: '{player_name},\nI feel hunger...',
    type: 'conversational',
  },
  {
    id: 'seaotter_065_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'グゥ......',
    text_en: 'Gwww......',
    type: 'conversational',
    next_script_id: 'seaotter_065_02',
  },
  {
    id: 'seaotter_065_02',
    animation: 'anxious',
    text_jp: 'お腹が鳴ってるッコ\n何か食べ物ないッコ？',
    text_en: 'My stomach is growling.\nDo you have any food?"',
    type: 'conversational',
  },
  {
    id: 'seaotter_066_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: '...とてもお腹がすいたッコ',
    text_en: "I'm very hungry...",
    type: 'conversational',
    next_script_id: 'seaotter_066_02',
  },
  {
    id: 'seaotter_066_02',
    animation: 'cry',
    text_jp: '食べるものほしいッコ...！',
    text_en: 'Please give me a food!',
    type: 'conversational',
  },
  {
    id: 'seaotter_067_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'お腹ペッコペコッコ...',
    text_en: "I'm so starving...",
    type: 'conversational',
    next_script_id: 'seaotter_067_02',
  },
  {
    id: 'seaotter_067_02',
    animation: 'anxious',
    text_jp: '何か食べなきゃ倒れるッコ...',
    text_en: "I can't stand unless I eat something...",
    type: 'conversational',
  },
  {
    id: 'seaotter_068_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '毛皮がベタベタしてきたッコ...',
    text_en: 'My fur is getting sticky.',
    type: 'conversational',
    next_script_id: 'seaotter_068_02',
  },
  {
    id: 'seaotter_068_02',
    expression: 'normal',
    text_jp: 'お風呂でさっぱり洗い流したいッコ',
    text_en: 'I want to wash it off in the bath.',
    type: 'conversational',
  },
  {
    id: 'seaotter_069_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'いつも水には浸かってるけど...',
    text_en: "I'm always in the water but...",
    type: 'conversational',
    next_script_id: 'seaotter_069_02',
  },
  {
    id: 'seaotter_069_02',
    expression: 'normal',
    text_jp: 'たまにボディソープで\nゴシゴシしたくなるッコ！',
    text_en: 'Sometimes I feel like scrubbing with body soap.',
    type: 'conversational',
  },
  {
    id: 'seaotter_070_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'クンクン...',
    text_en: 'Sniff, sniff...',
    type: 'conversational',
    next_script_id: 'seaotter_070_02',
  },
  {
    id: 'seaotter_070_02',
    animation: 'surprised',
    text_jp: 'コッ、これはっ...！\n臭いがだいぶきついッコ！',
    text_en: 'Gosh...!\nThe smell is getting beyond out of whack.',
    type: 'conversational',
  },
  {
    id: 'seaotter_071_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'そういえば最近お風呂に\n入ってないッコ...！',
    text_en: "It's no wonder because I haven't taken a bath lately.",
    type: 'conversational',
    next_script_id: 'seaotter_071_02',
  },
  {
    id: 'seaotter_071_02',
    animation: 'cry',
    text_jp: '清潔にしないとみんなに\n嫌われてしまうッコ...！',
    text_en: "If I don't keep myself clean, everyone will hate me...",
    type: 'conversational',
  },
  {
    id: 'seaotter_072_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}...',
    text_en: '{player_name}!!',
    type: 'conversational',
    next_script_id: 'seaotter_072_02',
  },
  {
    id: 'seaotter_072_02',
    animation: 'anxious',
    text_jp: '今日は遊んでくれるッコ？\n',
    text_en: 'Will you play with me today?',
    type: 'conversational',
  },
  {
    id: 'seaotter_073_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'もっといっぱい',
    text_en: '{player_name}!\nI want to...',
    type: 'conversational',
    next_script_id: 'seaotter_073_02',
  },
  {
    id: 'seaotter_073_02',
    expression: 'happy',
    text_jp: '{player_name}と\n遊びたいッコ！',
    text_en: 'Play with you more often!',
    type: 'conversational',
  },
  {
    id: 'seaotter_074_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'シクシク...\nシクシク...',
    text_en: 'Ssshhhh...\nSsshhhh...',
    type: 'conversational',
    next_script_id: 'seaotter_074_02',
  },
  {
    id: 'seaotter_074_02',
    animation: 'cry',
    text_jp: '人恋しくて泣けてくるッコ...！',
    text_en: 'I miss people so much it makes me cry.',
    type: 'conversational',
  },
  {
    id: 'seaotter_075_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '...聞いてくれるッコ',
    text_en: '...Listen to me.',
    type: 'conversational',
    next_script_id: 'seaotter_075_02',
  },
  {
    id: 'seaotter_075_02',
    animation: 'anxious',
    text_jp: 'なんか寂しいので\nギュッとしてほしいッコ...！',
    text_en: 'I feel lonely so please hold me tight...!',
    type: 'conversational',
  },
  {
    id: 'seaotter_076_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}？\n早めにトイレに連れて行って\nほしいッコ',
    text_en: '{player_name}?\nPlease take me to the bathroom.',
    type: 'conversational',
  },
  {
    id: 'seaotter_077_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '急ぎではないけど...\n今のうちにトイレに\n行っておきたいッコ',
    text_en: "It's not that urgent but I think it's better to go bathroom now.",
    type: 'conversational',
  },
  {
    id: 'seaotter_078_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '！...急にもよおしてきたッコ\nおトイレッコ...！',
    text_en: '!...Suddenly, I had a urinary urge.',
    type: 'conversational',
  },
  {
    id: 'seaotter_079_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: '急ぐッコ！',
    text_en: 'Hurry, hurry!',
    type: 'conversational',
    next_script_id: 'seaotter_079_02',
  },
  {
    id: 'seaotter_079_02',
    animation: 'surprised',
    text_jp: 'おトイレの時間ッコ！\nもれちゃうッコ...！',
    text_en: "Time to go to the bathroom!\nI can't take it...!",
    type: 'conversational',
  },
  {
    id: 'seaotter_080_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'サメに追いかけられる\n怖い夢を見たッコ...！',
    text_en: 'I had a nightmare to be chased by a shark...!',
    type: 'conversational',
    next_script_id: 'seaotter_080_02',
  },
  {
    id: 'seaotter_080_02',
    animation: 'cry',
    text_jp: '落ち着くまでそばに\nいてほしいッコ...',
    text_en: "Please stand by me until I'll calm down...",
    type: 'conversational',
  },
  {
    id: 'seaotter_081_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'カッパに足を引っ張られて\n海の底に沈む夢を見たッコ...',
    text_en:
      'I had a bad dream that Kappa dragged my leg and sank into bottom of ocean...',
    type: 'conversational',
    next_script_id: 'seaotter_081_02',
  },
  {
    id: 'seaotter_081_02',
    animation: 'anxious',
    text_jp: '怖かったッコ...\nなごませてほしいッコ...',
    text_en: 'That was so scary...\nI need you to calm me down...',
    type: 'conversational',
  },
  {
    id: 'seaotter_082_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: 'ア"ァ"ァ"ァ"ア"\n...ノドがいがらっぽいッコ',
    text_en: 'Nnnnnnn,\n...I have a sore throat.',
    type: 'conversational',
    next_script_id: 'seaotter_082_02',
  },
  {
    id: 'seaotter_082_02',
    animation: 'anxious',
    text_jp: 'おクスリ持ってないッコ？',
    text_en: "Don't you have a medicine?",
    type: 'conversational',
  },
  {
    id: 'seaotter_083_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: 'クシュンッ...！',
    text_en: 'Achoo..!',
    type: 'conversational',
    next_script_id: 'seaotter_083_02',
  },
  {
    id: 'seaotter_083_02',
    animation: 'anxious',
    text_jp: '鼻がつまってくしゃみが出るッコ\nおクスリがほしいッコ',
    text_en: 'I have a stuffy nose and sneeze. I want to have a medicine.',
    type: 'conversational',
  },
  {
    id: 'seaotter_084_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '奥歯がジンジンするッコ...\nもしかして虫歯ッコ...？',
    text_en: "I have a pain in one's back teeth... Is this a cavity...?",
    type: 'conversational',
    next_script_id: 'seaotter_084_02',
  },
  {
    id: 'seaotter_084_02',
    animation: 'anxious',
    text_jp: 'おクスリをもらえないッコ？',
    text_en: 'Can you give me a medicine?',
    type: 'conversational',
  },
  {
    id: 'seaotter_085_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: '歯が痛くて貝も食べられないッコ...',
    text_en: "I can't eat anything because of my toothache...",
    type: 'conversational',
    next_script_id: 'seaotter_085_02',
  },
  {
    id: 'seaotter_085_02',
    animation: 'anxious',
    text_jp: 'おクスリで治してほしいッコ...',
    text_en: 'I want you to fix it with a medicine.',
    type: 'conversational',
  },
  {
    id: 'seaotter_086_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '体がポカポカしてきたッコ...\n眠くなってきた証拠ッコ...',
    text_en:
      "My body is starting to feel warm and fuzzy. It's a sign of sleepiness...",
    type: 'conversational',
    next_script_id: 'seaotter_086_02',
  },
  {
    id: 'seaotter_086_02',
    animation: 'waive',
    text_jp: '{player_name}...\nおやすみッコ★',
    text_en: '{player_name}...\nGood night~.',
    type: 'conversational',
  },
  {
    id: 'seaotter_087_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ん？なんだか体が\nムズムズするッコ…',
    text_en: 'Hmm. My body is mushy.',
    type: 'conversational',
  },
  {
    id: 'seaotter_088_01',
    move_to: 'c',
    text_jp: '{pet_name}、どうやら\nしんじゃったみたいッコ…',
    text_en: 'I guess {pet_name} is dead now.',
    type: 'conversational',
    next_script_id: 'seaotter_088_02',
  },
  {
    id: 'seaotter_088_02',
    text_jp:
      'これまで一緒にあそんでくれて\nどうもありがとッコ\nとっても楽しかったッコ',
    text_en:
      'Thanks for playing with me a bunch until now.\nI had a lot of fun.',
    type: 'conversational',
    next_script_id: 'seaotter_088_03',
  },
  {
    id: 'seaotter_088_03',
    text_jp: 'もし生まれ変われたら、\nまた一緒にあそんで欲しいッコ\nじゃ〜ね〜',
    text_en: 'If I ever get reborn, I hope you play with me again!\nGoodbye!',
    type: 'conversational',
  },
  {
    id: 'seaotter_089_01',
    move_to: 'c',
    text_jp: 'これはただの病気じゃなさそうッコ\n命の危機だッコ',
    text_en: 'I’m not just sick…\nI think my life’s in danger.',
    type: 'conversational',
    next_script_id: 'seaotter_089_02',
  },
  {
    id: 'seaotter_089_02',
    text_jp: '万能コロンをかけて欲しいッコ',
    text_en: 'Can’t you use the Magic Potion?',
    type: 'conversational',
  },
  {
    id: 'seaotter_090_01',
    move_to: 'c',
    text_jp: 'おでかけしたいッコ\nおでかけしたいッコ〜',
    text_en: 'I wanna go out!\nI wanna go out!',
    type: 'conversational',
    next_script_id: 'seaotter_090_02',
  },
  {
    id: 'seaotter_090_02',
    expression: 'happy',
    text_jp: '友だちと貝殻コンコンするッコ〜',
    text_en: 'I wanna crack shells with my friend!',
    type: 'conversational',
  },
  {
    id: 'seaotter_091_01',
    move_to: 'c',
    text_jp: '{friend.player_name}\nあそびに来てくれたッコよ',
    text_en: '{friend.player_name} came over to play!',
    type: 'conversational',
    next_script_id: 'seaotter_091_02',
  },
  {
    id: 'seaotter_091_02',
    animation: 'joy',
    text_jp: 'いっぱいあそんでくれて\n楽しかったッコ',
    text_en: 'They played with me a lot, and I’m happy!',
    type: 'conversational',
  },
  {
    id: 'seaotter_092_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きなブランドは何か聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite brand is!',
    type: 'conversational',
    next_script_id: 'seaotter_092_02',
  },
  {
    id: 'seaotter_092_02',
    text_jp: '{friend.favorite_brand}って\n言ってたッコ！',
    text_en: 'They said it’s {friend.favorite_brand}!',
    type: 'conversational',
    next_script_id: 'seaotter_092_03',
  },
  {
    id: 'seaotter_092_03',
    expression: 'happy',
    animation: 'play',
    text_jp: 'おしゃれさんッコ！',
    text_en: 'Tres chic!',
    type: 'conversational',
  },
  {
    id: 'seaotter_093_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな色は何か聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite color is!',
    type: 'conversational',
    next_script_id: 'seaotter_093_02',
  },
  {
    id: 'seaotter_093_02',
    text_jp: '{friend.favorite_color}って\n言ってたッコ！',
    text_en: 'They said it’s {friend.favorite_color}!',
    type: 'conversational',
    next_script_id: 'seaotter_093_03',
  },
  {
    id: 'seaotter_093_03',
    expression: 'happy',
    text_jp: '今度その色を着てるのを見たら\n褒めてあげるといいッコ！',
    text_en: 'If you see them wearing that color, you should compliment them!',
    type: 'conversational',
  },
  {
    id: 'seaotter_094_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きなおやつを聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite snack is!',
    type: 'conversational',
    next_script_id: 'seaotter_094_02',
  },
  {
    id: 'seaotter_094_02',
    text_jp: '{friend.favorite_snack}って\n言ってたッコ！',
    text_en: 'They said it’s {friend.favorite_snack}!',
    type: 'conversational',
    next_script_id: 'seaotter_094_03',
  },
  {
    id: 'seaotter_094_03',
    animation: 'joy',
    text_jp: '{pet_name}も\n食べてみたいッコ〜',
    text_en: '{pet_name} wants to try it!',
    type: 'conversational',
  },
  {
    id: 'seaotter_095_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな宝石を聞いてみたら、',
    text_en: 'I asked {friend.player_name} what their favorite gemstone is!',
    type: 'conversational',
    next_script_id: 'seaotter_095_02',
  },
  {
    id: 'seaotter_095_02',
    text_jp: '{friend.favorite_gem}って\n言ってたッコ！',
    text_en: 'They said it’s {friend.favorite_gem}!',
    type: 'conversational',
    next_script_id: 'seaotter_095_03',
  },
  {
    id: 'seaotter_095_03',
    expression: 'happy',
    text_jp: '良い趣味してるッコ！',
    text_en: 'They’ve got great taste!',
    type: 'conversational',
  },
  {
    id: 'seaotter_096_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n子供の頃の夢を\n聞いてみたッコけど、',
    text_en: 'I asked {friend.player_name} what their dream was as a kid!',
    type: 'conversational',
    next_script_id: 'seaotter_096_02',
  },
  {
    id: 'seaotter_096_02',
    text_jp: '{friend.childhood_dream}って\n言ってたッコ！',
    text_en: 'They said {friend.childhood_dream}!',
    type: 'conversational',
    next_script_id: 'seaotter_096_03',
  },
  {
    id: 'seaotter_096_03',
    expression: 'happy',
    text_jp: '叶っても叶わなくても、\n夢を持つって素敵なことだッコ',
    text_en: 'Whether it comes true or not, it’s great to have a dream!',
    type: 'conversational',
  },
  {
    id: 'seaotter_097_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\nマイブームを聞いてみたら、',
    text_en: 'I asked {friend.player_name} what they’re into lately.',
    type: 'conversational',
    next_script_id: 'seaotter_097_02',
  },
  {
    id: 'seaotter_097_02',
    text_jp: '{friend.my_boom}って\n言ってたッコ！',
    text_en: 'They said {friend.my_boom}!',
    type: 'conversational',
    next_script_id: 'seaotter_097_03',
  },
  {
    id: 'seaotter_097_03',
    animation: 'play',
    text_jp: '{player_name}も\n真似してみるッコ？',
    text_en: 'Maybe you could try as well, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'seaotter_098_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n癖は何か聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they have any habits!',
    type: 'conversational',
    next_script_id: 'seaotter_098_02',
  },
  {
    id: 'seaotter_098_02',
    text_jp: '{friend.peculiarity}って\n言ってたッコ！',
    text_en: 'They said {friend.peculiarity}!',
    type: 'conversational',
    next_script_id: 'seaotter_098_03',
  },
  {
    id: 'seaotter_098_03',
    animation: 'play',
    text_jp: '今度よく観察してみるッコ！',
    text_en: 'Keep an eye out for it!',
    type: 'conversational',
  },
  {
    id: 'seaotter_099_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n嫌いな食べ物を聞いてみたら、',
    text_en: 'I asked {friend.player_name} what their least favorite food is.',
    type: 'conversational',
    next_script_id: 'seaotter_099_02',
  },
  {
    id: 'seaotter_099_02',
    text_jp: '{friend.disliked_food}って\n言ってたッコ！',
    text_en: 'They said it’s {friend.disliked_food}!',
    type: 'conversational',
    next_script_id: 'seaotter_099_03',
  },
  {
    id: 'seaotter_099_03',
    expression: 'happy',
    text_jp: '{friend.player_name}と\nご飯行くときに参考に\nするといいッコ！',
    text_en:
      'Keep that in mind the next time you eat with {friend.player_name}!',
    type: 'conversational',
  },
  {
    id: 'seaotter_100_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n得意な泳ぎ方を聞いてみたら、',
    text_en:
      'I asked {friend.player_name} what kind of swimming they’re best at!',
    type: 'conversational',
    next_script_id: 'seaotter_100_02',
  },
  {
    id: 'seaotter_100_02',
    text_jp: '{friend.favorite_swim}って\n言ってたッコ！',
    text_en: 'They said the {friend.favorite_swim}!',
    type: 'conversational',
    next_script_id: 'seaotter_100_03',
  },
  {
    id: 'seaotter_100_03',
    expression: 'sad',
    text_jp: 'なかなか背泳ぎって言う人、\nいないッコよね〜\n楽しいのにッコ〜',
    text_en:
      'Not too many people are good at the backstroke!\nPersonally, I think it’s the coolest!',
    type: 'conversational',
  },
  {
    id: 'seaotter_101_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな貝は何か聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite clam is!',
    type: 'conversational',
    next_script_id: 'seaotter_101_02',
  },
  {
    id: 'seaotter_101_02',
    text_jp: '{friend.favorite_shell}って\n言ってたッコ！',
    text_en: "They said it's {friend.favorite_shell}!",
    type: 'conversational',
    next_script_id: 'seaotter_101_03',
  },
  {
    id: 'seaotter_101_03',
    expression: 'happy',
    text_jp: '貝はだいたい何でも美味しいッコ！',
    text_en: 'I think all clams are delicious!',
    type: 'conversational',
  },
  {
    id: 'seaotter_102_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n好きなものは先に食べるか\n後にとっておくか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they eat their favorite first or save it till last!',
    type: 'conversational',
    case: 'friend.eat_first_later',
    next_script_id_1: 'seaotter_102_02',
    next_script_id_2: 'seaotter_102_03',
  },
  {
    id: 'seaotter_102_02',
    expression: 'happy',
    text_jp:
      '先に食べちゃうって言ってたッコ！\n我慢できないッコね〜\nその気持ち、よく分かるッコ！',
    text_en:
      'They said they eat their favorite first!\nIt’s too hard to resist! I get it!',
    type: 'conversational',
  },
  {
    id: 'seaotter_102_03',
    expression: 'happy',
    text_jp:
      '後にとっておくって言ってたッコ！\n楽しみを後にとっておける子は\n将来出世するらしいッコ！',
    text_en:
      'They said they save their favorite till last!\nI heard that people who can delay gratification go far in life!',
    type: 'conversational',
  },
  {
    id: 'seaotter_103_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n貝を好きかどうか聞いたら、',
    text_en: 'I asked if {friend.player_name} likes clams!',
    type: 'conversational',
    case: 'friend.cram_like',
    next_script_id_1: 'seaotter_103_02',
    next_script_id_2: 'seaotter_103_03',
  },
  {
    id: 'seaotter_103_02',
    expression: 'happy',
    text_jp: '好きって言ってたッコ！\nいいやつッコ！',
    text_en: 'They said they do!\nWhat a great person!',
    type: 'conversational',
  },
  {
    id: 'seaotter_103_03',
    expression: 'happy',
    text_jp: 'そうでもないって言ってたッコ！\nこの美味しさがわからないなんて…',
    text_en: 'They said not especially!\nWho couldn’t love that flavor?!',
    type: 'conversational',
  },
  {
    id: 'seaotter_104_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}は、\nせっかちな方かのんびりな方か\n聞いたら、',
    text_en: 'I asked if {friend.player_name} is more impatient or relaxed.',
    type: 'conversational',
    case: 'friend.hasty_slow',
    next_script_id_1: 'seaotter_104_02',
    next_script_id_2: 'seaotter_104_03',
  },
  {
    id: 'seaotter_104_02',
    expression: 'normal',
    text_jp: 'せっかちな方って言ってたッコ！\nたしかに、そんな感じするッコね？',
    text_en: "They said they're more impatient!\nYou can kind of tell, right?",
    type: 'conversational',
  },
  {
    id: 'seaotter_104_03',
    expression: 'normal',
    text_jp: 'のんびりな方って言ってたッコ！\nたしかに、そんな感じするッコね？',
    text_en: "They said they're more relaxed!\nYou can kind of tell, right?",
    type: 'conversational',
  },
  {
    id: 'seaotter_105_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nコーヒーは好きかどうか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} if they like coffee!',
    type: 'conversational',
    case: 'friend.coffee_like',
    next_script_id_1: 'seaotter_105_02',
    next_script_id_2: 'seaotter_105_03',
  },
  {
    id: 'seaotter_105_02',
    animation: 'surprised',
    text_jp: '好きって言ってたッコ！\n意外にオトナだったッコ！',
    text_en: 'They said they do!\nWhat a grown-up!',
    type: 'conversational',
  },
  {
    id: 'seaotter_105_03',
    expression: 'happy',
    text_jp:
      'そうでもないって言ってたッコ！\nお砂糖とミルク入れれば\n飲めるかもしれないッコね？',
    text_en:
      'They said not especially!\nMaybe they could try it with milk and sugar?',
    type: 'conversational',
  },
  {
    id: 'seaotter_106_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nいま映画な気分か音楽な気分か\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they prefer seeing a movie or listening to music!',
    type: 'conversational',
    case: 'friend.movie_music',
    next_script_id_1: 'seaotter_106_02',
    next_script_id_2: 'seaotter_106_03',
  },
  {
    id: 'seaotter_106_02',
    expression: 'happy',
    text_jp: '映画な気分って言ってたッコ！\n何か観に誘ってみたらどうッコ？',
    text_en:
      'They said they prefer seeing a movie!\nWhy don’t you invite them to see something?',
    type: 'conversational',
  },
  {
    id: 'seaotter_106_03',
    expression: 'happy',
    text_jp:
      '音楽な気分って言ってたッコ！\n映画より気楽に楽しめて\nいいッコよね〜',
    text_en:
      'They said they prefer listening to music!\nIt’s a lot easier than seeing a movie!',
    type: 'conversational',
  },
  {
    id: 'seaotter_107_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nストライプとボーダー、どっちが\n好きか聞いたら、',
    text_en:
      'I asked if {friend.player_name} likes horizontal or vertical stripes!',
    type: 'conversational',
    case: 'friend.stripe_border',
    next_script_id_1: 'seaotter_107_02',
    next_script_id_2: 'seaotter_107_04',
  },
  {
    id: 'seaotter_107_02',
    expression: 'happy',
    text_jp: 'ストライプが好きって\n言ってたッコ！',
    text_en: 'They said they like horizontal stripes!',
    type: 'conversational',
    next_script_id: 'seaotter_107_03',
  },
  {
    id: 'seaotter_107_03',
    expression: 'happy',
    text_jp:
      'ストライプとボーダーの\n違いが分かるなんて、\nオシャレ上級者だッコ！',
    text_en: 'They’re pretty fashionable to have a preference!',
    type: 'conversational',
  },
  {
    id: 'seaotter_107_04',
    text_jp: 'ボーダーが好きって\n言ってたッコ！',
    text_en: 'They said they like vertical stripes!',
    type: 'conversational',
    next_script_id: 'seaotter_107_05',
  },
  {
    id: 'seaotter_107_05',
    text_jp:
      'ストライプとボーダーの\n違いが分かるなんて、\nオシャレ上級者だッコ！',
    text_en: 'They’re pretty fashionable to have a preference!',
    type: 'conversational',
  },
  {
    id: 'seaotter_108_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nスペゲッティはクリームソースと\nトマトソース、どっち派か聞いたら',
    text_en:
      'I asked {friend.player_name} if they like spaghetti with cream or tomato sauce better!',
    type: 'conversational',
    case: 'friend.tomato_cream',
    next_script_id_1: 'seaotter_108_02',
    next_script_id_2: 'seaotter_108_03',
  },
  {
    id: 'seaotter_108_02',
    text_jp:
      'クリームソースって言ってたッコ！\n{pet_name}も、どちらかと\n言えばクリームソース派だッコ！',
    text_en:
      'They said they like cream sauce!\n{pet_name} likes cream sauce better, too!',
    type: 'conversational',
  },
  {
    id: 'seaotter_108_03',
    text_jp:
      'トマトソースって言ってたッコ！\nトマトソースは美味しいけど、\n服に飛び散るリスクがあるッコ！',
    text_en:
      'They said tomato sauce!\nTomato sauce is great, but it’s risky that it might get on your clothes!',
    type: 'conversational',
  },
  {
    id: 'seaotter_109_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nコアラとラッコ、どっちが\n好きか聞いたら、',
    text_en: 'I asked if {friend.player_name} likes koalas or otters better!',
    type: 'conversational',
    case: 'friend.koala_seaotter',
    next_script_id_1: 'seaotter_109_02',
    next_script_id_2: 'seaotter_109_03',
  },
  {
    id: 'seaotter_109_02',
    animation: 'cry',
    text_jp: 'コアラって言ってたコロ〜！\nひどいコロ〜！',
    text_en: 'They said koalas!\nHow DARE they?!',
    type: 'conversational',
  },
  {
    id: 'seaotter_109_03',
    animation: 'joy',
    text_jp:
      'ラッコって言ってたッコよ〜！\n{friend.player_name}、\n大好きッコ〜！',
    text_en: 'They said otters!\nI like {friend.player_name}, too!',
    type: 'conversational',
  },
  {
    id: 'seaotter_110_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に、\n紅茶に何を入れるか聞いたら、',
    text_en: 'I asked {friend.player_name} if they add anything to their tea!',
    type: 'conversational',
    case: 'friend.tea_type',
    next_script_id_1: 'seaotter_110_02',
    next_script_id_2: 'seaotter_110_03',
    next_script_id_3: 'seaotter_110_04',
  },
  {
    id: 'seaotter_110_02',
    expression: 'happy',
    text_jp: 'レモンって言ってたッコ！\nエレガントな感じがするッコ！',
    text_en: 'They said they add lemon!\nSeems pretty elegant!',
    type: 'conversational',
  },
  {
    id: 'seaotter_110_03',
    expression: 'happy',
    text_jp: 'ミルクって言ってたッコ！\n優しい味になって美味しいッコ！',
    text_en: 'They said they add milk!\nI’ll bet that makes it taste great!',
    type: 'conversational',
  },
  {
    id: 'seaotter_110_04',
    expression: 'happy',
    text_jp: '何も入れないって言ってたッコ！\nミニマリストってやつッコ！',
    text_en:
      "They said they don't add anything!\nThat’s what I call a minimalist!",
    type: 'conversational',
  },
  {
    id: 'seaotter_111_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\nエビ天とエビフライ、\nどっちが好きか聞いたら、',
    text_en:
      'I asked {friend.player_name} whether they like shrimp tempura or fried shrimp better!',
    type: 'conversational',
    case: 'friend.fried_shrimp',
    next_script_id_1: 'seaotter_111_02',
    next_script_id_2: 'seaotter_111_03',
  },
  {
    id: 'seaotter_111_02',
    expression: 'happy',
    text_jp: 'エビ天が好きって言ってたッコ！\nオトナっぽいッコ！',
    text_en: 'They said they like shrimp tempura!\nVery mature taste!',
    type: 'conversational',
  },
  {
    id: 'seaotter_111_03',
    expression: 'happy',
    text_jp: 'エビフライが好きって\n言ってたッコ！',
    text_en: 'They said they like fried shrimp!',
    type: 'conversational',
    next_script_id: 'seaotter_111_04',
  },
  {
    id: 'seaotter_111_04',
    expression: 'happy',
    text_jp: 'ちなみに{pet_name}は\nエビフライには\nタルタルソース派だッコ！',
    text_en: '{pet_name} likes tartar sauce on my fried shrimp!',
    type: 'conversational',
  },
  {
    id: 'seaotter_112_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n冷麺と冷やし中華、\nどっちが食べたいか聞いたら、',
    text_en:
      'I asked {friend.player_name} whether they like cold noodles or hot noodles better!',
    type: 'conversational',
    case: 'friend.cold_noodles',
    next_script_id_1: 'seaotter_112_02',
    next_script_id_2: 'seaotter_112_03',
  },
  {
    id: 'seaotter_112_02',
    expression: 'happy',
    text_jp: '冷麺って言ってたッコ！\nあのコシが最高ッコ！',
    text_en:
      'They said they like cold noodles better!\nNothing beats that combination!',
    type: 'conversational',
  },
  {
    id: 'seaotter_112_03',
    expression: 'happy',
    text_jp: '冷やし中華って言ってたッコ！',
    text_en: 'They said they like hot noodles better!',
    type: 'conversational',
    next_script_id: 'seaotter_112_04',
  },
  {
    id: 'seaotter_112_04',
    expression: 'sad',
    text_jp:
      '冷やし中華って、けっこう作るの\nたいへんなのに、簡単そうに\n思われてて、かわいそうッコ！',
    text_en:
      "It's tricky to get noodles just right!\nThey’re harder to make than people think!",
    type: 'conversational',
  },
  {
    id: 'seaotter_113_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n北海道と沖縄、\nどっちに行きたいか聞いたら、',
    text_en:
      "I asked {friend.player_name} if they'd rather go to Hokkaido or Okinawa!",
    type: 'conversational',
    case: 'friend.hokkaido_okinawa',
    next_script_id_1: 'seaotter_113_02',
    next_script_id_2: 'seaotter_113_03',
  },
  {
    id: 'seaotter_113_02',
    expression: 'happy',
    text_jp:
      '北海道って言ってたッコ！\n海の幸モリモリッコ！\n今度誘ってみたらどうッコ？',
    text_en:
      'They said Hokkaido!\nLots of great seafood there!\nWhy not invite them to go?',
    type: 'conversational',
  },
  {
    id: 'seaotter_113_03',
    expression: 'happy',
    text_jp:
      '沖縄って言ってたッコ！\n青い海が最高だッコ！\n今度誘ってみたらどうッコ？',
    text_en:
      'They said Okinawa!\nWhat could be better than that blue sea?\nWhy not invite them to go?',
    type: 'conversational',
  },
  {
    id: 'seaotter_114_01',
    move_to: 'c',
    text_jp: 'これからもいっぱい\nあそんでほしいッコ！',
    text_en: 'I hope we can play together a lot more from now on!',
    type: 'conversational',
  },
  {
    id: 'seaotter_115_01',
    animation: 'waive',
    text_jp: 'あそびに来たッコよ〜！',
    text_en: 'I’m here to play!',
    type: 'conversational',
  },
  {
    id: 'seaotter_116_01',
    animation: 'waive',
    text_jp: 'いらっしゃいませッコ〜\nゆっくりしていってッコ〜',
    text_en: 'Welcome! \nMake yourself at home!',
    type: 'conversational',
  },
  {
    id: 'seaotter_117_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'いっぱいお世話してくれて\nありがとッコ\nこれ、感謝のしるしッコ',
    text_en:
      'Thanks for everything you do!\nHere’s a little something from me.',
    type: 'conversational',
  },
  {
    id: 'seaotter_118_01',
    text_jp: 'そろそろ帰るッコね\n今度はうちにも来て欲しいッコ',
    text_en: 'I’ll start heading home.\nYou should come by my place sometime!',
    type: 'conversational',
  },
  {
    id: 'seaotter_119_01',
    text_jp: 'また来て欲しいッコ〜\n今日はありがとッコ〜',
    text_en: 'Come back soon!\nThanks for everything!',
    type: 'conversational',
  },
  {
    id: 'seaotter_120_01',
    text_jp: 'どうやら\n{friend.player_name}が\n帰ってきたみたいだッコ',
    text_en: 'Looks like {friend.player_name} is back!',
    type: 'conversational',
    next_script_id: 'seaotter_120_02',
  },
  {
    id: 'seaotter_120_02',
    text_jp: '今日はそろそろ帰るッコ\nまたあそびに来るッコ',
    text_en: 'I’ll get going now.\nCome back again sometime!',
    type: 'conversational',
  },
  {
    id: 'seaotter_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないッコ〜',
    text_en: 'It’s too scary to go the bathroom!',
    type: 'conversational',
  },
  {
    id: 'seaotter_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないッコ〜',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'seaotter_123_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '今は、少しでも早く\n万能コロンをかけて欲しいッコ…',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'seaotter_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないッコ〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'seaotter_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったッコ！\nどうもありがとうッコ！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'seaotter_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったッコ！\nどうもありがとうッコ！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'seaotter_127_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ふ〜。なんとか助かったッコ〜！\nありがとッコ！',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'seaotter_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったッコ…\nもう1回試してみて欲しいッコ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'seaotter_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったッコ…\nもう1回試してみて欲しいッコ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'seaotter_130_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったッコ…\nもう1回試してみて欲しいッコ',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'cat_001_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'こんにちミャ★',
    text_en: 'Hello :)',
    type: 'conversational',
    next_script_id: 'cat_001_02',
  },
  {
    id: 'cat_001_02',
    animation: 'play',
    text_jp: 'なにして遊ぶミャ？',
    text_en: 'What do you want to do today?',
    type: 'conversational',
  },
  {
    id: 'cat_002_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '今日もおつかれミャ★',
    text_en: 'Good work today.',
    type: 'conversational',
    next_script_id: 'cat_002_02',
  },
  {
    id: 'cat_002_02',
    animation: 'joy',
    text_jp: 'ゴロゴロ、ゴロゴロ',
    text_en: 'Grrrr, grrrrr',
    type: 'conversational',
    next_script_id: 'cat_002_03',
  },
  {
    id: 'cat_002_03',
    expression: 'happy',
    text_jp: '癒やされたミャ？',
    text_en: 'Were you healed?',
    type: 'conversational',
  },
  {
    id: 'cat_003_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '若干...',
    text_en: 'A little bit...',
    type: 'conversational',
    next_script_id: 'cat_003_02',
  },
  {
    id: 'cat_003_02',
    expression: 'happy',
    text_jp: '花粉症にあこがれている\nフシがあるミャ',
    text_en: 'I long for hay fever.',
    type: 'conversational',
  },
  {
    id: 'cat_004_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '遺伝子組み換え食品って',
    text_en: "I'd like to try",
    type: 'conversational',
    next_script_id: 'cat_004_02',
  },
  {
    id: 'cat_004_02',
    expression: 'normal',
    text_jp: 'どんなものなのかいっそ試して\nみたいものミャ',
    text_en: "GMO food to see what it's like.",
    type: 'conversational',
  },
  {
    id: 'cat_005_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '鉛筆の後ろについてる\n消しゴムを使ったら',
    text_en: 'I used the eraser on the back of the pencil',
    type: 'conversational',
    next_script_id: 'cat_005_02',
  },
  {
    id: 'cat_005_02',
    animation: 'surprised',
    text_jp: 'もっと真っ黒になったミャ...',
    text_en: 'and it got even darker...',
    type: 'conversational',
  },
  {
    id: 'cat_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'タンスの角に後ろ足を\nぶつけた勢いで',
    text_en: 'I hit my back foot on the corner of the dresser',
    type: 'conversational',
    next_script_id: 'cat_006_02',
  },
  {
    id: 'cat_006_02',
    expression: 'very_sad',
    text_jp: 'あつあつのコーヒーに手を\nつっこんだミャ...',
    text_en: 'and stuck my hand in the hot coffee...',
    type: 'conversational',
    next_script_id: 'cat_006_03',
  },
  {
    id: 'cat_006_03',
    animation: 'cry',
    text_jp: 'やんなるミャ...',
    text_en: "I'm sick of it...",
    type: 'conversational',
  },
  {
    id: 'cat_007_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '台所のスポンジって',
    text_en: "Don't you think that sometimes kitchen sponges",
    type: 'conversational',
    next_script_id: 'cat_007_02',
  },
  {
    id: 'cat_007_02',
    expression: 'normal',
    text_jp: 'たまにカステラそっくりな\nやつがあると思わないミャ？',
    text_en: 'look just like sponge cake?',
    type: 'conversational',
  },
  {
    id: 'cat_008_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'モンスターペアレンツって\n最初に聞いた時',
    text_en: 'Monster Parents.\nWhen I first heard it,',
    type: 'conversational',
    next_script_id: 'cat_008_02',
  },
  {
    id: 'cat_008_02',
    expression: 'sad',
    text_jp: '新作アニメのタイトル\nだと思ったミャ',
    text_en: 'I thought it was a title of a new anime film.',
    type: 'conversational',
  },
  {
    id: 'cat_009_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'TVのチャンネルを変えた時...',
    text_en: "Aren't you glad when you change TV channels",
    type: 'conversational',
    next_script_id: 'cat_009_02',
  },
  {
    id: 'cat_009_02',
    expression: 'happy',
    text_jp: 'たまたま同じCMをやってると\nうれしくならないミャ？',
    text_en: 'and they happen to be playing the same commercial?',
    type: 'conversational',
  },
  {
    id: 'cat_010_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '【閲覧注意】って書いてあると',
    text_en: 'When it says "Viewer discretion is advised",',
    type: 'conversational',
    next_script_id: 'cat_010_02',
  },
  {
    id: 'cat_010_02',
    animation: 'anxious',
    text_jp: 'むしろ見たくなるミャ',
    text_en: 'rather, it makes me want to look at it.',
    type: 'conversational',
  },
  {
    id: 'cat_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコは魚好きって思ってるミャ？',
    text_en: 'Do you think cats like fish?',
    type: 'conversational',
    next_script_id: 'cat_011_02',
  },
  {
    id: 'cat_011_02',
    expression: 'normal',
    text_jp: '肉食なので、どっちかって\nいうと肉が好きミャ',
    text_en: "I'm a carnivore, so I'm more of a meat eater.",
    type: 'conversational',
    next_script_id: 'cat_011_03',
  },
  {
    id: 'cat_011_03',
    animation: 'anxious',
    text_jp: '某長寿アニメの主題歌の影響で\nそう思われがちミャ！',
    text_en:
      'It is often thought so due to the influence of the song of a long-lived anime in Japan.',
    type: 'conversational',
  },
  {
    id: 'cat_012_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'コピ・ルアクっていう\n高級コーヒーは、',
    text_en: 'Kopi Luwak. High-grade coffee is',
    type: 'conversational',
    next_script_id: 'cat_012_02',
  },
  {
    id: 'cat_012_02',
    expression: 'normal',
    text_jp: 'ジャコウネコの未消化のうんち\nから作られるミャ',
    text_en: 'made from the undigested feces of civets.',
    type: 'conversational',
    next_script_id: 'cat_012_03',
  },
  {
    id: 'cat_012_03',
    expression: 'happy',
    text_jp: '試してみるミャ？',
    text_en: 'Do you want to try it?',
    type: 'conversational',
  },
  {
    id: 'cat_013_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '三毛猫のオスは超絶\nめずらしいミャ',
    text_en: 'Male tortoiseshell cats are extremely rare.',
    type: 'conversational',
    next_script_id: 'cat_013_02',
  },
  {
    id: 'cat_013_02',
    animation: 'surprised',
    text_jp:
      'なんと3万匹に1匹位の確率ミャ\n難しいことはわからミャいけど\n染色体の関係ミャ',
    text_en: 'The probability is about 1 in 30,000 cats.',
    type: 'conversational',
  },
  {
    id: 'cat_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコにも利き手があるミャ',
    text_en: 'Cats have dominant hands, too..',
    type: 'conversational',
    next_script_id: 'cat_014_02',
  },
  {
    id: 'cat_014_02',
    expression: 'normal',
    text_jp: 'しかもオスは左利き、\nメスは右利きの割合が\nすごく多いミャ',
    text_en: 'Mostly, males are left-handed and females are right-handed.',
    type: 'conversational',
  },
  {
    id: 'cat_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '飼いイヌと飼いネコ、全世界では\nどっちが多いと思うミャ？',
    text_en:
      'Which do you think is more common in the world, domesticated dogs or cats?',
    type: 'conversational',
    next_script_id: 'cat_015_02',
  },
  {
    id: 'cat_015_02',
    animation: 'joy',
    text_jp:
      '正解はネコミャ！\nイヌの頭数は1.7億、ネコは2.4億\nとネコの圧勝だミャ★',
    text_en:
      'The answer is cats! With 170 million dogs and 240 million cats, cats win hands down.',
    type: 'conversational',
  },
  {
    id: 'cat_016_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '知ってるミャ？',
    text_en: 'Do you know that?',
    type: 'conversational',
    next_script_id: 'cat_016_02',
  },
  {
    id: 'cat_016_02',
    expression: 'normal',
    text_jp:
      'ネコを大事にするエジプト軍に対し\nペルシャが盾にネコをつけたら\n圧勝した、という歴史があるミャ',
    text_en:
      'History has it that the Persians won when they put cats on their shields against Egypt.',
    type: 'conversational',
    next_script_id: 'cat_016_03',
  },
  {
    id: 'cat_016_03',
    animation: 'angry',
    text_jp: '...ペルシャ軍、卑怯ミャ！',
    text_en: '...The Persians are unfair!',
    type: 'conversational',
  },
  {
    id: 'cat_017_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '熱いものが苦手なことを\nネコ舌っていうミャ？',
    text_en: "It's called \"cat's tongue\" if you don't like hot food.",
    type: 'conversational',
    next_script_id: 'cat_017_02',
  },
  {
    id: 'cat_017_02',
    expression: 'normal',
    text_jp: 'でも、ネコが温度を感じるのは\n鼻なので正しくないミャ',
    text_en:
      'But the cat senses temperature through nose, so it is not correct.',
    type: 'conversational',
    next_script_id: 'cat_017_03',
  },
  {
    id: 'cat_017_03',
    animation: 'surprised',
    text_jp: 'ついでに、人間以外の生き物は\nだいたいネコ舌ミャ...！',
    text_en: 'By the way, most of non-human creatures are "cat\'s tongue."',
    type: 'conversational',
  },
  {
    id: 'cat_018_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコを飼うと健康になるらしいミャ',
    text_en: 'They say owning a cat makes you healthier.',
    type: 'conversational',
    next_script_id: 'cat_018_02',
  },
  {
    id: 'cat_018_02',
    expression: 'happy',
    text_jp:
      'ある報告だと、ネコを飼っていると\n心臓発作になる可能性が1/3も\n低下するらしいミャ',
    text_en:
      'One report says that owning a cat decreases your chances of having a heart attack by 1/3.',
    type: 'conversational',
    next_script_id: 'cat_018_03',
  },
  {
    id: 'cat_018_03',
    animation: 'joy',
    text_jp: 'かわいいは正義、ミャ★',
    text_en: 'Cute is a justice!',
    type: 'conversational',
  },
  {
    id: 'cat_019_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '一日一歩三日で三歩\n三歩進んで二歩下がる\nを本当にやったら、',
    text_en:
      'If you practice one step a day, three steps in three days, three steps forward and two steps back.',
    type: 'conversational',
    next_script_id: 'cat_019_02',
  },
  {
    id: 'cat_019_02',
    animation: 'surprised',
    text_jp: '1km歩くのに18年も\nかかるミャ...！',
    text_en: 'It takes about 18 years to walk 1 km...!',
    type: 'conversational',
  },
  {
    id: 'cat_020_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '招きネコには右手を上げているのと\n左手を上げているのがあるミャ',
    text_en:
      'There are two types of beckoning cats: one with its right hand raised and one with its left hand raised.',
    type: 'conversational',
    next_script_id: 'cat_020_02',
  },
  {
    id: 'cat_020_02',
    expression: 'happy',
    text_jp: '右手のほうはお金を\n左手のほうは人を\n招くと言われてるミャ',
    text_en:
      'The right hand side is said to invite money and the left hand side people.',
    type: 'conversational',
    next_script_id: 'cat_020_03',
  },
  {
    id: 'cat_020_03',
    animation: 'surprised',
    text_jp:
      '両手を上げているのも\nあるらしいけど...\n欲張りすぎでひっくり返るミャ！',
    text_en:
      "Some of them have their both hands up, but they're too greedy to turn over!",
    type: 'conversational',
  },
  {
    id: 'cat_021_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '肉と魚、どっちが好きミャ？',
    text_en: 'Which do you prefer, meat or fish?',
    type: 'selectional',
    answer_var: 'meat_fish',
    option_1_jp: '肉',
    option_1_en: 'Meat',
    option_2_jp: '魚',
    option_2_en: 'Fish',
    case: 'meat_fish',
    next_script_id_1: 'cat_021_02',
    next_script_id_2: 'cat_021_03',
  },
  {
    id: 'cat_021_02',
    expression: 'happy',
    text_jp:
      'やっぱり肉だミャ〜\n{pet_name}の\n夢はハムを丸々1本食べることミャ',
    text_en: 'I agree! My dream is to eat a whole ham someday.',
    type: 'conversational',
  },
  {
    id: 'cat_021_03',
    expression: 'happy',
    text_jp: '魚も捨てがたいミャ〜\n{pet_name}の\n好物はマグロのお刺身ミャ★',
    text_en: 'I like fish too. My favorite is tuna sashimi :)',
    type: 'conversational',
  },
  {
    id: 'cat_022_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ベッド派ミャ？お布団派ミャ？',
    text_en: 'Do you sleep in bed? Sleep on a futon?',
    type: 'selectional',
    answer_var: 'bed_futon',
    option_1_jp: 'ベッド派',
    option_1_en: 'Bed',
    option_2_jp: 'お布団',
    option_2_en: 'Futon',
    case: 'bed_futon',
    next_script_id_1: 'cat_022_02',
    next_script_id_2: 'cat_022_04',
  },
  {
    id: 'cat_022_02',
    expression: 'normal',
    text_jp: 'ふ〜ん',
    text_en: 'Ah-huh.',
    type: 'conversational',
    next_script_id: 'cat_022_03',
  },
  {
    id: 'cat_022_03',
    expression: 'happy',
    text_jp: '{pet_name}は\nお布団派だけど、ベッドで\nポムポムするのは好きミャ',
    text_en: "I'm a futon person, but I like to pom-pom in bed.",
    type: 'conversational',
  },
  {
    id: 'cat_022_04',
    animation: 'joy',
    text_jp:
      '{pet_name}も\nお布団派ミャ！たたんだお布団の\n間に入り込むのが最高ミャ',
    text_en:
      "I'm a futon person too! It's great to get in between the folded futon.",
    type: 'conversational',
  },
  {
    id: 'cat_023_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '冷房はエアコンと扇風機、\nどっちがいいミャ？',
    text_en: 'Which do you prefer for cooling, air conditioner or fan?',
    type: 'selectional',
    answer_var: 'ac_fan',
    option_1_jp: 'エアコン',
    option_1_en: 'Air conditioner',
    option_2_jp: '扇風機',
    option_2_en: 'Fan',
    case: 'ac_fan',
    next_script_id_1: 'cat_023_02',
    next_script_id_2: 'cat_023_03',
  },
  {
    id: 'cat_023_02',
    expression: 'normal',
    text_jp:
      '確かにエアコンは涼しいミャ〜\nでも寒すぎると風邪を引くので\n設定温度は28度位がいいミャ',
    text_en:
      'It is true that air conditioners are cool. I like to set the temperature at 28 degrees.',
    type: 'conversational',
  },
  {
    id: 'cat_023_03',
    expression: 'happy',
    text_jp:
      '扇風機はいいミャ〜\n見るとついア"ア"ア"ア"ア"って\nやっちゃうミャ',
    text_en: 'Fans are nice. Ialways say "Ahhh" to a spinning fan.',
    type: 'conversational',
  },
  {
    id: 'cat_024_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちが好きミャ？',
    text_en: 'Which do you prefer?',
    type: 'selectional',
    answer_var: 'melon_watermelon',
    option_1_jp: 'メロン',
    option_1_en: 'Melon',
    option_2_jp: 'すいか',
    option_2_en: 'Watermelon',
    case: 'melon_watermelon',
    next_script_id_1: 'cat_024_02',
    next_script_id_2: 'cat_024_03',
  },
  {
    id: 'cat_024_02',
    expression: 'happy',
    text_jp:
      'メロンはいいよミャ〜\nちなみに生ハムとメロンは別々で\n食べたい方ミャ',
    text_en:
      'Melon is good.\nI am a person who likes to eat ham and melon separately.',
    type: 'conversational',
  },
  {
    id: 'cat_024_03',
    expression: 'happy',
    text_jp: 'すいかはいいよミャ〜',
    text_en: 'Watermelon is good.',
    type: 'conversational',
    next_script_id: 'cat_024_04',
  },
  {
    id: 'cat_024_04',
    animation: 'anxious',
    text_jp: 'ところで人間はなんで\nすいかに塩をかけるミャ？',
    text_en: 'By the way, why do humans put salt on watermelon?',
    type: 'conversational',
  },
  {
    id: 'cat_025_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちで寝てみたいミャ？',
    text_en: 'Which do you prefer to sleep on?',
    type: 'selectional',
    answer_var: 'hammock_waterbed',
    option_1_jp: 'ハンモック',
    option_1_en: 'Hammock',
    option_2_jp: 'ウォーターベッド',
    option_2_en: 'Water bed',
    case: 'hammock_waterbed',
    next_script_id_1: 'cat_025_02',
    next_script_id_2: 'cat_025_03',
  },
  {
    id: 'cat_025_02',
    animation: 'joy',
    text_jp: '{pet_name}も\nハンモックで\nゆらゆら寝てみたいミャ〜',
    text_en: "I'd love to sleep in a hammock, too.",
    type: 'conversational',
  },
  {
    id: 'cat_025_03',
    animation: 'sleep',
    text_jp: '... ... ...',
    text_en: '.........',
    type: 'conversational',
    next_script_id: 'cat_025_04',
  },
  {
    id: 'cat_025_04',
    expression: 'happy',
    text_jp: '...ごめんミャ\n想像してたら寝ちゃったミャ',
    text_en: '...Sorry.\nI imagined it and took a nap.',
    type: 'conversational',
  },
  {
    id: 'cat_026_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '乗るならどっちがいいミャ？',
    text_en: 'Which do you want to ride on?',
    type: 'selectional',
    answer_var: 'ferris_coaster',
    option_1_jp: '観覧車',
    option_1_en: 'Ferris wheel',
    option_2_jp: 'ジェットコースター',
    option_2_en: 'Roller coaster',
    case: 'ferris_coaster',
    next_script_id_1: 'cat_026_02',
    next_script_id_2: 'cat_026_03',
  },
  {
    id: 'cat_026_02',
    expression: 'happy',
    text_jp: '賛成ミャ\n{pet_name}も\n高いところが大好きミャ★',
    text_en: 'I agree. I love high places too!',
    type: 'conversational',
  },
  {
    id: 'cat_026_03',
    animation: 'surprised',
    text_jp: '勇気あるミャ〜\n{pet_name}は\n怖いので遠慮しとくミャ...',
    text_en: "You're very brave.I'm scared, so I'll pass.",
    type: 'conversational',
  },
  {
    id: 'cat_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'どっちが食べたいミャ？',
    text_en: 'Which do you want to eat?',
    type: 'selectional',
    answer_var: 'oyako_don',
    option_1_jp: '親子丼',
    option_1_en: 'Oyako-don',
    option_2_jp: '鮭イクラ丼',
    option_2_en: 'Salmon ikura-don',
    case: 'oyako_don',
    next_script_id_1: 'cat_027_02',
    next_script_id_2: 'cat_027_03',
  },
  {
    id: 'cat_027_02',
    expression: 'happy',
    text_jp: 'とろとろ卵の親子丼、\nたまらないミャ〜',
    text_en: "Oyako-don with half-boiled egg, that's irresistible!.",
    type: 'conversational',
  },
  {
    id: 'cat_027_03',
    expression: 'happy',
    text_jp: 'ねっとり鮭にぷちぷちイクラ\n最高の組み合わせミャ〜',
    text_en: "Salmon and ikura, that's a perfect combination!",
    type: 'conversational',
    next_script_id: 'cat_027_04',
  },
  {
    id: 'cat_027_04',
    expression: 'normal',
    text_jp: 'ん？\n鮭とイクラも親子じゃないミャ？',
    text_en: 'Wait. Aren\'t salmon and ikura also "Oyako?"',
    type: 'conversational',
  },
  {
    id: 'cat_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n体やわらかいミャ？かたいミャ？',
    text_en: 'Is your body flexible?',
    type: 'selectional',
    answer_var: 'body_flexibility',
    option_1_jp: 'やわらかい',
    option_1_en: 'Flexible',
    option_2_jp: 'かたい',
    option_2_en: 'Not flexible',
    case: 'body_flexibility',
    next_script_id_1: 'cat_028_02',
    next_script_id_2: 'cat_028_04',
  },
  {
    id: 'cat_028_02',
    expression: 'happy',
    text_jp: '{pet_name}\nもミャ〜',
    text_en: 'Me too~~~.',
    type: 'conversational',
    next_script_id: 'cat_028_03',
  },
  {
    id: 'cat_028_03',
    animation: 'play',
    text_jp: 'ほら\nもうふにゃふにゃミャ★',
    text_en: "See? I'm almost squishy.",
    type: 'conversational',
  },
  {
    id: 'cat_028_04',
    animation: 'surprised',
    text_jp: '体かたいんだミャ\nお酢ミャ！お酢を飲むミャ！',
    text_en: "Oh, you're not flexible.\nVinegar! Try drinking vinegar!",
    type: 'conversational',
  },
  {
    id: 'cat_029_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n苦手なスポーツはあるミャ？',
    text_en: 'Are there any sports you are not good at?',
    type: 'descriptive',
    answer_var: 'sports_not_good_at',
    question_jp: '苦手なスポーツ',
    question_en: "Sports you're not good at",
    max_len: 14,
    next_script_id: 'cat_029_02',
  },
  {
    id: 'cat_029_02',
    expression: 'normal',
    text_jp: 'そうミャ〜\n{pet_name}は\n水泳が苦手ミャ...',
    text_en: "I see.\nI'm not good at swimming.",
    type: 'conversational',
    next_script_id: 'cat_029_03',
  },
  {
    id: 'cat_029_03',
    expression: 'sad',
    text_jp: '体毛が水を吸収しちゃうから\n沈んじゃうミャ...',
    text_en: 'I sink when I swim because my body hair absorbs water...',
    type: 'conversational',
  },
  {
    id: 'cat_030_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きな味噌汁の具は何ミャ？',
    text_en: 'What is your favorite miso soup?',
    type: 'descriptive',
    answer_var: 'miso_soup',
    question_jp: '好きな味噌汁の具',
    question_en: 'Favorite miso soup',
    max_len: 14,
    next_script_id: 'cat_030_02',
  },
  {
    id: 'cat_030_02',
    expression: 'happy',
    text_jp: '{miso_soup}の\n味噌汁が好きミャ〜',
    text_en: 'Ok, you like miso soup with\n{miso_soup}.',
    type: 'conversational',
    next_script_id: 'cat_030_03',
  },
  {
    id: 'cat_030_03',
    expression: 'happy',
    text_jp: '{pet_name}は\n豚汁を冷まして飲むのが好みミャ',
    text_en: 'In my case, I like to eat cold "Tonjiru".',
    type: 'conversational',
  },
  {
    id: 'cat_031_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n休みの日は何をしてるミャ？',
    text_en: 'What do you do on your days off?',
    type: 'descriptive',
    answer_var: 'holiday_todo',
    question_jp: '休みの日何してる？',
    question_en: 'What do you do on your days off?',
    max_len: 14,
    next_script_id: 'cat_031_02',
  },
  {
    id: 'cat_031_02',
    expression: 'happy',
    text_jp: '{holiday_todo}？\nそうミャ〜',
    text_en: '{holiday_todo}?\nOh, I see.',
    type: 'conversational',
    next_script_id: 'cat_031_03',
  },
  {
    id: 'cat_031_03',
    animation: 'joy',
    text_jp: '{pet_name}は\nひたすらゴロゴロする、\nこれに限るミャ',
    text_en: 'For me, spending a lazy time is the best.',
    type: 'conversational',
  },
  {
    id: 'cat_032_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n得意な教科は何ミャ？',
    text_en: 'What is your best school subject?',
    type: 'descriptive',
    answer_var: 'favorite_subject',
    question_jp: '好きな教科',
    question_en: 'Favorite subject',
    max_len: 10,
    next_script_id: 'cat_032_02',
  },
  {
    id: 'cat_032_02',
    expression: 'happy',
    text_jp: '{favorite_subject}ミャ〜',
    text_en: '{favorite_subject}?',
    type: 'conversational',
    next_script_id: 'cat_032_03',
  },
  {
    id: 'cat_032_03',
    animation: 'play',
    text_jp: '{pet_name}は\nもちろん体育ミャ！\n特に高跳びは自信あるミャ',
    text_en: 'I am of course PE!\nI am especially confident in the high jump.',
    type: 'conversational',
  },
  {
    id: 'cat_033_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'トランプするなら\nなんのゲームがいいミャ？',
    text_en: 'If you play cards, what game would you like to play?',
    type: 'descriptive',
    answer_var: 'favorite_card_game',
    question_jp: '好きなトランプゲーム',
    question_en: 'Favorite card game',
    max_len: 10,
    next_script_id: 'cat_033_02',
  },
  {
    id: 'cat_033_02',
    expression: 'happy',
    text_jp: '{favorite_card_game}ミャ〜\n{pet_name}は',
    text_en: '{favorite_card_game}?',
    type: 'conversational',
    next_script_id: 'cat_033_03',
  },
  {
    id: 'cat_033_03',
    animation: 'play',
    text_jp: '"スピード"ミャ\n反射神経なら負けないミャ！',
    text_en: 'I like to play "Speed." I can\'t lose when it comes to reflexes!',
    type: 'conversational',
  },
  {
    id: 'cat_034_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きなピアノ曲は何ミャ？',
    text_en: 'What is your favorite piano song?',
    type: 'descriptive',
    answer_var: 'piano_song',
    question_jp: '好きなピアノ曲',
    question_en: 'Favorite piano song',
    max_len: 10,
    next_script_id: 'cat_034_02',
  },
  {
    id: 'cat_034_02',
    expression: 'happy',
    text_jp: '{piano_song}ミャ〜\n{pet_name}の\n好きな曲は"ラ・カンパネラ"ミャ',
    text_en: 'Hm, {piano_song}\nMy favorite is "La Campanella."',
    type: 'conversational',
    next_script_id: 'cat_034_03',
  },
  {
    id: 'cat_034_03',
    animation: 'angry',
    text_jp: 'ついでに嫌いな曲は\n"ネコふんじゃった"ミャ！',
    text_en: 'And by the way, my least favorite is "I Stepped on the Cat."',
    type: 'conversational',
  },
  {
    id: 'cat_035_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きなTV番組は何ミャ？',
    text_en: 'What is your favorite TV show?',
    type: 'descriptive',
    answer_var: 'favorite_tv_show',
    question_jp: '好きなTV番組',
    question_en: 'Favorite TV show',
    max_len: 12,
    next_script_id: 'cat_035_02',
  },
  {
    id: 'cat_035_02',
    expression: 'normal',
    text_jp: '{favorite_tv_show}？\nそれ、面白いミャ？',
    text_en: '{favorite_tv_show}?\nIs that fun?',
    type: 'conversational',
    next_script_id: 'cat_035_03',
  },
  {
    id: 'cat_035_03',
    expression: 'happy',
    text_jp: '{pet_name}は\n"やっぱりネコが好き"が好きミャ',
    text_en: 'I love the show "I still like cats."',
    type: 'conversational',
    next_script_id: 'cat_035_04',
  },
  {
    id: 'cat_035_04',
    expression: 'normal',
    text_jp: '...古いミャ？',
    text_en: 'Is it too old?',
    type: 'conversational',
  },
  {
    id: 'cat_036_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\nどんな髪型ミャ？',
    text_en: 'What is your hairstyle?',
    type: 'descriptive',
    answer_var: 'hair_style',
    question_jp: 'あなたの髪型',
    question_en: 'Your hairstyle',
    max_len: 14,
    next_script_id: 'cat_036_02',
  },
  {
    id: 'cat_036_02',
    expression: 'happy',
    text_jp:
      '{hair_style}っていう\n髪型だったミャ\nとってもオシャレだと思うミャ★',
    text_en:
      'I see that the haircut is called {hair_style}.\nI think it is very stylish.',
    type: 'conversational',
  },
  {
    id: 'cat_037_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次のうちネコにはない\n血液型はどれミャ？',
    text_en: 'Which of the following blood types is not found in cats?',
    type: 'selectional',
    answer_var: 'cat_blood',
    option_1_jp: 'A型',
    option_1_en: 'Type-A',
    option_2_jp: 'B型',
    option_2_en: 'Type-B',
    option_3_jp: 'O型',
    option_3_en: 'Type-O',
    case: 'cat_blood',
    next_script_id_1: 'cat_037_02',
    next_script_id_2: 'cat_037_02',
    next_script_id_3: 'cat_037_03',
  },
  {
    id: 'cat_037_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\nってことは正解はあれミャ',
    text_en: 'Incorrect... That means the one is the right answer.',
    type: 'conversational',
  },
  {
    id: 'cat_037_03',
    expression: 'happy',
    text_jp: '正解ミャ〜\nネコにはA型、B型、AB型しかなく\nO型は存在しないミャ',
    text_en: 'Correct!\nCats have only type A, B, and AB; there is no type O.',
    type: 'conversational',
  },
  {
    id: 'cat_038_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコが汗をかくのは鼻の周りと\nもう1箇所はどこミャ？',
    text_en: 'Where does the cat sweat, around the nose and one other spot?',
    type: 'selectional',
    answer_var: 'cat_sweat',
    option_1_jp: '肉球',
    option_1_en: 'Paws',
    option_2_jp: 'しっぽ',
    option_2_en: 'Tail',
    option_3_jp: '耳',
    option_3_en: 'Ears',
    case: 'cat_sweat',
    next_script_id_1: 'cat_038_03',
    next_script_id_2: 'cat_038_02',
    next_script_id_3: 'cat_038_02',
  },
  {
    id: 'cat_038_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\nまたくるミャ',
    text_en: 'Incorrect... Please try again.',
    type: 'conversational',
  },
  {
    id: 'cat_038_03',
    expression: 'happy',
    text_jp: '正解ミャ〜\nそこにしか汗腺がないので\n体温調整は苦手ミャ',
    text_en:
      "Correct! Since they are only sweat glands, I'm not good at regulating body temperature.",
    type: 'conversational',
  },
  {
    id: 'cat_039_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコが通るための出入口、\nキャットドア\n誰が発明したと思うミャ？',
    text_en:
      'Who do you think invented the cat door, a doorway for cats to pass through?',
    type: 'selectional',
    answer_var: 'cat_door',
    option_1_jp: 'エジソン',
    option_1_en: 'Edison',
    option_2_jp: 'ニュートン',
    option_2_en: 'Newton',
    option_3_jp: 'ノーベル',
    option_3_en: 'Nobel',
    case: 'cat_door',
    next_script_id_1: 'cat_039_02',
    next_script_id_2: 'cat_039_03',
    next_script_id_3: 'cat_039_02',
  },
  {
    id: 'cat_039_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\n難しかったミャ〜',
    text_en: 'Incorrect... Was that too hard?',
    type: 'conversational',
  },
  {
    id: 'cat_039_03',
    expression: 'happy',
    text_jp: '正解ミャ〜',
    text_en: 'Correct!',
    type: 'conversational',
    next_script_id: 'cat_039_04',
  },
  {
    id: 'cat_039_04',
    animation: 'joy',
    text_jp:
      'ニュートンはペット好きだったけど\n毎回ドアの開け閉めが面倒で\nキャットドアを発明したそうミャ',
    text_en:
      'Newton was a cat lover, but he had to open and close the door every time, so he invented the cat door.',
    type: 'conversational',
  },
  {
    id: 'cat_040_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次のうちネコが食べられないもの\nはどれミャ？',
    text_en: 'Which of the following is NOT edible for cats?',
    type: 'selectional',
    answer_var: 'cat_alergy',
    option_1_jp: 'チョコレート',
    option_1_en: 'Chocolate',
    option_2_jp: 'アボカド',
    option_2_en: 'Avocado',
    option_3_jp: 'にんにく',
    option_3_en: 'Garlic',
    case: 'cat_alergy',
    next_script_id_1: 'cat_040_02',
    next_script_id_2: 'cat_040_02',
    next_script_id_3: 'cat_040_02',
  },
  {
    id: 'cat_040_02',
    expression: 'normal',
    text_jp: '正解は...',
    text_en: 'The correct answer is...',
    type: 'conversational',
    next_script_id: 'cat_040_03',
  },
  {
    id: 'cat_040_03',
    expression: 'happy',
    text_jp:
      '全部食べられないミャ★\n他にもネギやナッツもNGミャ\n...偏食ってわけではないミャ',
    text_en:
      'All of them!\nOther foods such as green onions and nuts are also inedible...',
    type: 'conversational',
  },
  {
    id: 'cat_041_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'エベレストより高い山\nってあるミャ？',
    text_en: 'Is there a mountain higher than Everest?',
    type: 'selectional',
    answer_var: 'higher_everest',
    option_1_jp: 'ある',
    option_1_en: 'Yes',
    option_2_jp: 'ない',
    option_2_en: 'No',
    case: 'higher_everest',
    next_script_id_1: 'cat_041_03',
    next_script_id_2: 'cat_041_02',
  },
  {
    id: 'cat_041_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\nそう、エベレストより高い山は\nあるんだミャ',
    text_en: 'Incorrect... Yes, there is!',
    type: 'conversational',
  },
  {
    id: 'cat_041_03',
    expression: 'happy',
    text_jp:
      '正解ミャ〜\nハワイのマウナ・ケア山は\n海底から測ると10,203mもあるミャ',
    text_en:
      'Correct! Mauna Kea in Hawaii is 10,203 meters when measured from the ocean floor.',
    type: 'conversational',
    next_script_id: 'cat_041_04',
  },
  {
    id: 'cat_041_04',
    animation: 'surprised',
    text_jp: '海水を全部抜いたらエベレストより\n高いので、世界一になるミャ★',
    text_en:
      'If all the seawater were removed, it would be higher than Mount Everest.',
    type: 'conversational',
  },
  {
    id: 'cat_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '次のうちネコ嫌いなのにネコの\n名前にもなった人物は誰ミャ？',
    text_en: "Who of the following is a cat hater but also a cat's namesake?",
    type: 'selectional',
    answer_var: 'cat_dislike_history',
    option_1_jp: 'アレキサンダー',
    option_1_en: 'Alexander',
    option_2_jp: 'シーザー',
    option_2_en: 'Caesar',
    option_3_jp: 'ナポレオン',
    option_3_en: 'Napoleon',
    case: 'cat_dislike_history',
    next_script_id_1: 'cat_042_02',
    next_script_id_2: 'cat_042_02',
    next_script_id_3: 'cat_042_03',
  },
  {
    id: 'cat_042_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\n残念だったミャ',
    text_en: 'Incorrect... Please try again.',
    type: 'conversational',
  },
  {
    id: 'cat_042_03',
    expression: 'happy',
    text_jp:
      '正解ミャ〜\nナポレオンは恐怖症に近いくらい\nネコが苦手だったみたいミャ',
    text_en: 'Correct! Napoleon seems to have had a near phobia of cats.',
    type: 'conversational',
    next_script_id: 'cat_042_04',
  },
  {
    id: 'cat_042_04',
    expression: 'happy',
    text_jp:
      'でもミヌエットと呼ばれるネコは昔\nナポレオンという名前だったミャ\n皮肉なものミャ',
    text_en:
      "But the cat called Minuet used to be called Napoleon. It's ironic, isn't it?",
    type: 'conversational',
  },
  {
    id: 'cat_043_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '気分がいいので',
    text_en: 'I feel so good and',
    type: 'conversational',
    next_script_id: 'cat_043_02',
  },
  {
    id: 'cat_043_02',
    animation: 'play',
    text_jp: 'ちょっと踊りたい気分ミャ♪',
    text_en: 'I feel like dancing a little!',
    type: 'conversational',
  },
  {
    id: 'cat_044_01',
    move_to: 'c',
    animation: 'joy',
    text_jp: '★#$%&=¥@♪〜\n...文字化けじゃないミャ',
    text_en: "★#$%&=¥@♪〜\n...It's not garbled.",
    type: 'conversational',
    next_script_id: 'cat_044_02',
  },
  {
    id: 'cat_044_02',
    animation: 'sleep',
    text_jp: 'マタタビ嗅いだらなんだか\n変な感じミャ〜',
    text_en: 'I smelled the matatabi and am feeling strange~.',
    type: 'conversational',
  },
  {
    id: 'cat_045_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '空き箱があったら\nどんなに小さくても',
    text_en: 'If I find an empty box,',
    type: 'conversational',
    next_script_id: 'cat_045_02',
  },
  {
    id: 'cat_045_02',
    expression: 'happy',
    text_jp: 'とりあえず入ってみること\nにしてるミャ',
    text_en: 'I try to get in it no matter how small it is.',
    type: 'conversational',
  },
  {
    id: 'cat_046_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'カリカリは大好物なので\n常に切らさないでほしいミャ',
    text_en:
      "I'm a big fan of crunchies. I don't want them to run out all the time.",
    type: 'conversational',
    next_script_id: 'cat_046_02',
  },
  {
    id: 'cat_046_02',
    animation: 'surprised',
    text_jp: 'カリカリは切らしたらだめミャ\n..大事なことだから2回言ったミャ',
    text_en:
      "Don't rung out crunchies. I said twice because it's very important.",
    type: 'conversational',
  },
  {
    id: 'cat_047_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'いつかほしいもの第1位は\nレイバンのサングラスミャ',
    text_en: 'The number one thing I want someday is a teardrop sunglasses.',
    type: 'conversational',
    next_script_id: 'cat_047_02',
  },
  {
    id: 'cat_047_02',
    expression: 'happy',
    text_jp: '...きっと似合うミャ\n鬼シブになるにちがいないミャ',
    text_en: "...I'm sure it will suit me. I'll be really cool.",
    type: 'conversational',
  },
  {
    id: 'cat_048_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'zzZ zzZ zzZ…',
    text_en: 'zzZ zzZ zzZ....',
    type: 'conversational',
    next_script_id: 'cat_048_02',
  },
  {
    id: 'cat_048_02',
    animation: 'sleep',
    text_jp: '...なんか用ミャ？\n寝ながらで失礼するミャ',
    text_en: '...Anything else? Excuse me as I lie down.',
    type: 'conversational',
  },
  {
    id: 'cat_049_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '"食べるラー油"っていうけれど',
    text_en: 'It\'s called "eating raayu," but',
    type: 'conversational',
    next_script_id: 'cat_049_02',
  },
  {
    id: 'cat_049_02',
    animation: 'surprised',
    text_jp: 'ラー油は元から食べ物だと思うミャ',
    text_en: 'I think raayu is a food from the start.',
    type: 'conversational',
  },
  {
    id: 'cat_050_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコよけのペットボトル、\nあれ、意味ないミャ',
    text_en:
      'You should stop using plastic bottles to keep cats away, because they are useless.',
    type: 'conversational',
    next_script_id: 'cat_050_02',
  },
  {
    id: 'cat_050_02',
    expression: 'happy',
    text_jp: 'とっくの昔に慣れてるので\n怖くもなんともないミャ★',
    text_en: "It's not scary because we got used to it a long time ago.",
    type: 'conversational',
  },
  {
    id: 'cat_051_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '銀行に大体観葉植物が\n置いてあるのには理由があるミャ',
    text_en: 'There is a reason why there are usually houseplants in banks.',
    type: 'conversational',
    next_script_id: 'cat_051_02',
  },
  {
    id: 'cat_051_02',
    animation: 'anxious',
    text_jp: 'もしも銀行強盗が入った時に\n犯人の身長の目安にするためミャ',
    text_en:
      'If a bank were robbed, this would be used as a guide to the height of the bank robber.',
    type: 'conversational',
    next_script_id: 'cat_051_03',
  },
  {
    id: 'cat_051_03',
    expression: 'normal',
    text_jp: 'だから高さは170cmに\n統一されてるらしいミャ',
    text_en: "That's why the height is always 170cm.",
    type: 'conversational',
  },
  {
    id: 'cat_052_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコの身体能力は\nめちゃめちゃ高いミャ',
    text_en: "Cats' physical ability is extremely high.",
    type: 'conversational',
    next_script_id: 'cat_052_02',
  },
  {
    id: 'cat_052_02',
    animation: 'play',
    text_jp: '身長の5〜7倍ジャンプできるし、\n走れば時速48kmくらい出るミャ',
    text_en:
      'I can jump five to seven times my height. I can run about 48 km/h.',
    type: 'conversational',
    next_script_id: 'cat_052_03',
  },
  {
    id: 'cat_052_03',
    expression: 'happy',
    text_jp: 'すごいミャ？',
    text_en: 'Surprised?',
    type: 'conversational',
  },
  {
    id: 'cat_053_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '人間の指紋に同じものが\nないのと同じで、ネコの\n鼻の形はどれも違うミャ',
    text_en:
      "Just as no two human fingerprints are the same, every cat's nose is different.",
    type: 'conversational',
    next_script_id: 'cat_053_02',
  },
  {
    id: 'cat_053_02',
    expression: 'happy',
    text_jp: '鼻紋、と言われるミャ\n{pet_name}の\n鼻はどうミャ？',
    text_en: 'That\'s been called "Nose prints."\nHow is my nose?',
    type: 'conversational',
    next_script_id: 'cat_053_03',
  },
  {
    id: 'cat_053_03',
    expression: 'happy',
    text_jp: 'ん？鼻がないって？\n心の目で見るミャ★',
    text_en:
      "You say I don't have a nose?\nNo way, let's look with your mind eye.",
    type: 'conversational',
  },
  {
    id: 'cat_054_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネコは振動に敏感なので',
    text_en: 'Cats are sensitive to vibration and',
    type: 'conversational',
    next_script_id: 'cat_054_02',
  },
  {
    id: 'cat_054_02',
    expression: 'happy',
    text_jp: '人間より早く地震を\n察知することができるミャ★',
    text_en: 'can detect earthquakes earlier than humans.',
    type: 'conversational',
  },
  {
    id: 'cat_055_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}は\n好きな人はいるミャ？',
    text_en: 'Do you have someone you love?',
    type: 'selectional',
    answer_var: 'love_someone',
    option_1_jp: 'いる',
    option_1_en: 'Yes',
    option_2_jp: 'いない',
    option_2_en: 'No',
    case: 'love_someone',
    next_script_id_1: 'cat_055_02',
    next_script_id_2: 'cat_055_03',
  },
  {
    id: 'cat_055_02',
    expression: 'happy',
    text_jp: 'そうミャ〜〜〜\n愛のある生活っていいミャ★',
    text_en: 'Ok, ok, ok.\nIt should be great a life with love.',
    type: 'conversational',
  },
  {
    id: 'cat_055_03',
    expression: 'normal',
    text_jp: 'へえ、いないんミャね',
    text_en: "Well, you don't have one?",
    type: 'conversational',
    next_script_id: 'cat_055_04',
  },
  {
    id: 'cat_055_04',
    animation: 'joy',
    text_jp: '...{pet_name}を\n好きになってもいいミャよ？',
    text_en: '...Then, you can love me now.',
    type: 'conversational',
  },
  {
    id: 'cat_056_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '辛いものは好きミャ？',
    text_en: 'Do you like spicy foods?',
    type: 'selectional',
    answer_var: 'spicy_foods',
    option_1_jp: '好き',
    option_1_en: 'Like',
    option_2_jp: '好きじゃない',
    option_2_en: "Don't like",
    case: 'spicy_foods',
    next_script_id_1: 'cat_056_02',
    next_script_id_2: 'cat_056_03',
  },
  {
    id: 'cat_056_02',
    expression: 'very_sad',
    text_jp: 'そうミャ〜\n{pet_name}は\n辛いもの食べられないミャ...',
    text_en: "I see. I can't eat spicy foods...",
    type: 'conversational',
    next_script_id: 'cat_056_04',
  },
  {
    id: 'cat_056_03',
    expression: 'very_sad',
    text_jp: 'そうミャ〜\n{pet_name}も\n辛いもの食べられないミャ...',
    text_en: "I see. I can't eat spicy foods too...",
    type: 'conversational',
    next_script_id: 'cat_056_04',
  },
  {
    id: 'cat_056_04',
    expression: 'happy',
    text_jp: 'でも一度カレーというやつを\n食べてみたいミャ...！',
    text_en: 'But one day I want to try curry!',
    type: 'conversational',
  },
  {
    id: 'cat_057_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '宝くじを買うなら\n連番、バラどっちでで買うミャ？',
    text_en:
      'If you buy lottery tickets, do you buy them in sequential numbers or in loose lots?',
    type: 'selectional',
    answer_var: 'buy_lottery',
    option_1_jp: '連番',
    option_1_en: 'Sequential number',
    option_2_jp: 'バラ',
    option_2_en: 'Loose lots',
    case: 'buy_lottery',
    next_script_id_1: 'cat_057_02',
    next_script_id_2: 'cat_057_03',
  },
  {
    id: 'cat_057_02',
    expression: 'happy',
    text_jp: '堅実派ミャ〜\n10枚買えば最低300円は\n回収できるミャ',
    text_en:
      "You're so realistic. If you buy 10 tickets, you can collect at least ¥300. ",
    type: 'conversational',
  },
  {
    id: 'cat_057_03',
    animation: 'surprised',
    text_jp:
      'チャレンジャーミャね〜\nでも当選確認の時の楽しみが\n増えるというメリットもあるミャ',
    text_en:
      "You're such a challenger! But it's a lot of fun when you confirm your winnings. ",
    type: 'conversational',
  },
  {
    id: 'cat_058_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '映画は字幕で観る派ミャ？\n吹き替えで観る派ミャ？',
    text_en: 'Do you watch movies with subtitles? Or dubbed?',
    type: 'selectional',
    answer_var: 'subtitle_dub',
    option_1_jp: '字幕派',
    option_1_en: 'Subtitle',
    option_2_jp: '吹き替え派',
    option_2_en: 'Dubbed',
    case: 'subtitle_dub',
    next_script_id_1: 'cat_058_02',
    next_script_id_2: 'cat_058_03',
  },
  {
    id: 'cat_058_02',
    expression: 'happy',
    text_jp: '字幕派ミャ〜\n{pet_name}は\n字幕だと大体途中で寝るミャ',
    text_en:
      'Hm, you watch with subtitles. With subtitles, I usually fall asleep...',
    type: 'conversational',
  },
  {
    id: 'cat_058_03',
    expression: 'happy',
    text_jp: '吹き替え派ミャ〜\n{pet_name}も\n楽なので吹き替え推しミャ',
    text_en:
      "Hm, you like dubbed ones. I like that too because it's too easy~.",
    type: 'conversational',
  },
  {
    id: 'cat_059_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きなお弁当のおかずは何ミャ？',
    text_en: 'What is your favorite bento side dish?',
    type: 'descriptive',
    answer_var: 'bento_side_dish',
    question_jp: '好きなお弁当の具',
    question_en: 'Favorite bento side dish',
    max_len: 14,
    next_script_id: 'cat_059_02',
  },
  {
    id: 'cat_059_02',
    expression: 'happy',
    text_jp: '{bento_side_dish}も\nいいミャね〜',
    text_en: '{bento_side_dish}\nsounds good :)',
    type: 'conversational',
    next_script_id: 'cat_059_03',
  },
  {
    id: 'cat_059_03',
    expression: 'happy',
    text_jp: '{pet_name}は\nソーセージミャ\nタコの形にしてほしいミャ！',
    text_en: 'I like sausages with a shape of octopus!',
    type: 'conversational',
  },
  {
    id: 'cat_060_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}が\nコンビニでつい買っちゃうもの\nは何ミャ？',
    text_en: 'What do you buy usually at convenience stores?',
    type: 'descriptive',
    answer_var: 'conveni_buy',
    question_jp: 'コンビニで買っちゃうもの',
    question_en: 'What you buy at convenience stores',
    max_len: 13,
    next_script_id: 'cat_060_02',
  },
  {
    id: 'cat_060_02',
    expression: 'normal',
    text_jp: '{conveni_buy}ミャ〜',
    text_en: '{conveni_buy}?',
    type: 'conversational',
    next_script_id: 'cat_060_03',
  },
  {
    id: 'cat_060_03',
    expression: 'happy',
    text_jp: '{pet_name}は...\nうーん\n今だったらチーズかまぼこミャ！',
    text_en: "If I were you, I'll buy cheese kamaboko right now!",
    type: 'conversational',
  },
  {
    id: 'cat_061_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'ネコやウマが匂いに反応して\n唇を引き上げる現象を\nなんと呼ぶミャ？',
    text_en:
      "What's the name of phenomenon; cats and horses pulling up their lips in response to a scent?",
    type: 'selectional',
    answer_var: 'cat_lip_up',
    option_1_jp: 'ブレーメン反応',
    option_1_en: 'Bremen ',
    option_2_jp: 'フレーメン反応',
    option_2_en: 'Flehmen',
    option_3_jp: 'イケーメン反応',
    option_3_en: 'Ikemen',
    case: 'cat_lip_up',
    next_script_id_1: 'cat_061_02',
    next_script_id_2: 'cat_061_03',
    next_script_id_3: 'cat_061_02',
  },
  {
    id: 'cat_061_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\nまた挑戦するミャ',
    text_en: 'Incorrect... Please try again.',
    type: 'conversational',
  },
  {
    id: 'cat_061_03',
    expression: 'happy',
    text_jp: '正解ミャ！',
    text_en: 'Correct!',
    type: 'conversational',
    next_script_id: 'cat_061_04',
  },
  {
    id: 'cat_061_04',
    animation: 'surprised',
    text_jp:
      'ネコだったら驚いたような顔、\nウマだったら笑ってるような顔\nになるミャ',
    text_en:
      'If it is a cat, it will look surprised. If it is a horse, it will look like it is laughing.',
    type: 'conversational',
  },
  {
    id: 'cat_062_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '文豪ヘミングウェイの\n飼っていたネコのちょっと\n変わった特徴は何ミャ？',
    text_en:
      'Hemingway, the great writer. What are the unusual characteristics of his cat? ',
    type: 'selectional',
    answer_var: 'hemingway_cat',
    option_1_jp: 'しっぽが2本',
    option_1_en: 'Had 2 tails',
    option_2_jp: 'オッドアイ',
    option_2_en: 'Odd eye',
    option_3_jp: '指が6本',
    option_3_en: 'Had 6 fingers',
    case: 'hemingway_cat',
    next_script_id_1: 'cat_062_02',
    next_script_id_2: 'cat_062_02',
    next_script_id_3: 'cat_062_03',
  },
  {
    id: 'cat_062_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\nまた挑戦するミャ',
    text_en: 'Incorrect... Please try again.',
    type: 'conversational',
  },
  {
    id: 'cat_062_03',
    expression: 'happy',
    text_jp: '正解ミャ！\nその子孫のネコたちは今も\n6本指が遺伝しているミャ★',
    text_en: 'Correct! Their offspring cats still inherit the six fingers.',
    type: 'conversational',
  },
  {
    id: 'cat_063_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '鶏の唐揚げと竜田揚げ\n違いはなんだか知ってるミャ？',
    text_en: 'What is the difference between Tatsuta-age and Kara-age?',
    type: 'selectional',
    answer_var: 'fried_chicken',
    option_1_jp: '粉',
    option_1_en: 'Powder',
    option_2_jp: '調味料',
    option_2_en: 'Seasoning',
    option_3_jp: '卵使用の有無',
    option_3_en: 'Use egg or not',
    case: 'fried_chicken',
    next_script_id_1: 'cat_063_03',
    next_script_id_2: 'cat_063_02',
    next_script_id_3: 'cat_063_02',
  },
  {
    id: 'cat_063_02',
    expression: 'sad',
    text_jp: 'はずれミャ...\n今度はきっと正解するミャ',
    text_en: "Incorrect... Next time, you'll get a right one.",
    type: 'conversational',
  },
  {
    id: 'cat_063_03',
    expression: 'happy',
    text_jp: '正解ミャ！\n唐揚げは小麦粉、\n竜田揚げは片栗粉を使うミャ',
    text_en:
      'Correct! Use flour for Kara-age and potato starch for Tatsuta-age.',
    type: 'conversational',
    next_script_id: 'cat_063_04',
  },
  {
    id: 'cat_063_04',
    expression: 'normal',
    text_jp:
      'と言っても、唐揚げに片栗粉を\n使うこともあるし、最近では\n厳密な違いはないらしいミャ',
    text_en: 'However, there seems to be no strict difference between the two.',
    type: 'conversational',
  },
  {
    id: 'cat_064_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '{player_name}\nなんだかお腹が減ったミャ',
    text_en: "{player_name},\nI'm hungry...",
    type: 'conversational',
  },
  {
    id: 'cat_065_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'お腹すいたミャ\nそろそろご飯の時間ミャ？',
    text_en: 'My stomach is empty.\nIsn\'t it a time for a meal?"',
    type: 'conversational',
  },
  {
    id: 'cat_066_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '{player_name}！\n腹ペコミャ...',
    text_en: "I'm very starving...",
    type: 'conversational',
    next_script_id: 'cat_066_02',
  },
  {
    id: 'cat_066_02',
    expression: 'very_sad',
    text_jp: '食べものがほしいミャ...',
    text_en: 'Please give me a food!',
    type: 'conversational',
  },
  {
    id: 'cat_067_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'ひもじいミャ...',
    text_en: "I'm so hungry...",
    type: 'conversational',
    next_script_id: 'cat_067_02',
  },
  {
    id: 'cat_067_02',
    animation: 'cry',
    text_jp: '空腹感がハンパないミャ...',
    text_en: 'My hunger level is over the top...',
    type: 'conversational',
  },
  {
    id: 'cat_068_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'なんか体毛が茶色く\nなってきたミャ...',
    text_en: 'My fur is colored brown...',
    type: 'conversational',
    next_script_id: 'cat_068_02',
  },
  {
    id: 'cat_068_02',
    expression: 'sad',
    text_jp: '{player_name}\n水浴びしてさっぱりしたいミャ',
    text_en: "{player_name}\nI'd like to clean up myself.",
    type: 'conversational',
  },
  {
    id: 'cat_069_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '最近お風呂入ってないミャ',
    text_en: "I haven't taken a bath lately.",
    type: 'conversational',
    next_script_id: 'cat_069_02',
  },
  {
    id: 'cat_069_02',
    animation: 'anxious',
    text_jp: 'ひとっ風呂浴びたいミャ★',
    text_en: 'I need a hot bath.',
    type: 'conversational',
  },
  {
    id: 'cat_070_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'か、からだがかゆいミャ...',
    text_en: "I'm itchy...",
    type: 'conversational',
    next_script_id: 'cat_070_02',
  },
  {
    id: 'cat_070_02',
    animation: 'surprised',
    text_jp: 'ノ、ノミかもしれないミャ\nシャンプーしてほしいミャ！',
    text_en: 'I, it could be fleas... I need you to shampoo my body.',
    type: 'conversational',
  },
  {
    id: 'cat_071_01',
    expression: 'very_sad',
    move_to: 'c',
    text_jp: 'プ〜ン\nっていう文字が見えるミャ',
    text_en: 'I can see the word, "puh-un."',
    type: 'conversational',
    next_script_id: 'cat_071_02',
  },
  {
    id: 'cat_071_02',
    animation: 'cry',
    text_jp: '不潔にしてるとかわいさも\n下がっちゃうミャ\n...お風呂だミャ！',
    text_en: "My cuteness goes down when I'm filthy...\nBath time!",
    type: 'conversational',
  },
  {
    id: 'cat_072_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}...\n退屈ミャ...',
    text_en: "{player_name}...\nI'm bored...",
    type: 'conversational',
    next_script_id: 'cat_072_02',
  },
  {
    id: 'cat_072_02',
    animation: 'play',
    text_jp: 'オモチャかなんかで遊ぶミャ',
    text_en: "Let's play with toys or something.",
    type: 'conversational',
  },
  {
    id: 'cat_073_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'うたたねして目覚めたから\nなんかさびしいミャ...',
    text_en: "I took a nap and woke up right now. I'm kind of lonely.",
    type: 'conversational',
    next_script_id: 'cat_073_02',
  },
  {
    id: 'cat_073_02',
    animation: 'anxious',
    text_jp: '少しかまってほしいミャ',
    text_en: 'I need a little attention now.',
    type: 'conversational',
  },
  {
    id: 'cat_074_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'なんだか...\nおセンチな気分ミャ...',
    text_en: "I'm feeling somewhat sentimental...",
    type: 'conversational',
    next_script_id: 'cat_074_02',
  },
  {
    id: 'cat_074_02',
    animation: 'anxious',
    text_jp: 'ちょっとすりすりして\nいってほしいミャ！',
    text_en: 'I hope you rubbed up against me a little.',
    type: 'conversational',
  },
  {
    id: 'cat_075_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '...{player_name}\n最近放置プレイがすぎるミャ...',
    text_en: "...{player_name}\nYou've left me alone too much...",
    type: 'conversational',
    next_script_id: 'cat_075_02',
  },
  {
    id: 'cat_075_02',
    animation: 'angry',
    text_jp: 'かまってくれなきゃ\nグレちゃうミャ！',
    text_en: "If you don't take care of me, I'll go crazy...!",
    type: 'conversational',
  },
  {
    id: 'cat_076_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'そろそろトイレに\n連れて行ってほしいミャ',
    text_en: 'Please take me to the bathroom.',
    type: 'conversational',
  },
  {
    id: 'cat_077_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'ちょっともよおしてきた\nみたいミャ',
    text_en: 'I have to urinate a little.',
    type: 'conversational',
  },
  {
    id: 'cat_078_01',
    move_to: 'bc',
    animation: 'surprised',
    text_jp: 'ト、トイレミャ...！\n結構急ぎミャ...！',
    text_en: "B, bathroom...! It's quite urgent...!",
    type: 'conversational',
  },
  {
    id: 'cat_079_01',
    move_to: 'c',
    animation: 'surprised',
    text_jp: 'ハウッ...！',
    text_en: 'Oh, my..!',
    type: 'conversational',
    next_script_id: 'cat_079_02',
  },
  {
    id: 'cat_079_02',
    animation: 'surprised',
    text_jp: '大きいのと小さいのの\n波が同時に来たミャ...！',
    text_en:
      'The big one and the little one came in waves at the same time...!',
    type: 'conversational',
  },
  {
    id: 'cat_080_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '...怖い話を聞いてしまったミャ',
    text_en: '...I heard a scary story.',
    type: 'conversational',
    next_script_id: 'cat_080_02',
  },
  {
    id: 'cat_080_02',
    expression: 'sad',
    text_jp: 'なんか違うことで気をそらせて\nほしいミャ...',
    text_en: 'Please distract me by another thing...',
    type: 'conversational',
  },
  {
    id: 'cat_081_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'テレビの中から幽霊が出てくる\n映画を観たミャ...',
    text_en: 'I watched a movie that a ghost came out of TV...',
    type: 'conversational',
    next_script_id: 'cat_081_02',
  },
  {
    id: 'cat_081_02',
    animation: 'surprised',
    text_jp: 'ブルブル震えるくらい\n怖かったミャ...\nなぐさめるミャ...',
    text_en: 'I was so scared that I was shaking...\nPlease calm me down...',
    type: 'conversational',
  },
  {
    id: 'cat_082_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '...ちょっとめまいするミャ\nもしかして風邪ミャ？',
    text_en: '...I feel dizzy. I may catch a cold.',
    type: 'conversational',
    next_script_id: 'cat_082_02',
  },
  {
    id: 'cat_082_02',
    animation: 'anxious',
    text_jp: 'クスリ、持ってないミャ？',
    text_en: "Don't you have a medicine?",
    type: 'conversational',
  },
  {
    id: 'cat_083_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'なんだか体がだるいミャ...',
    text_en: "I'm feeling kinda woozy...",
    type: 'conversational',
    next_script_id: 'cat_083_02',
  },
  {
    id: 'cat_083_02',
    animation: 'sleep',
    text_jp: '病気かもしれないミャ\nクスリをくれないかミャ？',
    text_en: "I may be sick. Don't you give me a medicine?",
    type: 'conversational',
  },
  {
    id: 'cat_084_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: '何か飲もうとすると\n歯にしみるミャ...',
    text_en: 'When I try to drink something, it stings my teeth.',
    type: 'conversational',
    next_script_id: 'cat_084_02',
  },
  {
    id: 'cat_084_02',
    expression: 'sad',
    text_jp: '痛み止め持ってないかミャ？',
    text_en: "Don't you have a pain killer?",
    type: 'conversational',
  },
  {
    id: 'cat_085_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '歯茎がはれて痛いミャ...',
    text_en: 'My gums are swollen and painful...',
    type: 'conversational',
    next_script_id: 'cat_085_02',
  },
  {
    id: 'cat_085_02',
    expression: 'very_sad',
    text_jp: '歯のクスリ持ってないかミャ...？',
    text_en: 'Do you have any dental drugs?',
    type: 'conversational',
  },
  {
    id: 'cat_086_01',
    move_to: 'c',
    animation: 'sleep',
    text_jp: 'ふぁ〜〜〜\nおネムの時間みたいミャ',
    text_en: "Yawn...\nIt's time to go to bed.",
    type: 'conversational',
    next_script_id: 'cat_086_02',
  },
  {
    id: 'cat_086_02',
    animation: 'waive',
    text_jp: '{player_name}...\nぐっどないとミャ★',
    text_en: '{player_name}...\nGood night.',
    type: 'conversational',
  },
  {
    id: 'cat_087_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ミャミャ？なんか体が\nムズムズするミャ…',
    text_en: 'Hmm. My body is mushy.',
    type: 'conversational',
  },
  {
    id: 'cat_088_01',
    move_to: 'c',
    text_jp: 'しんじゃったミャ〜…\nまさかこんなことになるとはミャ〜',
    text_en: 'I guess I died.\nWhat a cat-astrophe…',
    type: 'conversational',
    next_script_id: 'cat_088_02',
  },
  {
    id: 'cat_088_02',
    text_jp:
      '{player_name}、\n今までどうもありがとうミャ〜\nすっごく楽しかったミャ〜',
    text_en: 'Thanks for everything, {player_name}!\nI had a lot of fun!',
    type: 'conversational',
    next_script_id: 'cat_088_03',
  },
  {
    id: 'cat_088_03',
    text_jp:
      '今度生まれ変わっても、また\n{player_name}の\nところに会いにくるミャ！',
    text_en: 'If I get reborn someday, I’ll come to see you, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'cat_089_01',
    move_to: 'c',
    text_jp: 'これは、あかんやつミャ〜\nこのままいくとしんじゃうやつミャ',
    text_en:
      'This is getting serious…\nI’m going to die if you don’t do something!',
    type: 'conversational',
    next_script_id: 'cat_089_02',
  },
  {
    id: 'cat_089_02',
    text_jp: '万能コロンを使えばなんとか\nなるって、聞いたことがあるミャ！',
    text_en: 'I heard the Magic Potion can fix everything!',
    type: 'conversational',
  },
  {
    id: 'cat_090_01',
    move_to: 'c',
    text_jp: 'おでかけしたいミャね〜\nうん、おでかけしたミャ〜',
    text_en: 'I want to go meowtside!\nLet’s go meowtside!',
    type: 'conversational',
    next_script_id: 'cat_090_02',
  },
  {
    id: 'cat_090_02',
    expression: 'happy',
    text_jp: 'お友だちと一緒に\nひなたぼっこしたいミャ〜',
    text_en: 'I want to lie in the sun with my friend!',
    type: 'conversational',
  },
  {
    id: 'cat_091_01',
    move_to: 'c',
    text_jp: '{friend.player_name}が\nあそびに来てたミャ',
    text_en: '{friend.player_name} came over to play!',
    type: 'conversational',
    next_script_id: 'cat_091_02',
  },
  {
    id: 'cat_091_02',
    animation: 'joy',
    text_jp: 'とっても楽しかったから、\nお礼を言っておいて欲しいミャ！',
    text_en: 'We had a lot of fun, so please say thank you for me!',
    type: 'conversational',
  },
  {
    id: 'cat_092_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n苦手なスポーツを聞いたら、',
    text_en: 'I asked {friend.player_name} what sport they’re not good at!',
    type: 'conversational',
    next_script_id: 'cat_092_02',
  },
  {
    id: 'cat_092_02',
    text_jp: '{friend.sports_not_good_at}って\n言ってたミャ！',
    text_en: 'They said {friend.sports_not_good_at}!',
    type: 'conversational',
    next_script_id: 'cat_092_03',
  },
  {
    id: 'cat_092_03',
    animation: 'play',
    text_jp: '{friend.player_name}にも\n苦手なものがあるなんて\nびっくりミャ！',
    text_en: 'I’m surprised {friend.player_name} is bad at anything!',
    type: 'conversational',
  },
  {
    id: 'cat_093_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな味噌汁の具を聞いたら、',
    text_en:
      'I asked {friend.player_name} what their favorite miso soup ingredient is!',
    type: 'conversational',
    next_script_id: 'cat_093_02',
  },
  {
    id: 'cat_093_02',
    text_jp: '{friend.miso_soup}って\n言ってたミャ！',
    text_en: 'They said it’s {friend.miso_soup}!',
    type: 'conversational',
    next_script_id: 'cat_093_03',
  },
  {
    id: 'cat_093_03',
    expression: 'happy',
    text_jp: '一周回ってこだわりを感じるミャ！',
    text_en: 'What a specific answer!',
    type: 'conversational',
  },
  {
    id: 'cat_094_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nお休みの日に何をしているか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} what they do on their days off!',
    type: 'conversational',
    next_script_id: 'cat_094_02',
  },
  {
    id: 'cat_094_02',
    text_jp: '{friend.holiday_todo}って\n言ってたミャ！',
    text_en: 'They said {friend.holiday_todo}!',
    type: 'conversational',
    next_script_id: 'cat_094_03',
  },
  {
    id: 'cat_094_03',
    animation: 'joy',
    text_jp: '今度一緒にどうミャ？',
    text_en: 'Why not join them sometime?',
    type: 'conversational',
  },
  {
    id: 'cat_095_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n得意な教科を聞いてみたら、',
    text_en:
      'I asked {friend.player_name} what their best subject in school was!',
    type: 'conversational',
    next_script_id: 'cat_095_02',
  },
  {
    id: 'cat_095_02',
    text_jp: '{friend.favorite_subject}って\n言ってたミャ！',
    text_en: 'They said {friend.favorite_subject}!',
    type: 'conversational',
    next_script_id: 'cat_095_03',
  },
  {
    id: 'cat_095_03',
    expression: 'happy',
    text_jp: '隠しきれない知性を\n感じるミャ…！',
    text_en: "They're too smart to hide it!",
    type: 'conversational',
  },
  {
    id: 'cat_096_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}が\n好きなトランプゲームを\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} what their favorite card games is!',
    type: 'conversational',
    next_script_id: 'cat_096_02',
  },
  {
    id: 'cat_096_02',
    text_jp: '{friend.favorite_card_game}って\n言ってたミャ！',
    text_en: 'They said it’s {friend.favorite_card_game}!',
    type: 'conversational',
    next_script_id: 'cat_096_03',
  },
  {
    id: 'cat_096_03',
    expression: 'happy',
    text_jp: '今度一緒にやってみるミャ！',
    text_en: 'You should play together!',
    type: 'conversational',
  },
  {
    id: 'cat_097_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n好きなピアノの曲を聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite piano song is!',
    type: 'conversational',
    next_script_id: 'cat_097_02',
  },
  {
    id: 'cat_097_02',
    text_jp: '{friend.piano_song}って\n言ってたミャ！',
    text_en: 'They said it’s {friend.piano_song} !',
    type: 'conversational',
    next_script_id: 'cat_097_03',
  },
  {
    id: 'cat_097_03',
    expression: 'happy',
    text_jp: '{player_name}も\n知ってる曲かミャ？',
    text_en: 'Do you know it, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'cat_098_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きなテレビ番組を聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite TV show is!',
    type: 'conversational',
    next_script_id: 'cat_098_02',
  },
  {
    id: 'cat_098_02',
    text_jp: '{friend.favorite_tv_show}って\n言ってたミャ！',
    text_en: 'They said it’s {friend.favorite_tv_show}!',
    type: 'conversational',
    next_script_id: 'cat_098_03',
  },
  {
    id: 'cat_098_03',
    text_jp: '{player_name}は\n見たことあるかミャ？',
    text_en: 'Have you seen it, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'cat_099_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n髪型は',
    text_en: '{friend.player_name}’s hairstyle…',
    type: 'conversational',
    next_script_id: 'cat_099_02',
  },
  {
    id: 'cat_099_02',
    text_jp: '{friend.hair_style}って\n言うらしいミャ！',
    text_en: '…is called a {friend.hair_style}!',
    type: 'conversational',
    next_script_id: 'cat_099_03',
  },
  {
    id: 'cat_099_03',
    text_jp: '{player_name}も\n真似するといいミャ！',
    text_en: 'Maybe you could try it out, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'cat_100_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}の\n好きなお弁当のおかずを聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite side dish is!',
    type: 'conversational',
    next_script_id: 'cat_100_02',
  },
  {
    id: 'cat_100_02',
    text_jp: '{friend.bento_side_dish}って\n言ってたミャ！',
    text_en: 'They said it’ s {friend.bento_side_dish}!',
    type: 'conversational',
    next_script_id: 'cat_100_03',
  },
  {
    id: 'cat_100_03',
    expression: 'sad',
    text_jp: 'お弁当の話してたら、\nおなかすいてきたミャ…',
    text_en: 'Talking about food is making me hungry!',
    type: 'conversational',
  },
  {
    id: 'cat_101_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}が\nコンビニでつい買ってしまう\nものを聞いたら、',
    text_en:
      'I asked {friend.player_name} what they buy on impulse at convenience stores!',
    type: 'conversational',
    next_script_id: 'cat_101_02',
  },
  {
    id: 'cat_101_02',
    text_jp: '{friend.conveni_buy}って\n言ってたミャ！',
    text_en: 'They said {friend.conveni_buy}!',
    type: 'conversational',
    next_script_id: 'cat_101_03',
  },
  {
    id: 'cat_101_03',
    expression: 'happy',
    text_jp: '人は本能にはあらがえないミャ…！',
    text_en: 'You can’t fight your instincts!',
    type: 'conversational',
  },
  {
    id: 'cat_102_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nお肉とお魚どっちが\n好きか聞いたら、',
    text_en: 'I asked {friend.player_name} if they prefer meat or fish!',
    type: 'conversational',
    case: 'friend.meat_fish',
    next_script_id_1: 'cat_102_02',
    next_script_id_2: 'cat_102_03',
  },
  {
    id: 'cat_102_02',
    expression: 'happy',
    text_jp: 'お肉って言ってたミャ！\nやはり肉こそ至高ミャ…！',
    text_en: 'They said they prefer meat!\nIt’s the best!',
    type: 'conversational',
  },
  {
    id: 'cat_102_03',
    expression: 'happy',
    text_jp: 'お魚って言ってたミャ！\nオトナな感じがするミャ！',
    text_en: 'They said they prefer fish!\nSeems like the grown-up choice!',
    type: 'conversational',
  },
  {
    id: 'cat_103_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nベッド派か布団派か聞いたら、',
    text_en:
      'I asked {friend.player_name} if they prefer to sleep on a bed or futon!',
    type: 'conversational',
    case: 'friend.bed_futon',
    next_script_id_1: 'cat_103_02',
    next_script_id_2: 'cat_103_03',
  },
  {
    id: 'cat_103_02',
    expression: 'happy',
    text_jp: 'ベッド派って言ってたミャ！\nふと気づくと寝転んでしまミャ！',
    text_en:
      'They said they prefer sleeping on a bed!\nThey’ll be out like a light in no time!',
    type: 'conversational',
  },
  {
    id: 'cat_103_03',
    expression: 'happy',
    text_jp:
      '布団派って言ってたミャ！\n上げ下ろしはめんどくさいけど、\n部屋が広く使えていいミャ！',
    text_en:
      'They said they prefer sleeping on a futon!\nFolding it up and back out is a chore, but it frees up lots of floor space!',
    type: 'conversational',
  },
  {
    id: 'cat_104_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nエアコンと扇風機、\nどっちが好きか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they like air conditioning or a fan better!',
    type: 'conversational',
    case: 'friend.ac_fan',
    next_script_id_1: 'cat_104_02',
    next_script_id_2: 'cat_104_03',
  },
  {
    id: 'cat_104_02',
    expression: 'happy',
    text_jp:
      'エアコンって言ってたミャ！\n風に直接当たらないように\n気をつけるミャ！',
    text_en:
      'They said they like the AC better!\nThey should be careful to stay out of the direct wind!',
    type: 'conversational',
  },
  {
    id: 'cat_104_03',
    expression: 'happy',
    text_jp: '扇風機って言ってたミャ！\nオトナな感じがするミャ！',
    text_en:
      'They said they like a fan better!\nSeems like the grown-up choice!',
    type: 'conversational',
  },
  {
    id: 'cat_105_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nメロンとすいか、どっちが\n好きか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they like melon or watermelon better!',
    type: 'conversational',
    case: 'friend.melon_watermelon',
    next_script_id_1: 'cat_105_02',
    next_script_id_2: 'cat_105_03',
  },
  {
    id: 'cat_105_02',
    expression: 'happy',
    text_jp:
      'メロンって言ってたミャ！\nプレゼント選びの参考に\nするといいミャ！',
    text_en:
      'They said they like melon better!\nThat might help you choose a present for them!',
    type: 'conversational',
  },
  {
    id: 'cat_105_03',
    expression: 'happy',
    text_jp: 'すいかって言ってたミャ！\n今度すいか割りに誘うといいミャ！',
    text_en:
      'They said they like watermelon better!\nThere’s a game in Japan where you break one open blindfolded!',
    type: 'conversational',
  },
  {
    id: 'cat_106_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nハンモックとウォーターベッド、\nどっちで寝てみたいか聞いたら、',
    text_en:
      'I asked if {friend.player_name} would rather sleep in a hammock or a waterbed!',
    type: 'conversational',
    case: 'friend.hammock_waterbed',
    next_script_id_1: 'cat_106_02',
    next_script_id_2: 'cat_106_03',
  },
  {
    id: 'cat_106_02',
    expression: 'happy',
    text_jp:
      'ハンモックって言ってたミャ！\n小さい頃、だれもが一度は\nあこがれるやつミャ！',
    text_en:
      "They said they'd rather sleep in a hammock!\nEveryone’s always wanted to try it once!",
    type: 'conversational',
  },
  {
    id: 'cat_106_03',
    expression: 'happy',
    text_jp:
      'ウォーターベッドって\n言ってたミャ！水が漏れたら\nどうしようって不安になるミャ！',
    text_en:
      "They said they'd rather sleep in a waterbed!\nI’d be scared that it would spring a leak and get me wet!",
    type: 'conversational',
  },
  {
    id: 'cat_107_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n観覧車とジェットコースター\nどっちがいいか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they like ferris wheels or roller coasters better!',
    type: 'conversational',
    case: 'friend.ferris_coaster',
    next_script_id_1: 'cat_107_02',
    next_script_id_2: 'cat_107_03',
  },
  {
    id: 'cat_107_02',
    expression: 'happy',
    text_jp:
      '観覧車って言ってたミャ！\n頂上で「人がゴミのようだ」って\n言うまでがセットミャ！',
    text_en:
      'They said they like ferris wheels better!\nYou have to say "People look like ants" from the top to complete the loop!',
    type: 'conversational',
  },
  {
    id: 'cat_107_03',
    expression: 'happy',
    text_jp: 'ジェットコースターって\n言ってたミャ！\n意外に度胸あるミャ！',
    text_en:
      'They said they roller coasters better!\nThey’re braver than they look!',
    type: 'conversational',
  },
  {
    id: 'cat_108_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n親子丼と鮭イクラ丼\nどっちが食べたいか聞いたら',
    text_en:
      'I asked {friend.player_name} if they like chicken and egg bowls or salmon and salmon roe bowls better!',
    type: 'conversational',
    case: 'friend.oyako_don',
    next_script_id_1: 'cat_108_02',
    next_script_id_2: 'cat_108_03',
  },
  {
    id: 'cat_108_02',
    expression: 'happy',
    text_jp: '親子丼って言ってたミャ！\nおなかすいてきたミャ！',
    text_en:
      'They said they like like chicken and egg bowls better!\nI’m getting hungry!',
    type: 'conversational',
  },
  {
    id: 'cat_108_03',
    expression: 'happy',
    text_jp: '鮭イクラ丼って言ってたミャ！\nおなかすいてきたミャ！',
    text_en:
      'They said they like salmon and salmon roe bowls better!\nI’m getting hungry!',
    type: 'conversational',
  },
  {
    id: 'cat_109_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n体が柔らかいかどうが聞いたら',
    text_en: "I asked {friend.player_name} if they're flexible!",
    type: 'conversational',
    case: 'friend.body_flexibility',
    next_script_id_1: 'cat_109_02',
    next_script_id_2: 'cat_109_03',
  },
  {
    id: 'cat_109_02',
    expression: 'happy',
    text_jp: '柔らかいって言ってたミャ！\nストレッチとかしてるミャかね？',
    text_en:
      "They said they're flexible!\nI wonder if they do yoga or something?",
    type: 'conversational',
  },
  {
    id: 'cat_109_03',
    expression: 'happy',
    text_jp: 'かたいって言ってたミャ！\nお酢でもプレゼントすると\nいいミャ！',
    text_en: "They said they're not flexible!\nYou should help them loosen up!",
    type: 'conversational',
  },
  {
    id: 'cat_110_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きな人がいるかどうか\n聞いたら、',
    text_en:
      'I asked {friend.player_name} if there’s someone they like right now!',
    type: 'conversational',
    case: 'friend.love_someone',
    next_script_id_1: 'cat_110_02',
    next_script_id_2: 'cat_110_03',
  },
  {
    id: 'cat_110_02',
    expression: 'happy',
    text_jp: 'いるって言ってたミャ！\nたぶん{pet_name}の\nことだと思うミャ！',
    text_en: 'They said there is!\nI’ll bet it’s {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'cat_110_03',
    expression: 'normal',
    text_jp:
      '今はいないって言ってたミャ！\nがんばって{pet_name}の\n魅力をアピールしていくミャ！',
    text_en:
      'They said there isn’t!\n{pet_name} will have to turn up the charm!',
    type: 'conversational',
  },
  {
    id: 'cat_111_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n辛いものは好きかどうか聞いたら',
    text_en: 'I asked {friend.player_name} if they like spicy food.',
    type: 'conversational',
    case: 'friend.spicy_foods',
    next_script_id_1: 'cat_111_02',
    next_script_id_2: 'cat_111_03',
  },
  {
    id: 'cat_111_02',
    expression: 'happy',
    text_jp: '好きって言ってたミャ！\n今度、激辛料理の店に\n誘ってみるミャ！',
    text_en:
      'They said they love it!\nYou should go to a super spicy restaurant with them!\n',
    type: 'conversational',
  },
  {
    id: 'cat_111_03',
    text_jp:
      '好きじゃないって言ってたミャ！\n{pet_name}も、辛いもの\n苦手だからちょうどいいミャ！',
    text_en:
      'They said not really!\n{pet_name} isn’t good with spicy food, so it works out!',
    type: 'conversational',
  },
  {
    id: 'cat_112_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n宝くじを買うなら連番か\nバラかどっちで買うか聞いたら',
    text_en:
      'I asked if {friend.player_name} would buy lottery tickets with continuous numbers or random numbers!',
    type: 'conversational',
    case: 'friend.buy_lottery',
    next_script_id_1: 'cat_112_02',
    next_script_id_2: 'cat_112_03',
  },
  {
    id: 'cat_112_02',
    expression: 'happy',
    text_jp: '連番って言ってたミャ！\n堅実で好感が持てるミャ！',
    text_en:
      'They said they’d buy continuous numbers!\nTheir predictable nature is so dependable!',
    type: 'conversational',
  },
  {
    id: 'cat_112_03',
    expression: 'happy',
    text_jp: 'バラって言ってたミャ！\nチャレンジャーで\n好感が持てるミャ！',
    text_en:
      'They said they’d buy random numbers!\nTheir risk-taking nature is so wild!',
    type: 'conversational',
  },
  {
    id: 'cat_113_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n映画は字幕派か吹き替え派か\n聞いたら、',
    text_en:
      'I asked {friend.player_name} if they prefer subtitled or dubbed movies!',
    type: 'conversational',
    case: 'friend.subtitle_dub',
    next_script_id_1: 'cat_113_02',
    next_script_id_2: 'cat_113_03',
  },
  {
    id: 'cat_113_02',
    expression: 'happy',
    text_jp:
      '字幕派だって言ってたミャ！\n一緒に映画観に行くときの\n参考にするといいミャ！',
    text_en:
      'They said they prefer subtitled movies!\nKeep that in mind when you go see a movie together!',
    type: 'conversational',
  },
  {
    id: 'cat_113_03',
    expression: 'happy',
    text_jp:
      '吹き替え派だって言ってたミャ！\n一緒に映画観に行くときの\n参考にするといいミャ！',
    text_en:
      'They said they prefer dubbed movies!\nKeep that in mind when you go see a movie together!',
    type: 'conversational',
  },
  {
    id: 'cat_114_01',
    move_to: 'c',
    text_jp: 'よろしくだミャー。\nむにゃむにゃ…。',
    text_en: 'Good to see you!\nPurr Purr…',
    type: 'conversational',
  },
  {
    id: 'cat_115_01',
    animation: 'waive',
    text_jp: 'あそびに来たミャ〜\n一緒にお昼寝するミャ〜',
    text_en: 'I’m here to play!\nLet’s take a cat nap together.',
    type: 'conversational',
  },
  {
    id: 'cat_116_01',
    animation: 'waive',
    text_jp: 'いらっしゃいミャ〜\nあそぼうミャ〜',
    text_en: 'Welcome! \nLet’s play!',
    type: 'conversational',
  },
  {
    id: 'cat_117_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}、\nすごくいいやつミャから、\n宝物あげるミャ〜',
    text_en:
      'I’m going to give you a treasure because you’re so nice, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'cat_118_01',
    text_jp: 'そろそろ帰るミャね〜\nまたミャ〜',
    text_en: 'I’m going to get going!\nSee you soon!',
    type: 'conversational',
  },
  {
    id: 'cat_119_01',
    text_jp: 'ミャ〜ミャ〜',
    text_en: 'Meow Meow',
    type: 'conversational',
  },
  {
    id: 'cat_120_01',
    text_jp: 'ミャミャ！\n{friend.player_name}が\n帰ってきたみたいミャ！',
    text_en: 'Meow! Meow!\nLooks like {friend.player_name} is back!',
    type: 'conversational',
    next_script_id: 'cat_120_02',
  },
  {
    id: 'cat_120_02',
    text_jp: '今日はこのへんでミャ！\nミャ〜ミャ〜',
    text_en: 'See you later!\nMeow Meow',
    type: 'conversational',
  },
  {
    id: 'cat_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないミャ〜',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'cat_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないミャ〜',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'cat_123_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'それより万能コロンを\nかけて欲しいミャ〜\nこのままじゃ危険ミャ〜',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'cat_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないミャ〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'cat_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったミャ！\nどうもありがとうミャ！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'cat_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったミャ！\nどうもありがとうミャ！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'cat_127_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '助かったミャ〜\nあんな苦しい思いは\n二度とごめんだミャ〜',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'cat_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったミャ…\nもう1回試してみて欲しいミャ〜',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'cat_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったミャ…\nもう1回試してみて欲しいミャ〜',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'cat_130_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったミャ…\nもう1回試してみて欲しいミャ〜',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'whale_001_01',
    move_to: 'c',
    animation: 'waive',
    text_jp: 'あ！\n{player_name}ラ！\n今日も元気ラ？',
    text_en: 'Oh, it’s you, {player_name}!\nHow are you today?',
    type: 'conversational',
  },
  {
    id: 'whale_002_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ちょっとお部屋が乾燥してるラね\nちょっと加湿するラ',
    text_en: 'This room’s a little dry.\nI’ll turn up the humidity.',
    type: 'conversational',
    next_script_id: 'whale_002_02',
  },
  {
    id: 'whale_002_02',
    animation: 'angry',
    text_jp: 'ラララー！',
    text_en: 'TOOT!!',
    type: 'conversational',
  },
  {
    id: 'whale_003_01',
    animation: 'waive',
    text_jp: 'ふりふり',
    text_en: 'Toot Toot!',
    type: 'conversational',
    next_script_id: 'whale_003_02',
  },
  {
    id: 'whale_003_02',
    animation: 'waive',
    text_jp: 'ふりふり',
    text_en: 'ふりふり',
    type: 'conversational',
  },
  {
    id: 'whale_004_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{pet_name}、最近は\nだいぶオトナとしての自覚が\n芽生えてきたラ',
    text_en: '{pet_name} is finally feeling like a grown-up lately.',
    type: 'conversational',
    next_script_id: 'whale_004_02',
  },
  {
    id: 'whale_004_02',
    expression: 'happy',
    text_jp:
      'おやつをもらっても、\n一度に食べきらずにあとの\n楽しみにとっておけるラ！',
    text_en:
      'Even when I get a snack or food, I save some for later and don’t finish it all at once!',
    type: 'conversational',
  },
  {
    id: 'whale_005_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'わーい\n呼んだラ〜？\n何してあそぶラ〜？',
    text_en: 'Toot! \nYou called?\nWhat should we play?',
    type: 'conversational',
  },
  {
    id: 'whale_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ねーねー\n{player_name}',
    text_en: 'Hey, {player_name}!',
    type: 'conversational',
    next_script_id: 'whale_006_02',
  },
  {
    id: 'whale_006_02',
    expression: 'happy',
    text_jp: '呼んだだけラ〜',
    text_en: 'I just like saying your name!',
    type: 'conversational',
  },
  {
    id: 'whale_007_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: 'またお部屋をびしょ濡れに\nしてしまったラ…',
    text_en: 'I soaked the room again…',
    type: 'conversational',
    next_script_id: 'whale_007_02',
  },
  {
    id: 'whale_007_02',
    expression: 'sad',
    text_jp: '{player_name}、\nごめんラ…',
    text_en: 'Sorry, {player_name}…',
    type: 'conversational',
  },
  {
    id: 'whale_008_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '喉の乾燥にはハチミツがいいのラ！',
    text_en: 'Honey is good for a dry throat!',
    type: 'conversational',
    next_script_id: 'whale_008_02',
  },
  {
    id: 'whale_008_02',
    expression: 'sad',
    text_jp: 'ついついなめすぎてしまうのが\n玉にキズラ…',
    text_en: 'It’s hard to stop eating it when you start, though…',
    type: 'conversational',
  },
  {
    id: 'whale_009_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'いま、何時ラ？',
    text_en: 'What time is it?',
    type: 'conversational',
    next_script_id: 'whale_009_02',
  },
  {
    id: 'whale_009_02',
    animation: 'joy',
    text_jp: '9時ラ！',
    text_en: 'You tell time very WHALE!',
    type: 'conversational',
    next_script_id: 'whale_009_03',
  },
  {
    id: 'whale_009_03',
    expression: 'happy',
    text_jp: '…\n……\nなんて、さすがに言わないラよ…',
    text_en: '…\n……\nDid you get the joke?',
    type: 'conversational',
  },
  {
    id: 'whale_010_01',
    animation: 'surprised',
    text_jp: 'わっ！',
    text_en: 'TOOT!',
    type: 'conversational',
    next_script_id: 'whale_010_02',
  },
  {
    id: 'whale_010_02',
    expression: 'sad',
    text_jp:
      '急に呼ぶからびっくりしたラー\n{pet_name}を呼ぶときには\n事前に一声かけて欲しいラ',
    text_en: 'You scared me!\nLet {pet_name} know before you call me!',
    type: 'conversational',
  },
  {
    id: 'whale_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海はなんで青いか知ってるラ？',
    text_en: 'Do you know why the ocean is blue?',
    type: 'conversational',
    next_script_id: 'whale_011_02',
  },
  {
    id: 'whale_011_02',
    text_jp:
      '光が海の水の中を通るとき、\n波長の長い赤や黄色は海水に\n吸収されるラ',
    text_en:
      'When light goes through seawater, it blocks higher frequency light waves like red and yellow.',
    type: 'conversational',
    next_script_id: 'whale_011_03',
  },
  {
    id: 'whale_011_03',
    text_jp:
      '吸収されずに残った青い光が\n海の中の細かい粒に反射されて\n青く見えるラ',
    text_en:
      'The blue light that isn’t absorbed reflects off particles in the ocean, making it look blue!',
    type: 'conversational',
  },
  {
    id: 'whale_012_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海の深さはどれくらいか\n知ってるラ？',
    text_en: 'Do you know how deep the ocean is?',
    type: 'conversational',
    next_script_id: 'whale_012_02',
  },
  {
    id: 'whale_012_02',
    animation: 'surprised',
    text_jp:
      '平均で3.8kmと言われているラ\n富士山とだいたい同じくらいラ！\nめちゃくちゃ深いラ！',
    text_en:
      'Its average depth is about 3.8km!\nThat’s as deep as Mt. Fuji is tall!\nThat’s really deep!',
    type: 'conversational',
    next_script_id: 'whale_012_03',
  },
  {
    id: 'whale_012_03',
    animation: 'surprised',
    text_jp: '一番深いところだと11kmあるラ！\nもうよく分かんないラ！',
    text_en:
      'The deepest part is at least 11km deep!\nIt’s literally unfathomable!',
    type: 'conversational',
  },
  {
    id: 'whale_013_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「七つの海」ってどこのことか\n知ってるラ？',
    text_en: 'Do you know the names of “The 7 Seas?”',
    type: 'conversational',
    next_script_id: 'whale_013_02',
  },
  {
    id: 'whale_013_02',
    text_jp:
      '一般的には、「北太平洋」、\n「南太平洋」、「北大西洋」、\n「南大西洋」、「インド洋」、',
    text_en:
      'It’s usually the North Pacific, \nSouth Pacific, North Atlantic, \nSouth Atlantic, Indian Ocean,',
    type: 'conversational',
    next_script_id: 'whale_013_03',
  },
  {
    id: 'whale_013_03',
    expression: 'happy',
    text_jp:
      '「北氷洋(北極海)」、「南氷洋」\nのことを言うラ！\n明日誰かに自慢するといいラ！',
    text_en:
      'Arctic, and Antarctic!\nYou can show off your smarts to someone tomorrow!',
    type: 'conversational',
  },
  {
    id: 'whale_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '波はどうして起きるか知ってるラ？',
    text_en: 'Do you know where waves come from?',
    type: 'conversational',
    next_script_id: 'whale_014_02',
  },
  {
    id: 'whale_014_02',
    text_jp:
      '波は、強い風によって起こされるラ\n海に限らず、大きい湖とかでも\n波は起きるラ！',
    text_en:
      'Waves are caused by strong winds!\nIt’s not just the ocean, because big lakes have waves, too!',
    type: 'conversational',
  },
  {
    id: 'whale_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海の深さは、どうやって\n測るか知ってるラ？',
    text_en: 'Do you know how they measure how deep the ocean is?',
    type: 'conversational',
    next_script_id: 'whale_015_02',
  },
  {
    id: 'whale_015_02',
    expression: 'happy',
    text_jp:
      '海の深さは音波を使って測るラ\nでも、昔はながーいロープで\n測っていたらしいラ！',
    text_en:
      'They use sonar to measure it!\nIn the old days, they used a really long rope!',
    type: 'conversational',
  },
  {
    id: 'whale_016_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ホッケって美味しいラよね\n「ホッケ」の語源って知ってるラ？',
    text_en:
      'Atlantic mackerel is delicious!\nIt’s called “Hokke” in Japanese!',
    type: 'conversational',
    next_script_id: 'whale_016_02',
  },
  {
    id: 'whale_016_02',
    text_jp: 'なんと、北海道が語源らしいラ\n北海道でよくとれるから、',
    text_en:
      'The name comes from Hokkaido because they caught a lot of them there.',
    type: 'conversational',
    next_script_id: 'whale_016_03',
  },
  {
    id: 'whale_016_03',
    expression: 'happy',
    text_jp:
      'ほっかいどう、ほっけいどう、\nほっけい、ほっけ…\nとなったらしいラ！',
    text_en: 'Hokkaido became Hokkeido, Hokkei, then Hokke!',
    type: 'conversational',
  },
  {
    id: 'whale_017_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '船の名前は、どうして\n「なんとか丸」が多いか\n知ってるラ？',
    text_en:
      'Do you know why Japanese ships usually have “-maru” at the end of their names, like “Yamato-maru?”',
    type: 'conversational',
    next_script_id: 'whale_017_02',
  },
  {
    id: 'whale_017_02',
    text_jp:
      '一説によると、平安時代に\n自分のことを「マロ」と言って\nいたのが、自分の大事なものも',
    text_en: 'Some say that back in the Heian period, the word “I” was “Maro”.',
    type: 'conversational',
    next_script_id: 'whale_017_03',
  },
  {
    id: 'whale_017_03',
    text_jp:
      '「マロ」と呼ぶようになって、\nそれが船にも付けられて、やがて\n「マロ」が「マル」に変わった',
    text_en:
      'Then special belongings were called “Maro”, then it was used for ships, and became “-maru!”',
    type: 'conversational',
    next_script_id: 'whale_017_04',
  },
  {
    id: 'whale_017_04',
    expression: 'happy',
    text_jp: 'らしいのラ！\nでも、諸説あるのラ！',
    text_en: 'There are other theories, though!',
    type: 'conversational',
  },
  {
    id: 'whale_018_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '水族館はどうして薄暗いか\n知ってるラ？',
    text_en: 'Do you know why aquariums are so dark?',
    type: 'conversational',
    next_script_id: 'whale_018_02',
  },
  {
    id: 'whale_018_02',
    text_jp:
      '魚側から人間を見えづらくして、\n魚のストレスがたまらないように\n工夫しているのラ！',
    text_en:
      "It's so the fish can’t see the people very well and don’t get stressed out!",
    type: 'conversational',
    next_script_id: 'whale_018_03',
  },
  {
    id: 'whale_018_03',
    expression: 'happy',
    text_jp: '今度水族館に行ったら、\n誰かに自慢するといいラ！',
    text_en:
      'Show off your trivia knowledge the next time you go to an aquarium!',
    type: 'conversational',
  },
  {
    id: 'whale_019_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'イルカはどうしてあんなにお肌が\nスベスベか知っているラ？',
    text_en: 'Do you know why dolphins are so smooth?',
    type: 'conversational',
    next_script_id: 'whale_019_02',
  },
  {
    id: 'whale_019_02',
    text_jp:
      'イルカは新陳代謝がとっても盛んで\n2時間に1回皮膚が入れ替わって\nいるらしいラ！',
    text_en:
      'Dolphins have a really fast metabolism and grow a new layer of skin once every two hours!',
    type: 'conversational',
    next_script_id: 'whale_019_03',
  },
  {
    id: 'whale_019_03',
    text_jp: 'うらやましいラ！',
    text_en: 'Lucky them!',
    type: 'conversational',
  },
  {
    id: 'whale_020_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'フグは感じで「河豚」と書くラ。\nなんでか知ってるラ？',
    text_en:
      'Do you know why the Chinese characters for blowfish are “River Pig”?',
    type: 'conversational',
    next_script_id: 'whale_020_02',
  },
  {
    id: 'whale_020_02',
    text_jp: 'フグは驚いたときに「ブーブー」と\nブタみたいになくらしいラ',
    text_en: 'Apparently blowfish oink like pigs!',
    type: 'conversational',
    next_script_id: 'whale_020_03',
  },
  {
    id: 'whale_020_03',
    text_jp: 'だから漢字で河の豚と\n書かれるようになったらしいラ！',
    text_en: "That's why they used the character for pig in the name!",
    type: 'conversational',
  },
  {
    id: 'whale_021_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\nお料理は得意ラか？',
    text_en: 'Are you a good cook, {player_name}?',
    type: 'selectional',
    answer_var: 'good_at_cooking',
    option_1_jp: '得意',
    option_1_en: 'Yes',
    option_2_jp: 'そうでもない',
    option_2_en: 'No',
    case: 'good_at_cooking',
    next_script_id_1: 'whale_021_02',
    next_script_id_2: 'whale_021_04',
  },
  {
    id: 'whale_021_02',
    text_jp: 'すごいラ！尊敬するラ！',
    text_en: 'Wow! I’m impressed!',
    type: 'conversational',
    next_script_id: 'whale_021_03',
  },
  {
    id: 'whale_021_03',
    expression: 'happy',
    text_jp:
      '{pet_name}は\n食べるのは大得意ラから、\n味見はいつでも付き合うラ！',
    text_en:
      '{pet_name} is a good eater, so let me be your taste-tester any time!',
    type: 'conversational',
  },
  {
    id: 'whale_021_04',
    expression: 'happy',
    text_jp: '同じラ〜\n{pet_name}、食べるのは\n得意なんラけどね〜…',
    text_en: 'Me, too!\n{pet_name} is better at eating, though!',
    type: 'conversational',
  },
  {
    id: 'whale_022_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\n海に行ったら何するのが好きラ？',
    text_en: 'What do you like to do at the beach, {player_name}?',
    type: 'selectional',
    answer_var: 'todo_in_ocean',
    option_1_jp: '泳ぐ',
    option_1_en: 'Swimming',
    option_2_jp: '砂浜で遊ぶ',
    option_2_en: 'Playing on the beach',
    option_3_jp: 'のんびりする',
    option_3_en: 'Relaxing',
    case: 'todo_in_ocean',
    next_script_id_1: 'whale_022_02',
    next_script_id_2: 'whale_022_03',
    next_script_id_3: 'whale_022_04',
  },
  {
    id: 'whale_022_02',
    expression: 'happy',
    text_jp: '意外とガチ勢ラね！\n{pet_name}も泳ぎは\n負けないラ！',
    text_en:
      'You’re surprisingly passionate!\nI’ll bet {pet_name} can keep up with swimming!',
    type: 'conversational',
  },
  {
    id: 'whale_022_03',
    expression: 'happy',
    text_jp: 'やっぱり砂浜でキャッキャ\nするのが一番楽しいラね〜！',
    text_en: 'Playing in the sand is definitely the most fun!',
    type: 'conversational',
  },
  {
    id: 'whale_022_04',
    expression: 'happy',
    text_jp: 'オトナなのラ！\n{pet_name}も真似するラ！',
    text_en: 'What a grown-up!\n{pet_name} will try to be like you!',
    type: 'conversational',
  },
  {
    id: 'whale_023_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n男女の友情は\n成立すると思うラ？',
    text_en: 'Do you think guys and girls can just be friends, {player_name}?',
    type: 'selectional',
    answer_var: 'friendship_with_opposite_sex',
    option_1_jp: '成立すると思う',
    option_1_en: 'Yes',
    option_2_jp: '成立すると思わない',
    option_2_en: 'No',
    next_script_id: 'whale_023_02',
  },
  {
    id: 'whale_023_02',
    text_jp: 'なるほどラ〜\n{pet_name}は、ありえなくは\nないと思うラ！',
    text_en: 'I SEA!\n{pet_name} doesn’t think it’s out of the question!',
    type: 'conversational',
  },
  {
    id: 'whale_024_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}は、\nファスナーが開いている人を見たら\n教えてあげるタイプラ？',
    text_en:
      'Are you the type to tell someone if their bag is open,{player_name}?',
    type: 'selectional',
    answer_var: 'xyz',
    option_1_jp: '教える',
    option_1_en: 'Yes',
    option_2_jp: '教えない',
    option_2_en: 'No',
    next_script_id: 'whale_024_02',
  },
  {
    id: 'whale_024_02',
    expression: 'sad',
    text_jp: 'とっても難しい問題ラよね〜',
    text_en: "It's a really tough choice!",
    type: 'conversational',
    next_script_id: 'whale_024_03',
  },
  {
    id: 'whale_024_03',
    expression: 'sad',
    text_jp:
      '{pet_name}は、赤の他人や\n仲良しには言えるラけど、微妙な\n知り合いには言えないラ〜',
    text_en:
      '{pet_name} can tell strangers or friends, but not casual acquaintances!',
    type: 'conversational',
  },
  {
    id: 'whale_025_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\n思い出しムカつきとか\nするタイプラ？',
    text_en: 'Do you ever get annoyed by a memory, {player_name}?',
    type: 'selectional',
    answer_var: 'angry_memory',
    option_1_jp: 'けっこうする',
    option_1_en: 'Yes',
    option_2_jp: 'あまりしない',
    option_2_en: 'No',
    case: 'angry_memory',
    next_script_id_1: 'whale_025_02',
    next_script_id_2: 'whale_025_03',
  },
  {
    id: 'whale_025_02',
    text_jp:
      'そうラよね〜。\nけっこうしちゃうラよね〜。\nあ、また思い出して来た…',
    text_en:
      'I know what you mean!\nIt kind of creeps up on you sometimes.\nOh, no! I’m starting to remember something…',
    type: 'conversational',
    next_script_id: 'whale_025_04',
  },
  {
    id: 'whale_025_03',
    text_jp:
      'あんまりしないラか？\n{pet_name}はけっこう\nしちゃうラ。あ、また…',
    text_en:
      'Not really?\nIt happens to {pet_name} pretty often.\nUh-oh… It’s happening…',
    type: 'conversational',
    next_script_id: 'whale_025_04',
  },
  {
    id: 'whale_025_04',
    animation: 'angry',
    text_jp: 'ムキー！\n{pet_name}は\nイルカじゃなくてクジラなのラ〜！',
    text_en: 'TOOT!\n{pet_name} is a whale, not a dolphin!',
    type: 'conversational',
  },
  {
    id: 'whale_026_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}は\n買い物するとき、ネットの\nレビューとか気にするラ？',
    text_en:
      'Do you read online reviews before you buy something, {player_name}?',
    type: 'selectional',
    answer_var: 'review',
    option_1_jp: 'けっこう気にする',
    option_1_en: 'Yes',
    option_2_jp: 'あまり気にしない',
    option_2_en: 'No',
    case: 'review',
    next_script_id_1: 'whale_026_02',
    next_script_id_2: 'whale_026_03',
  },
  {
    id: 'whale_026_02',
    animation: 'anxious',
    text_jp:
      '{pet_name}も、レビューが\n悪いと、欲しいものでもなかなか\n買う気になれないラ…',
    text_en:
      'When the reviews are bad, {pet_name} can’t bring myself to buy it…',
    type: 'conversational',
  },
  {
    id: 'whale_026_03',
    expression: 'happy',
    text_jp: '自分の軸がしっかりしていて\n素敵ラ〜\nあこがれるラ〜',
    text_en: 'You’re so decisive!\nThat’s great!\nI need to be more like you…',
    type: 'conversational',
  },
  {
    id: 'whale_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n海に行くなら、日本と海外\nどっちがいいラ？',
    text_en:
      'Would you rather go to the beach in Japan or somewhere else, {player_name}?',
    type: 'selectional',
    answer_var: 'japan_oversea',
    option_1_jp: '日本',
    option_1_en: 'Japan',
    option_2_jp: '海外',
    option_2_en: 'Overseas',
    case: 'japan_oversea',
    next_script_id_1: 'whale_027_02',
    next_script_id_2: 'whale_027_03',
  },
  {
    id: 'whale_027_02',
    expression: 'happy',
    text_jp: '海の家とか、海外にはない\n独特の趣があっていいラよね！',
    text_en: 'They don’t have as many unique beachfront shops overseas!',
    type: 'conversational',
  },
  {
    id: 'whale_027_03',
    expression: 'happy',
    text_jp: 'あの空と海の青さは、なかなか\n日本では味わえないラね〜！',
    text_en: 'The ocean always seems bluer overseas!',
    type: 'conversational',
  },
  {
    id: 'whale_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海の家で食べるなら\nどれがいいラ？',
    text_en: 'What do you like to eat at the beach?',
    type: 'selectional',
    answer_var: 'food_beach',
    option_1_jp: 'カキ氷',
    option_1_en: 'Shaved ice',
    option_2_jp: 'やきそば',
    option_2_en: 'Fried noodle',
    option_3_jp: 'ラーメン',
    option_3_en: 'Ramen',
    next_script_id: 'whale_028_02',
  },
  {
    id: 'whale_028_02',
    animation: 'cry',
    text_jp: '自分で聞いておいて\nおなかがすいてきたラ〜…',
    text_en: 'I know I’m the one who asked, but your answer made me hungry!',
    type: 'conversational',
  },
  {
    id: 'whale_029_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海に向かって叫ぶなら\n何て叫ぶラ？',
    text_en:
      'What would you shout at the ocean at the top of your lungs if you could?',
    type: 'descriptive',
    answer_var: 'shout_to_sea',
    question_jp: '海に向かって何て叫ぶ？',
    question_en: 'Shout to the sea',
    max_len: 14,
    next_script_id: 'whale_029_02',
  },
  {
    id: 'whale_029_02',
    expression: 'happy',
    text_jp: '久しぶりに良い\n心の叫びを聞いたラ〜',
    text_en: 'Sounds like it’s straight from the soul!',
    type: 'conversational',
  },
  {
    id: 'whale_030_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海に行くときに絶対に持って行く\nマストアイテムを教えて欲しいラ！',
    text_en: 'What’s the one thing you absolutely must bring to the beach?',
    type: 'descriptive',
    answer_var: 'must_have_beach',
    question_jp: '海のマストアイテム',
    question_en: 'Must-have item at beach',
    max_len: 14,
    next_script_id: 'whale_030_02',
  },
  {
    id: 'whale_030_02',
    animation: 'anxious',
    text_jp: 'え…。海に\n{must_have_beach}を\n持って行くラ、と…？',
    text_en: 'Huh?\n{must_have_beach} at the beach??',
    type: 'conversational',
    next_script_id: 'whale_030_03',
  },
  {
    id: 'whale_030_03',
    expression: 'happy',
    text_jp: 'さすが\n{player_name}ラ。\nマニアック過ぎてついて行けないラ',
    text_en:
      'I’m impressed, {player_name}!\nThat’s the last thing I would expect!',
    type: 'conversational',
  },
  {
    id: 'whale_031_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'もし生まれ変わるとしたら、\n男と女、どっちがいいラ？',
    text_en:
      'If you were going to be reborn, would you choose to be a boy or a girl?',
    type: 'selectional',
    answer_var: 'man_woman',
    option_1_jp: '男',
    option_1_en: 'Man',
    option_2_jp: '女',
    option_2_en: 'Woman',
    case: 'man_woman',
    next_script_id_1: 'whale_031_02',
    next_script_id_2: 'whale_031_03',
  },
  {
    id: 'whale_031_02',
    text_jp: 'へー。\nどうして男に生まれたいのラ？',
    text_en: 'Hmm?\nWhy a boy?',
    type: 'descriptive',
    answer_var: 'man_woman_reason',
    question_jp: 'どうして男？',
    question_en: 'Why man?',
    max_len: 14,
    next_script_id: 'whale_031_04',
  },
  {
    id: 'whale_031_03',
    text_jp: 'へー。\nどうして女に生まれたいのラ？',
    text_en: 'Hmm?\nWhy a girl?',
    type: 'descriptive',
    answer_var: 'man_woman_reason',
    question_jp: 'どうして女？',
    question_en: 'Why woman?',
    max_len: 14,
    next_script_id: 'whale_031_04',
  },
  {
    id: 'whale_031_04',
    text_jp: 'なるほど…。\n一理ある……ラ…？',
    text_en: 'I see…\nThat makes sense!',
    type: 'conversational',
  },
  {
    id: 'whale_032_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}が\n新しく校則を作るとしたら、\nどんな校則を作るラ？',
    text_en:
      'Hey, {player_name}, if you could make a new school rule, what would it be?',
    type: 'descriptive',
    answer_var: 'shcool_regulations',
    question_jp: '新しい校則',
    question_en: 'New school regulation',
    max_len: 14,
    next_script_id: 'whale_032_02',
  },
  {
    id: 'whale_032_02',
    animation: 'surprised',
    text_jp: 'なるほど！\nその発想は無かったラ！',
    text_en: 'Whoa!\nI never would have thought of that!',
    type: 'conversational',
    next_script_id: 'whale_032_03',
  },
  {
    id: 'whale_032_03',
    expression: 'happy',
    text_jp: '{player_name}は\nやっぱり天才ラ〜',
    text_en: 'You’re a genius, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_033_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '無人島に何か1つだけ\n持って行けるとしたら、\n何を持って行くラ？',
    text_en:
      'If you could take one thing with you to a desert island, what would it be?',
    type: 'descriptive',
    answer_var: 'bring_to_island',
    question_jp: '無人島に持って行くもの',
    question_en: "What would you bring to a no man's island?",
    max_len: 14,
    next_script_id: 'whale_033_02',
  },
  {
    id: 'whale_033_02',
    expression: 'happy',
    text_jp: 'なるほど！\nそれもありラね〜！',
    text_en: 'Makes sense!\nThat’s a good choice!',
    type: 'conversational',
  },
  {
    id: 'whale_034_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}が\nいま一番欲しいものって何ラ？',
    text_en: 'What’s the thing you want most right now, {player_name}?',
    type: 'descriptive',
    answer_var: 'want_most',
    question_jp: 'いま一番欲しいもの',
    question_en: 'What you want most',
    max_len: 14,
    next_script_id: 'whale_034_02',
  },
  {
    id: 'whale_034_02',
    expression: 'sad',
    text_jp: 'なるほど…\n{pet_name}が\nあげられるといいラけど、',
    text_en: 'Well, yeah…',
    type: 'conversational',
    next_script_id: 'whale_034_03',
  },
  {
    id: 'whale_034_03',
    animation: 'play',
    text_jp: 'いまは虹を出すのが精一杯ラ…',
    text_en: '…maybe just use your imagination for now.',
    type: 'conversational',
  },
  {
    id: 'whale_035_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n将来の夢を教えて欲しいラ！',
    text_en: 'What do you want to be when you grow up, {player_name}?',
    type: 'descriptive',
    answer_var: 'future_dream',
    question_jp: '将来の夢',
    question_en: 'Future dream',
    max_len: 14,
    next_script_id: 'whale_035_02',
  },
  {
    id: 'whale_035_02',
    expression: 'happy',
    text_jp: '素敵な夢なのラ〜！',
    text_en: 'That’s a great dream!',
    type: 'conversational',
    next_script_id: 'whale_035_03',
  },
  {
    id: 'whale_035_03',
    animation: 'joy',
    text_jp:
      '{pet_name}の夢は\nぶるぶるカフェでデビューして\nスターになることなのラ！',
    text_en:
      '{pet_name}’s dream is to debut at the BuruBuru Café and become a superstar!',
    type: 'conversational',
  },
  {
    id: 'whale_036_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n夜寝る前の習慣を教えて欲しいラ！',
    text_en: 'What do you do before bedtime, {player_name}?',
    type: 'descriptive',
    answer_var: 'habit_before_sleep',
    question_jp: '夜寝る前の習慣',
    question_en: 'Habits before sleeping',
    max_len: 14,
    next_script_id: 'whale_036_02',
  },
  {
    id: 'whale_036_02',
    animation: 'surprised',
    text_jp: 'え？寝る前に……\n{habit_before_sleep}…？\n……',
    text_en: 'Huh? You really {habit_before_sleep} before bedtime?\n……',
    type: 'conversational',
    next_script_id: 'whale_036_03',
  },
  {
    id: 'whale_036_03',
    expression: 'happy',
    text_jp: 'さすが\n{player_name}。\n常人とは一線を画しているラ〜',
    text_en:
      'I’m impressed, {player_name}.\nYou’re clearly on another level from everyone else.',
    type: 'conversational',
  },
  {
    id: 'whale_037_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '地球上に存在する水のうち、\n何％が海にあるか知ってるラ？',
    text_en:
      'What percentage of the world’s water do you think is in the oceans?',
    type: 'selectional',
    answer_var: 'water_in_ocean',
    option_1_jp: '56パーセント',
    option_1_en: '56 percent',
    option_2_jp: '78パーセント',
    option_2_en: '78 percent',
    option_3_jp: '97パーセント',
    option_3_en: '97 percent',
    next_script_id: 'whale_037_02',
  },
  {
    id: 'whale_037_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_037_03',
  },
  {
    id: 'whale_037_03',
    expression: 'happy',
    text_jp: '「97パーセント」ラ！',
    text_en: 'It’s 97%!',
    type: 'conversational',
    next_script_id: 'whale_037_04',
  },
  {
    id: 'whale_037_04',
    text_jp: '地球上のほぼ全ての水は\n海にあるのラ！\nびっくりラ！',
    text_en:
      'Basically all of the water on Earth is in the oceans!\nAmazing, right?',
    type: 'conversational',
  },
  {
    id: 'whale_038_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海岸から見える水平線、\nどのくらい遠いか知ってるラ？',
    text_en: 'Do you know how far the horizon you can see from a beach is?',
    type: 'selectional',
    answer_var: 'distance_to_horizon',
    option_1_jp: '4.5km',
    option_1_en: '4.5 km',
    option_2_jp: '45km',
    option_2_en: '45 km',
    option_3_jp: '450km',
    option_3_en: '450 km',
    next_script_id: 'whale_038_02',
  },
  {
    id: 'whale_038_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_038_03',
  },
  {
    id: 'whale_038_03',
    text_jp: '海岸からだいたい\n「4.5km」くらいラ！',
    text_en: "It's about 4.5km away from the beach!",
    type: 'conversational',
    next_script_id: 'whale_038_04',
  },
  {
    id: 'whale_038_04',
    animation: 'joy',
    text_jp:
      '自動車で5〜6分ぐらい。\n得意な人なら泳げる距離ラ。\n意外と近いと思わないラ？',
    text_en:
      "That's about 5 or 6 minutes by car.\nA good swimmer could even swim there!\nThat’s closer than you’d think, right?",
    type: 'conversational',
  },
  {
    id: 'whale_039_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '海水浴が日本で初めて行われた\nときの目的を知ってるラ？',
    text_en:
      'Do you know why people started recreational swimming in the ocean in Japan?',
    type: 'selectional',
    answer_var: 'purpose_of_swimming',
    option_1_jp: '生物の観察',
    option_1_en: 'Biological observation',
    option_2_jp: '精神力を鍛える',
    option_2_en: 'Mental training',
    option_3_jp: '病気の治療',
    option_3_en: 'Treatment of diseases',
    next_script_id: 'whale_039_02',
  },
  {
    id: 'whale_039_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_039_03',
  },
  {
    id: 'whale_039_03',
    expression: 'happy',
    text_jp: '「病気の治療」ラ！',
    text_en: 'It was to cure illnesses!',
    type: 'conversational',
    next_script_id: 'whale_039_04',
  },
  {
    id: 'whale_039_04',
    text_jp:
      '明治13年に、かっけの治療のために\n海水浴をしたのが初めてと\n言われているラ！',
    text_en:
      'They say that in 1880, people started recreational swimming in the ocean to treat vitamin B1 deficiency!',
    type: 'conversational',
  },
  {
    id: 'whale_040_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'クロダイはなんで\n体が黒いか知ってるラ？',
    text_en: 'Do you know where black sea bream gets its color from?',
    type: 'selectional',
    answer_var: 'black_porgy',
    option_1_jp: '日焼け',
    option_1_en: 'Sun tanned',
    option_2_jp: '海藻を食べるから',
    option_2_en: 'Eating sea weeds',
    option_3_jp: '目立たないように',
    option_3_en: 'To hide from enemies',
    next_script_id: 'whale_040_02',
  },
  {
    id: 'whale_040_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_040_03',
  },
  {
    id: 'whale_040_03',
    animation: 'joy',
    text_jp: '「日焼け」ラ！',
    text_en: "They're sunburned!",
    type: 'conversational',
    next_script_id: 'whale_040_04',
  },
  {
    id: 'whale_040_04',
    text_jp:
      'クロダイは比較的浅い場所で\n暮らすから、太陽に多く当たって\nメラニン色素が沈着するラ！',
    text_en:
      'Black sea bream live in relatively shallow water, so the sunlight makes them produce more melanin!',
    type: 'conversational',
  },
  {
    id: 'whale_041_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'タラバガニは分類学上は何の仲間か\n知っているラか？',
    text_en: 'Do you know what else is in the same family as red king crabs?*',
    type: 'selectional',
    answer_var: 'king_crab',
    option_1_jp: 'カニ',
    option_1_en: 'Crab',
    option_2_jp: 'ヤドカリ',
    option_2_en: 'Hermit crab',
    option_3_jp: 'ザリガニ',
    option_3_en: 'Crawfish',
    next_script_id: 'whale_041_02',
  },
  {
    id: 'whale_041_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_041_03',
  },
  {
    id: 'whale_041_03',
    expression: 'happy',
    text_jp: '「ヤドカリ」ラ！',
    text_en: 'Hermit crabs!',
    type: 'conversational',
    next_script_id: 'whale_041_04',
  },
  {
    id: 'whale_041_04',
    text_jp:
      'カニは足が10本あるラけど、\nタラバガニは8本しかなくて、\nヤドカリと同じなのラ',
    text_en:
      'Normal crabs have 10 legs, but red king crabs only have 8 legs, like hermit crabs!',
    type: 'conversational',
    next_script_id: 'whale_041_05',
  },
  {
    id: 'whale_041_05',
    text_jp: 'でも、お魚屋さんでは\n普通にカニとして売られているラ！',
    text_en: 'But they sell them in the seafood department along with crabs!',
    type: 'conversational',
  },
  {
    id: 'whale_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'お店で売っているワカメは\n緑色ラけど、海の中にいるワカメは\n何色か知ってるラ？',
    text_en:
      'The seaweed you see at the supermarket is green, but do you know what color it is in the ocean?',
    type: 'selectional',
    answer_var: 'wakame_color',
    option_1_jp: '赤色',
    option_1_en: 'Red',
    option_2_jp: '青色',
    option_2_en: 'Blue',
    option_3_jp: '茶色',
    option_3_en: 'Brown',
    next_script_id: 'whale_042_02',
  },
  {
    id: 'whale_042_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_042_03',
  },
  {
    id: 'whale_042_03',
    expression: 'happy',
    text_jp: '「茶色」ラ！',
    text_en: 'Brown!',
    type: 'conversational',
    next_script_id: 'whale_042_04',
  },
  {
    id: 'whale_042_04',
    text_jp:
      '収穫されてお湯に入れられると、\nクロロフィルaとその他の色素が\n分離して緑色になるラ！',
    text_en:
      'After it’s harvested and boiled, “Chlorophyll-a” and other pigments separate to make it green!',
    type: 'conversational',
  },
  {
    id: 'whale_043_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ラーララー♪\n今日も良い日なのラ〜',
    text_en: 'Toot Toot!\nAnother great day!',
    type: 'conversational',
  },
  {
    id: 'whale_044_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'すごく良いことがあったのラ！\n知りたいラ？',
    text_en:
      'Something great happened today!\nDo you want to hear what it was?',
    type: 'conversational',
    next_script_id: 'whale_044_02',
  },
  {
    id: 'whale_044_02',
    animation: 'joy',
    text_jp: 'コンビニのお会計が\n777円だったのラ！',
    text_en: 'I bought something at the store for exactly 777 yen!',
    type: 'conversational',
    next_script_id: 'whale_044_03',
  },
  {
    id: 'whale_044_03',
    expression: 'happy',
    text_jp: 'すさまじい運気が\n流れ込んでいるのラ！',
    text_en: 'I can feel a wave of good luck coming my way!',
    type: 'conversational',
  },
  {
    id: 'whale_045_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'かなり良いことがあったのラ！\n知りたいラ？',
    text_en:
      'Something pretty great happened today!\nDo you want to hear what it was?',
    type: 'conversational',
    next_script_id: 'whale_045_02',
  },
  {
    id: 'whale_045_02',
    text_jp:
      'お散歩からの帰り道で、\n1回も信号で止まらずに\n帰ってこられたのラ！',
    text_en:
      'I was on my way home from a walk and didn’t have to stop at a single red light!',
    type: 'conversational',
    next_script_id: 'whale_045_03',
  },
  {
    id: 'whale_045_03',
    animation: 'joy',
    text_jp: '世界は{pet_name}を\n中心に回っているような\n気がするラ！',
    text_en: 'It’s like the world is revolving around {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_046_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ん？\nにらめっこするラ？',
    text_en: 'Hm?\nYou want a staring contest?',
    type: 'conversational',
    next_script_id: 'whale_046_02',
  },
  {
    id: 'whale_046_02',
    text_jp: 'よーし、負けないラよ！\nあっぷっぷ！',
    text_en: 'Ok! I’m good at this!\nLet’s go!',
    type: 'conversational',
    next_script_id: 'whale_046_03',
  },
  {
    id: 'whale_046_03',
    animation: 'joy',
    text_jp: 'きゃっきゃっきゃっきゃ！',
    text_en: 'HRRRRRM!',
    type: 'conversational',
    next_script_id: 'whale_046_04',
  },
  {
    id: 'whale_046_04',
    expression: 'happy',
    text_jp:
      'もー。なんでそんな顔できるラー？\n{player_name}は\nにらめっこの天才ラねー',
    text_en:
      'How did you do that?\nYou’re a staring contest champion, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_047_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '時計をちらっと見たら、',
    text_en: 'I glanced at my watch…',
    type: 'conversational',
    next_script_id: 'whale_047_02',
  },
  {
    id: 'whale_047_02',
    animation: 'surprised',
    text_jp: '11時11分11秒だったラ！',
    text_en: '…and it was 11:11:11!',
    type: 'conversational',
    next_script_id: 'whale_047_03',
  },
  {
    id: 'whale_047_03',
    expression: 'happy',
    text_jp: '今日も良いことありそうな\n気がするラ！',
    text_en: 'It feels like something wonderful will happen today!',
    type: 'conversational',
  },
  {
    id: 'whale_048_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'さっき、すごくおもしろい\n話を聞いたラ！\n知りたいラ？',
    text_en:
      'I heard something really funny!\nDo you want to hear what it was?',
    type: 'conversational',
    next_script_id: 'whale_048_02',
  },
  {
    id: 'whale_048_02',
    text_jp: 'あのね…',
    text_en: 'Well…',
    type: 'conversational',
    next_script_id: 'whale_048_03',
  },
  {
    id: 'whale_048_03',
    animation: 'joy',
    text_jp: 'クッ…\nクックック…\nプヒー！きゃきゃきゃきゃきゃ！',
    text_en: 'Hee…\nHee Hee Hee…\nHa! HAHAHAHA! ',
    type: 'conversational',
    next_script_id: 'whale_048_04',
  },
  {
    id: 'whale_048_04',
    expression: 'happy',
    text_jp: 'お、おもしろ過ぎて、\nうまく話せないラー\nプーッ！ククク……',
    text_en: 'I-It’s too funny to repeat!\nHA! Hee Hee Hee…',
    type: 'conversational',
  },
  {
    id: 'whale_049_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'わーい！呼ばれたラー？',
    text_en: 'Hooray! You called me!',
    type: 'conversational',
    next_script_id: 'whale_049_02',
  },
  {
    id: 'whale_049_02',
    text_jp: 'ん？特に用事はないラ？',
    text_en: 'Hm? You don’t need anything from me?',
    type: 'conversational',
    next_script_id: 'whale_049_03',
  },
  {
    id: 'whale_049_03',
    animation: 'joy',
    text_jp: '用事ないのに呼ばれるのが\n一番うれしいラー！',
    text_en:
      'Just calling because you want to talk to me makes me really happy!',
    type: 'conversational',
  },
  {
    id: 'whale_050_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ウナギはどうしてお刺身で\n食べないか、知ってるラ？',
    text_en: 'Do you know why you don’t eat unagi raw, like other sushi?',
    type: 'conversational',
    next_script_id: 'whale_050_02',
  },
  {
    id: 'whale_050_02',
    text_jp:
      'ウナギの血には毒が含まれていて、\n加熱処理をしないと取り除くのは\n難しいのラ！',
    text_en:
      'Unagi have a poison in their bloodstream that has to be removed by cooking it!',
    type: 'conversational',
    next_script_id: 'whale_050_03',
  },
  {
    id: 'whale_050_03',
    expression: 'happy',
    text_jp:
      'かば焼きがすごく美味しいから、\nわざわざお刺身で食べようとも\n思わないラけどねー',
    text_en: 'Broiled unagi is so tasty that you’d never want to eat it raw!',
    type: 'conversational',
  },
  {
    id: 'whale_051_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'フグのお刺身はどうして\nあんなに薄っぺらいか、\n知ってるラ？',
    text_en: 'Do you know why blowfish sashimi is sliced so thinly?',
    type: 'conversational',
    next_script_id: 'whale_051_02',
  },
  {
    id: 'whale_051_02',
    expression: 'normal',
    text_jp:
      'フグにはあばら骨が無いんラけど\n代わりに硬い身で内蔵を\n守っているラ',
    text_en:
      'Blowfish have no ribcage, but a tough layer around their organs to protect them instead!',
    type: 'conversational',
    next_script_id: 'whale_051_03',
  },
  {
    id: 'whale_051_03',
    expression: 'happy',
    text_jp:
      'だから、普通に切ると硬くて\nかみ切れないのラ！\n別にケチってるわけじゃないのラ！',
    text_en:
      'It’s too hard to bite through normally, so they cut it thin!\nThey’re not being stingy!',
    type: 'conversational',
  },
  {
    id: 'whale_052_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ネギトロはどうして\n「ネギトロ」と\nいうか知ってるラ？',
    text_en: 'Do you know why minced tuna is called “negitoro” in Japanese?',
    type: 'conversational',
    next_script_id: 'whale_052_02',
  },
  {
    id: 'whale_052_02',
    expression: 'normal',
    text_jp: '実は野菜のネギとマグロのトロの\nことではないラよ',
    text_en:
      'It’s NOT because negi is Welsh Onion, and toro is a kind of tuna!',
    type: 'conversational',
    next_script_id: 'whale_052_03',
  },
  {
    id: 'whale_052_03',
    expression: 'normal',
    text_jp:
      '骨の周辺についた身を削りとるのを\n「ねぎ取る」というのラけど、\nそこから「ネギトロ」になったのラ',
    text_en:
      'They call the process of getting the meat off the bone “negi-toru”, (removing meat) which became “negitoro”!',
    type: 'conversational',
    next_script_id: 'whale_052_04',
  },
  {
    id: 'whale_052_04',
    expression: 'happy',
    text_jp: '今度お寿司屋さんで\n自慢するといいラ！',
    text_en: 'You can show off your smarts the next time you get sushi!',
    type: 'conversational',
  },
  {
    id: 'whale_053_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'ハワイのワイキキビーチ、\n大人気ラよね！ワイキキの砂浜は\n人工的に作られたって知ってたラ？',
    text_en:
      'Waikiki Beach in Hawaii is super popular! \nDid you know the sandy beach there is manmade?',
    type: 'conversational',
    next_script_id: 'whale_053_02',
  },
  {
    id: 'whale_053_02',
    animation: 'joy',
    text_jp:
      '1920〜30年代に、オアフ島北部や\nカリフォルニア州から白砂を運んで\n作られたのラ！',
    text_en:
      'Between 1920 and 1930, they brought white sand from northern Oahu and California to make the beach!',
    type: 'conversational',
  },
  {
    id: 'whale_054_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'これまで観測された最大の津波の\n高さを知ってるラ？',
    text_en: 'Can you guess how tall the largest recorded tsunami was?',
    type: 'conversational',
    next_script_id: 'whale_054_02',
  },
  {
    id: 'whale_054_02',
    animation: 'surprised',
    text_jp:
      '1958年にアメリカで起きた津波で、\nなんと高さ524mラ！\n東京タワー1.5本分ラ！',
    text_en:
      'It was in 1958, and was 524m tall!\nThat’s 1 and a half Tokyo Towers!',
    type: 'conversational',
    next_script_id: 'whale_054_03',
  },
  {
    id: 'whale_054_03',
    animation: 'cry',
    text_jp: 'もしこんな津波が来たら、もう\n呆然としちゃうしかないラ…',
    text_en: 'If a tsunami like that came, all you could do is watch…',
    type: 'conversational',
  },
  {
    id: 'whale_055_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}は、\n名字と下の名前、どっちで\n呼ばれることが多いラ？',
    text_en:
      'Do most people call you by your first or last name, {player_name}?',
    type: 'selectional',
    answer_var: 'last_first',
    option_1_jp: '名字',
    option_1_en: 'Last name',
    option_2_jp: '下の名前',
    option_2_en: 'First name',
    case: 'last_first',
    next_script_id_1: 'whale_055_02',
    next_script_id_2: 'whale_055_03',
  },
  {
    id: 'whale_055_02',
    text_jp: 'なるほどー\n名字で呼ばれることが多いラ？\n{pet_name}はだいたい',
    text_en:
      'Is that right?\nThey call you by your last name?\nAs for {pet_name}…',
    type: 'conversational',
    next_script_id: 'whale_055_04',
  },
  {
    id: 'whale_055_03',
    text_jp:
      'なるほどー\n下の名前で呼ばれることが多いラ？\n{pet_name}はだいたい',
    text_en:
      'Is that right?\nThey call you by your first name?\nAs for {pet_name}…',
    type: 'conversational',
    next_script_id: 'whale_055_04',
  },
  {
    id: 'whale_055_04',
    expression: 'happy',
    text_jp: '{pet_name}って\n呼ばれることが多いラ',
    text_en: 'everyone calls me {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_056_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n初対面からグイグイ来て欲しい\nタイプラ？',
    text_en:
      'Is it OK for me to be asking you all these questions, {player_name}?',
    type: 'selectional',
    answer_var: 'first_meeting',
    option_1_jp: 'グイグイ来て欲しい',
    option_1_en: 'Yes',
    option_2_jp: 'ちょっと引いちゃう',
    option_2_en: 'No',
    case: 'first_meeting',
    next_script_id_1: 'whale_056_02',
    next_script_id_2: 'whale_056_03',
  },
  {
    id: 'whale_056_02',
    expression: 'happy',
    text_jp: '{pet_name}も\nそっちの方が早く仲良くなれて\n好きなのラ〜',
    text_en: '{pet_name} thinks it makes it easier to be friends faster!',
    type: 'conversational',
  },
  {
    id: 'whale_056_03',
    expression: 'sad',
    text_jp: 'え、そうだったのラ？\n{pet_name}、大丈夫ラ？\n引かれてないラ？',
    text_en: 'Oh, really?\n{pet_name} hasn’t been bothering you, have I?',
    type: 'conversational',
  },
  {
    id: 'whale_057_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\nけっこう自分に自信が\nあるほうラ？',
    text_en: 'Are you pretty self-confident, {player_name}?',
    type: 'selectional',
    answer_var: 'self_confidence',
    option_1_jp: 'けっこうある',
    option_1_en: 'Yes',
    option_2_jp: 'あまりない',
    option_2_en: 'No',
    case: 'self_confidence',
    next_script_id_1: 'whale_057_02',
    next_script_id_2: 'whale_057_03',
  },
  {
    id: 'whale_057_02',
    expression: 'happy',
    text_jp: 'やっぱりラ〜？\n頼りがいがあって素敵なのラ〜',
    text_en: 'I thought so!\nConfidence is so cool!',
    type: 'conversational',
  },
  {
    id: 'whale_057_03',
    expression: 'normal',
    text_jp: 'え、そうなのラ？',
    text_en: 'Oh, really?',
    type: 'conversational',
    next_script_id: 'whale_057_04',
  },
  {
    id: 'whale_057_04',
    expression: 'happy',
    text_jp:
      '{player_name}は\nすごく素敵な人なのラから、\nもっと自信を持っていいと思うラ！',
    text_en:
      'You’re great, {player_name}!\nYou should believe in yourself more!',
    type: 'conversational',
  },
  {
    id: 'whale_058_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\nSかMかだと、どっちが好きラ？',
    text_en: 'Hey, {player_name}, do you prefer S or M?',
    type: 'selectional',
    answer_var: 'sm',
    option_1_jp: 'S',
    option_1_en: 'S',
    option_2_jp: 'M',
    option_2_en: 'M',
    case: 'sm',
    next_script_id_1: 'whale_058_02',
    next_script_id_2: 'whale_058_03',
  },
  {
    id: 'whale_058_02',
    expression: 'normal',
    text_jp:
      'だいたいSで十分ラよね〜\n{pet_name}はいつもMを\n頼んで、ちょっと残しちゃうラ…',
    text_en:
      'S is usually enough!\n{pet_name} always chooses M, but has some left over.',
    type: 'conversational',
    next_script_id: 'whale_058_04',
  },
  {
    id: 'whale_058_03',
    expression: 'normal',
    text_jp:
      '{pet_name}も\nいつもMを頼むラけど、\nたいていちょっと残しちゃうラ…',
    text_en: '{pet_name} also always chooses M, but has some left over.',
    type: 'conversational',
    next_script_id: 'whale_058_04',
  },
  {
    id: 'whale_058_04',
    animation: 'waive',
    text_jp: 'ん？コーヒーのサイズの話ラよ？\n何だと思ったラ？',
    text_en:
      'Huh? I was talking about coffee sizes.\nWhat did you think I was talking about?',
    type: 'conversational',
  },
  {
    id: 'whale_059_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}が、\n「自分もオトナになったなあ」って\n思うのってどんなときラ？',
    text_en:
      'Hey, {player_name}, what’s a time that you thought you’re really a grown-up now?',
    type: 'descriptive',
    answer_var: 'grownup',
    question_jp: 'オトナになったと思うとき',
    question_en: 'When you feel like an adult',
    max_len: 14,
    next_script_id: 'whale_059_02',
  },
  {
    id: 'whale_059_02',
    text_jp: 'なるほどー',
    text_en: 'I see!',
    type: 'conversational',
    next_script_id: 'whale_059_03',
  },
  {
    id: 'whale_059_03',
    expression: 'happy',
    text_jp: 'オトナになるって、案外\nそういうことかもしれないラね',
    text_en: 'That might just be what being a grown-up is all about!',
    type: 'conversational',
  },
  {
    id: 'whale_060_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{pet_name}、\n何を言われても動じない、\n強いココロが欲しいラ！',
    text_en:
      'I wish {pet_name} had a strong heart that never gets hurt, no matter what anyone says!',
    type: 'conversational',
    next_script_id: 'whale_060_02',
  },
  {
    id: 'whale_060_02',
    expression: 'normal',
    text_jp: '{player_name}が\n考えつく、一番ひどい\n悪口を教えて欲しいラ！',
    text_en: 'What’s the worst insult you can think of, {player_name}?',
    type: 'descriptive',
    answer_var: 'slander',
    question_jp: '一番ひどい悪口',
    question_en: 'Worst slander',
    max_len: 14,
    next_script_id: 'whale_060_03',
  },
  {
    id: 'whale_060_03',
    expression: 'very_sad',
    animation: 'surprised',
    text_jp: 'ひぃっ……！',
    text_en: 'EEEP…!',
    type: 'conversational',
    next_script_id: 'whale_060_04',
  },
  {
    id: 'whale_060_04',
    expression: 'very_sad',
    animation: 'cry',
    text_jp: 'なにもそこまでひどいこと\n言うことないラ〜！',
    text_en: 'It doesn’t have to be THAT horrible!',
    type: 'conversational',
  },
  {
    id: 'whale_061_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '水族館のサメは、どうして他の\n魚を食べないか、知ってるラ？',
    text_en: 'Do you know why sharks at the aquarium don’t eat the other fish?',
    type: 'selectional',
    answer_var: 'shark',
    option_1_jp: '魚を食べない種類だから',
    option_1_en: "They're the kinds that don't eat fish",
    option_2_jp: '訓練されているから',
    option_2_en: "They're trained",
    option_3_jp: 'お腹いっぱいだから',
    option_3_en: "They're full",
    next_script_id: 'whale_061_02',
  },
  {
    id: 'whale_061_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_061_03',
  },
  {
    id: 'whale_061_03',
    text_jp: '「お腹いっぱいだから」ラ！',
    text_en: 'It’s because their stomachs are full!',
    type: 'conversational',
    next_script_id: 'whale_061_04',
  },
  {
    id: 'whale_061_04',
    animation: 'anxious',
    text_jp:
      '飼育員さんからエサをもらって\nお腹いっぱいだから、他の魚を\n食べないだけなのラ',
    text_en: 'The staff feed them enough, so they don’t eat the other fish.',
    type: 'conversational',
  },
  {
    id: 'whale_062_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'イカ墨パスタはあるのに、\nどうしてタコ墨パスタが無いか\n知ってるラ？',
    text_en:
      'Do you know why there’s squid ink pasta, but not octopus ink pasta?',
    type: 'selectional',
    answer_var: 'squid_ink',
    option_1_jp: '毒があるから',
    option_1_en: 'It has poison',
    option_2_jp: '法律で禁止されているから',
    option_2_en: "It's illegal",
    option_3_jp: '高級だから',
    option_3_en: "It's expensive",
    next_script_id: 'whale_062_02',
  },
  {
    id: 'whale_062_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_062_03',
  },
  {
    id: 'whale_062_03',
    expression: 'happy',
    text_jp: '「高級だから」ラ！',
    text_en: 'Because it’s expensive!',
    type: 'conversational',
    next_script_id: 'whale_062_04',
  },
  {
    id: 'whale_062_04',
    expression: 'normal',
    text_jp:
      '1匹からとれる墨の量は、タコより\nイカの方が多いのラ。だから、\nイカ墨の方がお安く仕入れられるラ',
    text_en:
      '1 squid has more ink than 1 octopus. That’s why they buy the cheaper squid ink!',
    type: 'conversational',
    next_script_id: 'whale_062_05',
  },
  {
    id: 'whale_062_05',
    expression: 'sad',
    text_jp:
      '実はタコ墨料理もあるのラけど、\nとってもお高いから、あまり\n普及していないのラ',
    text_en:
      'Octopus ink dishes do exist, but they’re really expensive and not very popular.',
    type: 'conversational',
  },
  {
    id: 'whale_063_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'マグロはどうやって眠るか\n知っているラ？',
    text_en: 'Do you know how tuna sleep?',
    type: 'selectional',
    answer_var: 'tuna_sleep',
    option_1_jp: '泳ぎながら眠る',
    option_1_en: 'Sleep while swimming',
    option_2_jp: '水面に浮かんで眠る',
    option_2_en: 'Sleep on the surface of the water',
    option_3_jp: '海底で眠る',
    option_3_en: 'Sleep at the bottom of the ocean',
    next_script_id: 'whale_063_02',
  },
  {
    id: 'whale_063_02',
    text_jp: '正解は…',
    text_en: 'The answer is…',
    type: 'conversational',
    next_script_id: 'whale_063_03',
  },
  {
    id: 'whale_063_03',
    expression: 'happy',
    text_jp: '「泳ぎながら眠る」ラ！',
    text_en: 'They sleep while swimming!',
    type: 'conversational',
    next_script_id: 'whale_063_04',
  },
  {
    id: 'whale_063_04',
    text_jp:
      'マグロはずっと泳いでいないと\n呼吸ができないのラ！\n寝てる間に事故らないのラかね？',
    text_en:
      'If tuna stop swimming, they can’t breathe!\nIt’s amazing they don’t bump into anything while they’re asleep!',
    type: 'conversational',
  },
  {
    id: 'whale_064_01',
    move_to: 'c',
    text_jp: 'ちょっとおなかすいてきたラー',
    text_en: "I'm getting hungry!",
    type: 'conversational',
    next_script_id: 'whale_064_02',
  },
  {
    id: 'whale_064_02',
    text_jp: 'ごはんタイムにするラ？',
    text_en: 'Want to take a break for food or a snack?',
    type: 'conversational',
  },
  {
    id: 'whale_065_01',
    move_to: 'c',
    text_jp: 'おなかがグーグーないてるラ',
    text_en: 'My tummy is growling!',
    type: 'conversational',
    next_script_id: 'whale_065_02',
  },
  {
    id: 'whale_065_02',
    expression: 'happy',
    text_jp: '今日のごはんがたのしみラー',
    text_en: "I can't wait for today’s meal!",
    type: 'conversational',
  },
  {
    id: 'whale_066_01',
    move_to: 'c',
    text_jp: 'うううう\nおなかがすき過ぎて\nガクガクするラー',
    text_en: 'Urghhh…\nI’m so hungry I’m feeling dizzy…',
    type: 'conversational',
    next_script_id: 'whale_066_02',
  },
  {
    id: 'whale_066_02',
    animation: 'cry',
    text_jp: '何か食べさせて欲しいラー',
    text_en: 'Can’t you please feed me something?',
    type: 'conversational',
  },
  {
    id: 'whale_067_01',
    move_to: 'c',
    text_jp: 'これはホントにやばいラー',
    text_en: 'I’m feeling really weak…',
    type: 'conversational',
    next_script_id: 'whale_067_02',
  },
  {
    id: 'whale_067_02',
    animation: 'cry',
    text_jp: '何か食べないと\n病気になっちゃうラー',
    text_en: 'I have to eat something soon or I’m going to get sick!',
    type: 'conversational',
  },
  {
    id: 'whale_068_01',
    move_to: 'c',
    text_jp: 'ちょっと体がかゆくなってきたラ',
    text_en: 'I feel itchy all over!',
    type: 'conversational',
    next_script_id: 'whale_068_02',
  },
  {
    id: 'whale_068_02',
    expression: 'happy',
    text_jp: 'お風呂に入って\nリフレッシュしたいラー',
    text_en: 'I want to take a bath and get refreshed!',
    type: 'conversational',
  },
  {
    id: 'whale_069_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'そろそろお風呂タイムに\nしませんかラ？',
    text_en: "It's about time for a bath, isn’t it?",
    type: 'conversational',
  },
  {
    id: 'whale_070_01',
    move_to: 'c',
    text_jp: '体がベタベタして\n気持ち悪いラー',
    text_en: 'I feel all grimy and gross!',
    type: 'conversational',
    next_script_id: 'whale_070_02',
  },
  {
    id: 'whale_070_02',
    animation: 'cry',
    text_jp: 'お風呂入らないと\n病気になっちゃうラー',
    text_en: 'If I don’t have a bath soon, I’m gonna get sick!',
    type: 'conversational',
  },
  {
    id: 'whale_071_01',
    move_to: 'c',
    text_jp: 'なんか生臭いと思ったら\n自分の体臭だったラー',
    text_en: 'Something is stinky…\nOh, it’s me!',
    type: 'conversational',
    next_script_id: 'whale_071_02',
  },
  {
    id: 'whale_071_02',
    animation: 'cry',
    text_jp: 'ショックラー\nお風呂入れてほしいラー',
    text_en: 'How embarrassing!\nLet me take a bath!',
    type: 'conversational',
  },
  {
    id: 'whale_072_01',
    move_to: 'c',
    text_jp: '{player_name}、\nちょっとだけあそんで\n欲しいラ…',
    text_en: 'Won’t you play with me a little, {player_name}?',
    type: 'conversational',
    next_script_id: 'whale_072_02',
  },
  {
    id: 'whale_072_02',
    expression: 'normal',
    text_jp: 'あ、ウソウソ\n{player_name}も\n忙しいんだから、がまんするラー',
    text_en:
      'Oh, that’s OK. \nI know you’re busy, {player_name}, so I’ll just wait.',
    type: 'conversational',
  },
  {
    id: 'whale_073_01',
    move_to: 'c',
    text_jp: 'もしおもちゃであそぶ時間が\nなかったら、おやつくれても…',
    text_en:
      'If you don’t have time to play with me, could you at least give me a snack?',
    type: 'conversational',
    next_script_id: 'whale_073_02',
  },
  {
    id: 'whale_073_02',
    expression: 'normal',
    text_jp: 'あ、ウソウソ\n{player_name}の\n都合に合わせるラよー',
    text_en:
      'No, no, that’s all right.\nI’ll wait until it’s a good time for you, {player_name}.',
    type: 'conversational',
  },
  {
    id: 'whale_074_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'ひっぐ、ひっぐ…\nひっ…\nぐぅぅ…',
    text_en: 'Sniff.. Sniff…\nSniff…\nSob…',
    type: 'conversational',
    next_script_id: 'whale_074_02',
  },
  {
    id: 'whale_074_02',
    animation: 'cry',
    text_jp: 'うぅ…\n{player_name}と\nあそびたいのラー……',
    text_en: 'Sigh…\nI want to play with you, {player_name}…',
    type: 'conversational',
  },
  {
    id: 'whale_075_01',
    move_to: 'c',
    text_jp: '最近、あまりかまってくれないラ？',
    text_en: 'You haven’t wanted to spend any time with me lately?',
    type: 'conversational',
    next_script_id: 'whale_075_02',
  },
  {
    id: 'whale_075_02',
    animation: 'angry',
    text_jp:
      'あまりほっとかれると、\n{player_name}を\n嫌いになっちゃうかもしれないラ！',
    text_en:
      'If you keep ignoring me, \nI won’t be friends with you anymore, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_076_01',
    move_to: 'c',
    text_jp: 'あっ…この感じ…\nこれは…\nトイレに行きたいのラ…',
    text_en: 'Oh.. Uh-oh…\nI think…\n…I need to use the bathroom…',
    type: 'conversational',
  },
  {
    id: 'whale_077_01',
    move_to: 'c',
    text_jp:
      '{pet_name}はもう\nオトナなのラから、おトイレは\n早めに行っておきたいのラ',
    text_en:
      '{pet_name} is a big whale, so I try to use the bathroom ahead of time.',
    type: 'conversational',
  },
  {
    id: 'whale_078_01',
    move_to: 'c',
    animation: 'angry',
    text_jp: 'うぐぐぐぐぅぅ…\n一刻も早くトイレに\n連れて行って欲しいのラ〜！',
    text_en: 'Groan….\nPlease take me to the bathroom soon!',
    type: 'conversational',
  },
  {
    id: 'whale_079_01',
    move_to: 'c',
    text_jp: 'おトイレおトイレ！\n緊急事態なのラ！',
    text_en: 'The toilet! The toilet!\nIt’s an emergency!',
    type: 'conversational',
    next_script_id: 'whale_079_02',
  },
  {
    id: 'whale_079_02',
    animation: 'cry',
    text_jp: 'おもらしだけは\nなんとしても避けたいのラ…！',
    text_en: 'I don’t want to have an accident!',
    type: 'conversational',
  },
  {
    id: 'whale_080_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '後ろに何かいる気がするラ！\n怖くて振り向けないラ！',
    text_en:
      'I feel like there’s something behind me!\nI’m too scared to look back!',
    type: 'conversational',
  },
  {
    id: 'whale_081_01',
    move_to: 'c',
    text_jp: '壁のシミが人の顔にしか\n見えないラ！\n怖すぎるラ！',
    text_en: 'The stains on the walls look like faces!\nI’m terrified!',
    type: 'conversational',
    next_script_id: 'whale_081_02',
  },
  {
    id: 'whale_081_02',
    text_jp: '何かで気をまぎらわしてほしいラ！',
    text_en: 'Can’t you say something to distract me?',
    type: 'conversational',
  },
  {
    id: 'whale_082_01',
    move_to: 'c',
    text_jp: 'うーん。\nちょっと病気になっちゃった\nみたいラ〜',
    text_en: 'Groan…\nI think I’m sick…',
    type: 'conversational',
    next_script_id: 'whale_082_02',
  },
  {
    id: 'whale_082_02',
    text_jp: '申し訳ないけど、おクスリを\n飲ませてもらえるラ？',
    text_en: "If you don't mind, can you give me some medicine?",
    type: 'conversational',
  },
  {
    id: 'whale_083_01',
    move_to: 'c',
    text_jp: 'けっこう苦しくなってきたラー',
    text_en: 'I’m really feeling bad…',
    type: 'conversational',
    next_script_id: 'whale_083_02',
  },
  {
    id: 'whale_083_02',
    text_jp: '重症化する前に、\nおクスリ飲ませてほしいラー',
    text_en: 'Won’t you please give me some medicine before I get any worse?',
    type: 'conversational',
  },
  {
    id: 'whale_084_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'は……\n歯が痛いラー\nどうやらおやつを食べ過ぎたラー',
    text_en: 'O-Ow!\nMy tooth hurts…\nI must have eaten too many snacks.',
    type: 'conversational',
    next_script_id: 'whale_084_02',
  },
  {
    id: 'whale_084_02',
    expression: 'sad',
    text_jp: '虫歯のおクスリ、\n飲ませてほしいラー',
    text_en: 'Can you give me some toothache medicine?',
    type: 'conversational',
  },
  {
    id: 'whale_085_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '歯が痛くて何も\n食べられないラー\n悲しいラー',
    text_en: 'My tooth hurts too much to eat anything!\nThat’s depressing…',
    type: 'conversational',
    next_script_id: 'whale_085_02',
  },
  {
    id: 'whale_085_02',
    expression: 'sad',
    text_jp: '虫歯のおクスリ、\n飲ませてほしいラー',
    text_en: 'Please give me some toothache medicine!',
    type: 'conversational',
  },
  {
    id: 'whale_086_01',
    move_to: 'c',
    text_jp: 'そろそろ眠たくなってきたラ',
    text_en: 'I’m getting sleepy…',
    type: 'conversational',
    next_script_id: 'whale_086_02',
  },
  {
    id: 'whale_086_02',
    animation: 'waive',
    text_jp: 'おやすみなさいラー',
    text_en: 'Good night…',
    type: 'conversational',
  },
  {
    id: 'whale_087_01',
    move_to: 'c',
    text_jp:
      'しんでしまったのラー\nせっかくここまで育ててくれたのに\n申し訳ないラー',
    text_en: 'I died…\nAfter all that time you spent raising me, I’m sorry…\n',
    type: 'conversational',
    next_script_id: 'whale_087_02',
  },
  {
    id: 'whale_087_02',
    text_jp:
      '{player_name}には\n{pet_name}がまだ小さい\n頃から、本当にお世話になったラー',
    text_en:
      'You took really good care of\n{pet_name} since I was really little, {player_name}…',
    type: 'conversational',
    next_script_id: 'whale_087_03',
  },
  {
    id: 'whale_087_03',
    text_jp:
      'もし生まれ変わってまた会えたら、\n今度こそぶるぶるカフェで\nデビューする姿を見せたいラー',
    text_en:
      'If I get reborn and we see each other again, I’ll show you I can debut at the BuruBuru Café for sure next time!',
    type: 'conversational',
  },
  {
    id: 'whale_088_01',
    move_to: 'c',
    text_jp: 'これは危険な状態ラ！\nほっとくと死んでしまうラ！',
    text_en: 'I’m almost gone!\nYou have to do something, or I’ll die!',
    type: 'conversational',
    next_script_id: 'whale_088_02',
  },
  {
    id: 'whale_088_02',
    text_jp: 'すぐに万能コロンを\n使って欲しいラ！',
    text_en: 'I need you to use the Magic Potion right now!',
    type: 'conversational',
  },
  {
    id: 'whale_089_01',
    move_to: 'c',
    text_jp: 'おでかけがしたいラー\nお友だちのおうちに行きたいラー',
    text_en: 'I want to go somewhere!\nCan I go over to my friend’s house?',
    type: 'conversational',
    next_script_id: 'whale_089_02',
  },
  {
    id: 'whale_089_02',
    expression: 'happy',
    text_jp: 'お友だちといっしょに\nお水をかけ合いっこしたいラー',
    text_en: 'I want to have a water fight with my friend!',
    type: 'conversational',
  },
  {
    id: 'whale_090_01',
    move_to: 'c',
    text_jp: '{friend.player_name}が\nあそびに来てたラよ〜',
    text_en: '{friend.player_name} came over to play!',
    type: 'conversational',
    next_script_id: 'whale_090_02',
  },
  {
    id: 'whale_090_02',
    expression: 'happy',
    text_jp: 'たくさんあそんでもらったラ〜\n今度お返しに行くラ〜',
    text_en: 'They played with me a lot!\nI want to repay them next time!',
    type: 'conversational',
  },
  {
    id: 'whale_091_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n海に向かって何て叫ぶか\n聞いてみたら、',
    text_en: 'I asked {friend.player_name} what they would shout at the ocean!',
    type: 'conversational',
    next_script_id: 'whale_091_02',
  },
  {
    id: 'whale_091_02',
    text_jp: '{friend.shout_to_sea}って\n言ってたラ！',
    text_en: 'They said {friend.shout_to_sea}!',
    type: 'conversational',
    next_script_id: 'whale_091_03',
  },
  {
    id: 'whale_091_03',
    expression: 'happy',
    text_jp: 'みんなには内緒ラよ？',
    text_en: 'Don’t tell anyone, OK?',
    type: 'conversational',
  },
  {
    id: 'whale_092_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\n海に行くときに絶対に持って行く\nマストアイテムを聞いたら、',
    text_en:
      'I asked {friend.player_name} what they absolutely must have at the beach.',
    type: 'conversational',
    next_script_id: 'whale_092_02',
  },
  {
    id: 'whale_092_02',
    text_jp: '{friend.must_have_beach}って\n言ってたラ！',
    text_en: 'They said {friend.must_have_beach}!',
    type: 'conversational',
    next_script_id: 'whale_092_03',
  },
  {
    id: 'whale_092_03',
    animation: 'anxious',
    text_jp: '一体何に使うのか、\n{pet_name}には\n検討もつかないラ〜',
    text_en: '{pet_name} has no idea what they need that for!',
    type: 'conversational',
  },
  {
    id: 'whale_093_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\nもし生まれ変わるとしたら\n男女どっちがいいか聞いたら、',
    text_en:
      "I asked {friend.player_name} if they'd rather be reborn as a boy or a girl!",
    type: 'conversational',
    next_script_id: 'whale_093_02',
  },
  {
    id: 'whale_093_02',
    text_jp:
      '{friend.man_woman}がいいって言ってたのラ！\nどうして？って聞いたら、',
    text_en: 'They said {friend.man_woman}!\nWhen I asked them why…',
    type: 'conversational',
    next_script_id: 'whale_093_03',
  },
  {
    id: 'whale_093_03',
    text_jp: '{friend.man_woman_reason}って\n言ってたのラ！',
    text_en: 'They said {friend.man_woman_reason}!',
    type: 'conversational',
    next_script_id: 'whale_093_04',
  },
  {
    id: 'whale_093_04',
    expression: 'sad',
    text_jp: '{pet_name}には\nちょっとよくわからないラ…',
    text_en: '{pet_name} doesn’t really get it…',
    type: 'conversational',
  },
  {
    id: 'whale_094_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n新しく校則を作るならどんな\n校則を作るか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they could make a new school rule, what would it be?',
    type: 'conversational',
    next_script_id: 'whale_094_02',
  },
  {
    id: 'whale_094_02',
    text_jp: '{friend.shcool_regulations}って\n言ってたのラ！',
    text_en: 'They said {friend.shcool_regulations}!',
    type: 'conversational',
    next_script_id: 'whale_094_03',
  },
  {
    id: 'whale_094_03',
    expression: 'happy',
    text_jp: '{friend.player_name}って\n本当に面白いラ！',
    text_en: '{friend.player_name} is so funny!',
    type: 'conversational',
  },
  {
    id: 'whale_095_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n無人島に1つだけ持って行くとしたら\n何を持っていくか聞いたら、',
    text_en:
      'I asked {friend.player_name} If they could only take one thing to a desert island, what would it be?',
    type: 'conversational',
    next_script_id: 'whale_095_02',
  },
  {
    id: 'whale_095_02',
    text_jp: '{friend.bring_to_island}って\n言ってたのラ！',
    text_en: 'They said {friend.bring_to_island}!',
    type: 'conversational',
    next_script_id: 'whale_095_03',
  },
  {
    id: 'whale_095_03',
    expression: 'happy',
    text_jp: '{friend.player_name}が\nいれば無人島も怖くないのラ！',
    text_en:
      'A desert island wouldn’t be scary as long as {friend.player_name} is around!',
    type: 'conversational',
  },
  {
    id: 'whale_096_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に、\nいま一番欲しいものを聞いたら、',
    text_en:
      'I asked {friend.player_name} what the thing they want most right now is!',
    type: 'conversational',
    next_script_id: 'whale_096_02',
  },
  {
    id: 'whale_096_02',
    text_jp: '{friend.want_most}って\n言ってたラ！',
    text_en: 'They said {friend.want_most}!',
    type: 'conversational',
    next_script_id: 'whale_096_03',
  },
  {
    id: 'whale_096_03',
    expression: 'happy',
    text_jp: '今度こっそりプレゼント\nしてみるラ？',
    text_en: 'Maybe you could surprise them with it?',
    type: 'conversational',
  },
  {
    id: 'whale_097_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n将来の夢を聞いたら、',
    text_en:
      'I asked {friend.player_name} what they want to be when they grow up',
    type: 'conversational',
    next_script_id: 'whale_097_02',
  },
  {
    id: 'whale_097_02',
    text_jp: '{friend.future_dream}って\n言ってたら！',
    text_en: 'They said {friend.future_dream}!',
    type: 'conversational',
    next_script_id: 'whale_097_03',
  },
  {
    id: 'whale_097_03',
    expression: 'happy',
    text_jp: 'みんなには内緒ラよ？',
    text_en: 'Keep it a secret, OK?',
    type: 'conversational',
  },
  {
    id: 'whale_098_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n夜寝る前の習慣を聞いたら、',
    text_en: 'I asked {friend.player_name} what they do before bedtime!',
    type: 'conversational',
    next_script_id: 'whale_098_02',
  },
  {
    id: 'whale_098_02',
    text_jp: '{friend.habit_before_sleep}って\n言ってたラ！',
    text_en: 'They said {friend.habit_before_sleep}!',
    type: 'conversational',
    next_script_id: 'whale_098_03',
  },
  {
    id: 'whale_098_03',
    expression: 'happy',
    text_jp: 'さすが\n{friend.player_name}ラ！\nよくわからないけどすごいのラ！',
    text_en:
      'That’s {friend.player_name} for you!\nI can’t imagine why, but it’s great!',
    type: 'conversational',
  },
  {
    id: 'whale_099_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n自分がオトナになったって\n思うのはどんなときか聞いたら、',
    text_en:
      'I asked {friend.player_name} when they felt like a real grown-up!',
    type: 'conversational',
    next_script_id: 'whale_099_02',
  },
  {
    id: 'whale_099_02',
    text_jp: '{friend.grownup}って\n言ってたラ！',
    text_en: 'They said {friend.grownup}!',
    type: 'conversational',
    next_script_id: 'whale_099_03',
  },
  {
    id: 'whale_099_03',
    expression: 'happy',
    text_jp: '{player_name}も\nそう思うラ？',
    text_en: 'Do you feel the same, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'whale_100_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n一番ひどいと思う悪口を\n言ってみてってお願いしたら、',
    text_en:
      'I asked {friend.player_name} the worst insult they could think of!',
    type: 'conversational',
    next_script_id: 'whale_100_02',
  },
  {
    id: 'whale_100_02',
    text_jp: '{friend.slander}って\n言ってたラ！',
    text_en: 'They said {friend.slander}!',
    type: 'conversational',
    next_script_id: 'whale_100_03',
  },
  {
    id: 'whale_100_03',
    expression: 'sad',
    text_jp: 'ひどすぎて一瞬泣きそうになったラ',
    text_en: 'It was so horrible I almost cried!',
    type: 'conversational',
  },
  {
    id: 'whale_101_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nお料理が得意かどうか\n聞いたら、',
    text_en: 'I asked {friend.player_name} if they’re a good cook!',
    type: 'conversational',
    case: 'friend.good_at_cooking',
    next_script_id_1: 'whale_101_02',
    next_script_id_2: 'whale_101_03',
  },
  {
    id: 'whale_101_02',
    expression: 'happy',
    text_jp: '得意って言ってたのラ！\n今度何か作ってもらうラ！',
    text_en: 'They said they are!\nYou should have them make you something!',
    type: 'conversational',
  },
  {
    id: 'whale_101_03',
    text_jp: 'そうでもないって言ってたのラ！',
    text_en: 'They said they aren’t!',
    type: 'conversational',
    next_script_id: 'whale_101_04',
  },
  {
    id: 'whale_101_04',
    expression: 'happy',
    text_jp: 'と言いつつ普通にできるパターン\nじゃないかと疑ってるラ！',
    text_en: 'I still think they’re probably at least average!',
    type: 'conversational',
  },
  {
    id: 'whale_102_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\n海に行ったら',
    text_en: 'When {friend.player_name} goes to the beach…',
    type: 'conversational',
    case: 'friend.todo_in_ocean',
    next_script_id_1: 'whale_102_02',
    next_script_id_2: 'whale_102_03',
    next_script_id_3: 'whale_102_04',
  },
  {
    id: 'whale_102_02',
    text_jp: '泳ぐのが好きらしいラ！\n意外にガチ勢なとこあるラね！',
    text_en: 'They like to swim!\nThey’re surprisingly passionate about it!',
    type: 'conversational',
  },
  {
    id: 'whale_102_03',
    text_jp: '砂浜であそぶのが好きらしいラ！\n足腰も鍛えられて、一石二鳥ラ！',
    text_en:
      'They like to play in the sand on the beach!\nYou can condition your lower body at the same time!',
    type: 'conversational',
  },
  {
    id: 'whale_102_04',
    expression: 'happy',
    text_jp:
      'のんびりするのが好きらしいラ！\nわざわざ海に行って何もしないって\n実は一番のぜいたくラ！',
    text_en:
      'They like to just relax!\nGoing all the way to the beach and not doing anything in particular is actually the best!',
    type: 'conversational',
  },
  {
    id: 'whale_103_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\n男女の友情は成立すると\n思うか聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they think guys and girls can just be friends!',
    type: 'conversational',
    case: 'friend.friendship_with_opposite_sex',
    next_script_id_1: 'whale_103_02',
    next_script_id_2: 'whale_103_03',
  },
  {
    id: 'whale_103_02',
    text_jp: '成立すると思うって言ってたラ！\n{player_name}は\nどう思うラ？',
    text_en: 'They said they do!\nWhat do you think, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'whale_103_03',
    text_jp: '成立しないと思うって言ってたラ！\n{player_name}は\nどう思うラ？',
    text_en: 'They said they don’t!\nWhat do you think, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'whale_104_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\nファスナーが開いている人を見たら\n教えてあげるかどうか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they’re the type to tell someone if their bag is open!',
    type: 'conversational',
    case: 'friend.xyz',
    next_script_id_1: 'whale_104_02',
    next_script_id_2: 'whale_104_03',
  },
  {
    id: 'whale_104_02',
    expression: 'happy',
    text_jp: '教えるって言ってたラ！\nなかなかの胆力の持ち主ラ！',
    text_en: 'They said they would!\nPretty brave, right?',
    type: 'conversational',
  },
  {
    id: 'whale_104_03',
    text_jp: '教えないって言ってたラ！\nあえて言わない優しさも\nあるラよね〜',
    text_en:
      'They said they wouldn’t!\nYou wouldn’t want to embarrass them, after all!',
    type: 'conversational',
  },
  {
    id: 'whale_105_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n思い出しムカつきとかしちゃうか\nどうか聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they ever get annoyed by a memory!',
    type: 'conversational',
    case: 'friend.angry_memory',
    next_script_id_1: 'whale_105_02',
    next_script_id_2: 'whale_105_03',
  },
  {
    id: 'whale_105_02',
    text_jp:
      'けっこうしちゃうって言ってたラ！\n一人で怒ってるのを見かけたら、\nそっとしておくのがいいラ！',
    text_en:
      'They said they do!\nIf you see them by themselves looking angry, better leave them alone!',
    type: 'conversational',
  },
  {
    id: 'whale_105_03',
    text_jp: 'あまりしないって言ってたラ！\nコツを教えて欲しいラ！',
    text_en: "They said they don't!\nI wish I could learn that trick!",
    type: 'conversational',
  },
  {
    id: 'whale_106_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n買い物すときにネットのレビューを\n気にするかどうか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they read online reviews before they buy something!',
    type: 'conversational',
    case: 'friend.review',
    next_script_id_1: 'whale_106_02',
    next_script_id_2: 'whale_106_03',
  },
  {
    id: 'whale_106_02',
    text_jp: 'けっこう気にするって言ってたラ！',
    text_en: 'They said they do!',
    type: 'conversational',
    next_script_id: 'whale_106_04',
  },
  {
    id: 'whale_106_03',
    text_jp: 'あまり気にしないって言ってたラ！',
    text_en: 'They said they don’t!',
    type: 'conversational',
    next_script_id: 'whale_106_04',
  },
  {
    id: 'whale_106_04',
    text_jp: '{player_name}は\n気にするほうラ？',
    text_en: 'Do you check the reviews, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'whale_107_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n海に行くなら日本と海外\nどっちがいい？って聞いたら、',
    text_en:
      'I asked {friend.player_name} if they’d rather go to the beach in Japan or somewhere else!',
    type: 'conversational',
    case: 'friend.japan_oversea',
    next_script_id_1: 'whale_107_02',
    next_script_id_2: 'whale_107_03',
  },
  {
    id: 'whale_107_02',
    text_jp: '日本って言ってたラ！\nやっぱり近場が一番ラ！',
    text_en: 'They said Japan!\nMakes sense if you live there!',
    type: 'conversational',
  },
  {
    id: 'whale_107_03',
    text_jp: '海外って言ってたラ！\n{pet_name}は\nどっちもいいと思うラよ',
    text_en: 'They said somewhere else!\nAny beach is OK with {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_108_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n海の家で食べるなら何が\nいいか聞いたら、',
    text_en: 'I asked {friend.player_name} what they like to eat at the beach!',
    type: 'conversational',
    next_script_id: 'whale_108_02',
  },
  {
    id: 'whale_108_02',
    text_jp: '{friend.food_beach}がいいって\n言ってたラ！',
    text_en: 'They said {friend.food_beach}!',
    type: 'conversational',
    next_script_id: 'whale_108_03',
  },
  {
    id: 'whale_108_03',
    expression: 'happy',
    text_jp: '正直、海の家では\n何食べてもおいしいラ！',
    text_en: 'Honestly, everything tastes better at the beach!',
    type: 'conversational',
  },
  {
    id: 'whale_109_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に、\n名字と名前、どっちで\n呼ばれることが多いか聞いたら、',
    text_en:
      'I asked {friend.player_name} if most people call them by their first or last name!',
    type: 'conversational',
    case: 'friend.last_first',
    next_script_id_1: 'whale_109_02',
    next_script_id_2: 'whale_109_03',
  },
  {
    id: 'whale_109_02',
    text_jp: '名字で呼ばれることが多いって\n言ってたラ！',
    text_en: 'They said most people call them by their last name!',
    type: 'conversational',
  },
  {
    id: 'whale_109_03',
    text_jp: '下の名前で呼ばれることが\n多いって言ってたラ！',
    text_en: 'They said most people call them by their first name!',
    type: 'conversational',
    next_script_id: 'whale_109_04',
  },
  {
    id: 'whale_109_04',
    expression: 'happy',
    text_jp: '{player_name}も\nフレンドリーに\n下の名前で呼んでみるラ？',
    text_en:
      'You should call them by their first name for a change, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_110_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}は、\nけっこう',
    text_en: 'Actually, {friend.player_name}…',
    type: 'conversational',
    case: 'friend.first_meeting',
    next_script_id_1: 'whale_110_02',
    next_script_id_2: 'whale_110_03',
  },
  {
    id: 'whale_110_02',
    text_jp: '初対面からグイグイ来てくれる方が\n好きらしいラよ',
    text_en: '…likes it when someone they’ve just met is friendly with them!',
    type: 'conversational',
  },
  {
    id: 'whale_110_03',
    text_jp: '初対面からグイグイ来られると\nちょっと引いちゃうらしいラ',
    text_en:
      '…doesn’t like it when someone they’ve just met is friendly with them!',
    type: 'conversational',
    next_script_id: 'whale_110_04',
  },
  {
    id: 'whale_110_04',
    expression: 'happy',
    text_jp: '{player_name}も\nあまりグイグイ行かないように\n気をつけるラ！',
    text_en: 'So be careful not to ask too many questions, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_111_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}は、',
    text_en: 'Did you know that {friend.player_name}…',
    type: 'conversational',
    case: 'friend.self_confidence',
    next_script_id_1: 'whale_111_02',
    next_script_id_2: 'whale_111_03',
  },
  {
    id: 'whale_111_02',
    expression: 'happy',
    text_jp:
      'けっこう自分に自信があるタイプ\nらしいラ！\n自信がある人って素敵ラ！',
    text_en:
      '…is actually pretty self-confident?\nIt’s great to be able to believe in yourself!',
    type: 'conversational',
  },
  {
    id: 'whale_111_03',
    expression: 'sad',
    text_jp: 'あまり自分に自信がないタイプ\nらしいのラ',
    text_en: '…actually has pretty low self-esteem.',
    type: 'conversational',
    next_script_id: 'whale_111_04',
  },
  {
    id: 'whale_111_04',
    expression: 'normal',
    text_jp: 'もっと自信持っても\nいいと思うんラけどね〜',
    text_en: 'But I think they have a lot to be confident about!',
    type: 'conversational',
  },
  {
    id: 'whale_112_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nSかMだとどっちって聞いたら、',
    text_en: 'I asked {friend.player_name} if they prefer S or M!',
    type: 'conversational',
    case: 'friend.sm',
    next_script_id_1: 'whale_112_02',
    next_script_id_2: 'whale_112_03',
  },
  {
    id: 'whale_112_02',
    text_jp:
      'ドSだって言ってたラ！\nコーヒーのサイズに「ドS」なんて\nあるの、知らなかったラ！',
    text_en:
      'They said they prefer a “Super S!”\nI didn’t know coffee came in a “Super S” size!',
    type: 'conversational',
  },
  {
    id: 'whale_112_03',
    text_jp:
      'ドMだって言ってたラ！\nコーヒーのサイズに「ドM」なんて\nあるの、知らなかったラ！',
    text_en:
      'They said they prefer a “Super M!”\nI didn’t know coffee came in a “Super M” size!',
    type: 'conversational',
  },
  {
    id: 'whale_113_01',
    move_to: 'c',
    text_jp: 'もうオトナなのラー。\nこれからもよろしくラー。',
    text_en: 'I’m all grown up!\nLet’s stay friends!',
    type: 'conversational',
  },
  {
    id: 'whale_114_01',
    animation: 'waive',
    text_jp: 'あそびに来たのラー\nおじゃましますラー',
    text_en: 'I’m here to hang out.\nCan I make myself at home?',
    type: 'conversational',
  },
  {
    id: 'whale_115_01',
    animation: 'waive',
    text_jp: 'いらっしゃいませラー',
    text_en: 'Welcome!',
    type: 'conversational',
  },
  {
    id: 'whale_116_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'たくさんお世話してくれて\nありがとうなのラー\n感謝のしるしラー',
    text_en: 'Thanks for talking with me so much!\nI appreciate it!',
    type: 'conversational',
  },
  {
    id: 'whale_117_01',
    text_jp: 'そろそろおいとまするラー\n今度はうちに遊びに来るラー',
    text_en: 'I’m going to get going!\nCome to my place next time!',
    type: 'conversational',
  },
  {
    id: 'whale_118_01',
    text_jp: 'とっても楽しかったラー\nまたいつでも来て欲しいラー',
    text_en: 'That was a lot of fun!\nCome by again any time!',
    type: 'conversational',
  },
  {
    id: 'whale_119_01',
    text_jp: 'どうやら\n{friend.player_name}が\n帰ってきたみたいラー',
    text_en: 'Looks like {friend.player_name} is back!',
    type: 'conversational',
    next_script_id: 'whale_119_02',
  },
  {
    id: 'whale_119_02',
    text_jp: 'あまり長居しても悪いラから、\n今日はこのへんでおいとまするラー',
    text_en: "I don't want to overstay my welcome, so I’ll get going.",
    type: 'conversational',
  },
  {
    id: 'whale_120_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないラー',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'whale_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないラー',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'whale_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'それよりも、今は早く\n万能コロンをかけて欲しいのラ…',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'whale_123_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないラ〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'whale_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったラー！\nどうもありがとうラー！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'whale_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったラー！\nどうもありがとうラー！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'whale_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '助かったのラー！\n今度ばかりはヒヤヒヤしたラー！',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'whale_127_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったラ…\nもう1回試してみて欲しいラ…',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'whale_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったラ…\nもう1回試してみて欲しいラ…',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'whale_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったラ…\nもう1回試してみて欲しいラ…',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'whale_130_01',
    text_jp:
      '{pet_name}と一緒に\nぶるぶるカフェにビッグウェーブを\n起こさないかラ？',
    text_en: 'Will {pet_name} help make big waves at the BuruBuru Café?',
    type: 'conversational',
  },
  {
    id: 'whale_131_01',
    expression: 'normal',
    text_jp:
      'お誘いありがとうラー\n{invitee.player_name}とも\n相談して真剣に考えるラ！',
    text_en:
      'Thanks for the invitation!\nI’ll talk to {invitee.player_name} and really think about it!',
    type: 'conversational',
  },
  {
    id: 'whale_132_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'ドキドキなのラー',
    text_en: "I'm getting excited!",
    type: 'conversational',
  },
  {
    id: 'whale_133_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '{inviter.player_name}から\nコンビ結成のお誘いを\nもらったんラけど',
    text_en: '{inviter.player_name} asked if I want to join their team!',
    type: 'conversational',
    next_script_id: 'whale_133_02',
  },
  {
    id: 'whale_133_02',
    text_jp: 'どうしたらいいと思うラ…？',
    text_en: 'What do you think I should say?',
    type: 'conversational',
  },
  {
    id: 'whale_134_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{invitee.player_name}が\nお返事の準備ができたみたいラ！',
    text_en: 'Looks like {invitee.player_name} came to a decision!',
    type: 'conversational',
  },
  {
    id: 'whale_135_01',
    expression: 'normal',
    text_jp: '{invitee.player_name}とも\n相談して真剣に考えたんラけど…',
    text_en: 'I talked it over with {invitee.player_name}, and…',
    type: 'conversational',
  },
  {
    id: 'whale_136_01',
    expression: 'happy',
    text_jp:
      'このお誘い、お受けするラ！\n一緒にビッグウェーブを\n巻き起こすラ！',
    text_en: 'I’ll accept your invitation!\nLet’s make big waves together!',
    type: 'conversational',
  },
  {
    id: 'whale_137_01',
    expression: 'normal',
    text_jp: 'ごめんラけど、今回は\nお断りさせていただくラ…',
    text_en: 'Sorry, but I’m going to have to pass this time.',
    type: 'conversational',
  },
  {
    id: 'whale_138_01',
    expression: 'normal',
    text_jp: '{invitee.player_name}から\nメッセージを預かっているラ',
    text_en: 'I have a message from {invitee.player_name}!',
    type: 'conversational',
  },
  {
    id: 'whale_139_01',
    expression: 'normal',
    text_jp: '「{invitee.message}」',
    text_en: '"{invitee.message}"',
    type: 'conversational',
  },
  {
    id: 'whale_140_01',
    expression: 'very_sad',
    text_jp: '気にしなくていいラー…',
    text_en: 'Don’t worry about it…',
    type: 'conversational',
  },
  {
    id: 'giraffe_001_01',
    expression: 'normal',
    animation: 'waive',
    text_jp: 'リンリン！',
    text_en: 'Hi there!',
    type: 'conversational',
  },
  {
    id: 'giraffe_002_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'あれ？{pet_name}、\n玄関の鍵かけたかリン？\nちょっと確認してくるリン！',
    text_en:
      'Huh? Did {pet_name} forget to lock my door?\nI’m going to go check!',
    type: 'conversational',
    next_script_id: 'giraffe_002_02',
  },
  {
    id: 'giraffe_002_02',
    expression: 'normal',
    move_to: 'lm',
    text_jp: '……\n………',
    text_en: '…….\n………',
    type: 'conversational',
    next_script_id: 'giraffe_002_03',
  },
  {
    id: 'giraffe_002_03',
    expression: 'happy',
    move_to: 'c',
    text_jp: '大丈夫だったリン！',
    text_en: 'It was OK!',
    type: 'conversational',
  },
  {
    id: 'giraffe_003_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '呼んだリン？\n{pet_name}と\nあそんでくれるリン？',
    text_en: 'Did you call me?\nAre you going to play with {pet_name}?',
    type: 'conversational',
  },
  {
    id: 'giraffe_004_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{pet_name}、ちゃんと\nぶるぶるカフェでデビュー\nできるリンかねー？',
    text_en: 'Do you think {pet_name} can debut at the BuruBuru Café?',
    type: 'conversational',
    next_script_id: 'giraffe_004_02',
  },
  {
    id: 'giraffe_004_02',
    text_jp:
      '{pet_name}とコンビを\n組んでくれるヒトなんて\n本当にいるのかリン？',
    text_en: 'I wonder who would actually team up with {pet_name}?',
    type: 'conversational',
    next_script_id: 'giraffe_004_03',
  },
  {
    id: 'giraffe_004_03',
    text_jp:
      '仮にデビューできたとしても、\n人気者になれるかどうかは、\nまた別の話だリン？',
    text_en: 'Even if I debut, there’s no guarantee I’ll be popular.',
    type: 'conversational',
    next_script_id: 'giraffe_004_04',
  },
  {
    id: 'giraffe_004_04',
    text_jp:
      '運良く人気者になれたとしても、\nその人気がいつまでも続くとは\n限らないリンし…',
    text_en: 'Even if I’m popular, there’s no guarantee it’ll last.',
    type: 'conversational',
    next_script_id: 'giraffe_004_05',
  },
  {
    id: 'giraffe_004_05',
    expression: 'sad',
    text_jp: '……\nあれ？何の話だったリン？',
    text_en: '…What were we talking about?',
    type: 'conversational',
  },
  {
    id: 'giraffe_005_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{pet_name}、よく\n話が長いって言われるリン',
    text_en: 'They tell me {pet_name} tends to go on for a long, long time.',
    type: 'conversational',
    next_script_id: 'giraffe_005_02',
  },
  {
    id: 'giraffe_005_02',
    text_jp: '{player_name}も、\nもし{pet_name}の話が\n長いなって感じたら、',
    text_en:
      'Hey, {player_name}.\nIf you think {pet_name} goes on for a long, long time…',
    type: 'conversational',
    next_script_id: 'giraffe_005_03',
  },
  {
    id: 'giraffe_005_03',
    text_jp:
      'いつでも言って欲しいリン！\n{pet_name}自身は、\nそんなに話が長いとは',
    text_en:
      '…just let me know!\nI don’t think that {pet_name} actually goes on…',
    type: 'conversational',
    next_script_id: 'giraffe_005_04',
  },
  {
    id: 'giraffe_005_04',
    text_jp:
      '思わないリンけどねー。\nそもそも、話が長いかどうかなんて\n個人の感想だリン？',
    text_en:
      '…and on, and on… and on… that long.\nIt depends on the person how long something feels anyway!',
    type: 'conversational',
    next_script_id: 'giraffe_005_05',
  },
  {
    id: 'giraffe_005_05',
    expression: 'happy',
    text_jp: '乾燥と言えば、{pet_name}、\n最近良い加湿器見つけたリンけど…',
    text_en:
      'Speaking of feelings, {pet_name} found a good humidifier recently…',
    type: 'conversational',
    next_script_id: 'giraffe_005_06',
  },
  {
    id: 'giraffe_005_06',
    animation: 'surprised',
    text_jp: 'え？\nこういうとこだリン？',
    text_en: 'Huh? What’s my point?',
    type: 'conversational',
  },
  {
    id: 'giraffe_006_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{pet_name}もすっかり\nオトナになってしまったリン！',
    text_en: '{pet_name} is a grown-up!',
    type: 'conversational',
    next_script_id: 'giraffe_006_02',
  },
  {
    id: 'giraffe_006_02',
    text_jp: 'コンビニでお菓子を買うとき、\nなんと値段を見ずに買うリン！',
    text_en: 'I can buy snacks at a store without looking at the price!',
    type: 'conversational',
    next_script_id: 'giraffe_006_03',
  },
  {
    id: 'giraffe_006_03',
    expression: 'happy',
    text_jp: '代わりに、カロリー表示は\nしっかりチェックするリン！',
    text_en: 'Instead, I check the calories!',
    type: 'conversational',
  },
  {
    id: 'giraffe_007_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '{pet_name}、最近\n悩んでることがあるリン…',
    text_en: 'There’s something {pet_name} is having a problem with lately…',
    type: 'conversational',
    next_script_id: 'giraffe_007_02',
  },
  {
    id: 'giraffe_007_02',
    expression: 'sad',
    text_jp: '後ろに座っている人に申し訳なくて\n映画館に行けないリン…',
    text_en:
      "I can't go to the movie theater because I feel bad for the people behind me…",
    type: 'conversational',
    next_script_id: 'giraffe_007_03',
  },
  {
    id: 'giraffe_007_03',
    expression: 'sad',
    text_jp: '一番後ろの列だと、あまり\n映画に集中できない\nタイプなのリン…',
    text_en:
      'I can’t really focus on the movie when I’m all the way in the back…',
    type: 'conversational',
  },
  {
    id: 'giraffe_008_01',
    expression: 'sad',
    move_to: 'c',
    text_jp: '{pet_name}、最近\n悩んでることがあるリン…',
    text_en: 'There’s something {pet_name} is having a problem with lately…',
    type: 'conversational',
    next_script_id: 'giraffe_008_02',
  },
  {
    id: 'giraffe_008_02',
    expression: 'sad',
    text_jp:
      'のれんをくぐるときに、\nちょいちょいツノがのれんに\n引っかかるリン…',
    text_en:
      'When I go through a shop curtain, my horns get stuck in the fabric…',
    type: 'conversational',
    next_script_id: 'giraffe_008_03',
  },
  {
    id: 'giraffe_008_03',
    text_jp: 'クビがガクってなって、\nけっこうつらいのリン…',
    text_en: 'It yanks my neck back and hurts!',
    type: 'conversational',
  },
  {
    id: 'giraffe_009_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{pet_name}もすっかり\nオトナになってしまったリン！',
    text_en: '{pet_name} is a grown-up!',
    type: 'conversational',
    next_script_id: 'giraffe_009_02',
  },
  {
    id: 'giraffe_009_02',
    text_jp:
      '雪が降ったら、はしゃぐよりも、\n道路や電車大丈夫かなって\n思うようになったリン！',
    text_en:
      'When it snows, I don’t play in it so much as worry about the roads and trains!',
    type: 'conversational',
    next_script_id: 'giraffe_009_03',
  },
  {
    id: 'giraffe_009_03',
    expression: 'happy',
    text_jp: 'でも軒下のツララを見ると、\nいまだに嬉しくなってしまうリン！',
    text_en:
      'But when I see icicles hanging from the roof, I still get excited!',
    type: 'conversational',
  },
  {
    id: 'giraffe_010_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'ん？何か心配ごとがあるリン？\n{pet_name}に\n話してみるリン？',
    text_en:
      'Hm? Are you worried about something?\nDo you want to talk to {pet_name} about it?',
    type: 'conversational',
    next_script_id: 'giraffe_010_02',
  },
  {
    id: 'giraffe_010_02',
    text_jp: 'あ、特にないリン？\nじゃあ、{pet_name}の\n心配ごと聞くリン？',
    text_en:
      'Oh, nothing in particular?\nThen will you listen to what {pet_name} is worried about?',
    type: 'conversational',
    next_script_id: 'giraffe_010_03',
  },
  {
    id: 'giraffe_010_03',
    text_jp: 'え、それもいいリン？\n………',
    text_en: 'Oh, you don’t want to?',
    type: 'conversational',
    next_script_id: 'giraffe_010_04',
  },
  {
    id: 'giraffe_010_04',
    animation: 'angry',
    text_jp: 'じゃあ、いったい誰の\n心配ごとの話をすればいいリン！？',
    text_en: 'Then whose worries are we supposed to talk about?',
    type: 'conversational',
  },
  {
    id: 'giraffe_011_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}、\n知ってるリン？',
    text_en: 'Hey, {player_name} did you know…',
    type: 'conversational',
    next_script_id: 'giraffe_011_02',
  },
  {
    id: 'giraffe_011_02',
    text_jp:
      '空き巣の侵入手段で一番多いのは\n「無締り」、つまり\n鍵のかけ忘れだリン！',
    text_en:
      'The #1 cause of robberies when you’re out of the house is forgetting to lock the door!',
    type: 'conversational',
    next_script_id: 'giraffe_011_03',
  },
  {
    id: 'giraffe_011_03',
    text_jp:
      'ゴミ出しなどの短時間の\n外出でも、しっかり鍵を\nかけるのが大事だリン！',
    text_en:
      'Even if you’re just taking out the trash, you should always lock your door!',
    type: 'conversational',
  },
  {
    id: 'giraffe_012_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}、\n車上荒らしにあいやすい車の\n特徴、知ってるリン？',
    text_en:
      'Hey, {player_name}, do you know what cars that get broken into have in common?',
    type: 'conversational',
    next_script_id: 'giraffe_012_02',
  },
  {
    id: 'giraffe_012_02',
    text_jp: '実は、窓の小さい車が\n狙われやすい傾向が\nあるらしいリン！',
    text_en: 'Apparently, it’s cars with smaller windows!',
    type: 'conversational',
    next_script_id: 'giraffe_012_03',
  },
  {
    id: 'giraffe_012_03',
    text_jp:
      '窓を割って侵入するときに、\n窓が小さい方が目立ちにくい\nらしいのリン！',
    text_en: 'Breaking into a car through the window makes it less obvious!',
    type: 'conversational',
  },
  {
    id: 'giraffe_013_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '空き巣に入られやすい家には、\n「泥棒が下見しやすい」という\n特徴があるリン',
    text_en:
      'Houses that tend to get robbed are mostly ones that a burglar can check out beforehand!',
    type: 'conversational',
    next_script_id: 'giraffe_013_02',
  },
  {
    id: 'giraffe_013_02',
    text_jp:
      '例えば、近くに公園があると、\n泥棒が長時間滞在しても目立ち\nにくいから下見がしやすいリン',
    text_en:
      'For example, if you live next to a park, a burglar could be there for hours and not be noticed while they watch your house!',
    type: 'conversational',
    next_script_id: 'giraffe_013_03',
  },
  {
    id: 'giraffe_013_03',
    text_jp:
      '他に、商店街など不特定多数の\n人が多く出入りする場所の近くも\n要注意なのリン！',
    text_en:
      'Other risky areas are near shopping streets and other places with a lot of foot traffic!',
    type: 'conversational',
  },
  {
    id: 'giraffe_014_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\n護身術とかやってるリンか？',
    text_en: 'Hey, {player_name}, do you do any serf-defence?',
    type: 'conversational',
    next_script_id: 'giraffe_014_02',
  },
  {
    id: 'giraffe_014_02',
    text_jp:
      '実は、下手に護身術で暴漢に\n立ち向かおうとすると、よけい\n危険な目にあいやすいリン！',
    text_en:
      "It's actually more dangerous to try to resist an attack if you’re not well-trained!",
    type: 'conversational',
    next_script_id: 'giraffe_014_03',
  },
  {
    id: 'giraffe_014_03',
    text_jp: '大きな声を出して逃げるのが\n一番の護身術だと思うリン！',
    text_en: 'The best defence is to yell loud and run away!',
    type: 'conversational',
  },
  {
    id: 'giraffe_015_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '動物の中には、身を守るために\n死んだふりをするものがいるリン',
    text_en: 'Some animals play dead to protect themselves.',
    type: 'conversational',
    next_script_id: 'giraffe_015_02',
  },
  {
    id: 'giraffe_015_02',
    text_jp: '捕食者は、獲物が動かなくなると\nエサでなくなったと認識して',
    text_en: "If you don't move, a predator won’t see you as prey…",
    type: 'conversational',
    next_script_id: 'giraffe_015_03',
  },
  {
    id: 'giraffe_015_03',
    expression: 'happy',
    text_jp:
      '死んだふりをしている生き物を\n捕食しなくなるらしいリン！\nかしこいリン！',
    text_en: '…and they won’t eat an animal they don’t have to chase!\nSmart!',
    type: 'conversational',
    next_script_id: 'giraffe_015_04',
  },
  {
    id: 'giraffe_015_04',
    animation: 'anxious',
    text_jp: 'ちなみにクマには死んだふりは\n効かないから要注意リン！',
    text_en: 'By the way, playing dead doesn’t work with bears, so be careful!',
    type: 'conversational',
  },
  {
    id: 'giraffe_016_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '昔は家の周りを生け垣や塀で\n囲っていたけど、最近はオープンな\nものが増えたリン！',
    text_en:
      'A lot of houses used to have hedges and fences around them, but lately they’re a lot more open!',
    type: 'conversational',
    next_script_id: 'giraffe_016_02',
  },
  {
    id: 'giraffe_016_02',
    animation: 'anxious',
    text_jp:
      '塀があると一見安心だリンけど、\n一旦侵入者が中に入ると外側から\n見えなくなってしまうリン',
    text_en:
      'Having walls seems safe, but you can’t see an intruder once they’re behind the wall.',
    type: 'conversational',
  },
  {
    id: 'giraffe_017_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '家の敷地の周りを防犯砂利で\nぐるりと囲むと、少し踏んだだけで\nギシギシ音がするリン',
    text_en:
      'If you surround your house with anti-intrusion rocks, they make a lot of noise when someone steps on them.',
    type: 'conversational',
    next_script_id: 'giraffe_017_02',
  },
  {
    id: 'giraffe_017_02',
    text_jp:
      '侵入者が入ってきづらくなるので\nおすすめリン！\nホームセンター等で売ってるリン！',
    text_en:
      'It’s harder for an intruder to sneak around, so I recommend it!\nThey sell them at home improvement stores!',
    type: 'conversational',
  },
  {
    id: 'giraffe_018_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「安全」と「安心」の違いを\n知ってるリン？',
    text_en: 'Do you know what the difference between “Safety” and “Security”?',
    type: 'conversational',
    next_script_id: 'giraffe_018_02',
  },
  {
    id: 'giraffe_018_02',
    expression: 'normal',
    text_jp:
      'ざっくり言うと、安全は客観的、\n安心は主観的というのが\n一番大きな違いリン！',
    text_en:
      'The simplest explanation is that safety is subjective and security is objective!',
    type: 'conversational',
    next_script_id: 'giraffe_018_03',
  },
  {
    id: 'giraffe_018_03',
    animation: 'anxious',
    text_jp:
      'ジェットコースターは安全かも\nしれないリンけど、とても安心は\nできないリン〜！',
    text_en: 'Roller coasters might be secure, but they sure don’t feel safe!',
    type: 'conversational',
  },
  {
    id: 'giraffe_019_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '日本を守る自衛隊。その中には、\nイケメンしか入れない部隊が\nあるって知ってたリン？',
    text_en:
      'Did you know that the Japan Self Defense Force has a unit that’s all good-looking guys?',
    type: 'conversational',
    next_script_id: 'giraffe_019_02',
  },
  {
    id: 'giraffe_019_02',
    text_jp:
      '陸上自衛隊の部隊の1つである\n儀仗隊(ぎじょうたい)は、海外から\nお客様をお迎えする部隊リン',
    text_en:
      'It’s called the “Honor Guard” and is for entertaining guests from overseas.',
    type: 'conversational',
    next_script_id: 'giraffe_019_03',
  },
  {
    id: 'giraffe_019_03',
    expression: 'happy',
    text_jp:
      '「日本の顔」となる部隊だから、\n「容姿端麗」が選考基準の1つに\nなっているリン！',
    text_en:
      'The unit represents Japan as its “Face”, so their “Looks” are part of their requirements!',
    type: 'conversational',
  },
  {
    id: 'giraffe_020_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '錠（じょう）と鍵（かぎ）の\n違い、知ってるリン？',
    text_en: 'Do you know the difference between a “Latch” and a “Lock”?',
    type: 'conversational',
    next_script_id: 'giraffe_020_02',
  },
  {
    id: 'giraffe_020_02',
    text_jp:
      '「錠」は窓やドアが開かなくなる\nようにする機構のことで、「鍵」は\n錠を開閉するための器具のことリン',
    text_en:
      'A latch keeps a window or door from being opened, but a lock can be opened from the outside with a key!',
    type: 'conversational',
    next_script_id: 'giraffe_020_03',
  },
  {
    id: 'giraffe_020_03',
    text_jp:
      '「鍵をかける」っていうのは、\n正確には「錠をかける」が\n正しい言い方リン！',
    text_en: '“Locking a window” should actually be “Latching a window”!',
    type: 'conversational',
  },
  {
    id: 'giraffe_021_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n犬派リン？それとも猫派リン？',
    text_en: 'Hey, {player_name}, are you a dog person or a cat person?',
    type: 'selectional',
    answer_var: 'dog_cat',
    option_1_jp: '犬派',
    option_1_en: 'Dog',
    option_2_jp: '猫派',
    option_2_en: 'Cat',
    next_script_id: 'giraffe_021_02',
  },
  {
    id: 'giraffe_021_02',
    expression: 'happy',
    text_jp: 'なるほど、{dog_cat}リンね〜',
    text_en: 'I see! A {dog_cat} person…',
    type: 'conversational',
    next_script_id: 'giraffe_021_03',
  },
  {
    id: 'giraffe_021_03',
    expression: 'sad',
    text_jp:
      'ココロのどこかで「キリン派」って\n言ってくれるかもって\n期待してたリン…',
    text_en:
      'I was secretly hoping in my heart that you might say you’re a giraffe person…',
    type: 'conversational',
  },
  {
    id: 'giraffe_022_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '人の心が読める力と\n未来が見える力\nどっちが欲しいリン？',
    text_en: 'Would you rather be able to read thoughts or see the future?',
    type: 'selectional',
    answer_var: 'mind_future',
    option_1_jp: '人の心が読める力',
    option_1_en: 'Ability to read minds',
    option_2_jp: '未来が見える力',
    option_2_en: 'Ability to see the future',
    case: 'mind_future',
    next_script_id_1: 'giraffe_022_02',
    next_script_id_2: 'giraffe_022_03',
  },
  {
    id: 'giraffe_022_02',
    animation: 'anxious',
    text_jp: '人の心が読めたら便利そうだけど、\n人間不信になりそうだリン…',
    text_en:
      'Reading peoples’ thoughts seems cool, but I think it would make it hard to trust them.',
    type: 'conversational',
  },
  {
    id: 'giraffe_022_03',
    animation: 'anxious',
    text_jp:
      '未来が見えたら楽しそうだけど、\n将来に希望が持てなく\nなりそうだリン…',
    text_en:
      'Seeing the future seems cool, but I think it would make it hard to have hopes & dreams.',
    type: 'conversational',
  },
  {
    id: 'giraffe_023_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '時間に超ルーズな人と\nお金に超ルーズな人、\n付き合うならどっちリン？',
    text_en: 'Would you rather date someone who’s loose with time or money?',
    type: 'selectional',
    answer_var: 'time_money',
    option_1_jp: '時間に超ルーズな人',
    option_1_en: 'Person who is super loose with time',
    option_2_jp: 'お金に超ルーズな人',
    option_2_en: 'Person who is super loose with money',
    case: 'time_money',
    next_script_id_1: 'giraffe_023_02',
    next_script_id_2: 'giraffe_023_03',
  },
  {
    id: 'giraffe_023_02',
    expression: 'sad',
    text_jp: 'たしかに、お金にルーズな人よりは\nいいのかもしれないリンね〜…',
    text_en: 'Yeah, that’s probably better than being loose with money.',
    type: 'conversational',
  },
  {
    id: 'giraffe_023_03',
    expression: 'very_sad',
    text_jp: 'お金にルーズな人だけは\nやめた方がいいリン！',
    text_en: 'You definitely shouldn’t date someone who’s loose with money!',
    type: 'conversational',
  },
  {
    id: 'giraffe_024_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\n学校をズル休みしたことあるリン？',
    text_en: 'Hey, {player_name}, have you ever played hooky from school?',
    type: 'selectional',
    answer_var: 'playing_hookey',
    option_1_jp: 'ある',
    option_1_en: 'Yes',
    option_2_jp: 'ない',
    option_2_en: 'No',
    case: 'playing_hookey',
    next_script_id_1: 'giraffe_024_02',
    next_script_id_2: 'giraffe_024_03',
  },
  {
    id: 'giraffe_024_02',
    expression: 'happy',
    text_jp: 'どうしても学校に行きたくない、\nそんな日だってあるリンよね〜…',
    text_en: 'Some days, you just don’t want to go!',
    type: 'conversational',
  },
  {
    id: 'giraffe_024_03',
    animation: 'surprised',
    text_jp: 'そ、そんな人がいるなんて…\nすごすぎるリン…！',
    text_en: 'I-I didn’t know people could actually do that!',
    type: 'conversational',
  },
  {
    id: 'giraffe_025_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}は、\n友だちの恋人を好きになって\nしまったことはあるリンか？',
    text_en:
      'Hey, {player_name}, have you ever had a crush on someone that your friend is dating?',
    type: 'selectional',
    answer_var: 'friends_lover',
    option_1_jp: 'ある',
    option_1_en: 'Yes',
    option_2_jp: 'ない',
    option_2_en: 'No',
    option_3_jp: 'ナイショ',
    option_3_en: 'Secret',
    case: 'friends_lover',
    next_script_id_1: 'giraffe_025_02',
    next_script_id_2: 'giraffe_025_03',
    next_script_id_3: 'giraffe_025_04',
  },
  {
    id: 'giraffe_025_02',
    animation: 'joy',
    text_jp: 'きゃー！\n三角関係リン！オトナリン！',
    text_en: 'EEEEK!\nA love triangle! So grown-up!',
    type: 'conversational',
  },
  {
    id: 'giraffe_025_03',
    expression: 'happy',
    text_jp: 'ほんとリン？\nほんとに？\n一度もないリン？',
    text_en: 'Really?\nReally??\nNot even once?',
    type: 'conversational',
  },
  {
    id: 'giraffe_025_04',
    animation: 'joy',
    text_jp:
      'それ、あるって言ってるような\nものリンよ〜！\nきゃ〜！オトナリン！',
    text_en: 'That’s basically saying you have!\nEEEEK! So grown-up!',
    type: 'conversational',
  },
  {
    id: 'giraffe_026_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n腕力に自信はあるリンか？',
    text_en: 'Hey, {player_name}, do you think you’re strong?',
    type: 'selectional',
    answer_var: 'arm_power',
    option_1_jp: 'ある',
    option_1_en: 'Yes',
    option_2_jp: 'ない',
    option_2_en: 'No',
    case: 'arm_power',
    next_script_id_1: 'giraffe_026_02',
    next_script_id_2: 'giraffe_026_03',
  },
  {
    id: 'giraffe_026_02',
    expression: 'happy',
    text_jp:
      '意外と力持ちなのリンね！\n{pet_name}のこと\nしっかり守って欲しいリン！',
    text_en: 'Then you really must be!\nI hope you’ll protect {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_026_03',
    expression: 'happy',
    text_jp: 'か弱いのリンね！\n{pet_name}がしっかり\n守ってあげるリン！',
    text_en: 'That’s adorable!\n{pet_name} will protect you, OK?',
    type: 'conversational',
  },
  {
    id: 'giraffe_027_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}は\n一度決めたことは最後まで\nやり遂げられるタイプリン？',
    text_en:
      'Hey, {player_name}, are you the type to always finish what you start?',
    type: 'selectional',
    answer_var: 'until_end',
    option_1_jp: 'やり遂げられる',
    option_1_en: 'Yes',
    option_2_jp: 'くじけちゃう',
    option_2_en: 'No',
    case: 'until_end',
    next_script_id_1: 'giraffe_027_02',
    next_script_id_2: 'giraffe_027_03',
  },
  {
    id: 'giraffe_027_02',
    expression: 'happy',
    text_jp: 'えらいリン！すごいリン！\n尊敬しちゃうリン！',
    text_en: 'Good for you! Wow!\nI have new respect for you!',
    type: 'conversational',
  },
  {
    id: 'giraffe_027_03',
    expression: 'happy',
    text_jp: 'チャレンジすること自体が\nすばらしいリン！すてきリン！',
    text_en: 'Even giving it a try is amazing! \nGood for you!',
    type: 'conversational',
  },
  {
    id: 'giraffe_028_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\nお金遣いは荒いほうリンか？',
    text_en: 'Hey, {player_name}, do you spend a lot of money?',
    type: 'selectional',
    answer_var: 'spendthrift',
    option_1_jp: '荒いほう',
    option_1_en: 'Yes',
    option_2_jp: 'けっこう堅実',
    option_2_en: 'No',
    case: 'spendthrift',
    next_script_id_1: 'giraffe_028_02',
    next_script_id_2: 'giraffe_028_03',
  },
  {
    id: 'giraffe_028_02',
    expression: 'happy',
    text_jp:
      '宵越しの金は持たないって奴リン？\n江戸っ子リン！\n自分で自覚できてれば大丈夫リン！',
    text_en:
      'You spend what you make in a day the same night?\nJust like a classic Tokyoite!\nAs long as you know what you’re doing!',
    type: 'conversational',
  },
  {
    id: 'giraffe_028_03',
    expression: 'happy',
    text_jp:
      '一度生活レベル上げると\nなかなか下げられないリンから、\n堅実が一番リン！',
    text_en:
      'Once you have a certain lifestyle, it’s hard to go back to basics! Slow and steady is the way to go!',
    type: 'conversational',
  },
  {
    id: 'giraffe_029_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '悪者に襲われたときに\n「これを叫べば大丈夫！」って\n言葉を教えて欲しいリン！',
    text_en: 'What should I shout if a bad guy attacks me?',
    type: 'descriptive',
    answer_var: 'scream_danger',
    question_jp: 'ピンチのときの叫び声',
    question_en: 'Screaming in danger',
    max_len: 14,
    next_script_id: 'giraffe_029_02',
  },
  {
    id: 'giraffe_029_02',
    text_jp: 'なるほど！\n{scream_danger}って\n叫べばいいリンね！',
    text_en: 'OK!\nI should shout {scream_danger}, right?',
    type: 'conversational',
    next_script_id: 'giraffe_029_03',
  },
  {
    id: 'giraffe_029_03',
    animation: 'angry',
    text_jp: '練習してみるリン！\n{scream_danger}！',
    text_en: 'Let me practice!\n{scream_danger}!',
    type: 'conversational',
    next_script_id: 'giraffe_029_04',
  },
  {
    id: 'giraffe_029_04',
    expression: 'happy',
    text_jp: 'どうだったリン？',
    text_en: 'How was that?',
    type: 'conversational',
  },
  {
    id: 'giraffe_030_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}が\n誰かに言われて一番嬉しかった\n言葉を教えて欲しいリン！',
    text_en:
      'Hey, {player_name}, what has someone said to you that made you really happy?',
    type: 'descriptive',
    answer_var: 'best_word',
    question_jp: '一番嬉しかった言葉',
    question_en: 'Words that made you the happiest',
    max_len: 14,
    next_script_id: 'giraffe_030_02',
  },
  {
    id: 'giraffe_030_02',
    text_jp: 'なるほどー。\n{pet_name}も言うリン！',
    text_en: 'OK!\n{pet_name} will say that, too!',
    type: 'conversational',
    next_script_id: 'giraffe_030_03',
  },
  {
    id: 'giraffe_030_03',
    text_jp: '{best_word}！',
    text_en: '{best_word}!!',
    type: 'conversational',
    next_script_id: 'giraffe_030_04',
  },
  {
    id: 'giraffe_030_04',
    text_jp: 'どうリン？',
    text_en: 'How do you feel?',
    type: 'conversational',
  },
  {
    id: 'giraffe_031_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '今までもらったプレゼントの中で\n一番印象に残っているものを\n教えて欲しいリン！',
    text_en: 'What’s the present you got that you remember most?',
    type: 'descriptive',
    answer_var: 'memorable_gift',
    question_jp: '印象に残っているプレゼント',
    question_en: 'The most memorable gift',
    max_len: 14,
    next_script_id: 'giraffe_031_02',
  },
  {
    id: 'giraffe_031_02',
    animation: 'surprised',
    text_jp: 'なるほどー。\nそれは印象深いリンね！',
    text_en: 'I see! \nThat would definitely leave an impression!',
    type: 'conversational',
    next_script_id: 'giraffe_031_03',
  },
  {
    id: 'giraffe_031_03',
    expression: 'happy',
    text_jp: '{pet_name}も、そんな\nプレゼントもらってみたいリン！',
    text_en: '{pet_name} wants a present like that, too!',
    type: 'conversational',
  },
  {
    id: 'giraffe_032_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は、\n動物だと何に似てるリン？',
    text_en: 'Hey, {player_name}, what animal do you think you’re like?',
    type: 'descriptive',
    answer_var: 'similar_animal',
    question_jp: '似ている動物',
    question_en: 'Animal that looks like you',
    max_len: 14,
    next_script_id: 'giraffe_032_02',
  },
  {
    id: 'giraffe_032_02',
    text_jp: '{similar_animal}リン？\nうーん…。',
    text_en: 'A {similar_animal}?\nHmm…',
    type: 'conversational',
    next_script_id: 'giraffe_032_03',
  },
  {
    id: 'giraffe_032_03',
    expression: 'happy',
    text_jp: '言われてみるとたしかに！\nそっくりリン！\nきゃきゃきゃ！',
    text_en: 'Now that you mention it!\nYou look exactly like one!\nHahahaha!',
    type: 'conversational',
  },
  {
    id: 'giraffe_033_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{player_name}が、\n「これだけは誰にも負けない」\nと思うことを教えて欲しいリン！',
    text_en:
      'Hey, {player_name}, what’s something you don’t think anyone can beat you at?',
    type: 'descriptive',
    answer_var: 'special_strength',
    question_jp: '誰にも負けないところ',
    question_en: 'Your strength',
    max_len: 14,
    next_script_id: 'giraffe_033_02',
  },
  {
    id: 'giraffe_033_02',
    animation: 'surprised',
    text_jp: 'そ…それはすごいリン…。\nゴクリ…。',
    text_en: 'T-That’s amazing…\nGulp!',
    type: 'conversational',
    next_script_id: 'giraffe_033_03',
  },
  {
    id: 'giraffe_033_03',
    expression: 'sad',
    text_jp: '{pet_name}も\nそんなすごい特技が欲しいリン…',
    text_en: 'I wish {pet_name} had a superpower like that!',
    type: 'conversational',
  },
  {
    id: 'giraffe_034_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n座右の銘を教えて欲しいリン！',
    text_en: 'What’s your motto, {player_name}?',
    type: 'descriptive',
    answer_var: 'favorite_motto',
    question_jp: '座右の銘',
    question_en: 'Favorite motto',
    max_len: 14,
    next_script_id: 'giraffe_034_02',
  },
  {
    id: 'giraffe_034_02',
    expression: 'happy',
    text_jp: '{favorite_motto}…\n良い座右の銘リン…。',
    text_en: '{favorite_motto}…\nThat’s a great motto…',
    type: 'conversational',
    next_script_id: 'giraffe_034_03',
  },
  {
    id: 'giraffe_034_03',
    expression: 'normal',
    text_jp: '{pet_name}の座右の銘は、\n「細く長く」リン！',
    text_en: '{pet_name}’s motto is “Longer & Longer”!',
    type: 'conversational',
  },
  {
    id: 'giraffe_035_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}の\n好きなバンドを教えて欲しいリン！',
    text_en: 'Hey, {player_name}, what’s your favorite band?',
    type: 'descriptive',
    answer_var: 'favorite_band',
    question_jp: '好きなバンド',
    question_en: 'Favorite band',
    max_len: 14,
    next_script_id: 'giraffe_035_02',
  },
  {
    id: 'giraffe_035_02',
    expression: 'happy',
    text_jp: '知らなかったリン。\nあとでチェックしておくリン！',
    text_en: 'I didn’t know that!\nI’ll check them out!',
    type: 'conversational',
  },
  {
    id: 'giraffe_036_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '最近読んで面白かった本、\n何かあるリン？\nマンガでも良いリンよ？',
    text_en: 'Have you read any good books lately?\nOr any good manga?',
    type: 'descriptive',
    answer_var: 'interesting_book',
    question_jp: '面白かった本',
    question_en: 'Interesting book',
    max_len: 14,
    next_script_id: 'giraffe_036_02',
  },
  {
    id: 'giraffe_036_02',
    text_jp: '難しそうなタイトルリン…。\n{pet_name}でも\n読めるリンかね〜？',
    text_en: 'That’s quite a title!\nI wonder if {pet_name} would get it?',
    type: 'selectional',
    answer_var: 'can_read',
    option_1_jp: '読めるよ！',
    option_1_en: 'You can!',
    option_2_jp: '難しいかも',
    option_2_en: 'Might be hard',
    case: 'can_read',
    next_script_id_1: 'giraffe_036_03',
    next_script_id_2: 'giraffe_036_04',
  },
  {
    id: 'giraffe_036_03',
    expression: 'happy',
    text_jp: 'じゃあ、今度読んでみるリン！',
    text_en: 'I’ll try reading it!',
    type: 'conversational',
  },
  {
    id: 'giraffe_036_04',
    expression: 'happy',
    text_jp: 'じゃあ、今度読み聞かせして\n欲しいリン！',
    text_en: 'Then could you read it to me sometime?',
    type: 'conversational',
  },
  {
    id: 'giraffe_037_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '突然ですが防災クイズリン！',
    text_en: 'Time for a pop quiz on disaster preparedness!',
    type: 'conversational',
    next_script_id: 'giraffe_037_02',
  },
  {
    id: 'giraffe_037_02',
    expression: 'normal',
    text_jp:
      '災害時に避難するときは、動き\nやすいようにできるだけ身軽にする\nこれって正しいリン？',
    text_en:
      'During a disaster, should you leave everything behind so it’s easier to move?',
    type: 'selectional',
    answer_var: 'evacuation',
    option_1_jp: '正しい',
    option_1_en: 'Yes',
    option_2_jp: '間違い',
    option_2_en: 'No',
    next_script_id: 'giraffe_037_03',
  },
  {
    id: 'giraffe_037_03',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_037_04',
  },
  {
    id: 'giraffe_037_04',
    expression: 'happy',
    text_jp: '「間違い」リン！',
    text_en: 'NO!',
    type: 'conversational',
    next_script_id: 'giraffe_037_05',
  },
  {
    id: 'giraffe_037_05',
    text_jp:
      '避難するときは、ケガしないように\n夏でも長袖や長ズボンを着た方が\n良いリン！',
    text_en:
      'When running from a disaster, you should make sure you have long sleeves and pants even in the summer, so you don’t get hurt!',
    type: 'conversational',
  },
  {
    id: 'giraffe_038_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '突然ですが防犯クイズリン！',
    text_en: 'Time for a pop quiz on home security preparedness!',
    type: 'conversational',
    next_script_id: 'giraffe_038_02',
  },
  {
    id: 'giraffe_038_02',
    text_jp:
      '窓の近く（家の外側）に\n置いておくとよくないものは\n次のどれリン？',
    text_en:
      'Which of the following should you not leave on the outside of a window?',
    type: 'selectional',
    answer_var: 'item_by_window',
    option_1_jp: '鉢植え',
    option_1_en: 'Potted plant',
    option_2_jp: 'じょうろ',
    option_2_en: 'Watering pot',
    option_3_jp: 'スコップ',
    option_3_en: 'Shovel',
    next_script_id: 'giraffe_038_03',
  },
  {
    id: 'giraffe_038_03',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_038_04',
  },
  {
    id: 'giraffe_038_04',
    expression: 'happy',
    text_jp: '「スコップ」リン！',
    text_en: 'A shovel!',
    type: 'conversational',
    next_script_id: 'giraffe_038_05',
  },
  {
    id: 'giraffe_038_05',
    animation: 'anxious',
    text_jp:
      'スコップが置いてあると、\n窓を割るのに使われてしまう\n可能性があるリン！',
    text_en:
      'If you leave a shovel outside a window, someone could use it to break in!',
    type: 'conversational',
  },
  {
    id: 'giraffe_039_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '3階建て以下と、4階建て以上の\nマンション、どっちが犯罪者に\n狙われやすいか知ってるリン？',
    text_en:
      'Which do you think is easier for a burglar to break into: An apartment on the 3rd floor or an apartment on the 4th floor or above?',
    type: 'selectional',
    answer_var: 'low_high',
    option_1_jp: '3階建て以下',
    option_1_en: '3 stories or less',
    option_2_jp: '4階建て以上',
    option_2_en: '4 stores or more',
    next_script_id: 'giraffe_039_02',
  },
  {
    id: 'giraffe_039_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_039_03',
  },
  {
    id: 'giraffe_039_03',
    text_jp: '「4階建て以上」リン！',
    text_en: 'On the 4th floor or above!',
    type: 'conversational',
    next_script_id: 'giraffe_039_04',
  },
  {
    id: 'giraffe_039_04',
    text_jp:
      '「オートロックもあるし、こんな\n上まで上がってこないだろう」と\n安心して施錠しない人が多いリン！',
    text_en:
      'A lot of people think that burglars wouldn’t break into an auto-locking apartment so high up, and don’t lock their doors!',
    type: 'conversational',
  },
  {
    id: 'giraffe_040_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'エアコンの室外機の上に鉢植えが\n置いてあると、空き巣に狙われ\nにくくなる。これって正しいリン？',
    text_en:
      'If you have a plant on top of the air conditioning unit outside, it’s harder for someone to break in. True or false?',
    type: 'selectional',
    answer_var: 'potted_plant',
    option_1_jp: '正しい',
    option_1_en: 'Yes',
    option_2_jp: '間違い',
    option_2_en: 'No',
    next_script_id: 'giraffe_040_02',
  },
  {
    id: 'giraffe_040_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_040_03',
  },
  {
    id: 'giraffe_040_03',
    expression: 'happy',
    text_jp: '「正しい」リン！',
    text_en: 'True!',
    type: 'conversational',
    next_script_id: 'giraffe_040_04',
  },
  {
    id: 'giraffe_040_04',
    text_jp:
      '鉢植えを置くことで、室外機を\n足がかりにされることを\n防ぐことができるリン！',
    text_en:
      'Keeping a plant on top of the air conditioning unit keeps someone from using it as a foothold!',
    type: 'conversational',
    next_script_id: 'giraffe_040_05',
  },
  {
    id: 'giraffe_040_05',
    expression: 'happy',
    text_jp:
      'そんなのどければいいじゃんって\n思うかもしれないけど、空き巣は\nちょっとした時間のロスも嫌うリン',
    text_en:
      'You might think it wouldn’t matter, but burglars want to be as fast as possible.',
    type: 'conversational',
  },
  {
    id: 'giraffe_041_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '空き巣の70％が侵入を諦める\n所要時間って何分か知ってるリン？',
    text_en: 'Do you know what the average length of a break-in is?',
    type: 'selectional',
    answer_var: 'burglar_giveup',
    option_1_jp: '5分',
    option_1_en: '5 minutes',
    option_2_jp: '10分',
    option_2_en: '10 minutes',
    option_3_jp: '15分',
    option_3_en: '15 minutes',
    next_script_id: 'giraffe_041_02',
  },
  {
    id: 'giraffe_041_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_041_03',
  },
  {
    id: 'giraffe_041_03',
    expression: 'happy',
    text_jp: '「5分」リン！',
    text_en: "It's 5 minutes!",
    type: 'conversational',
    next_script_id: 'giraffe_041_04',
  },
  {
    id: 'giraffe_041_04',
    text_jp:
      '「ここは時間がかかりそうだ」と\n空き巣に思わせるような対策を\nしておくのが大事だリン！',
    text_en:
      'You should take precautions to make a burglar think it would take too much time to break in!',
    type: 'conversational',
  },
  {
    id: 'giraffe_042_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '泥棒が入りやすいのは、\nどんなお天気の日か知ってるリン？',
    text_en:
      'Do you know what kind of weather makes it easy for a burglar to break in?',
    type: 'selectional',
    answer_var: 'burglar_weather',
    option_1_jp: '晴れの日',
    option_1_en: 'Sunny day',
    option_2_jp: 'くもりの日',
    option_2_en: 'Cloudy day',
    option_3_jp: '雨の日',
    option_3_en: 'Rainy day',
    next_script_id: 'giraffe_042_02',
  },
  {
    id: 'giraffe_042_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_042_03',
  },
  {
    id: 'giraffe_042_03',
    expression: 'happy',
    text_jp: '「雨の日」リン！',
    text_en: 'A rainy day!',
    type: 'conversational',
    next_script_id: 'giraffe_042_04',
  },
  {
    id: 'giraffe_042_04',
    animation: 'anxious',
    text_jp:
      'ガラスを割る音や侵入する音が\n雨の音でわからなくなって\nしまうのリン！',
    text_en:
      'That’s because the sound of the rain makes it harder to hear glass breaking!',
    type: 'conversational',
  },
  {
    id: 'giraffe_043_01',
    expression: 'happy',
    text_jp: 'はぴはぴリーン！',
    text_en: 'Hiya!',
    type: 'conversational',
    next_script_id: 'giraffe_043_02',
  },
  {
    id: 'giraffe_043_02',
    animation: 'joy',
    text_jp: 'きゃきゃきゃ！',
    text_en: 'Hahaha!',
    type: 'conversational',
  },
  {
    id: 'giraffe_044_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '今日はすごくいいことが\nあったリン！',
    text_en: 'Something great happened today!',
    type: 'conversational',
    next_script_id: 'giraffe_044_02',
  },
  {
    id: 'giraffe_044_02',
    text_jp: '買おうと思ってた本が、\nもう本棚に入ってたリン！',
    text_en: 'A book I wanted to buy was already on my bookshelf!',
    type: 'conversational',
    next_script_id: 'giraffe_044_03',
  },
  {
    id: 'giraffe_044_03',
    animation: 'play',
    text_jp: 'ずっと前に買ったのを\n忘れてたリン！\n得したリン！',
    text_en: 'I forgot that I already bought it a while ago!',
    type: 'conversational',
  },
  {
    id: 'giraffe_045_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{pet_name}もすっかり\nオトナになってしまったリン！',
    text_en: '{pet_name} feels like such an adult!',
    type: 'conversational',
    next_script_id: 'giraffe_045_02',
  },
  {
    id: 'giraffe_045_02',
    text_jp:
      '「好きなケーキ選んでいいよ」って\n言われたとき、昔はとにかく一番\n大きいのを選んでたけど、',
    text_en:
      'In the old days, if someone said I could have any piece of cake I want, I’d pick the biggest one.',
    type: 'conversational',
    next_script_id: 'giraffe_045_03',
  },
  {
    id: 'giraffe_045_03',
    text_jp: '今は小さくても美味しいものを\n選ぶようにしてるリン！',
    text_en: 'Now, I pick a smaller one instead!',
    type: 'conversational',
  },
  {
    id: 'giraffe_046_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '{pet_name}、最近日常の\nふとした瞬間に感じる幸せを\n大切にしてるリン',
    text_en:
      '{pet_name} is trying to find happiness in the little moments of life.',
    type: 'conversational',
    next_script_id: 'giraffe_046_02',
  },
  {
    id: 'giraffe_046_02',
    expression: 'happy',
    text_jp:
      '空気が澄んでて気持ちいいなとか\n紅茶が上手に入れられたなとか\n楽しくおしゃべりできたなとか',
    text_en:
      'Like when the air is clear and feels nice,\nor when I made my tea really well,\nor when I had a nice conversation with someone.',
    type: 'conversational',
    next_script_id: 'giraffe_046_03',
  },
  {
    id: 'giraffe_046_03',
    expression: 'happy',
    text_jp: '幸せってそういうことだリン',
    text_en: "That's what happiness is all about!",
    type: 'conversational',
  },
  {
    id: 'giraffe_047_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'コーヒーか紅茶、どっちに\nしようかリンね〜？',
    text_en: 'Should I have coffee or tea today?',
    type: 'selectional',
    answer_var: 'coffee_tea',
    option_1_jp: 'コーヒー',
    option_1_en: 'Coffee',
    option_2_jp: '紅茶',
    option_2_en: 'Tea',
    next_script_id: 'giraffe_047_02',
  },
  {
    id: 'giraffe_047_02',
    expression: 'happy',
    text_jp: 'よし、決めた！\n今日は麦茶だリン！',
    text_en: 'OK! I’ve made up my mind!\nToday I’ll have barely tea!',
    type: 'conversational',
  },
  {
    id: 'giraffe_048_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '{pet_name}はけっこう\n心配性だリンけど、そんな自分も\nけっこう好きだリンよ',
    text_en: '{pet_name} is a worrier, but I like that about myself.',
    type: 'conversational',
    next_script_id: 'giraffe_048_02',
  },
  {
    id: 'giraffe_048_02',
    expression: 'happy',
    text_jp: 'いつも注意深く周りを見ていて、\n自分えらい！って思ってるリン！',
    text_en:
      'I’m careful and keep an eye on my surroundings and tell myself I’m doing a good job!',
    type: 'conversational',
  },
  {
    id: 'giraffe_049_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      'ぶるぶるカフェでデビューするには\nコンビを組む必要があるリンけど、',
    text_en: 'I need a partner to debut at the BuruBuru Café…',
    type: 'conversational',
    next_script_id: 'giraffe_049_02',
  },
  {
    id: 'giraffe_049_02',
    expression: 'normal',
    text_jp:
      '自分から相方を誘いに行くか、\n向こうから誘われるのを待つか、\nそれが問題リン',
    text_en:
      '…but I don’t know if I should ask someone or wait for someone to ask me to partner up.',
    type: 'conversational',
    next_script_id: 'giraffe_049_03',
  },
  {
    id: 'giraffe_049_03',
    expression: 'normal',
    text_jp: '{player_name}は\nどっちがいいと思うリン？',
    text_en: 'What do you think, {player_name}?',
    type: 'selectional',
    answer_var: 'invite_wait',
    option_1_jp: '自分から誘う',
    option_1_en: 'Invite',
    option_2_jp: '誘われるのを待つ',
    option_2_en: 'Wait',
    case: 'invite_wait',
    next_script_id_1: 'giraffe_049_04',
    next_script_id_2: 'giraffe_049_05',
  },
  {
    id: 'giraffe_049_04',
    expression: 'happy',
    text_jp:
      'たしかにその方が、自分に合った\n相方を見つけられるかも\nしれないリンね！',
    text_en:
      'True, that way I can be sure that my partner is someone suited to me!',
    type: 'conversational',
  },
  {
    id: 'giraffe_049_05',
    expression: 'happy',
    text_jp:
      'たしかにその方が、自分を必要と\nしてくれている相方を見つけられる\nかもしれないリンね！',
    text_en: 'True, that way I can find a partner that needs me!',
    type: 'conversational',
  },
  {
    id: 'giraffe_050_01',
    expression: 'normal',
    move_to: 'c',
    animation: 'anxious',
    text_jp: '窓の近くに花壇や自転車があると、\n泥棒が足場にできて危ないリン！',
    text_en:
      'If you keep a bicycle or hedge near your window, it gives burglars a foothold!',
    type: 'conversational',
    next_script_id: 'giraffe_050_02',
  },
  {
    id: 'giraffe_050_02',
    expression: 'normal',
    text_jp:
      '窓の近くには、\n足場になりそうなものを\nなるべく作らないほうがいいリン！',
    text_en:
      'You should try to keep anything they could use to climb away from your windows!',
    type: 'conversational',
  },
  {
    id: 'giraffe_051_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '泥棒対策には、窓に\n防犯フィルムを貼っておくのが\n意外に効果的リン！',
    text_en:
      'Putting an anti-intruder film over your window glass is actually pretty effective!',
    type: 'conversational',
    next_script_id: 'giraffe_051_02',
  },
  {
    id: 'giraffe_051_02',
    expression: 'happy',
    text_jp: '窓が割りづらくなるし、そもそも\n空き巣に狙われづらくなるリン！',
    text_en:
      'It’s harder to break the glass and will keep burglars from targeting your house!',
    type: 'conversational',
  },
  {
    id: 'giraffe_052_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '一人暮らしでも、出かけるときに\n「行ってきます」、帰ってきたら\n「ただいま」と言うと良いリン！',
    text_en:
      'Even if you live alone, you should say “Goodbye” when you leave and “I’m home” when you come back!',
    type: 'conversational',
    next_script_id: 'giraffe_052_02',
  },
  {
    id: 'giraffe_052_02',
    expression: 'happy',
    text_jp:
      '下調べをしている泥棒に、\n「この家には他に誰かいる」と\n思わせることができるリン！',
    text_en:
      'If a burglar hears you, they’ll think that someone else lives there!',
    type: 'conversational',
  },
  {
    id: 'giraffe_053_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '表札に家族全員の名前が書いてある\nお宅、たまに見かけるリンけど、\nあれは防犯上は良くないリン',
    text_en:
      'Sometimes people have their entire family’s names at their entrance, but that’s not a good idea for safety.',
    type: 'conversational',
    next_script_id: 'giraffe_053_02',
  },
  {
    id: 'giraffe_053_02',
    text_jp:
      '泥棒に家族構成が分かってしまって\n標的にされやすくなるリン！\n表札には名字だけがおすすめリン！',
    text_en:
      'If a burglar knows everyone in your family you’ll be easier to target! You should only have your last name written out!',
    type: 'conversational',
  },
  {
    id: 'giraffe_054_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '留守中にカーテンを開けっ放しに\nすると、留守だということが\n空き巣にバレてしまうリン！',
    text_en:
      'If you leave your curtains open while you’re out, a burglar can tell when you’re not home!',
    type: 'conversational',
    next_script_id: 'giraffe_054_02',
  },
  {
    id: 'giraffe_054_02',
    text_jp: '留守にするときは、必ずカーテンを\n閉めて行くリン！\n約束リンよ？',
    text_en:
      'Whenever you leave the house, be sure to close your curtains! Promise?',
    type: 'conversational',
  },
  {
    id: 'giraffe_055_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{player_name}は\n告白するのとされるの、\nどっちが多いリン？',
    text_en:
      'Hey, {player_name}, would you rather tell someone you like them or have them tell you they like you?',
    type: 'selectional',
    answer_var: 'propose_wait',
    option_1_jp: '告白する方',
    option_1_en: 'Tell',
    option_2_jp: '告白される方',
    option_2_en: 'Be told',
    case: 'propose_wait',
    next_script_id_1: 'giraffe_055_02',
    next_script_id_2: 'giraffe_055_03',
  },
  {
    id: 'giraffe_055_02',
    expression: 'happy',
    text_jp: 'けっこう積極的なのリンね！\n素敵リン！',
    text_en: 'You’re pretty forward!\nThat’s great!',
    type: 'conversational',
  },
  {
    id: 'giraffe_055_03',
    expression: 'happy',
    text_jp: 'きゃー！\nモテモテなのリンね！\nうらやましいリン！',
    text_en: 'EEEK!\nYou’re so popular!\nI’m jealous!',
    type: 'conversational',
  },
  {
    id: 'giraffe_056_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}は、\n悩みがあったら誰かに\n相談するタイプリン？',
    text_en:
      'Hey, {player_name}, are you the type to ask advice when you have a problem?',
    type: 'selectional',
    answer_var: 'consult',
    option_1_jp: '相談する',
    option_1_en: 'Yes',
    option_2_jp: '相談しない',
    option_2_en: 'No',
    case: 'consult',
    next_script_id_1: 'giraffe_056_02',
    next_script_id_2: 'giraffe_056_03',
  },
  {
    id: 'giraffe_056_02',
    expression: 'happy',
    text_jp: '何か悩み事があれば、\n{pet_name}にも\n相談して欲しいリン！',
    text_en:
      'If something is bothering you, you can always talk to {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_056_03',
    text_jp: '自立してるリンね！\nでも、{pet_name}には\n相談してもいいリンよ？',
    text_en: 'You’re so self-reliant!\nBut you can always talk to {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_057_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}も、\n昔はけっこうヤンチャしてたリン？',
    text_en: 'Hey, {player_name}, were you a rambunctious youth?',
    type: 'selectional',
    answer_var: 'bad_boy',
    option_1_jp: 'ヤンチャしてた',
    option_1_en: 'Yes',
    option_2_jp: '真面目だった',
    option_2_en: 'No',
    case: 'bad_boy',
    next_script_id_1: 'giraffe_057_02',
    next_script_id_2: 'giraffe_057_03',
  },
  {
    id: 'giraffe_057_02',
    expression: 'happy',
    text_jp: '{pet_name}も、\nこう見えて昔はけっこう\nヤンチャしてたリンよ？',
    text_en: '{pet_name} was pretty rambunctious back in the day, you know?',
    type: 'conversational',
    next_script_id: 'giraffe_057_04',
  },
  {
    id: 'giraffe_057_03',
    expression: 'happy',
    text_jp: '{pet_name}は、\nこう見えて昔はけっこう\nヤンチャしてたリンよ？',
    text_en: '{pet_name} was pretty rambunctious back in the day, you know?',
    type: 'conversational',
    next_script_id: 'giraffe_057_04',
  },
  {
    id: 'giraffe_057_04',
    animation: 'joy',
    text_jp: '毎日暗くなるまで虫取りしたり\n木登りしたりしてたリン！',
    text_en: 'I used to stay out until dark catching bugs and climbing trees!',
    type: 'conversational',
    next_script_id: 'giraffe_057_05',
  },
  {
    id: 'giraffe_057_05',
    expression: 'happy',
    text_jp: 'あの頃は若かったリンね…。',
    text_en: 'Ah, to be young again…',
    type: 'conversational',
  },
  {
    id: 'giraffe_058_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}は\n学校の先生に好かれるタイプ\nだったかリン？',
    text_en:
      'Hey, {player_name}, were you the type that got along with your teachers?',
    type: 'selectional',
    answer_var: 'teacher_like',
    option_1_jp: '好かれてた',
    option_1_en: 'Yes',
    option_2_jp: 'そうでもない',
    option_2_en: 'No',
    case: 'teacher_like',
    next_script_id_1: 'giraffe_058_02',
    next_script_id_2: 'giraffe_058_03',
  },
  {
    id: 'giraffe_058_02',
    expression: 'happy',
    text_jp: 'けっこう優等生だったのリンね！\n素敵リン！',
    text_en: 'You were a good student!\nGood for you!',
    type: 'conversational',
  },
  {
    id: 'giraffe_058_03',
    expression: 'happy',
    text_jp: 'アウトローだったのリンね！\n素敵リン！',
    text_en: 'You were an outlaw!\nSo cool!',
    type: 'conversational',
  },
  {
    id: 'giraffe_059_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '{player_name}が\n今までにした中で\n一番悪いことを教えて欲しいリン！',
    text_en: "Hey, {player_name}, what's the worst thing you’ve ever done?",
    type: 'descriptive',
    answer_var: 'worst_thing',
    question_jp: '一番悪いこと',
    question_en: 'Worst thing',
    max_len: 14,
    next_script_id: 'giraffe_059_02',
  },
  {
    id: 'giraffe_059_02',
    animation: 'anxious',
    text_jp: 'ひっ……\nほ、本当に\nそんなことをしたリン…？',
    text_en: 'EEK!\nY-You really did that…?!',
    type: 'conversational',
    next_script_id: 'giraffe_059_03',
  },
  {
    id: 'giraffe_059_03',
    animation: 'surprised',
    text_jp: 'さすが\n{player_name}リン\nワルのレベルが違ったリン',
    text_en: 'Wow, {player_name}…\nYou’re so bad…',
    type: 'conversational',
  },
  {
    id: 'giraffe_060_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{player_name}が\n最近した良い行いを\n教えて欲しいリン！',
    text_en: 'What’s something good that you’ve done lately, {player_name}?',
    type: 'descriptive',
    answer_var: 'good_act',
    question_jp: '最近した良い行い',
    question_en: 'Good act',
    max_len: 14,
    next_script_id: 'giraffe_060_02',
  },
  {
    id: 'giraffe_060_02',
    animation: 'surprised',
    text_jp:
      'そ、そんなことをしたリン？\n個人ができる善行の限界を\n遥かに超えているリン…！',
    text_en:
      'Y-You really did that?\nThat’s more than anyone would ever expect from anyone!',
    type: 'conversational',
    next_script_id: 'giraffe_060_03',
  },
  {
    id: 'giraffe_060_03',
    expression: 'happy',
    text_jp: 'これからは神と\n呼ばせてもらうリン…。',
    text_en: 'I’m going to tell everyone you’re a saint!',
    type: 'conversational',
  },
  {
    id: 'giraffe_061_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '「交番」の名前の由来、\n知ってるかリン？',
    text_en:
      'Do you know why small police stations in Japan are called “Koban”?',
    type: 'selectional',
    answer_var: 'koban',
    option_1_jp: '交通の番をするから',
    option_1_en: 'Watching traffic',
    option_2_jp: '交代で番をするから',
    option_2_en: 'Wathing in turn',
    option_3_jp: '交差点の番をするから',
    option_3_en: 'Watching intersection',
    next_script_id: 'giraffe_061_02',
  },
  {
    id: 'giraffe_061_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_061_03',
  },
  {
    id: 'giraffe_061_03',
    expression: 'happy',
    text_jp: '「交代で番をするから」リン！',
    text_en: "It's because they “Ban” (Protect) in “Kotai” (Shifts)!",
    type: 'conversational',
    next_script_id: 'giraffe_061_04',
  },
  {
    id: 'giraffe_061_04',
    text_jp:
      '初めは警察官が交代で立って番を\nしていた場所に建物が建てられて\n交番になったリン！',
    text_en:
      'They built those stations where police used to take shifts being on guard duty!',
    type: 'conversational',
  },
  {
    id: 'giraffe_062_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '警察の隠語で「フライパン」って\nどんな犯罪のことか知ってるリン？',
    text_en: 'Do you know what “Frying Pan” is a police code for?',
    type: 'selectional',
    answer_var: 'frypan',
    option_1_jp: '強盗',
    option_1_en: 'Robbery',
    option_2_jp: '暴行',
    option_2_en: 'Atrocity',
    option_3_jp: '恐喝',
    option_3_en: 'Extortion',
    next_script_id: 'giraffe_062_02',
  },
  {
    id: 'giraffe_062_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_062_03',
  },
  {
    id: 'giraffe_062_03',
    expression: 'happy',
    text_jp: '「恐喝」リン！',
    text_en: "It's code for “Kyokatsu” (Threat)!",
    type: 'conversational',
    next_script_id: 'giraffe_062_04',
  },
  {
    id: 'giraffe_062_04',
    text_jp:
      '恐喝はカツアゲともいうリンから、\nカツを作る道具のフライパンが\n恐喝の隠語になったリン！',
    text_en:
      'Kyokatsu is also called Katsuage, which is fried pork cutlets, so they chose frying pan as the codeword because it’s what you use to make it!',
    type: 'conversational',
  },
  {
    id: 'giraffe_063_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '不安や心配ごとあるときに\n食べるといいものはどれか\n分かるリン？',
    text_en: 'Do you know what you should eat If you’re worried or anxious?',
    type: 'selectional',
    answer_var: 'anxious_food',
    option_1_jp: '甘いもの',
    option_1_en: 'Sweet food',
    option_2_jp: '辛いもの',
    option_2_en: 'Spicy food',
    option_3_jp: '酸っぱいもの',
    option_3_en: 'Sour food',
    next_script_id: 'giraffe_063_02',
  },
  {
    id: 'giraffe_063_02',
    text_jp: '正解は…',
    text_en: 'The answer is...',
    type: 'conversational',
    next_script_id: 'giraffe_063_03',
  },
  {
    id: 'giraffe_063_03',
    expression: 'happy',
    text_jp: '「酸っぱいもの」リン！',
    text_en: 'Something sour!',
    type: 'conversational',
    next_script_id: 'giraffe_063_04',
  },
  {
    id: 'giraffe_063_04',
    text_jp:
      '不安で頭がお疲れな人は、一日に\nレモン2個分のクエン酸(2700mg)を\n摂るといいリン！',
    text_en:
      'If you’re feeling foggy and anxious, you should have two lemon’s worth (2,700mg) of citric acid a day!',
    type: 'conversational',
  },
  {
    id: 'giraffe_064_01',
    move_to: 'c',
    text_jp: 'ちょっぴりおなかが\nすいてきたリン！',
    text_en: 'I’m getting a little hungry!',
    type: 'conversational',
  },
  {
    id: 'giraffe_065_01',
    move_to: 'c',
    text_jp: 'そろそろ何か食べたいリン！',
    text_en: 'I wanna eat something soon!',
    type: 'conversational',
  },
  {
    id: 'giraffe_065_02',
    expression: 'happy',
    text_jp: 'ごはん楽しみリン！',
    text_en: 'Can’t wait to eat!',
    type: 'conversational',
    next_script_id: 'giraffe_065_02',
  },
  {
    id: 'giraffe_066_01',
    move_to: 'c',
    text_jp: 'うぅぅ…\nおなかがすいて\n倒れちゃいそうだリン…',
    text_en: 'Ohhh… \nI’m so hungry I could fall over…',
    type: 'conversational',
    next_script_id: 'giraffe_066_02',
  },
  {
    id: 'giraffe_066_02',
    animation: 'cry',
    text_jp: '何でもいいから、\n食べさせてほしいのリン…',
    text_en: 'Can’t you get me something to eat?\nI don’t care what it is…',
    type: 'conversational',
  },
  {
    id: 'giraffe_067_01',
    move_to: 'c',
    text_jp: 'このままでは、\nおなかと背中がくっついて、',
    text_en: 'My belly button is going to stick to my back at this rate!',
    type: 'conversational',
    next_script_id: 'giraffe_067_02',
  },
  {
    id: 'giraffe_067_02',
    animation: 'anxious',
    text_jp: 'さらに逆転して、おなかが背中に\n背中がおなかになってしまうリン！',
    text_en:
      'They’ll switch places and I’ll have a front for a back and back for a front!',
    type: 'conversational',
    next_script_id: 'giraffe_067_03',
  },
  {
    id: 'giraffe_067_03',
    animation: 'cry',
    text_jp: 'お洋服を着るのが難しく\nなってしまうリン！\nこまっちゃうリン！',
    text_en:
      'That’s going to make it hard to wear clothes!\nWhat am I going to do?',
    type: 'conversational',
  },
  {
    id: 'giraffe_068_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'はー。\nいい汗かいたリーン。',
    text_en: 'Ah…\nThat was a nice sweat.',
    type: 'conversational',
    next_script_id: 'giraffe_068_02',
  },
  {
    id: 'giraffe_068_02',
    expression: 'happy',
    text_jp: 'そろそろお風呂入りたいリン',
    text_en: 'I want to take a bath pretty soon.',
    type: 'conversational',
  },
  {
    id: 'giraffe_069_01',
    move_to: 'c',
    text_jp: '{pet_name}、けっこう\nこまめにお風呂入るのが\n好きなのリン',
    text_en: '{pet_name} likes to bathe regularly.',
    type: 'conversational',
    next_script_id: 'giraffe_069_02',
  },
  {
    id: 'giraffe_069_02',
    text_jp: 'そろそろお風呂連れて行って\nくれるとうれしいリン',
    text_en: 'I sure would like it if you took me to the bath soon!',
    type: 'conversational',
  },
  {
    id: 'giraffe_070_01',
    move_to: 'c',
    text_jp: 'ちょっと、この汚さは\n危険レベルリン！',
    text_en: 'This is getting downright unhygienic!',
    type: 'conversational',
    next_script_id: 'giraffe_070_02',
  },
  {
    id: 'giraffe_070_02',
    animation: 'angry',
    text_jp: '早くお風呂入れて欲しいリン！',
    text_en: 'Please let me take a bath!',
    type: 'conversational',
  },
  {
    id: 'giraffe_071_01',
    move_to: 'c',
    text_jp: 'こんなに汚い{pet_name}、\nきっとみんなから嫌われちゃうリン',
    text_en: 'Everyone is going to hate {pet_name} if I’m this dirty!',
    type: 'conversational',
    next_script_id: 'giraffe_071_02',
  },
  {
    id: 'giraffe_071_02',
    animation: 'cry',
    text_jp: 'お風呂入れて欲しいリン〜',
    text_en: 'I want to take a bath!',
    type: 'conversational',
  },
  {
    id: 'giraffe_072_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'あそぶリン？うれしいリン！',
    text_en: 'Time to play? Yay!',
    type: 'conversational',
  },
  {
    id: 'giraffe_073_01',
    move_to: 'c',
    text_jp: '最近あまりかまって\nもらえてないリン…',
    text_en: "You haven't spent much time with me lately…",
    type: 'conversational',
    next_script_id: 'giraffe_073_02',
  },
  {
    id: 'giraffe_073_02',
    text_jp: '{pet_name}の魅力が\n足りないのリンか…？',
    text_en: 'Is {pet_name} not good enough for you…?',
    type: 'conversational',
  },
  {
    id: 'giraffe_074_01',
    move_to: 'c',
    text_jp: 'ウサギはさみしいと\nしんじゃうって言うリンけど',
    text_en: 'They say that rabbits can die of loneliness.',
    type: 'conversational',
    next_script_id: 'giraffe_074_02',
  },
  {
    id: 'giraffe_074_02',
    text_jp: '今ならウサギの気持ちが\n分かるリン！',
    text_en: 'Now I know how rabbits feel!',
    type: 'conversational',
    next_script_id: 'giraffe_074_03',
  },
  {
    id: 'giraffe_074_03',
    animation: 'cry',
    text_jp: '{pet_name}と一緒に\nあそんで欲しいリン……！',
    text_en: 'Please play with {pet_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_075_01',
    move_to: 'c',
    text_jp: 'かまって欲しいリン！\nかまって欲しいリン！',
    text_en: 'Pay attention to me!\nPay attention to me!',
    type: 'conversational',
    next_script_id: 'giraffe_075_02',
  },
  {
    id: 'giraffe_075_02',
    text_jp: 'もうなりふりかまって\nられないのリン！',
    text_en: "I'm throwing away my pride!",
    type: 'conversational',
  },
  {
    id: 'giraffe_076_01',
    move_to: 'c',
    text_jp: 'そろそろトイレ行くリンかね…',
    text_en: 'I need to go to the bathroom…',
    type: 'conversational',
  },
  {
    id: 'giraffe_077_01',
    move_to: 'c',
    text_jp: 'おもらししそうになる前に\nトイレ行った方がいいと思うリン…',
    text_en: 'Can you take me to the bathroom before I have an accident…?',
    type: 'conversational',
  },
  {
    id: 'giraffe_078_01',
    move_to: 'c',
    animation: 'anxious',
    text_jp: 'いま、けっこう危ない状況リン…\n対応を誤ると大惨事になるリン…',
    text_en: "I can't hold it much longer…\nI’m almost at my limit…",
    type: 'conversational',
  },
  {
    id: 'giraffe_079_01',
    move_to: 'c',
    text_jp: 'ははは、早く…\nおトイレ…',
    text_en: 'P-P-Please…\nThe bathroom…!',
    type: 'conversational',
    next_script_id: 'giraffe_079_02',
  },
  {
    id: 'giraffe_079_02',
    animation: 'angry',
    text_jp: '一刻を争う事態リン！',
    text_en: 'There’s no time left!',
    type: 'conversational',
  },
  {
    id: 'giraffe_080_01',
    move_to: 'c',
    text_jp: 'なんだか漠然とした不安に\n襲われているリン！',
    text_en: 'I’m suddenly super anxious and I don’t know why!',
    type: 'conversational',
    next_script_id: 'giraffe_080_02',
  },
  {
    id: 'giraffe_080_02',
    text_jp: '気を紛らわして欲しいリン！',
    text_en: 'Can you help me take my mind off things?',
    type: 'conversational',
  },
  {
    id: 'giraffe_081_01',
    move_to: 'c',
    text_jp:
      'しんだらどうなるんだろうって\n考えだしたら、\n怖くてたまらないリン！',
    text_en:
      'I started thinking about what would happen if I died and got super scared!',
    type: 'conversational',
    next_script_id: 'giraffe_081_02',
  },
  {
    id: 'giraffe_081_02',
    text_jp: '何か他のことで\n気を紛らわして欲しいリン！',
    text_en: 'Can you distract me with something?',
    type: 'conversational',
  },
  {
    id: 'giraffe_082_01',
    move_to: 'c',
    text_jp: 'んー。\n病気になっちゃったリンー…。',
    text_en: 'Ohhh… \nI think I’m sick…',
    type: 'conversational',
    next_script_id: 'giraffe_082_02',
  },
  {
    id: 'giraffe_082_02',
    text_jp: 'おクスリもらえるとうれしいリン…',
    text_en: 'I sure would like some medicine…',
    type: 'conversational',
  },
  {
    id: 'giraffe_083_01',
    move_to: 'c',
    text_jp: 'こころなしか、いつもより\n首も短めな気がするリン…',
    text_en: 'Somehow, my neck feels shorter than usual…',
    type: 'conversational',
    next_script_id: 'giraffe_083_02',
  },
  {
    id: 'giraffe_083_02',
    text_jp: 'おクスリ欲しいりん…',
    text_en: 'I wish I had some medicine…',
    type: 'conversational',
  },
  {
    id: 'giraffe_084_01',
    move_to: 'c',
    text_jp: '虫歯がこんなに痛いなんて\n知らなかったリン…',
    text_en: 'I never knew a toothache could hurt this much…',
    type: 'conversational',
    next_script_id: 'giraffe_084_02',
  },
  {
    id: 'giraffe_084_02',
    animation: 'cry',
    text_jp: 'これからはおやつ控えめに\nするから、おクスリ欲しいリン…',
    text_en:
      'I promise I’ll lay off the snacks if you’d just give me some medicine…',
    type: 'conversational',
  },
  {
    id: 'giraffe_085_01',
    move_to: 'c',
    text_jp: 'うー。痛いリンー…\n何も食べられないリンー…',
    text_en: 'Ohh… It hurts…\nI can’t even eat anything…',
    type: 'conversational',
  },
  {
    id: 'giraffe_086_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: 'そろそろ寝る時間リンね\nまた明日一緒にあそぶリン',
    text_en: 'It’s time for me to go to sleep.\nLet’s play again tomorrow, OK?',
    type: 'conversational',
    next_script_id: 'giraffe_086_02',
  },
  {
    id: 'giraffe_086_02',
    animation: 'waive',
    text_jp: 'おやすみーリン',
    text_en: 'Good night…',
    type: 'conversational',
  },
  {
    id: 'giraffe_087_01',
    move_to: 'c',
    text_jp: 'し、しんでしまったリン…\nまさかこんなことになるとはリン…',
    text_en: 'I-I’m dead…\nI can’t believe this happened.',
    type: 'conversational',
    next_script_id: 'giraffe_087_02',
  },
  {
    id: 'giraffe_087_02',
    text_jp: '{player_name}、\n今まで{pet_name}のこと\nかわいがってくれて、',
    text_en: 'Hey, {player_name}, thanks for looking out for {pet_name}…',
    type: 'conversational',
    next_script_id: 'giraffe_087_03',
  },
  {
    id: 'giraffe_087_03',
    text_jp: '本当にありがとリン\n{pet_name}はとっても\n幸せだったリン',
    text_en: '…for so long.\n{pet_name} was really happy.',
    type: 'conversational',
    next_script_id: 'giraffe_087_04',
  },
  {
    id: 'giraffe_087_04',
    text_jp:
      'もし生まれ変われたら、また\n{pet_name}と一緒に\nあそんで欲しいリン…',
    text_en: 'If I ever get reborn, I hope you’ll play with {pet_name} again…',
    type: 'conversational',
  },
  {
    id: 'giraffe_088_01',
    move_to: 'c',
    text_jp:
      'うぅぅ…\nこれはただの病気とは違うリン…\n早く治さないとしんじゃうリン…',
    text_en:
      'Ohhh…\nThis is no ordinary cold…\nIf you don’t do something, I’m going to die…',
    type: 'conversational',
    next_script_id: 'giraffe_088_02',
  },
  {
    id: 'giraffe_088_02',
    text_jp: '万能コロンをおねがいリン…',
    text_en: 'Please, the Magic Potion…',
    type: 'conversational',
  },
  {
    id: 'giraffe_089_01',
    move_to: 'c',
    text_jp: 'きゃー！おでかけしたいリン〜！',
    text_en: 'EEEEK!\nI wanna go somewhere!',
    type: 'conversational',
    next_script_id: 'giraffe_089_02',
  },
  {
    id: 'giraffe_089_02',
    text_jp: 'お友だちと背比べしたいリン！',
    text_en: 'I want to compare heights with my friend!',
    type: 'conversational',
  },
  {
    id: 'giraffe_090_01',
    move_to: 'c',
    text_jp: 'さっき、\n{friend.player_name}が\nあそびに来てくれたリン！',
    text_en: '{friend.player_name} came over to play just now!',
    type: 'conversational',
    next_script_id: 'giraffe_090_02',
  },
  {
    id: 'giraffe_090_02',
    expression: 'happy',
    text_jp: 'すっごく楽しかったリン！\n今度は向こうに遊びに行こうリン！',
    text_en: 'It was a lot of fun!\nLet’s visit them next time!',
    type: 'conversational',
  },
  {
    id: 'giraffe_091_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nピンチのときにはこれを叫べ！\nっていう言葉を教わったリン',
    text_en: '{friend.player_name} taught me what to shout when I’m in danger!',
    type: 'conversational',
    next_script_id: 'giraffe_091_02',
  },
  {
    id: 'giraffe_091_02',
    text_jp: '{friend.scream_danger}\nだリン！',
    text_en: 'They said to shout {friend.scream_danger}',
    type: 'conversational',
    next_script_id: 'giraffe_091_03',
  },
  {
    id: 'giraffe_091_03',
    expression: 'happy',
    text_jp: '{player_name}も、\n今度使っていいリンよ',
    text_en: 'You should use it too, {player_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_092_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n誰かに言われて一番嬉しかった\n言葉を聞いたら、',
    text_en:
      'I asked {friend.player_name} what the nicest thing anyone has every said to them was.',
    type: 'conversational',
    next_script_id: 'giraffe_092_02',
  },
  {
    id: 'giraffe_092_02',
    text_jp: '{friend.best_word}って\n言ってたリン！',
    text_en: 'They said it’s {friend.best_word}!',
    type: 'conversational',
    next_script_id: 'giraffe_092_03',
  },
  {
    id: 'giraffe_092_03',
    expression: 'happy',
    text_jp: '{player_name}は、\nそんなこと言われたことあるリン？',
    text_en: 'Has anyone ever said that to you, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'giraffe_093_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n一番印象に残っている\nプレゼントを聞いたら、',
    text_en:
      'I asked {friend.player_name} what the most memorable present they ever got was.',
    type: 'conversational',
    next_script_id: 'giraffe_093_02',
  },
  {
    id: 'giraffe_093_02',
    text_jp: '{friend.memorable_gift}って\n言ってたリン！',
    text_en: 'They said {friend.memorable_gift}!',
    type: 'conversational',
    next_script_id: 'giraffe_093_03',
  },
  {
    id: 'giraffe_093_03',
    expression: 'happy',
    text_jp: '誰かにプレゼントするときの\n参考にするといいリン！',
    text_en: 'Keep that in mind the next time you need a present for someone!',
    type: 'conversational',
  },
  {
    id: 'giraffe_094_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n動物だと何に似てると思うか\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} what animal they think they look like.',
    type: 'conversational',
    next_script_id: 'giraffe_094_02',
  },
  {
    id: 'giraffe_094_02',
    text_jp: '{friend.similar_animal}って\n言ってたリン！',
    text_en: 'They said a {friend.similar_animal}!',
    type: 'conversational',
    next_script_id: 'giraffe_094_03',
  },
  {
    id: 'giraffe_094_03',
    expression: 'happy',
    text_jp: '{player_name}は\nどう思うリン？',
    text_en: 'What do you think, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'giraffe_095_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\nこれだけは誰にも負けないと\n思うことを聞いたら、',
    text_en:
      "I asked {friend.player_name} what they're sure they can’t be beaten at.",
    type: 'conversational',
    next_script_id: 'giraffe_095_02',
  },
  {
    id: 'giraffe_095_02',
    text_jp: '{friend.special_strength}って\n言ってたリン！',
    text_en: 'They said {friend.special_strength}!',
    type: 'conversational',
    next_script_id: 'giraffe_095_03',
  },
  {
    id: 'giraffe_095_03',
    expression: 'happy',
    text_jp:
      '{friend.player_name}は\n他にもすごいところが\nたくさんあるリンけどねー',
    text_en: '{friend.player_name} has lots of other special skills as well!',
    type: 'conversational',
  },
  {
    id: 'giraffe_096_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n座右の銘を聞いたら、',
    text_en: 'I asked {friend.player_name} what their motto is.',
    type: 'conversational',
    next_script_id: 'giraffe_096_02',
  },
  {
    id: 'giraffe_096_02',
    text_jp: '{friend.favorite_motto}って\n言ってたリン！',
    text_en: 'They said it’s {friend.favorite_motto}!',
    type: 'conversational',
    next_script_id: 'giraffe_096_03',
  },
  {
    id: 'giraffe_096_03',
    expression: 'happy',
    text_jp: 'すごく\n{friend.player_name}\nらしいリン！',
    text_en: 'That’s so like {friend.player_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_097_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n好きなバンドを聞いたら、',
    text_en: 'I asked {friend.player_name} what their favorite band is.',
    type: 'conversational',
    next_script_id: 'giraffe_097_02',
  },
  {
    id: 'giraffe_097_02',
    text_jp: '{friend.favorite_band}って\n言ってたリン！',
    text_en: 'They said {friend.favorite_band}!',
    type: 'conversational',
    next_script_id: 'giraffe_097_03',
  },
  {
    id: 'giraffe_097_03',
    expression: 'happy',
    text_jp: '今度ライブに誘ってみるリン？',
    text_en: 'Why not invite them to a concert?',
    type: 'conversational',
  },
  {
    id: 'giraffe_098_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n最近読んで面白かった本を\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} if they’ve read any good books lately.',
    type: 'conversational',
    next_script_id: 'giraffe_098_02',
  },
  {
    id: 'giraffe_098_02',
    text_jp: '{friend.interesting_book}って\n言ってたリン！',
    text_en: 'They said {friend.interesting_book} was good!',
    type: 'conversational',
    next_script_id: 'giraffe_098_03',
  },
  {
    id: 'giraffe_098_03',
    expression: 'happy',
    text_jp: '{player_name}は\n読んだことあるリンか？',
    text_en: 'Have you read it, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'giraffe_099_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n今までにした一番悪いことを\n聞いたリン。知りたいリン？',
    text_en:
      'I asked {friend.player_name} what the worst thing they’ve ever done was.',
    type: 'conversational',
    next_script_id: 'giraffe_099_02',
  },
  {
    id: 'giraffe_099_02',
    animation: 'surprised',
    text_jp: 'なんと…\n{friend.worst_thing}って\n言ってたリン！',
    text_en: "I couldn't believe it…\nThey said it was {friend.worst_thing}!",
    type: 'conversational',
    next_script_id: 'giraffe_099_03',
  },
  {
    id: 'giraffe_099_03',
    animation: 'anxious',
    text_jp: 'さすがにそこまでのワルとは\n思わなかったリン\nガクブルするリン…',
    text_en: "I didn’t think they were so bad!\nI'm shivering!",
    type: 'conversational',
  },
  {
    id: 'giraffe_100_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n最近した良い行いを\n聞いてみたら、',
    text_en:
      'I asked {friend.player_name} what good deeds they’ve done lately.',
    type: 'conversational',
    next_script_id: 'giraffe_100_02',
  },
  {
    id: 'giraffe_100_02',
    animation: 'surprised',
    text_jp: '{friend.good_act}って\n言ってたリン！',
    text_en: 'They said {friend.good_act}!',
    type: 'conversational',
    next_script_id: 'giraffe_100_03',
  },
  {
    id: 'giraffe_100_03',
    animation: 'joy',
    text_jp: 'すさまじい善行じゃないリン？\nこんな良い人見たことないリン',
    text_en: "They're practically a saint!\nI’ve never seen anyone be so good!",
    type: 'conversational',
  },
  {
    id: 'giraffe_101_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n犬派か猫派か聞いたら、',
    text_en:
      "I asked {friend.player_name} if they're a dog person or a cat person.",
    type: 'conversational',
    case: 'friend.dog_cat',
    next_script_id_1: 'giraffe_101_02',
    next_script_id_2: 'giraffe_101_03',
  },
  {
    id: 'giraffe_101_02',
    expression: 'happy',
    text_jp: '犬派って言ってたリン！',
    text_en: "They said they're a dog person!",
    type: 'conversational',
    next_script_id: 'giraffe_101_04',
  },
  {
    id: 'giraffe_101_03',
    expression: 'happy',
    text_jp: '猫派って言ってたリン！',
    text_en: "They said they're a a cat person!",
    type: 'conversational',
    next_script_id: 'giraffe_101_04',
  },
  {
    id: 'giraffe_101_04',
    expression: 'sad',
    text_jp: 'てっきり、キリン派かと\n思ってたのに、おかしいリン…',
    text_en: 'I just assumed they were a giraffe person. \nHow odd…',
    type: 'conversational',
  },
  {
    id: 'giraffe_102_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n人の心が読める力と未来が見える力\nどっちが欲しいか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they would rather be able to read thoughts or see the future.',
    type: 'conversational',
    case: 'friend.mind_future',
    next_script_id_1: 'giraffe_102_02',
    next_script_id_2: 'giraffe_102_03',
  },
  {
    id: 'giraffe_102_02',
    animation: 'surprised',
    text_jp: '人の心が読める力が欲しいって\n言ってたリン！',
    text_en: 'They said they would rather read thoughts!',
    type: 'conversational',
    next_script_id: 'giraffe_102_04',
  },
  {
    id: 'giraffe_102_03',
    animation: 'surprised',
    text_jp: '未来が見える力が欲しいって\n言ってたリン！',
    text_en: 'They said they would rather see the future!',
    type: 'conversational',
    next_script_id: 'giraffe_102_04',
  },
  {
    id: 'giraffe_102_04',
    expression: 'happy',
    text_jp:
      '{pet_name}は、どっちを\nもらっても不幸になりそうだから、\nどっちもいらないリン！',
    text_en:
      '{pet_name} thinks both would make you unhappy, so I don’t need either!',
    type: 'conversational',
  },
  {
    id: 'giraffe_103_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n時間にルーズな人とお金にルーズな人\n付き合うならどっちか聞いたら',
    text_en:
      'I asked {friend.player_name} if they would rather date someone loose with time or money.',
    type: 'conversational',
    case: 'friend.time_money',
    next_script_id_1: 'giraffe_103_02',
    next_script_id_2: 'giraffe_103_03',
  },
  {
    id: 'giraffe_103_02',
    text_jp: '時間にルーズな人って\n言ってたリン！',
    text_en: 'They said they would rather date someone loose with time!',
    type: 'conversational',
    next_script_id: 'giraffe_103_04',
  },
  {
    id: 'giraffe_103_03',
    text_jp: 'お金にルーズな人って\n言ってたリン！',
    text_en: 'They said they would rather date someone loose with money!',
    type: 'conversational',
    next_script_id: 'giraffe_103_04',
  },
  {
    id: 'giraffe_103_04',
    expression: 'happy',
    text_jp: '{pet_name}は、正直\nどっちもお断りリンね〜',
    text_en: 'Honestly, {pet_name} wouldn’t date either!',
    type: 'conversational',
  },
  {
    id: 'giraffe_104_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n学校をズル休みしたこと\nあるかどうか聞いたら、',
    text_en:
      "I asked {friend.player_name} if they've ever played hooky from school.",
    type: 'conversational',
    case: 'friend.playing_hookey',
    next_script_id_1: 'giraffe_104_02',
    next_script_id_2: 'giraffe_104_03',
  },
  {
    id: 'giraffe_104_02',
    animation: 'surprised',
    text_jp: 'あるって言ってたリン！\nアウトローだリン！',
    text_en: 'They said they have!\nWhat an outlaw!',
    type: 'conversational',
  },
  {
    id: 'giraffe_104_03',
    expression: 'happy',
    text_jp: 'ないって言ってたリン！\n意外に真面目だったリン！',
    text_en: 'They said they haven’t!\nWhat an unexpetedly straight arrow!',
    type: 'conversational',
  },
  {
    id: 'giraffe_105_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n友だちの恋人を好きになって\nしまったことがあるか聞いたら、',
    text_en:
      "I asked {friend.player_name} if they've ever had a crush on someone their friend was dating.",
    type: 'conversational',
    case: 'friend.friends_lover',
    next_script_id_1: 'giraffe_105_02',
    next_script_id_2: 'giraffe_105_03',
    next_script_id_3: 'giraffe_105_04',
  },
  {
    id: 'giraffe_105_02',
    expression: 'happy',
    text_jp: 'あるって言ってたリン！\nきゃー！！',
    text_en: 'They said they have!\nEEEK!',
    type: 'conversational',
  },
  {
    id: 'giraffe_105_03',
    expression: 'happy',
    text_jp: 'ないって言ってたリン！\nちょっと怪しいと思うリン！',
    text_en: 'They said they haven’t!\nI think that’s a little suspicious!',
    type: 'conversational',
  },
  {
    id: 'giraffe_105_04',
    expression: 'happy',
    text_jp:
      'ナイショって言ってたリン！\nそれってあるってことリンよね〜？\nきゃー！！',
    text_en:
      "They said it's a secret!\nThat totally means they have, right?\nEEEK!",
    type: 'conversational',
  },
  {
    id: 'giraffe_106_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\n腕力に自信があるか聞いたら、',
    text_en: 'I asked {friend.player_name} if they think they’re strong.',
    type: 'conversational',
    case: 'friend.arm_power',
    next_script_id_1: 'giraffe_106_02',
    next_script_id_2: 'giraffe_106_03',
  },
  {
    id: 'giraffe_106_02',
    expression: 'happy',
    text_jp: 'あるって言ってたリン！\n意外と頼もしいリン！',
    text_en: 'They said they do!\nHow reliable!',
    type: 'conversational',
  },
  {
    id: 'giraffe_106_03',
    expression: 'happy',
    text_jp: 'ないって言ってたリン！\n守ってあげたくなるリン！',
    text_en: "They said they don't!\nMakes you want to protect them!",
    type: 'conversational',
  },
  {
    id: 'giraffe_107_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n一度決めたことを最後まで\nやり遂げられる方か聞いたら、',
    text_en:
      'I asked {friend.player_name} if they always finish what they start.',
    type: 'conversational',
    case: 'friend.until_end',
    next_script_id_1: 'giraffe_107_02',
    next_script_id_2: 'giraffe_107_03',
  },
  {
    id: 'giraffe_107_02',
    animation: 'joy',
    text_jp: 'やり遂げられるって言ってたリン！\nなにやらすごい自信だリン！',
    text_en: 'They said they do!\nThat’s some great confidence!',
    type: 'conversational',
  },
  {
    id: 'giraffe_107_03',
    expression: 'happy',
    text_jp: 'くじけちゃうタイプだって\n言ってたリン！\n応援したくなるリン！',
    text_en: 'They said they give up!\nMakes you want to cheer them on!',
    type: 'conversational',
  },
  {
    id: 'giraffe_108_01',
    expression: 'normal',
    move_to: 'c',
    text_jp: '{friend.player_name}に\nお金遣いは荒い方か聞いてみたら、',
    text_en: "I asked {friend.player_name} if they're loose with money.",
    type: 'conversational',
    case: 'friend.spendthrift',
    next_script_id_1: 'giraffe_108_02',
    next_script_id_2: 'giraffe_108_03',
  },
  {
    id: 'giraffe_108_02',
    expression: 'normal',
    text_jp:
      '荒い方だって言ってたリン！\n自分で自覚できてるうちは\n大丈夫リン！',
    text_en: 'They said they are! \nIt’s OK as long as you’re aware of it!',
    type: 'conversational',
  },
  {
    id: 'giraffe_108_03',
    expression: 'normal',
    text_jp:
      'けっこう堅実だって言ってたリン！\n{player_name}は、\n実際どう思うリン？',
    text_en:
      'They said they’re pretty stable!\nDo you think that’s true, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'giraffe_109_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n告白するのとされるの\nどっちが多いか聞いたら、',
    text_en:
      "I asked {friend.player_name} if they'd rather tell someone they like them or have someone tell them they like them.",
    type: 'conversational',
    case: 'friend.propose_wait',
    next_script_id_1: 'giraffe_109_02',
    next_script_id_2: 'giraffe_109_03',
  },
  {
    id: 'giraffe_109_02',
    text_jp: '告白する方が多いって\n言ってたリン！\n意外と積極的リン！',
    text_en:
      'They said they’d rather tell someone they like them!\nThey’re surprisingly forward!',
    type: 'conversational',
  },
  {
    id: 'giraffe_109_03',
    text_jp:
      '告白される方が多いって\n言ってたリン！\n意外にかけひきとかするリンかね？',
    text_en:
      'They said they’d rather have someone tell them they like them!\nI wonder if they bargain!',
    type: 'conversational',
  },
  {
    id: 'giraffe_110_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n悩みを誰かに相談するタイプか\n聞いてみたら、',
    text_en:
      "I asked {friend.player_name} if they're the type to ask for advice about a problem.",
    type: 'conversational',
    case: 'friend.consult',
    next_script_id_1: 'giraffe_110_02',
    next_script_id_2: 'giraffe_110_03',
  },
  {
    id: 'giraffe_110_02',
    expression: 'happy',
    text_jp:
      '割りと相談するって言ってたリン！\n{player_name}は\n相談されたことあるリンか？',
    text_en:
      'They said they usually ask for advice!\nHave they ever asked you, {player_name}?',
    type: 'conversational',
  },
  {
    id: 'giraffe_110_03',
    expression: 'happy',
    text_jp:
      'あまり相談しないって\n言ってたリン！\n自己解決できちゃうタイプリンね！',
    text_en:
      'They said they don’t usually ask for advice!\nI guess they can make up their own mind!',
    type: 'conversational',
  },
  {
    id: 'giraffe_111_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n昔はけっこうヤンチャしてたか\nどうか聞いたら、',
    text_en: 'I asked if {friend.player_name} used to be a rambunctious youth.',
    type: 'conversational',
    case: 'friend.bad_boy',
    next_script_id_1: 'giraffe_111_02',
    next_script_id_2: 'giraffe_111_03',
  },
  {
    id: 'giraffe_111_02',
    expression: 'happy',
    text_jp:
      'けっこうしてたって言ってたリン！\n本当に悪かった人はあまりそういう\nこと言わないって知ってるリン！',
    text_en:
      'They said they were!\nI don’t think anyone bad would actually admit it!',
    type: 'conversational',
  },
  {
    id: 'giraffe_111_03',
    animation: 'anxious',
    text_jp:
      '真面目だったって言ってたリン！\n何かとんでもない過去がありそうで\nぶるぶるしちゃうリン！',
    text_en:
      'They said they weren’t!\nI’ll bet they have lots of skeletons in their closet!',
    type: 'conversational',
  },
  {
    id: 'giraffe_112_01',
    expression: 'normal',
    move_to: 'c',
    text_jp:
      '{friend.player_name}に\n学校の先生に好かれるタイプ\nだったか聞いたら、',
    text_en:
      'I asked {friend.player_name} if they got along with their teachers.',
    type: 'conversational',
    case: 'friend.teacher_like',
    next_script_id_1: 'giraffe_112_02',
    next_script_id_2: 'giraffe_112_03',
  },
  {
    id: 'giraffe_112_02',
    expression: 'happy',
    text_jp: 'けっこう好かれてたって\n言ってたリン！\n優等生リン！',
    text_en: 'They said they did!\nWhat a good student!',
    type: 'conversational',
  },
  {
    id: 'giraffe_112_03',
    expression: 'happy',
    text_jp: 'そうでもなかったって\n言ってたリン！\nアウトローで素敵だリン！',
    text_en: 'They said they didn’t!\nWhat an awesome outlaw!',
    type: 'conversational',
  },
  {
    id: 'giraffe_113_01',
    move_to: 'c',
    text_jp:
      'こんなに大きくなったリン！\nこれから、もーーーーーっと、\n仲良くして欲しいリン！',
    text_en:
      'Look how big I’ve gotten!\nLet’s be friends for a loooooong time!',
    type: 'conversational',
  },
  {
    id: 'giraffe_114_01',
    animation: 'waive',
    text_jp: 'こんにちはー！\nあそびに来たリーン！',
    text_en: 'Hi there!\nI’m here to play!',
    type: 'conversational',
  },
  {
    id: 'giraffe_115_01',
    animation: 'waive',
    text_jp: 'いらっしゃいリーン！\nゆっくりしてってリーン！',
    text_en: 'Welcome! \nMake yourself at home!',
    type: 'conversational',
  },
  {
    id: 'giraffe_116_01',
    move_to: 'c',
    text_jp: 'おせわありがとリン！\nこれ、感謝の気持ちだリン！',
    text_en: 'Thanks for spending time with me!\nHere’s a little present!',
    type: 'conversational',
  },
  {
    id: 'giraffe_117_01',
    animation: 'waive',
    text_jp: 'そろそろおいとまするリーン！\nどうもありがとリーン！',
    text_en: 'I’ve got to get going.\nThank you for everything!',
    type: 'conversational',
  },
  {
    id: 'giraffe_118_01',
    animation: 'waive',
    text_jp: 'また来てねリーン！',
    text_en: 'Come back any time!',
    type: 'conversational',
  },
  {
    id: 'giraffe_119_01',
    text_jp: 'どうやら\n{friend.player_name}が\n帰ってきたみたいリン',
    text_en: 'Looks like {friend.player_name} is back!',
    type: 'conversational',
    next_script_id: 'giraffe_119_02',
  },
  {
    id: 'giraffe_119_02',
    animation: 'waive',
    text_jp: 'そろそろおいとまするリンね\nどうもありがとリン！',
    text_en: 'Time for me to get going.\nThanks again!',
    type: 'conversational',
  },
  {
    id: 'giraffe_120_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '怖くてお風呂やトイレに\nいけないリン',
    text_en: 'I’m too scared to use the bathroom.',
    type: 'conversational',
  },
  {
    id: 'giraffe_121_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: '虫歯が痛くてごはんやおやつが\n食べられないリン',
    text_en: 'I can’t eat snacks or food because my cavity hurts.',
    type: 'conversational',
  },
  {
    id: 'giraffe_122_01',
    move_to: 'c',
    animation: 'cry',
    text_jp: 'それよりいまは、\n万能コロンをかけて欲しいリン〜',
    text_en: 'It’s too hard to do right now.\nI want some universal cologne',
    type: 'conversational',
  },
  {
    id: 'giraffe_123_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'おでかけした過ぎて、他に\n何もできないリン〜！',
    text_en:
      'I want to go out more than anything right now!\nI wish you’d let me go outside.',
    type: 'conversational',
  },
  {
    id: 'giraffe_124_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '病気治ったリン！\nどうもありがとリン！',
    text_en: 'I’m all better!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'giraffe_125_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '虫歯治ったリン！\nどうもありがとリン！',
    text_en: 'My cavity is gone!\nThank you!',
    type: 'conversational',
  },
  {
    id: 'giraffe_126_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'なんとか助かったリン！\n{player_name}は\n命の恩人リンよ〜！',
    text_en: 'Phew, that was close!\nI almost didn’t make it!',
    type: 'conversational',
  },
  {
    id: 'giraffe_127_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったリン…\nもう1回試してみて欲しいリン',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'giraffe_128_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったリン…\nもう1回試してみて欲しいリン',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'giraffe_129_01',
    expression: 'very_sad',
    move_to: 'c',
    animation: 'cry',
    text_jp: '治んなかったリン…\nもう1回試してみて欲しいリン',
    text_en: 'It didn’t work.\nCan you try one more time?',
    type: 'conversational',
  },
  {
    id: 'giraffe_130_01',
    text_jp: '{pet_name}と一緒に\nぶるぶるカフェで伝説を作るリン！',
    text_en: 'You and {pet_name} will be legendary at the BuruBuru Café!',
    type: 'conversational',
  },
  {
    id: 'giraffe_131_01',
    expression: 'normal',
    text_jp:
      'お誘いありがとリン！\n{invitee.player_name}とも\n相談してお返事するリンね！',
    text_en:
      'Thanks for the invitation!\nI’ll let you know after I talk to {invitee.player_name}!',
    type: 'conversational',
  },
  {
    id: 'giraffe_132_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: 'どうかなどうかなー？\nきゃきゃきゃ！',
    text_en: 'What will happen? Who knows?\nHahaha!',
    type: 'conversational',
  },
  {
    id: 'giraffe_133_01',
    expression: 'happy',
    move_to: 'c',
    text_jp:
      '{inviter.player_name}から\nコンビ結成のお誘いを\nもらったリンけど',
    text_en: '{inviter.player_name} asked if I want to join their team!',
    type: 'conversational',
    next_script_id: 'giraffe_133_02',
  },
  {
    id: 'giraffe_133_02',
    text_jp: 'どうしたらいいと思うリン…？',
    text_en: 'What do you think I should do?',
    type: 'conversational',
  },
  {
    id: 'giraffe_134_01',
    expression: 'happy',
    move_to: 'c',
    text_jp: '{invitee.player_name}が\nお返事の準備ができたみたいリン！',
    text_en: '{invitee.player_name} is ready to answer!',
    type: 'conversational',
  },
  {
    id: 'giraffe_135_01',
    expression: 'normal',
    text_jp: '{invitee.player_name}とも\n相談して真剣に考えたリンけど…',
    text_en: 'I had a serious talk with {invitee.player_name}…',
    type: 'conversational',
  },
  {
    id: 'giraffe_136_01',
    expression: 'happy',
    text_jp: 'このお誘い、お受けするリン！\n一緒に伝説を作るリン！',
    text_en: 'I’ll accept your invitation!\nLet’s become legends together!',
    type: 'conversational',
  },
  {
    id: 'giraffe_137_01',
    expression: 'normal',
    text_jp: '本当にごめんリンけど、今回は\nお断りさせていただくリン…',
    text_en: 'I’m really sorry, but I have to say no right now.',
    type: 'conversational',
  },
  {
    id: 'giraffe_138_01',
    expression: 'normal',
    text_jp: '{invitee.player_name}から\nメッセージを預かっているリン',
    text_en: 'I have a message from {invitee.player_name}.',
    type: 'conversational',
  },
  {
    id: 'giraffe_139_01',
    expression: 'normal',
    text_jp: '「{invitee.message}」',
    text_en: '"{invitee.message}"',
    type: 'conversational',
  },
  {
    id: 'giraffe_140_01',
    expression: 'very_sad',
    text_jp: '気にしなくていいリンよー…',
    text_en: 'Don’t worry about it…',
    type: 'conversational',
  },
];
